export const translations = {
  uk: {
    // Header
    header: {
      logo: 'CONFY',
      nav: {
        courses: 'Курси',
        events: 'Події',
      },
      auth: {
        signIn: 'Увійти',
        signUp: 'Реєстрація',
        signOut: 'Вийти',
        profile: 'Профіль',
        dashboard: 'Панель управління',
        myTests: 'Мої тести',
        mySurveys: 'Мої опитування',
        myCertificates: 'Мої сертифікати',
        myMaterials: 'Мої матеріали',
        createdByMe: 'Створене мною',
        myTickets: 'Мої квитки',
        user: 'Користувач',
        loadingName: 'Завантаження імені...',
        profileUnavailable: 'Профіль не завантажився',
        retryProfile: 'Повторити',
      },
    },

    // Home Page
    home: {
      hero: {
        title: 'Ваш шлях у БПР ',
        titleHighlight: 'став простішим',
        subtitle: 'Знайдіть цікаву подію за вашою спеціальністю, зареєструйтесь за секунду та зберігайте всі досягнення у власному профілі',
        cta: 'Переглянути події та курси',
        ctaEvents: 'Переглянути події',
        ctaSubtext: 'Швидше. Зручніше. Професійніше. Ми оновили платформу, щоб надати вам нові можливості',
      },
      browse: {
        title: 'Знайдіть свою подію або курс',
        subtitle: 'Шукайте програми для вашої спеціальності та отримуйте бали БПР',
        mozAccredited: 'Бали БПР',
        availableContent: 'Доступно {{count}}+ програм',
        noResults: 'Нічого не знайдено',
        noResultsDesc: 'Спробуйте змінити параметри пошуку або перегляньте всі доступні події та курси.',
        loadFailed: 'Не вдалося завантажити дані',
        loadFailedDesc: 'Перевірте інтернет-з\'єднання та спробуйте ще раз.',
        retry: 'Спробувати ще раз',
        viewAll: 'Переглянути всі',
        backToHome: 'На головну',
        resultsCount: 'Знайдено: {{count}}',
        showingPastFallback: 'Наразі немає запланованих подій, тому показуємо минулі події та курси.',
      },
      search: {
        placeholder: 'Пошук подій і курсів...',
        specialty: 'Всі спеціальності',
        format: 'Будь-який формат',
        type: 'Тип',
        button: 'Пошук',
        popularSearches: 'Популярні пошуки:',
        showFilters: 'Додаткові фільтри',
        hideFilters: 'Приховати фільтри',
        advancedFilters: 'Додаткові фільтри пошуку',
        filters: 'Фільтри',
        clearFilters: 'Очистити',
        apply: 'Застосувати',
        showPastEvents: 'Показати минулі події',
        types: {
          all: 'Всі',
          courses: 'Тільки курси',
          events: 'Тільки події',
        },
        specialties: {
          all: 'Всі спеціальності',
          cardiology: 'Кардіологія',
          neurology: 'Неврологія',
          pediatrics: 'Педіатрія',
          surgery: 'Хірургія',
          internal_medicine: 'Внутрішні хвороби',
          emergency: 'Невідкладна медицина',
          radiology: 'Радіологія',
          anesthesiology: 'Анестезіологія',
        },
        formats: {
          any: 'Будь-який формат',
          online: 'Онлайн',
          selfPaced: 'Самостійний темп',
        },
      },
      courses: {
        latest: 'Останні медичні курси',
        latestSubtitle: 'Нещодавно додані курси від провідних медичних викладачів',
        searchResults: 'Результати пошуку',
        searchResultsSubtitle: 'Курси, що відповідають вашим критеріям пошуку',
        clearSearch: 'Очистити пошук та переглянути всі курси',
        noCourses: 'Нічого не знайдено',
        noCoursesDesc: 'Спробуйте змінити параметри пошуку або перевірте пізніше.',
        loading: 'Завантаження...',
        loadMore: 'Завантажити більше',
        showing: 'Показано',
        of: 'з',
        noMore: 'Більше немає елементів',
      },
      stats: {
        title: 'Приєднуйтесь до 78 000+ медичних фахівців',
        eventsHeld: 'Проведених заходів',
        participants: 'Учасників',
        doctorsInDatabase: 'Користувачів',
        organizers: 'Організаторів',
      },
      trust: {
        mozAccredited: 'Бали БПР',
        doctorsTrust: 'лікарів довіряють нам',
        eventsHeld: 'проведених заходів',
      },
      featured: {
        title: 'Актуальні події та курси',
        subtitle: 'Перегляньте та зареєструйтесь в один клік',
        viewAll: 'Переглянути всі',
      },
      browseSection: {
        title: 'Знайдіть свою подію або курс',
        subtitle: 'Шукайте серед усіх доступних подій та курсів',
      },
      whyChoose: {
        title: 'Чому лікарі обирають CONFY',
        subtitle: 'Каталог подій за спеціалізаціями, персоналізовані рекомендації та миттєвий доступ до сертифікатів',
        mozAccreditation: {
          title: 'Повна історія навчання',
          description: 'Всі ваші сертифікати та відеозаписи в одному захищеному місці',
        },
        expertInstructors: {
          title: 'Реєстрація в один клік',
          description: 'Ваші дані вже у профілі. Жодних повторних анкет',
        },
        flexibleLearning: {
          title: 'Гнучкий графік',
          description: 'Навчайтесь у зручний час у викладачів-практиків',
        },
        cpdCredits: {
          title: 'БПР',
          description: 'Більшість курсів та подій зареєстровані в системі БПР',
        },
      },
      browseCourses: 'Переглянути події та курси',
      allContent: 'Всі події та курси',
    },

    // Course Card
    courseCard: {
      instructor: 'Інструктор',
      duration: 'Тривалість',
      level: 'Рівень',
      price: 'Ціна',
      free: 'Безкоштовно',
      register: 'Зареєструватись',
      registerForEvent: 'Зареєструватись',
      registerForCourse: 'Зареєструватись',
      registrationOpensSoon: 'Реєстрація відкриється незабаром',
      startLearning: 'Почати навчання',
      continueLearning: 'Продовжити навчання',
      courseCompleted: 'Завершено',
      eventCompleted: 'Подія завершена!',
      startEvent: 'Почати',
      continueEvent: 'Продовжити',
      goToCourse: 'Перейти до курсу',
      goToEvent: 'Перейти до події',
      viewEvent: 'Переглянути подію',
      past: 'Завершено',
      viewDetails: 'Детальніше',
      course: 'Курс',
      event: 'Подія',
      cpdCredits: 'Бали БПР',
      cpdCreditsAvailable: 'Доступні бали БПР',
      scheduleTBA: 'Розклад буде оголошено',
      locationTBA: 'Місце буде оголошено',
      levels: {
        beginner: 'Початковий',
        intermediate: 'Середній',
        advanced: 'Просунутий',
      },
      formats: {
        online: 'Онлайн',
        in_person: 'Очно',
        hybrid: 'Гібридний',
        self_paced: 'Самостійний темп',
      },
    },

    // Auth Modal
    auth: {
      signIn: {
        title: 'Вхід в акаунт',
        email: 'Email',
        password: 'Пароль',
        button: 'Увійти',
        forgotPassword: 'Забули пароль?',
        noAccount: 'Немає акаунту?',
        signUp: 'Зареєструватися',
        orContinueWith: 'або продовжити з',
        error: 'Помилка входу',
      },
      signUp: {
        title: 'Створити акаунт',
        firstName: 'Ім\'я',
        lastName: 'Прізвище',
        email: 'Email',
        password: 'Пароль',
        confirmPassword: 'Підтвердити пароль',
        phone: 'Телефон',
        role: 'Роль',
        selectRole: 'Виберіть роль',
        roles: {
          student: 'Студент',
          instructor: 'Інструктор',
        },
        button: 'Зареєструватися',
        haveAccount: 'Вже є акаунт?',
        signIn: 'Увійти',
        terms: 'Реєструючись, ви погоджуєтесь з нашими',
        termsLink: 'Угодою користувача',
        and: 'та',
        privacyLink: 'Політикою конфіденційності',
        error: 'Помилка реєстрації',
        success: 'Реєстрація успішна! Перевірте вашу електронну пошту для підтвердження.',
        passwordMismatch: 'Паролі не співпадають',
      },
      // Sign-in confirmation interstitial (/auth/confirm)
      confirmTitle: 'Заходимо у CONFY…',
      confirmBody: 'Ще мить, і ви будете на місці. Якщо нічого не сталося, натисніть кнопку нижче.',
      confirmAction: 'Увійти',
      confirmManualTitle: 'Підтвердіть вхід',
      confirmManualBody: 'Натисніть кнопку, щоб увійти у CONFY.',
    },

    // Dashboard
    dashboard: {
      title: 'Панель управління',
      welcome: 'Ласкаво просимо',
      myCourses: 'Мої курси',
      enrolled: 'Зареєстровано',
      teaching: 'Мої викладання',
      createCourse: 'Створити новий курс',
      complete: 'Завершено',
      lastAccessed: 'Останній доступ',
      noCourses: 'У вас ще немає курсів',
      noCoursesDesc: 'Почніть з перегляду доступних курсів або створіть свій власний.',
      exploreCourses: 'Переглянути курси',
      progress: 'Прогрес',
      certificate: 'Сертифікат',
      continue: 'Продовжити',
      completed: 'Завершено',
      notStarted: 'Не розпочато',
      certificates: 'Сертифікати',
      inProgress: 'В процесі',
      myCreatedCourses: 'Створені мною курси',
      courses: 'курси',
      course: 'курс',
      noCoursesCreatedYet: 'Курси ще не створені',
      startCreatingFirstCourse: 'Почніть створювати свій перший курс, щоб поділитись знаннями!',
      createYourFirstCourse: 'Створіть свій перший курс',
      created: 'Створено',
      starts: 'Починається',
      unpublish: 'Зняти з публікації',
      publish: 'Опублікувати',
      draft: 'Чернетка',
      published: 'Опубліковано',
      editCourse: 'Редагувати курс',
      viewAnalytics: 'Переглянути аналітику',
      enrolledCourses: 'Мої курси',
      noCoursesYet: 'Курсів ще немає',
      notEnrolledYet: 'Ви ще не записалися на жоден курс. Почніть досліджувати наш каталог курсів!',
      enrolledStatus: 'Записаний',
      materials: 'Матеріали',
      required: 'обов\'язково',
      tests: 'Тести',
      surveys: 'Опитування',
      issued: 'виданих',
      tickets: 'Квитки',
      purchased: 'Придбано',
      free: 'Безкоштовно',
      startLearning: 'Почати навчання',
      continueLearning: 'Продовжити навчання',
      courseCompleted: 'Завершено',
      viewCertificate: 'Сертифікат',
      generateCertificate: 'Сформувати сертифікат',
      createNewCourse: 'Створити новий курс',
      chooseHowToCreate: 'Виберіть, як ви хочете створити вміст курсу. Ви можете створити його за допомогою нашого редактора з різними типами вмісту.',
      startWithCourseBuilder: 'Почати з конструктора курсів',
      useDragAndDrop: 'Використовуйте наш редактор перетягування для створення багатого вмісту курсу',
      useTemplate: 'Використати шаблон',
      startWithTemplate: 'Почніть з готового шаблону курсу',
      importContent: 'Імпортувати вміст',
      importExistingMaterials: 'Імпортувати існуючі матеріали курсу',
      creator: 'Автор',
      learner: 'Студент',
      more: 'Більше',
      archive: 'Архівувати',
      unarchive: 'Розархівувати',
      archived: 'Архівовано',
      duplicate: 'Дублювати подію',
      delete: 'Видалити',
      deleteSuccess: 'Контент успішно видалено',
      deleteError: 'Не вдалося видалити контент',
      statusUpdateError: 'Не вдалося оновити статус',
      enrolledEvents: 'Мої події',
      filter: {
        all: 'Всі',
        active: 'Активні',
        draft: 'Чернетки',
        archived: 'Архівовані',
        past: 'Минулі',
      },
      deleteModal: {
        title: {
          event: 'Видалити подію?',
          course: 'Видалити курс?',
        },
        warning: 'Ця дія є незворотною і не може бути скасована.',
        whatWillBeDeleted: 'Що буде видалено:',
        items: {
          eventDetails: 'Деталі події та налаштування',
          courseDetails: 'Деталі курсу та налаштування',
          materials: 'Всі матеріали та вміст',
          tests: 'Тести та опитування',
          tickets: 'Квитки',
          promocodes: 'Промокоди',
          allData: 'Всі пов\'язані дані',
        },
        confirmInstruction: 'Введіть "DELETE" для підтвердження:',
        cancel: 'Скасувати',
        deletePermanently: 'Видалити назавжди',
        deleting: 'Видалення...',
      },
      blockedDeleteModal: {
        title: {
          event: 'Неможливо видалити подію',
          course: 'Неможливо видалити курс',
        },
        message: 'Неможливо видалити {contentType}, оскільки є активні реєстрації.',
        currentActivity: 'Поточна активність:',
        enrollments: '{count} записаних студентів',
        payments: '{count} завершених платежів',
        certificates: '{count} виданих сертифікатів',
        archiveRecommendation: 'Замість цього архівуйте {contentType}, щоб зберегти дані студентів і приховати з вашого активного списку.',
        cancel: 'Скасувати',
        archiveInstead: 'Архівувати замість цього',
      },
      duplicateModal: {
        title: 'Дублювати подію',
        description: 'Виберіть, які компоненти ви хочете скопіювати в нову подію. Дубльована подія буде створена як чернетка.',
        selectAll: 'Вибрати все',
        button: 'Дублювати подію',
        duplicating: 'Дублювання...',
        success: 'Подія успішно дубльована!',
        partialSuccess: 'Подію дубльовано, але частину даних не вдалося скопіювати. Перевірте нову подію.',
        error: 'Не вдалося дублювати подію',
        eventNotFoundOrAccessDenied: 'Подію не знайдено або доступ заборонено',
        options: {
          generalInfo: 'Загальна інформація (назва, опис, дати, місце, спеціальність тощо)',
          tickets: 'Квитки',
          promocodes: 'Промокоди',
          speakers: 'Спікери',
          program: 'Програма',
          materials: 'Додаткові матеріали',
          partners: 'Партнери',
          mozSubmission: 'Дані БПР',
          tests: 'Тести',
          surveys: 'Опитування',
          customFields: 'Додаткові поля реєстрації',
          organizerAccess: 'Доступ організаторів (без сповіщень на email)',
        },
        availabilityHelpLine: 'Часові вікна копіюються – прив’язані до події переносяться автоматично; абсолютні дати зсуваються відповідно до нової дати події.',
      },
      cancellation: {
        cancelEvent: 'Скасувати подію',
        reactivateEvent: 'Відновити подію',
        eventCancelled: 'Подію скасовано',
        cancelledOn: 'Скасовано',
        cancelledBy: 'Скасував',
        reason: 'Причина скасування',
        reasonRequired: 'Причина скасування обов\'язкова',
        reasonPlaceholder: 'Введіть причину скасування події...',
        confirmCancel: 'Підтвердити скасування',
        confirmReactivate: 'Підтвердити відновлення',
        cancelling: 'Скасування...',
        reactivating: 'Відновлення...',
        cancelSuccess: 'Подію успішно скасовано',
        reactivateSuccess: 'Подію успішно відновлено',
        cancelError: 'Не вдалося скасувати подію',
        reactivateError: 'Не вдалося відновити подію',
        cannotCancelEnded: 'Неможливо скасувати подію, яка вже завершилась',
        alreadyCancelled: 'Подія вже скасована',
        notCancelled: 'Подія не скасована',
        pendingRefunds: 'Очікують повернення коштів',
        cannotReactivateWhileRefunding: 'Неможливо відновити подію поки обробляються повернення коштів',
        cannotPublishCancelled: 'Неможливо опублікувати скасовану подію. Спочатку відновіть її з панелі керування.',
        impactSummary: 'Вплив скасування',
        enrolledUsers: 'Зареєстрованих користувачів',
        paidEnrollments: 'Оплачених реєстрацій',
        totalRefundAmount: 'Загальна сума повернення',
        usersWillBeNotified: 'Користувачі будуть сповіщені про скасування',
        refundsWillBeProcessed: 'Після підтвердження організатором кошти будуть повернуті протягом 5-7 робочих днів',
        refundsQueuedForApproval: 'Оплачені реєстрації ({{count}}) буде поставлено в чергу на підтвердження організатором – затвердити повернення можна у списку учасників цієї події.',
        refundsFailed: 'Не вдалося поставити в чергу {{count}} повернень. Службу підтримки CONFY сповіщено.',
        warningTitle: 'Увага!',
        warningMessage: 'Ця дія скасує подію та ініціює повернення коштів всім платним учасникам.',
        reactivateWarning: 'Користувачі, яким було повернуто кошти, повинні будуть зареєструватися знову.',
        readyToReactivate: 'Готово до відновлення',
        readyToReactivateDescription: 'Цю подію можна відновити, і вона знову стане видимою для користувачів.',
        currentStatus: 'Поточний статус',
        activeEnrollments: 'Активні реєстрації (без повернення коштів)',
        notCancelledDescription: 'Ця подія не скасована і не потребує відновлення.',
        publicBannerMessage: 'Цю подію скасовано. Реєстрація більше недоступна.',
        refundStatus: {
          pending: 'Очікує',
          processing: 'Обробляється',
          completed: 'Повернено',
          failed: 'Помилка',
          not_applicable: 'Не застосовується',
          partial: 'Часткове повернення',
          queued: 'У черзі',
        },
      },
      // New 4-tab dashboard structure
      tabs: {
        pending: 'Очікує',
        learning: 'Навчання',
        history: 'Історія',
        created: 'Створене',
      },
      pending: {
        tests: 'Тести для проходження',
        surveys: 'Опитування для заповнення',
        inProgress: 'Продовжити навчання',
        required: 'Обов\'язково',
        passingScore: 'Прохідний бал',
        attempts: 'Спроби',
        overdue: 'Прострочено',
        dueToday: 'Сьогодні',
        daysLeft: 'днів залишилось',
        startTest: 'Почати тест',
        completeSurvey: 'Пройти опитування',
        testClosed: 'Тест закрито',
        surveyClosed: 'Опитування закрито',
        testOverdue: 'Цей тест більше недоступний – термін проходження минув',
        surveyOverdue: 'Це опитування більше недоступне – термін проходження минув',
        continue: 'Продовжити',
        allCaughtUp: 'Все виконано!',
        noPendingItems: 'У вас немає тестів, опитувань або курсів для завершення.',
      },
      learning: {
        all: 'Всі',
        events: 'Події',
        courses: 'Курси',
        noEnrollments: 'Ще немає реєстрацій',
        startLearning: 'Почніть навчання, зареєструвавшись на події або курси.',
        browse: 'Переглянути події та курси',
      },
      history: {
        title: 'Історія завершень',
        certificateEarned: 'Отримано сертифікат',
        testCompleted: 'Пройдено тест',
        surveyCompleted: 'Заповнено опитування',
        certificateNumber: 'Номер сертифіката',
        cpdCredits: 'Бали БПР',
        verificationCode: 'Код верифікації',
        passed: 'Пройдено',
        failed: 'Не пройдено',
        score: 'Результат',
        required: 'мін.',
        download: 'Завантажити',
        verify: 'Перевірити',
        getCertificate: 'Отримати сертифікат',
        empty: 'Історія порожня',
        emptyDescription: 'Пройдіть тести, опитування або отримайте сертифікати, щоб побачити історію тут.',
        fromEvent: 'Подія',
        fromCourse: 'Курс',
      },
    },

    createdPage: {
      title: 'Створене мною',
      subtitle: 'Події та курси, які ви створили',
      tabEvents: 'Події',
      tabCourses: 'Курси',
      statsTotal: 'Всього',
      typeEvent: 'Подія',
      typeCourse: 'Курс',
      enrolled: 'учасників',
      statusActive: 'Активна',
      statusDraft: 'Чернетка',
      statusArchived: 'Архівована',
      statusCancelled: 'Скасована',
      emptyEventsTitle: 'Подій ще не створено',
      emptyEventsSubtitle: 'Почніть створювати свою першу подію, щоб поділитись нею!',
      emptyCoursesTitle: 'Курсів ще не створено',
      emptyCoursesSubtitle: 'Почніть створювати свій перший курс, щоб поділитись знаннями!',
      emptyFilterTitle: 'Нічого не знайдено',
      emptyFilterSubtitle: 'Спробуйте обрати інший фільтр.',
      loadErrorTitle: 'Не вдалося завантажити список',
      loadErrorSubtitle: 'Ваші події та курси на місці – просто не вдалося їх отримати. Спробуйте ще раз.',
      retry: 'Спробувати ще раз',
      profileUnavailableTitle: 'Профіль не завантажився',
      profileUnavailableSubtitle: 'Ми не змогли перевірити вашу роль організатора. Спробуйте ще раз.',
      createEvent: 'Створити подію',
      createCourse: 'Створити курс',
      actionEdit: 'Редагувати',
      actionDuplicate: 'Дублювати',
      actionArchive: 'Архівувати',
      actionUnarchive: 'Розархівувати',
      actionCancel: 'Скасувати',
      actionReactivate: 'Реактивувати',
      actionViewStudents: 'Учасники',
      actionDelete: 'Видалити',
      backToDashboard: 'Назад до панелі управління',
      noAccess: 'У вас немає доступу до цієї сторінки.',
    },

    // Course Details
    course: {
      about: 'Про курс',
      curriculum: 'Навчальний план',
      instructors: 'Інструктори',
      reviews: 'Відгуки',
      enroll: 'Записатися на курс',
      startLearning: 'Почати навчання',
      price: 'Ціна',
      free: 'Безкоштовно',
      duration: 'Тривалість',
      level: 'Рівень',
      language: 'Мова',
      certificate: 'Сертифікат',
      yes: 'Так',
      no: 'Ні',
      students: 'Учасники',
      rating: 'Рейтинг',
      whatYouWillLearn: 'Що ви вивчите',
      requirements: 'Вимоги',
      description: 'Опис',
    },

    // Course Builder
    courseBuilder: {
      title: 'Конструктор курсів',
      backToDashboard: 'Назад до панелі управління',
      editingCourse: 'Редагування курсу',
      creatingNewCourse: 'Створення нового курсу',
      newCourse: 'Новий курс',
      saved: 'Збережено',
      savedAt: 'Збережено о',
      lastSavedAt: 'Останнє збереження',
      courseLink: 'Посилання на курс',
      shareCourse: 'Поділитись курсом',
      shareCourseLink: 'Поділитись посиланням на курс',
      copy: 'Копіювати',
      copied: 'Скопійовано!',
      createCourse: 'Створити новий курс',
      editCourse: 'Редагувати курс',
      courseTitle: 'Назва курсу',
      courseDescription: 'Опис курсу',
      category: 'Категорія',
      selectCategory: 'Виберіть категорію',
      level: 'Рівень',
      selectLevel: 'Виберіть рівень',
      duration: 'Тривалість (години)',
      price: 'Ціна (грн)',
      free: 'Безкоштовний курс',
      addSection: 'Додати розділ',
      addLesson: 'Додати урок',
      save: 'Зберегти',
      publish: 'Опублікувати',
      draft: 'Чернетка',
      published: 'Опубліковано',
      preview: 'Попередній перегляд',
      studentViewPreview: 'Попередній перегляд для студентів',
      previewBadge: 'ПОПЕРЕДНІЙ ПЕРЕГЛЯД',
      closePreview: 'Закрити попередній перегляд',
      delete: 'Видалити',
      checkingAccessPermissions: 'Перевірка прав доступу...',
      createAndOrganizeCourseContent: 'Створюйте та організовуйте вміст вашого курсу',
      saveCourse: 'Зберегти курс',
      saving: 'Зберігається...',
      coursePublishedSuccessfully: 'Курс успішно опубліковано',
      courseUnpublishedSuccessfully: 'Публікацію курсу скасовано',
      errorChangingCourseStatus: 'Помилка зміни статусу курсу',
      pleaseSaveCourseFirst: 'Спочатку збережіть курс',
      pleaseEnterCourseTitle: 'Будь ласка, введіть назву курсу',
      contentBlocksLabel: 'Блоки курсу',
      courseInformation: 'Інформація про курс',
      enterCourseTitle: 'Введіть назву курсу...',
      enterCourseDescription: 'Введіть опис курсу...',
      organizerName: 'Назва організації',
      enterOrganizerName: 'Введіть назву організації або ваше ім\'я...',
      medicalSpecialty: 'Медична спеціальність',
      selectSpecialty: 'Виберіть спеціальність...',
      courseFormat: 'Формат курсу',
      online: 'Онлайн',
      inPerson: 'Очно',
      hybrid: 'Гібридний',
      selfPaced: 'Самостійне навчання',
      locationAddress: 'Місцезнаходження/Адреса',
      enterVenueAddress: 'Введіть адресу місця проведення...',
      startDate: 'Дата початку',
      endDate: 'Дата завершення',
      coursePrice: 'Вартість курсу (грн)',
      cpdCredits: 'Бали БПР',
      maxParticipants: 'Максимальна кількість учасників',
      leaveEmptyForUnlimited: 'Залиште порожнім для необмеженої кількості',
      courseImage: 'Зображення курсу',
      uploadImage: 'Завантажити зображення',
      certificateTemplate: 'Шаблон сертифіката',
      advanced: 'Розширені',
      previewCertificate: 'Попередній перегляд сертифіката',
      loadExampleTemplate: 'Завантажити приклад шаблону',
      clearTemplate: 'Очистити шаблон',
      courseContent: 'Зміст курсу',
      blocks: 'блоків',
      noContentBlocks: 'Блоків ще немає',
      startBuildingCourse: 'Почніть створювати свій курс, додаючи блоки з лівої панелі.',
      contentBlocks: {
        text: 'Текст',
        video: 'Відео',
        pdf: 'PDF',
        image: 'Зображення',
        quiz: 'Тест',
        assignment: 'Завдання',
        lesson: 'Урок',
        test: 'Тест',
        survey: 'Опитування',
        videoEmbed: 'Відео',
        textBlock: 'Текст',
        pdfDocument: 'PDF',
        testBlock: 'Тест',
        surveyBlock: 'Опитування',
        lessonDesc: 'Створіть урок для групування блоків',
        videoEmbedDesc: 'Додавайте відео з YouTube або Vimeo',
        textBlockDesc: 'Додавайте текстовий вміст та форматування',
        pdfDocumentDesc: 'Завантажуйте та відображайте PDF файли',
        imageDesc: 'Завантажуйте та відображайте зображення',
        testBlockDesc: 'Додайте тест для оцінки знань студентів',
        surveyBlockDesc: 'Додайте опитування для збору відгуків',
        enterTitle: 'Введіть назву уроку',
        enterDescription: 'Введіть опис уроку',
        lessonTitle: 'Назва уроку',
        lessonDescription: 'Опис уроку',
      },
      addBlock: 'Додати блок',
      addToLesson: 'Додати до уроку',
      dragContentBlocksIntoLesson: 'Перетягуйте інші блоки всередину цього уроку',
      dropBlockHere: 'Відпустіть блок тут',
      noContentInLesson: 'Немає вмісту в уроці',
      knowledgeTest: 'Фінальний тест',
      editTest: 'Редагувати тест',
      addTest: 'Додати тест',
      courseSurvey: 'Фінальне опитування',
      editSurvey: 'Редагувати опитування',
      addSurvey: 'Додати опитування',
      noTestCreated: 'Тест ще не створено',
      addKnowledgeTest: 'Додайте тест знань для оцінки навчання студентів',
      noSurveyCreated: 'Опитування ще не створено',
      addFeedbackSurvey: 'Додайте опитування для збору думок студентів',
      collapse: 'Згорнути',
      expand: 'Розгорнути',
      videoBlock: 'Відео',
      videoEmbedBlock: 'Вставка відео',
      textBlockLabel: 'Текстовий блок',
      pdfDocumentBlock: 'PDF документ',
      documentBlock: 'Документ',
      presentationBlock: 'Презентація',
      audioBlock: 'Аудіо',
      linkBlock: 'Зовнішнє посилання',
      imageBlock: 'Зображення',
      lessonBlock: 'Урок',
      blockTitle: 'Назва блоку',
      content: 'Вміст',
      enterBlockTitle: 'Введіть назву блоку...',
      enterTextHere: 'Введіть ваш текст тут...',
      enterContentHere: 'Введіть ваш вміст тут... Ви можете використовувати Markdown форматування.',
      supportsMarkdown: 'Підтримує Markdown форматування. Використовуйте кнопки панелі інструментів або вводьте вручну.',

      // Video Block Translations
      videoUrl: 'URL відео',
      pasteVideoUrl: 'Вставте URL YouTube або Vimeo тут...',
      supportsYoutubeVimeo: 'Підтримує URL YouTube та Vimeo',
      validVideoUrl: '✓ Дійсний URL відео',
      invalidVideoUrl: '✗ Недійсний URL відео',
      enterValidUrl: 'Будь ласка, введіть дійсний URL YouTube або Vimeo',
      viewOriginalLink: 'Переглянути оригінальне посилання',
      videoPreviewHere: 'Попередній перегляд відео з\'явиться тут',

      // Navigation
      navigation: {
        mainSections: 'Основні розділи',
        organizer: 'Організатор',
        courseDetails: 'Деталі курсу',
        additionalOptions: 'Додаткові опції',
        statistics: 'Статистика',
        certificates: 'Сертифікати',
        tickets: 'Квитки',
        promocodes: 'Промокоди',
        toAccessAdditionalOptions: 'Для доступу до додаткових опцій',
        enterCourseTitle: 'Введіть назву курсу',
        enterOrganizerName: 'Введіть ім\'я організатора',
        enterOrganizerEmail: 'Введіть email організатора',
        fillInTitleAndOrganizer: 'Заповніть назву курсу та організатора, щоб отримати доступ до додаткових налаштувань.',
      },
      // Free registration
      freeRegistration: 'Безкоштовна реєстрація',
      freeAccess: 'Безкоштовний доступ',
      // Name of the ticket auto-created with a brand-new event
      defaultTicketName: 'Реєстрація',

      // Image Block Translations
      imageLabel: 'Зображення',
      altText: 'Альтернативний текст (для доступності)',
      describeImage: 'Опишіть, що показує зображення...',
      altTextHelper: 'Альтернативний текст допомагає програмам читання з екрана та з\'являється, коли зображення не може завантажитися',
      clickToUpload: 'Натисніть, щоб завантажити зображення',
      dragAndDrop: 'або перетягніть і відпустіть',
      pngJpgGif: 'PNG, JPG, GIF до 5МБ',
      uploadingImage: 'Завантаження зображення...',
      removeImage: 'Видалити зображення',
      failedToLoadImage: 'Не вдалося завантажити зображення',

      // PDF Block Translations
      pdfDocument: 'PDF документ',
      clickToUploadPdf: 'Натисніть, щоб завантажити PDF',
      pdfFilesUp10MB: 'PDF файли до 10МБ',
      uploadingPdf: 'Завантаження PDF...',
      pdfPreview: 'Попередній перегляд PDF',
      clickDownloadToView: 'Натисніть кнопку завантаження, щоб переглянути повний документ',
      viewPdf: 'Переглянути PDF',
      openPdf: 'Відкрити PDF',
      removePdf: 'Видалити PDF',
      pleaseSelectPdf: 'Будь ласка, оберіть PDF файл.',
      fileSizeLess10MB: 'Розмір файлу повинен бути менше 10МБ.',
      pleaseDropPdf: 'Будь ласка, перетягніть PDF файл.',
      uploadError: 'Помилка завантаження файлу. Спробуйте ще раз.',
      randomizeQuestionOrder: 'Випадковий порядок питань',
      availablePlaceholders: 'Доступні параметри:',
      placeholderDescription: 'Залиште порожнім, щоб використовувати стандартний шаблон сертифіката. Підтримуються HTML, CSS та вбудовані стилі.',
      certificateTemplatePlaceholder: 'Введіть власний HTML шаблон для сертифікатів (необов\'язково)...',
      certificateDescription: 'Налаштуйте шаблон сертифіката для учасників курсу',
      pleaseAddCertificateTemplateFirst: 'Спочатку додайте HTML шаблон сертифіката',

      // Private course
      privateCourseLabel: 'Приватний курс',
      privateCourseDescription: 'Приватні курси не відображаються публічно та потребують посилання-запрошення',

      // Publishing validation
      pleaseSelectAtLeastOneSpecialty: 'Будь ласка, оберіть принаймні одну цільову аудиторію',
      pleaseAddAtLeastOneBlock: 'Будь ласка, додайте принаймні один блок контенту',
      pleaseEnterOrganizerPhone: 'Будь ласка, введіть телефон організатора',

      // Publishing requirements panel
      publishRequirements: 'Вимоги для публікації',
      requirementCourseTitle: 'Введіть назву курсу',
      requirementOrganizer: 'Заповніть дані організатора',
      requirementSpecialties: 'Оберіть цільову аудиторію',
      requirementContent: 'Додайте контент курсу',
    },

    // Footer
    footer: {
      about: 'CONFY',
      aboutText: 'CONFY – медичні події і курси. Безперервний професійний розвиток для медичних працівників',
      quickLinks: 'Швидкі посилання',
      courses: 'Курси',
      events: 'Події',
      contact: 'Контакти',
      support: 'Підтримка',
      reportBug: 'Повідомити про помилку',
      organizer: 'Організатору',
      legal: 'Юридична інформація',
      privacy: 'Політика конфіденційності',
      terms: 'Умови використання',
      cookies: 'Політика cookie',
      followUs: 'Слідкуйте за нами',
      rights: 'Всі права захищені',
      paymentsAccepted: 'Приймаємо:',
    },

    // Terms page
    terms: {
      title: 'Угода користувача',
    },

    // Privacy page
    privacy: {
      title: 'Політика конфіденційності',
    },

    // Common
    session: {
      expired: 'Ваша сесія закінчилася. Будь ласка, оновіть сторінку, щоб продовжити.',
    },

    common: {
      announcement: {
        text: 'Ми оновили платформу! Якщо ви помітите помилку, будь ласка, повідомте нам.',
        reportBug: 'Повідомити про помилку',
      },
      all: 'Всі',
      loading: 'Завантаження...',
      updating: 'Оновлення...',
      error: 'Помилка',
      success: 'Успішно',
      cancel: 'Скасувати',
      save: 'Зберегти',
      saving: 'Збереження...',
      saved: 'Збережено',
      processing: 'Обробка…',
      autoSaving: 'Автозбереження...',
      publish: 'Опублікувати',
      unsavedChanges: 'Незбережені зміни',
      backToDashboard: 'Повернутися до панелі',
      delete: 'Видалити',
      remove: 'Прибрати',
      edit: 'Редагувати',
      view: 'Переглянути',
      upload: 'Завантажити',
      close: 'Закрити',
      next: 'Далі',
      previous: 'Назад',
      submit: 'Відправити',
      confirm: 'Підтвердити',
      required: "Обов'язкове поле",
      optional: 'необов\'язково',
      yes: 'Так',
      or: 'або',
      no: 'Ні',
      search: 'Пошук',
      filter: 'Фільтр',
      sort: 'Сортувати',
      select: 'Обрати',
      selectAll: 'Вибрати все',
      note: 'Примітка',
      noResults: 'Немає результатів',
      tryAgain: 'Спробувати знову',
      retry: 'Повторити',
      done: 'Готово',
      share: 'Поділитись',
      copied: 'Скопійовано!',
      copyFailed: 'Не вдалося скопіювати',
      linkCopied: 'Посилання скопійовано!',
      comingSoon: 'Незабаром',
      learnMore: 'Дізнатися більше',
      start: 'Початок',
      end: 'Кінець',
      completed: 'Завершено',
      progress: 'Прогрес',
      course: 'курс',
      event: 'подія',
      promocodes: 'Промокоди',
      errorLoadingData: 'Помилка завантаження даних',
      showing: 'Показано',
      of: 'з',
      events: 'подій',
      showMore: 'Показати більше',
      loadMore: 'Завантажити ще',
      remaining: 'залишилось',
      noMore: 'Все завантажено',
      backToHome: 'На головну',
      datePicker: {
        selectDate: 'Виберіть дату',
        clearDate: 'Очистити дату',
        openCalendar: 'Відкрити календар',
        time: 'Час',
        datePlaceholder: 'дд.мм.рррр',
        dateTimePlaceholder: 'дд.мм.рррр гг:хх',
        hourPlaceholder: 'ГГ',
        minutePlaceholder: 'ХХ',
        hourError: 'Години мають бути від 0 до 23',
        minuteError: 'Хвилини мають бути від 0 до 59',
        errorFormat: 'Перевірте формат. Приклади:',
        exampleDate: '24.04.2025',
        exampleDateTime: '24.04.2025 14:30',
        errorMinDate: 'Дата не може бути в минулому',
        errorMaxDate: 'Дата перевищує максимально допустиму',
        warningTimeAfter: 'Час має бути після',
      },
      availabilityWindow: {
        anchorAbsolute: 'Дата/час',
        anchorEventStart: 'Початок події',
        anchorEventEnd: 'Кінець події',
        resolvesTo: 'Розраховується як:',
        eventDateNotSet: 'Дату події ще не встановлено – це обмеження не діятиме, доки ви її не встановите.',
      },
    },

    offlinePayment: {
      reserveTitle: 'Зарезервувати місце',
      reserveSubtitle: 'Оплата приймається офлайн. Підтвердіть бронювання, і ви отримаєте інструкції для оплати.',
      amountDue: 'До сплати',
      confirmReservation: 'Підтвердити бронювання',
      reserveSuccess: 'Місце заброньовано! Перевірте пошту для інструкцій з оплати.',
      awaitingBanner: 'Очікується підтвердження оплати організатором. Дивіться інструкції в листі.',
      awaitingBadge: 'Очікує оплату',
      markAsPaid: 'Позначити оплаченим',
      markAsPaidSuccess: 'Оплату підтверджено',
      markAsPaidFailed: 'Не вдалося підтвердити оплату',
      cancelReservation: 'Скасувати бронювання',
      cancelReservationSuccess: 'Бронювання скасовано',
      cancelReservationFailed: 'Не вдалося скасувати бронювання',
    },

    // Share functionality
    share: {
      title: 'Поділитись',
      copyLink: 'Копіювати посилання',
      generatingLink: 'Генерація посилання...',
      orShareVia: 'або надіслати через',
      sendViaTelegram: 'Надіслати в Telegram',
      sendViaViber: 'Надіслати в Viber',
      sendViaEmail: 'Надіслати на email',
      shareOnLinkedIn: 'Поділитись в LinkedIn',
      shareOnFacebook: 'Поділитись в Facebook',
      qrCode: 'QR-код',
      downloadQR: 'QR-код завантажено',
    },

    // In-app Notifications
    notifications: {
      title: 'Сповіщення',
      empty: 'Немає нових сповіщень',
      markAllRead: 'Прочитати все',
      markAsRead: 'Позначити як прочитане',
      viewDetails: 'Переглянути деталі',
      justNow: 'Щойно',
      minutesAgo: '{count} хв тому',
      hoursAgo: '{count} год тому',
      daysAgo: '{count} дн тому',
    },

    // Participants Statistics
    participants: {
      title: 'Статистика учасників',
      subtitle: 'Демографічні дані та аналітика',
      total: 'Всього учасників',
      certificates: 'Сертифікати видано',
      specialties: 'Спеціальностей',
      regions: 'Регіонів',
      specialtyDistribution: 'Розподіл за спеціальностями',
      regionDistribution: 'Розподіл за регіонами',
      ageDistribution: 'Розподіл за віком',
      ticketDistribution: 'Розподіл за квитками',
      topCities: 'Топ міста',
      completionStatus: 'Статус завершення',
      registrationTimeline: 'Динаміка реєстрацій',
      noData: 'Немає даних для відображення',
      noParticipantsYet: 'Поки немає учасників',
      noParticipantsMessage: 'Статистика з\'явиться після реєстрації перших учасників',
      status: {
        registered: 'Зареєстровано',
        started: 'Розпочато',
        testsPassed: 'Тести здано',
        testsFailed: 'Тести не здано',
        surveysCompleted: 'Опитування завершено',
        certificateIssued: 'Сертифікат видано',
      },
    },

    // Analytics
    analytics: {
      title: 'Аналітика',
      subtitle: 'Дохід, відвідуваність та аудиторія',
      tabs: { money: 'Дохід і попит', operations: 'Відвідуваність', demographics: 'Аудиторія', livestream: 'Трансляція' },
      noData: 'Немає даних для відображення',
      money: {
        free: 'Безкоштовна подія – дохід відсутній',
        totalRevenue: 'Загальний дохід', paidOrders: 'Оплачені замовлення', avgOrder: 'Середній чек',
        salesTimeline: 'Динаміка продажів', revenueByTicket: 'Дохід за квитками',
        refunded: 'Повернено', netRevenue: 'Чистий дохід', grossRevenue: 'Валовий дохід',
      },
      ops: {
        registered: 'Зареєстровані', attended: 'Відвідали', noShow: 'Не з\'явились',
        attendanceRate: 'Відвідуваність', certificates: 'Отримали сертифікат', passRate: 'Складання тестів',
        engaged: 'Взяли участь', testsPassed: 'Склали тест', pending: 'очікують', completed: 'Завершили',
        funnel: 'Воронка проходження', timing: 'Коли складають тести', avgProgress: 'Середній прогрес',
        timingHourly: 'Складання тестів по годинах', hourAxis: 'год',
        timingHourlyHint: 'Годин після початку події (0-1 – перша година)',
        timingBuckets: { before: 'До початку', first_6h: 'Перші 6 год', '6_24h': '6–24 год', '1_7d': '1–7 днів', later: 'Пізніше', unknown: 'Невідомо' },
        funnelStages: { registered: 'Зареєстровані', started: 'Взяли участь', tests_passed: 'Склали тест', certificate_issued: 'Отримали сертифікат' },
      },
      demo: {
        total: 'Всього учасників', specialty: 'Спеціальності', region: 'Регіони',
        city: 'Топ міста', age: 'Вік', ticket: 'Квитки',
        specialtiesCount: 'Спеціальностей', regionsCount: 'Регіонів', topCity: 'Топ місто',
        topRegions: 'Топ регіони', mapLess: 'менше', mapMore: 'більше', others: 'Інші',
        registrationTimeline: 'Динаміка реєстрацій',
      },
      share: {
        button: 'Поділитись звітом',
        title: 'Поділитись звітом',
        subtitle: 'Публічне посилання на звіт для партнерів (аудиторія та відвідуваність)',
        create: 'Створити посилання', label: 'Назва (необов\'язково)', labelPlaceholder: 'Напр. Спонсор X',
        expiry: 'Діє до (необов\'язково)', copy: 'Копіювати', copied: 'Посилання скопійовано', revoke: 'Відкликати',
        active: 'Активне', expired: 'Прострочене', revoked: 'Відкликане', noLinks: 'Ще немає посилань',
        created: 'Створено', downloadPdf: 'Завантажити PDF', downloadReport: 'Завантажити звіт', viewOnline: 'Переглянути онлайн', reportFor: 'Звіт по події',
        invalid: 'Посилання недійсне або відкликане', poweredBy: 'Підготовлено на платформі CONFY',
        error: 'Помилка',
      },
      adjusted: {
        button: 'Скоригований звіт', title: 'Скоригований звіт',
        subtitle: 'Лише для суперадміністраторів: публічне посилання з цільовими показниками. Реальні дані не змінюються.',
        metric: 'Показник', real: 'Фактично', target: 'Ціль', factor: 'Множник', apply: 'Застосувати',
        registered: 'Зареєстровані', engaged: 'Взяли участь', testsPassed: 'Склали тест', certificates: 'Отримали сертифікат',
        belowReal: 'Буде показано фактичне значення', preview: 'Попередній перегляд', previewError: 'Не вдалося побудувати попередній перегляд',
        create: 'Створити скориговане посилання', created: 'Скориговане посилання створено та скопійовано', badge: 'Скориговане',
        links: 'Скориговані посилання', noLinks: 'Ще немає скоригованих посилань', targets: 'Цілі',
        engagedAboveRegistered: 'Взяли участь не може перевищувати зареєстрованих',
      },
      livestream: {
        soon: 'Статистика трансляції – незабаром', soonDesc: 'Тут з\'явиться кількість глядачів YouTube/Vimeo під час події.',
        title: 'Трансляція', badge: 'Трансляція',
        views: 'Всього переглядів трансляції', watch: 'Середній час перегляду', concurrent: 'У середньому одночасно в етері',
        watchRecording: 'Дивитися запис',
        empty: 'Статистика трансляції ще не додана', emptyDesc: 'Додайте перегляди, час перегляду та посилання на запис вручну.',
        add: 'Додати трансляцію', edit: 'Редагувати', save: 'Зберегти', cancel: 'Скасувати', remove: 'Видалити',
        saved: 'Статистику збережено', saveError: 'Не вдалося зберегти статистику', invalidWatch: 'Невірний формат часу (мм:сс)',
        invalidUrl: 'Невірне посилання – використовуйте http:// або https://',
        streamN: 'Трансляція', streamLabel: 'Назва (необовʼязково)', labelPlaceholder: 'Напр.: День 1 – Основна сцена',
        recordingUrl: 'Посилання на запис', watchHint: 'Формат мм:сс, напр. 6:12',
        recordingSelect: 'Оберіть відеозапис події', recordingOther: 'Інше посилання',
        recordingMadePublic: 'Запис тепер доступний за публічним посиланням', recordingsError: 'Не вдалося завантажити записи події',
      },
    },

    // Restricted Access Message
    restrictedAccess: {
      title: 'Доступ обмежено',
      message: 'Ваш квиток не включає доступ до {{featureName}}.',
      contactOrganizer: 'Будь ласка, зв\'яжіться з організатором події, якщо ви вважаєте, що це помилка.',
    },


    // Enhanced Dashboard
    enhancedDashboard: {
      organizerDashboard: 'Панель організатора',
      myDashboard: 'Моя панель управління',
      welcomeBack: 'Ласкаво просимо',
      backToHomepage: 'Повернутися на головну',
      addCourse: 'Додати курс',
      addEvent: 'Додати подію',
      emailNewsletters: 'Маркетингові розсилки',
      course: 'Курс',
      event: 'Подія',
      myCourses: 'Мої курси',
      myEvents: 'Мої події',
      totalStudents: 'Всього учасників',
      totalCourses: 'Всього курсів',
      certificates: 'Сертифікати',
      inProgress: 'В процесі',
      students: 'Учасники',
      myCreatedCourses: 'Створені мною курси',
      myCreatedEvents: 'Створені мною події',
      noEventsCreated: 'Подій ще не створено',
      createFirstEvent: 'Почніть створювати свою першу подію, щоб поділитись нею!',
      createYourFirstEvent: 'Створити свою першу подію',
      noPublishedEvents: 'Немає опублікованих подій',
      noDraftEvents: 'Немає чернеток подій',
      noArchivedEvents: 'Немає архівованих подій',
      noPastEvents: 'Ще немає проведених подій',
      noPastEventsHelp: 'Спробуйте обрати інший фільтр, щоб побачити події.',
      noEventsInFilter: 'Немає подій з таким фільтром',
      tryDifferentFilterEvent: 'Спробуйте обрати інший фільтр, щоб побачити події.',
      noEventsYet: 'Подій ще немає',
      notEnrolledInEventsYet: 'Ви ще не записалися на жодну подію. Почніть вивчати наш каталог подій!',
      editEvent: 'Редагувати подію',
      viewEvent: 'Переглянути подію',
      noCoursesCreated: 'Курсів ще не створено',
      createFirstCourse: 'Почніть створювати свій перший курс, щоб поділитись своїми знаннями!',
      createYourFirstCourse: 'Створити свій перший курс',
      noPublishedCourses: 'Немає опублікованих курсів',
      noDraftCourses: 'Немає чернеток курсів',
      noArchivedCourses: 'Немає архівованих курсів',
      noPastCourses: 'Ще немає проведених курсів',
      noPastCoursesHelp: 'Спробуйте обрати інший фільтр, щоб побачити курси.',
      noCoursesInFilter: 'Немає курсів з таким фільтром',
      tryDifferentFilterCourse: 'Спробуйте обрати інший фільтр, щоб побачити курси.',
      created: 'Створено',
      starts: 'Початок',
      unpublish: 'Зняти з публікації',
      publish: 'Опублікувати',
      editCourse: 'Редагувати курс',
      viewCourse: 'Переглянути курс',
      viewAnalytics: 'Переглянути аналітику',
      analyticsComingSoon: 'Аналітика незабаром!',
      deleteConfirm: 'Ви впевнені, що хочете видалити',
      unknownError: 'Невідома помилка',
      unexpectedError: 'Сталася неочікувана помилка. Спробуйте ще раз.',
      enrolledCourses: 'Мої курси',
      noCoursesYet: 'Курсів ще немає',
      notEnrolledYet: 'Ви ще не записалися на жодний курс. Почніть вивчати наш каталог курсів!',
      materials: 'Матеріали',
      required: 'обов\'язково',
      tests: 'Тести',
      surveys: 'Опитування',
      tickets: 'Квитки',
      purchased: 'Придбано',
      free: 'Безкоштовно',
      issued: 'Видано',
      continueLearning: 'Продовжити навчання',
      viewCertificate: 'Сертифікат',
      generateCertificate: 'Згенерувати сертифікат',
      loadingDashboard: 'Завантаження панелі управління...',
      noEnrolledCourses: 'Ви ще не записані на жоден курс',
      browseCoursesToEnroll: 'Перегляньте наші курси та почніть навчання',
      browseCourses: 'Переглянути курси',
      noEnrolledEvents: 'Ви ще не записані на жодну подію',
      browseEventsToEnroll: 'Перегляньте наші події та зареєструйтесь',
      browseEvents: 'Переглянути події',
      featured: {
        title: 'Актуальні події та курси',
        subtitle: 'Переглядайте доступні події та реєструйтесь',
      },
      pleaseSignIn: 'Будь ласка, увійдіть, щоб переглянути свою панель управління.',
      createNewCourse: 'Створити новий курс',
      chooseCreateMethod: 'Виберіть, як ви хочете створити вміст курсу. Ви можете створити його за допомогою нашого редактора перетягування з різними типами вмісту.',
      startWithCourseBuilder: 'Почати з конструктора курсів',
      useDragAndDrop: 'Використовуйте наш редактор перетягування для створення багатого вмісту курсу',
      useTemplate: 'Використати шаблон',
      startWithPrebuilt: 'Почніть з готового шаблону курсу',
      importContent: 'Імпортувати вміст',
      importExisting: 'Імпортувати існуючі матеріали курсу',
      templateComingSoon: 'Опція шаблону незабаром!',
      importComingSoon: 'Опція імпорту незабаром!',
      completed: 'Завершено',
      progress: 'Прогрес',
      studentsEnrolled: 'Учасники',
      viewEnrolledStudents: 'Переглянути записаних учасників',
      enrolledStudentsList: 'Список учасників',
      enrolledOn: 'Записано',
      noStudentsEnrolled: 'Немає записаних учасників',
      noStudentsEnrolledDesc: 'Поки що на цей курс не записалися учасники.',
      studentName: 'Ім\'я учасника',
      studentEmail: 'Email учасника',
      enrollmentDate: 'Дата запису',
      paymentStatus: 'Статус оплати',
      courseProgress: 'Прогрес курсу',
      creator: 'Автор',
      learner: 'Студент',
      more: 'Більше',
      noPermission: 'У вас немає прав для виконання цієї дії',
    },

    // Mini-CRM / Student Management
    miniCrm: {
      title: 'Управління студентами',
      studentDirectory: 'Довідник студентів',
      backToEvent: 'Назад до події',
      filters: 'Фільтри',
      showFilters: 'Показати фільтри',
      hideFilters: 'Приховати фільтри',
      clearAllFilters: 'Скинути фільтри',
      search: 'Пошук',
      searchPlaceholder: 'Пошук за ім\'ям, email або телефоном...',

      // Filters
      include: 'Включити',
      exclude: 'Виключити',
      includeFilters: 'Включити фільтри',
      excludeFilters: 'Виключити фільтри',
      ticketTypes: 'Типи квитків',
      selectTicketTypes: 'Виберіть типи квитків',
      noTicketTypes: 'Немає типів квитків',
      promoCodes: 'Промокоди',
      promoCode: 'Промокод',
      noPromoCode: 'Без промокоду',
      paidAmount: 'Сплачено',
      paidAmountMin: 'Від',
      paidAmountMax: 'До',
      paidAmountHelp: 'Сума у валюті заходу, фактично сплачена учасником (0 включає безкоштовних та зі знижкою 100%).',
      specialties: 'Спеціальності',
      selectSpecialties: 'Виберіть спеціальності',
      noSpecialties: 'Немає спеціальностей',
      clearAllSpecialties: 'Очистити все',
      clearSpecialtiesConfirmTitle: 'Очистити всі спеціальності?',
      clearSpecialtiesConfirmMessage: 'Ви впевнені, що хочете очистити всі вибрані спеціальності? Цю дію не можна скасувати.',
      specialtyScopePrimary: 'Основна',
      specialtyScopeAny: 'Будь-яка',
      secondarySpecialties: 'Додаткові спеціальності',
      attendanceStatus: 'Статус відвідування',
      attended: 'Відвідав',
      notAttended: 'Не відвідав',
      assessmentStatus: 'Тести та опитування',
      completedRequiredAssessments: 'Завершив',
      notCompletedRequiredAssessments: 'Не завершив',
      testStatus: 'Статус тесту',
      testPassed: 'Тест здано',
      testNotPassed: 'Тест не здано',
      completionStatus: 'Статус виконання',
      completionStatuses: {
        registered: 'Зареєстровано',
        started: 'Розпочато',
        tests_passed: 'Тести здано',
        tests_failed: 'Тести не здано',
        surveys_completed: 'Опитування пройдено',
        certificate_issued: 'Сертифікат отримано',
      },
      filterMode: 'Режим',
      matchAny: 'Будь-який',
      matchAll: 'Усі',
      milestoneYes: 'Так',
      milestoneNo: 'Ні',

      // Actions
      selectAll: 'Вибрати всіх',
      deselectAll: 'Скасувати вибір',
      sendEmail: 'Надіслати email',
      selectRecipientsFirst: 'Будь ласка, виберіть отримувачів перед надсиланням листа',
      sendSMS: 'Надіслати SMS',
      exportList: 'Експортувати список',

      // Table
      name: 'ПІБ',
      email: 'Email',
      emailAndPhone: 'Email та номер телефону',
      phone: 'Телефон',
      ticketType: 'Тип квитка',
      specialty: 'Спеціальність',
      registered: 'Зареєстровано',
      status: 'Статус',
      noData: 'Немає даних',

      // Stats
      showingStudents: 'Показано',
      ofStudents: 'з',
      students: 'учасників',
      selected: 'вибрано',
      participantsOnPageSelected: 'учасників на цій сторінці вибрано.',
      selectAllParticipants: 'Вибрати всіх ${count} учасників',
      allParticipantsSelected: 'Всіх ${count} учасників вибрано.',
      clearSelection: 'Скинути вибір',
      includeFutureRegistrants: 'Включити майбутні реєстрації',
      noStudentsEnrolled: 'Учасники ще не зареєстровані',
      noStudentsMatch: 'Жодних учасників не знайдено за вашим запитом',

      // Email Modal
      emailCompose: 'Надіслати email',
      emailTo: 'Кому',
      emailSubject: 'Тема',
      emailSubjectPlaceholder: 'Введіть тему email...',
      emailBody: 'Повідомлення',
      emailBodyPlaceholder: 'Введіть повідомлення email...',
      insertVariable: 'Вставити змінну',
      insertVariables: 'Вставити змінні',
      preview: 'Попередній перегляд',
      noSubject: '(Немає теми)',
      noMessage: '(Немає повідомлення)',
      send: 'Надіслати',
      sending: 'Надсилання...',
      cancel: 'Скасувати',
      emailSentSuccess: 'Email успішно надіслано',
      emailSentTo: 'Email надіслано до',
      recipients: 'отримувачів',

      // SMS Modal
      smsCompose: 'Написати SMS',
      smsTo: 'Кому',
      smsMessage: 'Повідомлення',
      smsMessagePlaceholder: 'Введіть SMS повідомлення (макс. 160 символів)...',
      charLimit: 'Ліміт символів',
      charsRemaining: '{count} символів залишилось',
      charsOver: 'Повідомлення перевищує на {count} символів',
      smsSentSuccess: 'SMS успішно надіслано',
      smsSentTo: 'SMS надіслано до',
      fillAllFields: 'Будь ласка, заповніть всі поля',

      // Variables
      variables: 'Змінні',
      variablesHelp: 'Використовуйте {{ім\'я_змінної}} для персоналізації',
      availableVariables: 'Доступні змінні',
      firstName: 'first_name',
      lastName: 'last_name',
      emailVar: 'email',
      phoneVar: 'phone',
      eventTitle: 'event_title',

      // Variable Labels
      varLabels: {
        first_name: 'Ім\'я',
        last_name: 'Прізвище',
        email: 'Email',
        phone: 'Телефон',
        event_title: 'Назва події',
      },

      // Formatting
      bold: 'Жирний',
      italic: 'Курсив',
      underline: 'Підкреслений',
      heading1: 'Заголовок 1',
      heading2: 'Заголовок 2',
      bulletList: 'Маркований список',
      numberedList: 'Нумерований список',

      // Errors
      noRecipients: 'Немає отримувачів',
      selectRecipients: 'Будь ласка, виберіть отримувачів',
      sendFailed: 'Не вдалося надіслати',
      loadFailed: 'Не вдалося завантажити дані',
      failedToSendEmails: 'Не вдалося надіслати ${failCount} email',
      failedToSendSms: 'Не вдалося надіслати ${failCount} SMS повідомлень',
      failedToScheduleEmails: 'Не вдалося запланувати ${failCount} email',

      // Unified CRM
      unifiedCRM: 'Керуйте своїми учасниками',
      studentManagement: 'Управління учасниками',
      allStudents: 'Всі учасники ваших подій та курсів',
      contentType: 'Тип контенту',
      eventsOnly: 'Тільки події',
      coursesOnly: 'Тільки курси',
      filterByContent: 'Фільтр за подією/курсом',
      searchContent: 'Пошук подій/курсів...',
      noMatchingContent: 'Не знайдено відповідних подій/курсів',
      eventCourse: 'Подія/Курс',
      event: 'Подія',
      course: 'Курс',
      clickToSeeResponses: 'Клікніть, щоб побачити відповіді на додаткові питання',
      tip: '💡 Підказка',
      expandRowHint: 'Клікніть на будь-який рядок учасника, щоб побачити його відповіді на додаткові питання реєстрації.',
      additionalQuestionOne: 'додаткове питання',
      additionalQuestionFew: 'додаткових питання',
      additionalQuestionMany: 'додаткових питань',
      ticketQuestionsInfo: 'Відповіді на питання реєстрації',
      ticketQuestionsFilterTitle: 'Питання реєстрації',
      selectContentFirstForQuestions: 'Виберіть подію або курс, щоб фільтрувати за питаннями реєстрації',
      noTicketQuestionResponses: 'Учасники ще не відповіли на питання реєстрації квитка',
      ticketQuestionDownload: 'Завантажити',
      ticketQuestionDownloadFailed: 'Не вдалося отримати посилання на файл',
      ticketQuestionAnswered: 'Відповіли',
      ticketQuestionNotAnswered: 'Не відповіли',
      ticketQuestionFileUploaded: 'Документ завантажено',
      exportBlockedByQuestionFilter: 'Експорт недоступний, поки застосовано фільтр за питаннями реєстрації. Зніміть цей фільтр, щоб експортувати учасників.',
      selectAllBlockedByQuestionFilter: 'Вибір усіх учасників недоступний, поки застосовано фільтр за питаннями реєстрації',

      // Export
      export: 'Експорт',
      exporting: 'Експортування...',
      exportToExcel: 'Експортувати в Excel',
      exportSuccess: 'Експорт успішно завершено',
      exportFailed: 'Не вдалося експортувати учасників',
      noStudentsToExport: 'Немає учасників для експорту',

      // Student Management Actions
      noTicket: 'Без квитка',
      ticketUpdated: 'Квиток оновлено',
      ticketUpdateFailed: 'Не вдалося оновити квиток',
      deleteStudent: 'Видалити студента',
      studentDeleted: 'Студента видалено',
      deleteFailed: 'Не вдалося видалити студента',
      confirmDelete: 'Підтвердіть видалення',
      confirmDeleteMessage: 'Ви впевнені, що хочете видалити',
      fromEvent: 'з',
      deleteWarning: 'Цю дію неможливо скасувати.',
      deleting: 'Видалення...',

      // Organizer Actions
      actions: 'Дії',
      changeTicket: 'Змінити квиток',
      updatingTicket: 'Оновлення...',
      selectTicket: '– Оберіть квиток –',
      grantTestAndCertificate: 'Зарахувати тест і сертифікат',
      deleteCertificate: 'Видалити сертифікат',
      clearTestAttempts: 'Очистити спроби тесту',
      confirmGrantTestCert: 'Зарахувати тест (100%) і створити сертифікат для',
      confirmDeleteCert: 'Видалити сертифікат для',
      confirmClearAttempts: 'Очистити всі спроби тесту для',
      grantingTestCert: 'Зарахування...',
      deletingCertificate: 'Видалення...',
      clearingAttempts: 'Очищення...',
      testCertGranted: 'Тест зараховано, сертифікат створено',
      certificateDeleted: 'Сертифікат видалено',
      testAttemptsCleared: 'Спроби тесту очищено',
      noTestConfigured: 'Для цієї події не налаштовано тест',
      testAlreadyPassed: 'Успішна спроба тесту вже існує – сертифікат можна створити з інтерфейсу',
      certificateAlreadyExists: 'Сертифікат вже існує',
      noCertificateFound: 'Сертифікат не знайдено',
      noTestAttempts: 'Спроби тесту відсутні',
      enrollmentRefunded: 'Оплату за цю реєстрацію повернуто – дія недоступна.',
      bulkActions: 'Масові дії',
      bulkConfirm: 'для ${count} учасників',
      bulkResult: 'Виконано: ${succeeded} з ${total}',
      bulkPartialFail: 'Помилки: ${failed}',
      registerParticipant: 'Додати учасника',
      enterParticipantEmail: 'Введіть email учасника...',
      userNotFound: 'Користувача з таким email не знайдено',
      alreadyEnrolled: 'Цей учасник вже зареєстрований',
      invalidTicket: 'Невірний квиток для цієї події',
      ticketRequired: 'Для цієї події потрібно обрати квиток',
      participantRegistered: 'Учасника зареєстровано',
      registering: 'Реєстрація...',
      register: 'Зареєструвати',

      // Field Settings
      fieldSettings: 'Налаштування полів CRM',
      fieldSettingsDescription: 'Виберіть, які поля відображати в CRM та експортувати',
      fieldsSelected: 'полів вибрано',
      resetToDefaults: 'Скинути до типових',
      requiredField: 'Обов\'язкове поле (завжди видиме)',
      additionalFieldsNote: 'Всі додаткові поля реєстрації завжди видимі та доступні для фільтрації.',
      settings: 'Налаштування',

      // Email Templates Manager
      emailTemplates: 'Шаблони Email',
      emailTemplatesTitle: 'Шаблони Email',
      newEmailTemplate: 'Новий шаблон',
      templateName: 'Назва шаблону',
      templateNamePlaceholder: 'напр., Вітальний лист',
      emailTemplateSubject: 'Тема',
      emailTemplateSubjectPlaceholder: 'Тема листа з підтримкою {{змінних}}',
      emailTemplateBody: 'Текст повідомлення',
      emailTemplateBodyPlaceholder: 'Текст email з підтримкою {{first_name}}, {{last_name}}, {{email}}...',
      emailTemplateVariablesHelp: 'Використовуйте {{змінна}} для персоналізації. Доступні: first_name, last_name, email, phone, event_title',
      setAsDefaultTemplate: 'Встановити типовим шаблоном',
      saveTemplate: 'Зберегти шаблон',
      savingTemplate: 'Збереження...',
      templateCreated: 'Шаблон створено',
      templateUpdated: 'Шаблон оновлено',
      templateDeleted: 'Шаблон видалено',
      deleteTemplateConfirm: 'Видалити цей шаблон?',
      failedToLoadTemplates: 'Не вдалося завантажити шаблони',
      failedToSaveTemplate: 'Не вдалося зберегти шаблон',
      failedToDeleteTemplate: 'Не вдалося видалити шаблон',
      noEmailTemplates: 'Шаблонів email ще немає. Створіть перший шаблон для швидкого листування.',
      defaultTemplate: 'Типовий',
      emailSubjectLabel: 'Тема:',
      emailBodyLabel: 'Текст:',

      // SMS Templates Manager
      smsTemplates: 'Шаблони SMS',
      smsTemplatesTitle: 'Шаблони SMS',
      newSmsTemplate: 'Новий шаблон',
      smsTemplateNamePlaceholder: 'напр., Нагадування про подію',
      smsTemplateMessageLabel: 'Повідомлення (SMS)',
      smsTemplateMessagePlaceholder: 'SMS повідомлення з підтримкою {{first_name}}, {{last_name}}, {{email}} (макс. 160 символів)...',
      smsTemplateVariablesHelp: 'Використовуйте {{змінна}} для персоналізації. Доступні: first_name, last_name, email, phone, event_title',
      smsCharLimitExceeded: 'Повідомлення перевищує ліміт на',
      smsCharLimitExceededSymbols: 'символів',
      smsCharsRemaining: 'символів залишилось',
      smsMessageExceedsLimit: 'Повідомлення перевищує ліміт на символів',
      noSmsTemplates: 'Шаблонів SMS ще немає. Створіть перший шаблон для швидкого надсилання.',
      smsCharCount: 'символів',

      // SMS Compose Modal
      sendSmsModalTitle: 'Надіслати SMS',
      sendSmsModalSubtitle: 'Кому',
      smsModalStudents: 'учасник(ів)',
      smsModalInsertVariables: 'Вставити змінні',
      smsModalMessage: 'Повідомлення',
      smsModalMessagePlaceholder: 'Введіть SMS повідомлення (макс. 160 символів)...',
      smsModalCharLimitExceeded: 'Повідомлення перевищує',
      smsModalCharsRemaining: 'символів залишилось',
      smsModalVariableHelp: 'Використовуйте {{назва_змінної}} для персоналізації',
      smsModalPreview: 'ПОПЕРЕДНІЙ ПЕРЕГЛЯД',
      smsModalSending: 'Надсилання...',
      smsModalSendButton: 'Надіслати SMS',
      smsModalPleaseEnterMessage: 'Будь ласка, введіть повідомлення',
      smsModalMessageOverLimit: 'Повідомлення перевищує ліміт',

      // Common Template Actions
      newTemplate: 'Новий шаблон',
      loadTemplate: 'Завантажити шаблон',
      saveAsDefault: 'Зберегти як типовий',
      deleteTemplate: 'Видалити шаблон',
    },

    // Email Templates & Scheduling
    email: {
      subject: 'Тема',

      templates: {
        browse: 'Шаблони',
        browser: 'Шаблони листів',
        browserDescription: 'Переглядайте та використовуйте збережені шаблони листів',
        saveAs: 'Зберегти як шаблон',
        saving: 'Збереження...',
        saved: 'Шаблон збережено',
        saveFailed: 'Не вдалося зберегти шаблон',
        fillFields: 'Будь ласка, заповніть тему та текст перед збереженням',
        noEvent: 'Неможливо зберегти шаблон без події',
        templateTitle: 'Назва шаблону',
        enterTitle: 'Введіть назву для цього шаблону',
        loadFailed: 'Не вдалося завантажити шаблони',
        updateFailed: 'Не вдалося оновити шаблон',
        confirmDelete: 'Видалити шаблон?',
        confirmDeleteMessage: 'Ви впевнені, що хочете видалити',
        cannotBeUndone: 'Цю дію не можна скасувати.',
        update: 'Оновити шаблон',
        updated: 'Шаблон успішно оновлено',
        edit: 'Редагувати шаблон',
        delete: 'Видалити шаблон',
        deleted: 'Шаблон успішно видалено',
        deleteFailed: 'Не вдалося видалити шаблон',
        search: 'Пошук шаблонів...',
        favoritesOnly: 'Тільки улюблені',
        noTemplates: 'Шаблонів ще не збережено',
        noMatches: 'Жодних шаблонів не знайдено за вашим запитом',
        addToFavorites: 'Додати до улюблених',
        removeFromFavorites: 'Прибрати з улюблених',
        addedToFavorites: 'Додано до улюблених',
        removedFromFavorites: 'Видалено з улюблених',
        global: 'Глобальний',
      },

      scheduling: {
        schedule: 'Запланувати',
        title: 'Запланувати Email',
        date: 'Дата',
        time: 'Час',
        info: 'Email буде надіслано автоматично у вказаний час.',
        selectDateTime: 'Будь ласка, виберіть дату та час для планування',
        mustBeFuture: 'Запланований час має бути в майбутньому',
        scheduleButton: 'Запланувати Email',
        scheduled: 'Email заплановано.',
        viewScheduled: 'Переглянути заплановані',
        scheduledCampaigns: 'Заплановані розсилки',
        scheduledCampaignsDescription: 'Перегляньте та керуйте запланованими email розсилками',
        noCampaigns: 'Немає запланованих розсилок',
        noScheduledEmails: 'У вас ще немає запланованих email розсилок',
        scheduledFor: 'Заплановано на',
        recipients: 'отримувачів',
        cancelCampaign: 'Скасувати розсилку',
        confirmCancel: 'Скасувати розсилку?',
        confirmCancelMessage: 'Ви впевнені, що хочете скасувати цю заплановану розсилку?',
        campaignCanceled: 'Розсилку скасовано',
        cancelFailed: 'Не вдалося скасувати розсилку',
        loadingCampaigns: 'Завантаження розсилок...',
        statusScheduled: 'Заплановано',
        statusSending: 'Надсилання',
        statusCompleted: 'Надіслано',
        statusFailed: 'Помилка',
        sent: 'надіслано',
        failed: 'помилок',
        yourTimezone: 'Ваш часовий пояс',
        edit: 'Редагувати',
        duplicate: 'Дублювати',
        saveChanges: 'Зберегти зміни',
      },

      confirm: {
        title: 'Підтвердження',
        sendMessage: 'Надіслати email {{count}} отримувачам зараз?',
        scheduleMessage: 'Запланувати email для {{count}} отримувачів на {{date}}?',
        dynamicNote: 'Всі учасники, зареєстровані на момент відправки, отримають email, включаючи нові реєстрації.',
        confirm: 'Підтвердити',
        cancel: 'Скасувати',
      },

      test: {
        button: 'Надіслати тест собі',
        sending: 'Надсилання...',
        sent: 'Тестовий email надіслано на вашу адресу',
        failed: 'Не вдалося надіслати тестовий email',
        fillFields: 'Будь ласка, заповніть тему та текст перед надсиланням тесту',
      },

      sender: {
        name: "Ім'я відправника",
        email: 'Email відправника',
        namePlaceholder: "Введіть ім'я відправника",
      },

      history: {
        title: 'Історія розсилок',
        description: 'Перегляд всіх надісланих email-кампаній та їх статистики',
        backToHistory: 'Назад до історії',
        noCampaigns: 'Немає надісланих кампаній',
        noCampaignsDescription: 'Ваші надіслані email-кампанії з\'являться тут',
        campaign: 'Кампанія',
        campaigns: 'Кампанії',
        allEvents: 'Всі події',
        filterByEvent: 'Фільтр за подією',
        filterByStatus: 'Фільтр за статусом',
        allStatuses: 'Всі статуси',
        loading: 'Завантаження...',
        loadMore: 'Завантажити більше',
        viewDetails: 'Переглянути деталі',
        sentTo: 'Надіслано',
        recipients: 'отримувачів',
        sentAt: 'Надіслано о',
        scheduledFor: 'Заплановано на',
        statistics: 'Статистика',
        deliveryRate: 'Доставлено',
        openRate: 'Відкрито',
        clickRate: 'Переходи',
        bounceRate: 'Відхилено',
        clickThroughRate: 'CTR',
        sent: 'Надіслано',
        delivered: 'Доставлено',
        opened: 'Відкрито',
        clicked: 'Переходи',
        bounced: 'Відхилено',
        failed: 'Помилки',
        unsubscribed: 'Відписалися',
        status: {
          draft: 'Чернетка',
          scheduled: 'Заплановано',
          sending: 'Надсилання',
          completed: 'Надіслано',
          failed: 'Помилка',
        },
        recipientDetails: 'Деталі отримувачів',
        emailAddress: 'Email адреса',
        recipientName: 'Ім\'я',
        recipientStatus: 'Статус',
        openedAt: 'Відкрито о',
        clickedAt: 'Клік о',
        deliveredAt: 'Доставлено о',
        bouncedAt: 'Відхилено о',
        errorMessage: 'Помилка',
        noOpens: 'Не відкривали',
        noClicks: 'Без переходів',
        opens: 'відкриттів',
        clicks: 'переходів',
        view: 'Переглянути',
        edit: 'Редагувати',
        duplicate: 'Дублювати',
        cancel: 'Скасувати',
        confirmCancel: 'Скасувати розсилку?',
        confirmCancelMessage: 'Ви впевнені, що хочете скасувати цю розсилку?',
        campaignCanceled: 'Розсилку скасовано',
        cancelFailed: 'Не вдалося скасувати розсилку',
        emailBody: 'Текст листа',
        createdAt: 'Створено',
      },
    },

    // CRM Refund System
    crm: {
      refund: {
        title: 'Повернення коштів',
        amount: 'Сума повернення',
        reason: 'Причина',
        reasonPlaceholder: 'Введіть причину повернення (необов\'язково)',
        originalPayment: 'Початковий платіж',
        previousRefunds: 'Попередні повернення',
        maxRefund: 'Доступно для повернення',
        maxNote: 'Максимум',
        status: 'Статус повернення',
        warning: 'Цю дію не можна скасувати. Повернення буде оброблено через платіжний шлюз організатора, і кошти повернуться на платіжний засіб учасника. Обробка може тривати кілька робочих днів.',
        issueRefund: 'Повернути кошти',
        processing: 'Обробка...',
        success: 'Повернення успішно оброблено',
        error: 'Помилка повернення',
        invalidAmount: 'Невірна сума повернення',
        exceedsMax: 'Сума повернення не може перевищувати максимум',
        errors: {
          INVALID_REFUND_PRECISION: 'Сума має забагато знаків після коми для цієї валюти.',
          ENROLLMENT_NOT_FOUND: 'Реєстрацію не знайдено',
          NOT_AUTHORIZED: 'У вас немає прав повертати кошти за цією подією',
          ENROLLMENT_NOT_PAID: 'За цією реєстрацією немає онлайн-оплати',
          REFUND_NOT_SUPPORTED_OFFLINE: 'Цю оплату прийнято поза платформою (готівка або банківський переказ). Поверніть кошти напряму та зафіксуйте це у своїх записах.',
          REFUND_ALREADY_IN_PROGRESS: 'Повернення за цим замовленням вже обробляється',
          INVALID_REFUND_AMOUNT: 'Некоректна сума повернення',
          CREDENTIALS_NOT_CONFIGURED: 'Платіжний шлюз не налаштовано',
          REFUND_GATEWAY_UNAVAILABLE: 'Платіжний шлюз зараз недоступний. Спробуйте пізніше.',
          REFUND_DECLINED: 'Платіжний шлюз відхилив повернення',
          REFUND_STATUS_UNKNOWN: 'Платіжний шлюз відповів незрозуміло. Перевірте статус у панелі свого платіжного провайдера, перш ніж повторювати.',
          REFUND_SETTLED_LEDGER_NOT_UPDATED: 'Кошти повернуто, але запис про повернення не оновлено. Зверніться до support@confy.cc',
          REFUND_SETTLED_ENROLLMENT_NOT_UPDATED: 'Кошти повернуто, але реєстрацію не оновлено. Зверніться до support@confy.cc',
          RATE_LIMITED: 'Забагато запитів. Зачекайте хвилину та спробуйте ще раз.',
          ORDER_NOT_ON_ENROLLMENT: 'Обране замовлення не належить цій реєстрації',
        },
        processingNotice: 'Повернення прийнято платіжним шлюзом і ще обробляється. Перевірте остаточний статус у панелі свого платіжного провайдера.',
        partial: 'Часткове повернення',
        order: 'Замовлення',
      },
      ticketChange: {
        errors: {
          UPGRADE_IN_FLIGHT: 'Учасник зараз оплачує підвищення квитка. Спробуйте пізніше.',
          TICKET_CHANGED: 'Квиток щойно змінився. Оновіть сторінку та спробуйте ще раз.',
          DOWNGRADE_NOT_SELF_SERVICE: 'Змінити квиток на дешевший може лише організатор. Зверніться до організатора заходу.',
        },
      },
      pendingRefunds: {
        title: 'Повернення коштів, що очікують підтвердження',
        subtitle: 'Нічого не надсилається до платіжного шлюзу, поки ви не підтвердите кожне повернення.',
        columns: {
          participant: 'Учасник',
          ticket: 'Квиток',
          amount: 'Сума',
          reason: 'Причина',
          queuedAt: 'У черзі з',
        },
        total: 'Разом',
        approve: 'Підтвердити',
        approveAll: 'Підтвердити всі',
        approveAllConfirm: 'Підтвердити всі повернення коштів на загальну суму {{total}}? Після підтвердження кошти буде надіслано до платіжного шлюзу.',
        confirm: {
          title: 'Підтвердити всі повернення',
          cancel: 'Скасувати',
          confirm: 'Так, підтвердити всі',
        },
        loadError: 'Не вдалося завантажити повернення коштів, що очікують підтвердження. Можливо, тут є повернення, які потребують вашого підтвердження.',
        retry: 'Спробувати ще раз',
        toast: {
          approved: 'Підтверджено повернень: {{count}}',
          someRefused: 'Деякі повернення не вдалося підтвердити',
          error: 'Не вдалося надіслати запит на підтвердження повернення коштів. Спробуйте ще раз.',
        },
        errors: {
          REFUND_EXCEEDS_PAID: 'Сума повернення перевищує те, що ще можна повернути за цим замовленням. Оновіть сторінку і перевірте суму.',
          ALREADY_APPROVED: 'Це повернення вже підтверджено.',
          NOT_ON_THIS_EVENT: 'Це повернення належить іншій події.',
          generic: 'Не вдалося підтвердити це повернення. Спробуйте ще раз.',
        },
      },
      paymentTimeline: {
        title: 'Історія платежу',
        empty: 'Ця реєстрація безкоштовна - історії платежів немає.',
        loadError: 'Не вдалося завантажити історію платежу.',
        retry: 'Спробувати ще раз',
        kinds: {
          payment_created: 'Платіж створено',
          payment_approved: 'Платіж підтверджено',
          upgrade_approved: 'Підвищення квитка підтверджено',
          refund_queued: 'Повернення коштів у черзі',
          refund_approved: 'Повернення коштів підтверджено',
          refund_sent: 'Запит на повернення надіслано до платіжного шлюзу',
          refund_settled: 'Повернення коштів завершено',
          refund_failed: 'Повернення коштів не вдалося',
          audit: 'Адміністративна дія',
        },
        auditActions: {
          refund_admin_override: 'Повернення коштів випущено адміністратором в обхід організатора',
          payment_amount_mismatch: 'Платіжний шлюз повідомив про іншу суму, ніж очікувалося',
          payment_fulfilment_blocked: 'Оплату отримано, але реєстрацію заблоковано для перевірки',
          generic: 'Невідома адміністративна дія',
        },
      },
      student: 'Студент',
      unknown: 'Невідомо',
    },

    // Course Builder
    courseBuilderPage: {
      courseBuilder: 'Конструктор курсів',
      editCourse: 'Редагувати курс',
      createOrganizeContent: 'Створюйте та організовуйте вміст свого курсу',
      preview: 'Попередній перегляд',
      saveCourse: 'Зберегти курс',
      saving: 'Збереження...',
      contentBlocksLabel: 'Блоки курсу',
      courseInformation: 'Інформація про курс',
      courseTitle: 'Назва курсу',
      enterCourseTitle: 'Введіть назву курсу...',
      courseDescription: 'Опис курсу',
      enterCourseDescription: 'Введіть опис курсу...',
      medicalSpecialty: 'Медична спеціальність',
      selectSpecialty: 'Виберіть спеціальність...',
      courseFormat: 'Формат курсу',
      online: 'Онлайн',
      inPerson: 'Очно',
      hybrid: 'Гібридний',
      selfPaced: 'Самостійний темп',
      locationAddress: 'Місце/Адреса',
      enterVenueAddress: 'Введіть адресу місця проведення...',
      startDate: 'Дата початку',
      endDate: 'Дата закінчення',
      coursePriceUAH: 'Ціна курсу (грн)',
      cpdCredits: 'Бали БПР',
      maxParticipants: 'Максимум учасників',
      leaveEmptyUnlimited: 'Залиште порожнім для необмеженої кількості',
      courseImage: 'Зображення курсу',
      uploadImage: 'Завантажити зображення',
      courseContent: 'Зміст курсу',
      blocks: 'блоків',
      noContentBlocks: 'Блоків ще немає',
      startBuildingCourse: 'Почніть створювати свій курс, додаючи блоки з лівої панелі.',
      knowledgeTest: 'Фінальний тест',
      editTest: 'Редагувати тест',
      addTest: 'Додати тест',
      optional: 'Необов\'язково',
      questions: 'Питання',
      passing: 'Прохідний бал',
      maxAttempts: 'Макс. спроб',
      timeLimit: 'Часовий ліміт',
      none: 'Немає',
      noTestCreated: 'Тест ще не створено',
      addKnowledgeTest: 'Додайте тест знань для оцінки навчання студентів',
      courseSurvey: 'Фінальне опитування',
      editSurvey: 'Редагувати опитування',
      addSurvey: 'Додати опитування',
      anonymous: 'Анонімне',
      availableAfterCompletion: 'Доступне після завершення',
      availableAnytime: 'Доступне в будь-який час',
      noSurveyCreated: 'Опитування ще не створено',
      addFeedbackSurvey: 'Додайте опитування для збору думок студентів',
      failedToUploadImage: 'Не вдалося завантажити зображення',
      checkingAccessPermissions: 'Перевірка дозволів доступу...',
      accessDenied: 'Доступ заборонено. Тільки організатори можуть створювати курси.',
      failedToLoadCourse: 'Не вдалося завантажити дані курсу',
      pleaseEnterCourseTitle: 'Будь ласка, введіть назву курсу',
      courseUpdatedSuccessfully: 'Курс успішно оновлено!',
      courseSavedSuccessfully: 'Курс успішно збережено!',
      errorSavingCourse: 'Помилка збереження курсу',
      testSavedSuccessfully: 'Тест успішно збережено!',
      failedToSaveTest: 'Не вдалося зберегти тест',
      surveysSavedSuccessfully: 'Опитування успішно збережено!',
      failedToSaveSurvey: 'Не вдалося зберегти опитування. Спробуйте ще раз.',
      noCourseId: 'Немає ідентифікатора курсу. Будь ласка, спочатку збережіть курс.',
      loadExampleTemplate: 'Завантажити приклад шаблону',
      clearTemplate: 'Очистити шаблон',
      availablePlaceholders: 'Доступні параметри:',
      placeholderDescription: 'Залиште порожнім, щоб використовувати стандартний шаблон сертифіката. Підтримуються HTML, CSS та вбудовані стилі.',
      certificateTemplatePlaceholder: 'Введіть власний HTML шаблон для сертифікатів (необов\'язково)...',
      randomizeQuestionOrder: 'Випадковий порядок питань',
      pleaseAddCertificateTemplateFirst: 'Будь ласка, спочатку додайте шаблон сертифіката',
      materialBlocksSaveWarning: 'Увага: деякі блоки матеріалів можуть не бути збережені',
    },

    // Course Details
    courseDetails: {
      inYourTime: 'За вашим часом',
      backToCourses: 'Повернутися до курсів',
      backToEvents: 'Повернутися до подій',
      startAnytime: 'Будь-який час',
      limitedParticipants: 'Обмежено до',
      participants: 'учасників',
      enrollNow: 'Записатися зараз',
      processing: 'Обробка...',
      goToCourse: 'Перейти до курсу',
      goToEvent: 'Перейти до події',
      courseContent: 'Зміст курсу',
      eventContent: 'Зміст події',
      eventDetails: 'Деталі події',
      eventDescription: 'Опис події',
      available: 'Доступно',
      contentAvailableAfterEnrollment: 'Зміст курсу буде доступний після реєстрації.',
      eventContentAvailableAfterEnrollment: 'Зміст події буде доступний після реєстрації.',
      courseDetails: 'Деталі курсу',
      courseDescription: 'Опис курсу',
      format: 'Формат',
      duration: 'Тривалість',
      dates: 'Дати',
      venue: 'Місце проведення',
      price: 'Ціна',
      start: 'Початок',
      end: 'Кінець',
      readyToStart: 'Готові почати?',
      youAreEnrolled: 'Ви записалися! Доступ до вмісту курсу з панелі управління.',
      youAreRegisteredEvent: 'Ви зареєстровані на цю подію!',
      joinCourseToday: 'Приєднайтесь до цього курсу та починайте вчитися сьогодні.',
      registerForEventToday: 'Зареєструйтесь на цю подію та отримайте доступ до всіх матеріалів.',
      enrollFor: 'Записатися',
      goToDashboard: 'Перейти до панелі управління',
      courseNotFound: 'Курс не знайдено',
      returnToHomepage: 'Повернутися на головну',
      pleaseLogIn: 'Будь ласка, увійдіть, щоб записатися на цей курс',
      paymentSuccessful: 'Платіж успішний! Ви зареєстровані.',
      paymentFailed: 'Платіж не вдався. Спробуйте ще раз.',
      successfullyEnrolled: 'Реєстрація успішна!',
      failedToEnroll: 'Не вдалося зареєструватися',
      fulfilmentBlocked: 'Оплата пройшла успішно, але реєстрацію завершити не вдалося. Служба підтримки CONFY вже сповіщена та зв\'яжеться з вами – будь ласка, не оплачуйте повторно. З питаннями звертайтесь на support@confy.cc.',
      answersNotStoredError: 'Вас зареєстровано, але не вдалося зберегти ваші відповіді на питання реєстрації. Будь ласка, зв\'яжіться з організатором.',
      failedToCheckProfileRequirements: 'Не вдалося перевірити вимоги профілю. Спробуйте ще раз.',
      sessionExpiredPleaseRefresh: 'Сесія закінчилась. Оновіть сторінку та спробуйте ще раз.',
      serverErrorTryAgain: 'Помилка сервера. Спробуйте ще раз через хвилину.',
      networkErrorCheckConnection: 'Немає з\'єднання з сервером. Перевірте інтернет та спробуйте ще раз.',
      refreshPage: 'Оновити сторінку',
      failedToProcessPayment: 'Не вдалося обробити платіж',
      failedToInitiatePayment: 'Не вдалося ініціювати платіж',
      paymentConfirmingTitle: 'Платіж підтверджується',
      paymentConfirming: 'Ми підтверджуємо ваш платіж – це зазвичай займає кілька хвилин. Ви отримаєте лист на пошту, щойно реєстрацію буде підтверджено. Оплачувати повторно не потрібно.',
      paymentConfirmingDelayedTitle: 'Підтвердження триває довше, ніж зазвичай',
      paymentConfirmingDelayed: 'Ваш платіж досі обробляється – це просто триває довше, ніж зазвичай. Ви отримаєте лист на пошту, щойно реєстрацію буде підтверджено. Оплачувати повторно не потрібно.',
      paymentRedirecting: 'Переадресація на сторінку оплати…',
      paymentContinue: 'Перейти до оплати',
      paymentCancel: 'Скасувати',
      paymentSuccessPage: {
        title: 'Оплата обробляється',
        message: 'Ваш платіж отримано. Реєстрація буде підтверджена протягом кількох хвилин.',
        successTitle: 'Оплата підтверджена!',
        successMessage: 'Ви успішно зареєстровані. Квиток доступний у вашому профілі.',
        declinedTitle: 'Оплату не завершено',
        declinedMessage: 'Платіж не було завершено. Якщо кошти все ж списано, реєстрацію буде підтверджено автоматично протягом години.',
        blockedTitle: 'Оплату отримано, реєстрацію не завершено',
        blockedMessage: 'Платіж пройшов, але реєстрацію не вдалося завершити. Не сплачуйте повторно – напишіть на support@confy.cc.',
        goToEvent: 'Перейти до події',
        goToTickets: 'Мої квитки',
        goToHome: 'На головну',
        verifying: 'Перевіряємо статус оплати...',
        tryAgain: 'Спробувати ще раз',
        redirecting: 'Зараз повернемо вас на сторінку події.',
      },
      module: 'Модуль',
      cpdCredits: 'Бали БПР',
      targetSpecialties: 'Цільова аудиторія',
      passingScore: 'Прохідний бал',
      required: 'Обов\'язково',
      optional: 'Необов\'язково',
      free: 'БЕЗКОШТОВНО',
      inPerson: 'Очно',
      online: 'Онлайн',
      hybrid: 'Гібридний',
      selfPaced: 'Самостійний темп',
      website: 'Веб-сайт',
      visitPage: 'Відвідати сторінку',
      visitWebsite: 'Відвідати веб-сайт',
      noDescription: 'Опис відсутній',
      noProgram: 'Програма відсутня',
      eventTimezone: 'за часом події',
      yourLocalTime: 'ваш місцевий час',
    },

    // Event-specific translations
    event: {
      eventNotFound: 'Подію не знайдено',
      loadFailed: 'Не вдалося завантажити подію. Перевірте інтернет-з\'єднання та спробуйте ще раз.',
      retry: 'Спробувати ще раз',
      register: 'Зареєструватись',
      registered: 'зареєстровано',
      registerSuccess: 'Ви успішно зареєстровані на подію!',
      joinNow: 'Приєднатися до події',
      viewMaterials: 'Переглянути матеріали',
      viewEvent: 'Переглянути подію',
      happeningNow: 'Подія відбувається зараз',
      upcoming: 'Майбутня подія',
      ended: 'Подія завершена',
      startsIn: 'Починається через',
      completionRequirements: 'Вимоги для отримання сертифіката',
      agenda: 'Порядок денний',
      eventDetails: 'Деталі події',
      youreRegistered: 'Ви зареєстровані!',
      eventStartsIn: 'Подія починається через',
      joinEventNow: 'Приєднатися до події зараз',
      viewEventMaterials: 'Переглянути матеріали події',
      eventHappeningNow: 'Подія відбувається зараз',
      upcomingEvent: 'Майбутня подія',
      eventEnded: 'Подія завершена',
      prepareForEvent: 'Підготуйтеся до події',
      completeBeforeEvent: 'Завершіть ці матеріали перед початком події.',
      completeToEarnCertificate: 'Виконайте ці вимоги, щоб отримати сертифікат:',
      attendedEvent: 'Відвідали подію',
      completeFinalTest: 'Пройдіть фінальний тест',
      completeSurvey: 'Завершіть опитування',
      days: 'днів',
      daysUntilEvent: 'днів до події',
      eventInProgress: 'Подія відбувається',
      clickToJoin: 'Натисніть, щоб приєднатися',
      viewMaterialsAndCertificate: 'Перегляньте матеріали та сертифікат',
      certificateReady: 'Сертифікат готовий!',
      clickToGenerate: 'Натисніть кнопку нижче, щоб згенерувати свій сертифікат',
      notConfiguredYet: 'Сертифікат готується',
      notConfiguredDescription: 'Сертифікат для цієї події ще готується організатором. Він буде доступний найближчим часом.',
      templateNotConfigured: 'Сертифікат для цієї події ще не налаштований організатором. Якщо ви виконали всі вимоги – не хвилюйтесь, сертифікат стане доступним, щойно організатор завершить налаштування. Спробуйте пізніше.',
      allRequirementsComplete: 'Ви виконали всі вимоги для отримання сертифіката.',
      generateCertificateInTab: 'Перейдіть на вкладку "Certificates", щоб згенерувати свій сертифікат.',
      streamingAvailable: 'Доступна онлайн-трансляція',
      sessionSchedule: 'Розклад сесій',
      session: 'Сесія',
      agendaComingSoon: 'Програма події незабаром буде оновлена',

      // Social Proof & Scarcity
      spotsRemaining: 'місць залишилось',
      registerSoon: 'Реєструйтеся швидше – місця закінчуються',
      soldOut: 'Місць немає',

      // Test Types
      finalExam: 'Фінальний іспит',
      preAssessment: 'Попередня оцінка',
      knowledgeCheck: 'Перевірка знань',
      attempts: 'спроб',

      // Event Organization
      speakers: 'Спікери',
      organizedBy: 'Організатор',
      organizerInformation: 'Організатор',

      // Online Event Access
      onlineAccess: {
        title: 'Приєднатися до онлайн-події',
        availableBeforeStart: 'Посилання на зустріч стане активним незадовго до початку події.',
        clickToJoin: 'Натисніть кнопку нижче, щоб приєднатися до онлайн-події.',
        notYetAvailable: 'Ще недоступно',
        joinNow: 'Приєднатися до онлайн-події',
        availableSoon: 'Доступно після початку події',
      },

      // Exit Confirmation Modal
      confirmExit: 'Вийти з тесту?',
      progressWillBeLost: 'Ваші відповіді не будуть збережені',
      exitAnyway: 'Вийти',

      // Event Tests and Surveys (Student-facing)
      test: {
        maxAttemptsReached: 'Ви використали всі доступні спроби',
        loading: 'Завантаження тестів...',
        noTestsAvailable: 'Зараз немає доступних тестів.',
        checkBackLater: 'Перевірте пізніше, коли тести стануть доступними.',
        availableAfterEvent: 'Тести стануть доступні після завершення події.',
        passedTitle: 'Вітаємо! Ви успішно склали тест!',
        scoredAbove: 'Ваш результат перевищує прохідний бал',
        certificateGenerating: 'Ваш сертифікат генерується і незабаром буде доступний!',
        notPassedTitle: 'Тест не пройдено',
        retryEncouragement: 'Для успішного проходження потрібно {percentage}%. Ви можете спробувати ще раз.',
        backToTests: 'Повернутися до тестів',
        tryAgain: 'Спробувати ще раз',
        availableTestsTitle: 'Доступні тести',
        closedTestsTitle: 'Завершені тести',
        upcomingTestsTitle: 'Майбутні тести',
        startTest: 'Розпочати тест',
        submitTest: 'Дізнатись результат',
        closed: 'Завершено',
        upcoming: 'Незабаром',
        missedTest: 'Ви не пройшли цей тест вчасно',
        viewResults: 'Переглянути результати',
        yourAnswer: 'Ваша відповідь',
        correctAnswer: 'Правильна відповідь',
        testAlreadyPassed: 'Ви вже склали цей тест',
        answerAllQuestions: 'Будь ласка, дайте відповідь на всі питання',
        questionsAnswered: 'питань відповідено',
        questionsCount: 'Питань',
        attemptsRemaining: 'Залишилось спроб',
        attemptsUnlimited: 'Спроби: необмежені',
        startDate: 'Початок',
        deadline: 'Дедлайн',
        beginTest: 'Розпочати тест',
        questionOf: 'Питання',
        reviewTitle: 'Перегляд відповідей',
        answeredCount: 'відповідей',
        notAnswered: 'Без відповіді',
        congratulations: 'Вітаємо!',
        youPassedTest: 'Ви пройшли тест!',
        yourScore: 'Ваш результат',
        passingPercentage: 'Прохідний поріг',
        next: 'Далі',
        previous: 'Назад',
        close: 'Закрити',
        timeUp: 'Час вичерпано',
        cancel: 'Скасувати',
        noAttemptsRemaining: 'Спроби вичерпано',
        notPreparedByOrganizer: 'Наразі немає інформації про тестування. Або воно не передбачене, або ще не підготовлене організатором.',
        notIncluded: {
          title: 'Тест не входить у ваш квиток',
          body: 'Для цієї події відкрито тестування, але ваш квиток «{{ticket}}» не включає тест і сертифікат.',
          bodyNoTicketName: 'Для цієї події відкрито тестування, але ваш квиток не включає тест і сертифікат.',
          upgradeHint: 'Оновіть квиток, щоб пройти тест і отримати сертифікат.',
          contactHint: 'Якщо вважаєте, що це помилка, зверніться до організатора.',
          upgradeButton: 'Оновити квиток',
          contactButton: 'Написати організатору',
          openUntil: 'Тест відкрито до {{date}}',
        },
        contactOrganizerAboutTest: 'Якщо у вас є питання щодо тесту, зверніться до організатора:',
      },
      testHistory: {
        title: 'Історія тестів',
        passed: 'Пройдено',
        failed: 'Не пройдено',
        attempt: 'Спроба',
        loadMore: 'Завантажити більше',
        remaining: 'залишилось',
        noHistory: 'Історія тестів відсутня',
      },
      survey: {
        alreadyCompleted: 'Ви вже завершили це опитування.',
        answerRequired: 'Будь ласка, дайте відповідь на всі обов\'язкові питання перед відправкою.',
        loading: 'Завантаження опитувань...',
        noSurveysAvailable: 'Зараз немає доступних опитувань.',
        checkBackLater: 'Перевірте пізніше, коли опитування стануть доступними.',
        availableAfterEvent: 'Опитування стануть доступні після завершення події.',
        thankYouTitle: 'Дякуємо!',
        submittedSuccess: 'Вашу відповідь успішно отримано.',
        backToSurveys: 'Повернутися до опитувань',
        availableSurveysTitle: 'Доступні опитування',
        closedSurveysTitle: 'Завершені опитування',
        upcomingSurveysTitle: 'Майбутні опитування',
        missedSurvey: 'Ви не пройшли це опитування вчасно',
        closed: 'Завершено',
        upcoming: 'Незабаром',
        notYetAvailable: 'Опитування ще не доступне',
        startSurvey: 'Розпочати опитування',
        submitSurvey: 'Відправити опитування',
        anonymous: 'Анонімне',
        errorSubmitting: 'Не вдалося відправити опитування. Спробуйте ще раз.',
      },
      preEvent: {
        testsTitle: 'Тести перед подією',
        surveysTitle: 'Опитування перед подією',
        preAssessmentBadge: 'Попередня оцінка',
      },
      tabs: {
        program: 'Програма',
        speakers: 'Спікери',
        materials: 'Матеріали',
        partners: 'Партнери',
        tests: 'Тести',
        surveys: 'Опитування',
        certificates: 'Сертифікати',
      },
      streamingError: 'Не вдалося приєднатися до трансляції. Будь ласка, спробуйте ще раз або зверніться до підтримки.',

      // Promocode Registration
      registration: {
        promocode: {
          haveCode: 'Маєте промокод?',
          placeholder: 'Введіть промокод',
          apply: 'Застосувати',
          remove: 'Прибрати',
          validating: 'Перевірка...',
          invalid: 'Невірний промокод',
          validationError: 'Помилка перевірки промокоду. Спробуйте ще раз.',
          enterCode: 'Будь ласка, введіть промокод',
          locked: 'Заблоковано',
          needsCode: 'Введіть промокод, щоб розблокувати цей квиток',
          promocodeRequired: 'Потрібен промокод',
          unlocked: 'Розблоковано',
        },
        ticketsAvailable: 'доступно',
        soldOut: 'Розпродано',
        noTicketsAvailable: 'Немає доступних квитків',
        loadFailed: 'Не вдалося завантажити квитки',
        loadFailedHint: 'Перевірте з\u2019єднання з інтернетом і спробуйте ще раз. Реєстрація відкрита.',
        retryLoad: 'Спробувати ще раз',
        salesEnded: 'Реєстрацію закрито',
        salesEndedHint: 'Період реєстрації на цю подію завершився',
        enterPromoToAccess: 'Введіть промокод для доступу до реєстрації',
        availableTickets: 'Доступні квитки',
        selectTickets: 'Виберіть квитки',
        selectYourTickets: 'Виберіть свої квитки',
        selectAtLeastOneTicket: 'Будь ласка, виберіть принаймні один квиток',
        total: 'Разом:',
        proceedToCheckout: 'Продовжити',
        finishRegistration: 'Завершити реєстрацію',
        specialAccessTickets: 'Спеціальний доступ (потрібен промокод)',
        includesParticipantCert: 'Сертифікат учасника',
        includesSpeakerCert: 'Сертифікат спікера',
      },
    },

    // Certificate Verification
    certificateVerification: {
      title: 'Перевірка сертифіката',
      description: 'Перевірте автентичність сертифікатів CONFY',
      certificateVerification: 'Перевірка сертифіката',
      verifyAuthenticity: 'Перевірте автентичність сертифікатів CONFY',
      backToHomepage: 'Повернутися на головну',
      verifyCertificate: 'Перевірити сертифікат',
      verifyButton: 'Перевірити сертифікат',
      instructions: 'Введіть код перевірки або номер сертифіката для перевірки автентичності сертифіката',
      enterVerificationCode: 'Введіть код перевірки або номер сертифіката для перевірки автентичності сертифіката',
      verificationCode: 'Код перевірки',
      verificationCodeLabel: 'Код перевірки',
      certificateNumber: 'Номер сертифіката',
      certificateNumberLabel: 'Номер сертифіката',
      verificationCodePlaceholder: 'Введіть код перевірки',
      enterVerificationCodePlaceholder: 'Введіть код перевірки (наприклад, AB1CD2EF3GH4IJ5K)',
      certificateNumberPlaceholder: 'Введіть номер сертифіката',
      verificationCodeHelp: 'Код перевірки можна знайти на сертифікаті або в посиланні',
      certificateNumberHelp: 'Номер сертифіката відображається на сертифікаті',
      verificationCodeLocation: 'Код перевірки можна знайти на сертифікаті або в посиланні',
      enterCertificateNumber: 'Введіть номер сертифіката (наприклад, CERT-2025-ABC1234567)',
      certificateNumberLocation: 'Номер сертифіката відображається на сертифікаті',
      verifying: 'Перевірка...',
      verified: 'Сертифікат підтверджено',
      certificateVerified: 'Сертифікат перевірено',
      verificationFailed: 'Перевірка не вдалася',
      validAndAuthentic: 'Цей сертифікат дійсний та автентичний.',
      certificateNotFound: 'Сертифікат не знайдено. Код перевірки або номер сертифіката можуть бути невірними.',
      certificateHasExpired: 'Термін дії цього сертифіката закінчився.',
      certificateStatus: 'Статус цього сертифіката:',
      certificateDetails: 'Деталі сертифіката',
      recipient: 'Отримувач',
      course: 'Курс',
      cpdCredits: 'Бали БПР',
      completionDate: 'Дата завершення',
      issueDate: 'Дата видачі',
      expiredWarning: 'Термін дії цього сертифіката закінчився',
      certificateExpired: '⚠️ Термін дії цього сертифіката закінчився.',
      expiryDate: 'Дата закінчення',
      howToUse: 'Як використовувати цей інструмент',
      howToUseThisTool: 'Як використовувати цей інструмент',
      howToUseStep1: 'Код перевірки: Знаходиться на сертифікатах і в посиланнях - унікальний код для перевірки',
      howToUseStep2: 'Номер сертифіката: Офіційний номер сертифіката, що відображається на документі сертифіката',
      howToUseStep3: 'Автентичність: Дійсні сертифікати показують детальну інформацію, включаючи ім\'я отримувача, курс та дати завершення',
      howToUseStep4: 'Безпека: Всі сертифікати цифрово підписані та безпечно зберігаються в нашій системі',
      verificationCodeInfo: '• Код перевірки: Знаходиться на сертифікатах і в посиланнях - унікальний код для перевірки',
      certificateNumberInfo: '• Номер сертифіката: Офіційний номер сертифіката, що відображається на документі сертифіката',
      authenticityInfo: '• Автентичність: Дійсні сертифікати показують детальну інформацію, включаючи ім\'я отримувача, курс та дати завершення',
      securityInfo: '• Безпека: Всі сертифікати цифрово підписані та безпечно зберігаються в нашій системі',
      pleaseEnterValid: 'Будь ласка, введіть дійсний',
      errorOccurred: 'Сталася помилка під час перевірки сертифіката. Спробуйте ще раз.',
      loadingVerification: 'Завантаження...',
      loadingCertificateVerification: 'Завантаження перевірки сертифіката...',
    },

    // Auth Modal Enhancements
    authModal: {
      welcomeBack: 'Ласкаво просимо',
      joinCONFY: 'Приєднуйтесь до CONFY',
      signInAccess: 'Увійдіть або зареєструйтесь, щоб користуватись платформою',
      createAccount: 'Створіть свій акаунт, щоб почати навчання',
      continueWithGoogle: 'Увійти з Google',
      pleaseWait: 'Будь ласка, зачекайте...',
      or: 'або',
      continueWithEmail: 'Увійти з Email',
      continueWithPhoneComingSoon: 'Продовжити з телефоном (Незабаром)',
      dontHaveAccount: 'Не маєте акаунта?',
      alreadyHaveAccount: 'Вже маєте акаунт?',
      signUp: 'Зареєструватися',
      signIn: 'Увійти',
      bySigningUp: 'Реєструючись, ви погоджуєтесь з нашою',
      userAgreement: 'Угодою користувача',
      and: 'та',
      privacyPolicy: 'Політикою конфіденційності',
      signInWithEmail: 'Увійти з Email',
      enterYourEmail: 'Введіть вашу електронну адресу',
      createYourAccount: 'Створити акаунт',
      checking: 'Перевірка...',
      continue: 'Продовжити',
      signInSubtitle: 'Введіть свої дані для доступу до акаунта',
      signUpSubtitle: 'Нам потрібні лише ваше ім\'я та email, щоб почати',
      firstName: 'Ім\'я',
      lastName: 'Прізвище',
      firstNamePlaceholder: 'Введіть ваше ім\'я',
      lastNamePlaceholder: 'Введіть ваше прізвище',
      emailAddress: 'Адреса електронної пошти',
      sending: 'Відправка...',
      sendSignInLink: 'Відправити посилання для входу',
      sendAccountSetupLink: 'Відправити посилання для налаштування акаунта',
      sendSecureLinkSignIn: 'Ми відправимо вам безпечне посилання для миттєвого входу.',
      sendSecureLinkSetup: 'Ми відправимо вам безпечне посилання для завершення налаштування акаунта.',
      pleaseEnterEmail: 'Будь ласка, введіть вашу адресу електронної пошти',
      pleaseEnterName: 'Будь ласка, введіть ім\'я та прізвище',
      pleaseProvideNames: 'Будь ласка, вкажіть ваше ім\'я та прізвище',
      userNotFoundError: 'Акаунт з цією адресою не знайдено. Бажаєте створити новий акаунт?',
      userAlreadyExistsError: 'Акаунт з цією адресою вже існує. Будь ласка, увійдіть замість цього.',
      switchToSignUp: 'Створити новий акаунт',
      switchToSignIn: 'Увійти в існуючий акаунт',
      accountCreated: 'Акаунт створено! Перевірте вашу електронну пошту для завершення реєстрації.',
      magicLinkSent: 'Посилання для входу відправлено! Перевірте вашу електронну пошту для входу.',
      failedToSendMagicLink: 'Не вдалося відправити магічне посилання',
      failedToSignInWithGoogle: 'Не вдалося увійти через Google',
      johnPlaceholder: 'Іван',
      doePlaceholder: 'Іванов',
      emailPlaceholder: 'ivan@example.com',
      // Check Email / OTP Verification
      checkYourEmail: 'Перевірте пошту',
      magicLinkInstructions: 'Ми надіслали лист для входу на адресу',
      clickButtonInEmail: 'Натисніть кнопку у листі, щоб увійти',
      resendEmail: 'Надіслати лист повторно',
      enterCodeManually: 'Або введіть 6-значний код вручну',
      enterCodeManuallyHint: 'Введіть код з листа:',
      enterCode: 'Введіть код',
      enterCodeSubtitle: 'Введіть 6-значний код, відправлений на',
      verificationCode: 'Код підтвердження',
      codePlaceholder: '000000',
      verifying: 'Перевірка...',
      verify: 'Підтвердити',
      invalidCode: 'Невірний код',
      codeExpired: 'Код застарів',
      resendCode: 'Відправити код знову',
      checkEmailForCode: 'Перевірте свою пошту для коду або натисніть посилання у листі',
      rateLimitError: 'Зачекайте {seconds} сек. перед наступним запитом',
      pleaseWaitBeforeResending: 'Будь ласка, зачекайте перед повторним надсиланням коду',
      resendInvalidatesCode: 'Надсилання нового коду скасує попередній',
      typoQuestion: 'Можливо, ви мали на увазі {email}?',
      typoUseFix: 'Так, виправити',
      typoKeep: 'Ні, надіслати на {email}',
      resendIn: 'Надіслати ще раз через {seconds} с',
      newCodeSent: 'Новий код надіслано. Код із попереднього листа більше не діє – використовуйте код з останнього листа.',
      googleNudgeTitle: 'Не вдається увійти?',
      googleNudgeBody: 'Ваша пошта працює на Google – увійдіть одним натисканням, без листів і кодів.',
      googleNudgeAccount: 'Оберіть обліковий запис {email}.',
      // Auth error/recovery messages
      authErrorPkce: 'Ви відкрили посилання в іншому браузері. З міркувань безпеки вхід має бути завершений у тому ж браузері, де ви його розпочали. Будь ласка, увійдіть через Google або запитайте новий лист і введіть 6-значний код з нього.',
      authErrorGeneric: 'Не вдалося увійти. Будь ласка, спробуйте ще раз.',
      authErrorLinkAlreadyUsed: 'Це посилання для входу вже було використане. Кожне посилання і код діють лише один раз \u2013 запитайте новий лист.',
      authRequestNewLink: 'Отримати новий лист',
      authErrorSessionExpired: 'Ваша сесія закінчилась. Будь ласка, увійдіть знову.',
      authSuccessSignedIn: 'Ви успішно увійшли!',
      authTryAgain: 'Спробувати знову',
      authSessionRestoreFailed: 'Щось пішло не так. Очистіть сесію та спробуйте знову.',
      authClearSessionAndRetry: 'Очистити сесію',
      // Device clock differs from server time (see ClockSkewNotice)
      clockSkewNotice: 'Час на вашому пристрої неточний (різниця {{amount}}). Увімкніть автоматичні дату, час і часовий пояс у налаштуваннях пристрою та оновіть сторінку.',
      clockSkewMinutes: '{{minutes}} хв',
      clockSkewHours: '{{hours}} год {{minutes}} хв',
      clockSkewHoursOnly: '{{hours}} год',
      clockSkewReload: 'Оновити сторінку',
      clockSkewDismiss: 'Закрити',
    },

    loginPage: {
      title: 'Вхід',
      loginRequired: 'Будь ласка, увійдіть для доступу до цієї сторінки',
      sessionExpired: 'Ваша сесія закінчилась. Увійдіть знову.',
      alreadyAuthenticated: 'Ви вже увійшли. Перенаправляємо...',
    },

    // Profile Completion Modal
    profileCompletion: {
      title: 'Завершіть свій профіль',
      subtitle: 'Всього один крок до початку',
      emailAddress: 'Адреса електронної пошти',
      firstName: 'Ім\'я',
      lastName: 'Прізвище',
      firstNamePlaceholder: 'Введіть ваше ім\'я',
      lastNamePlaceholder: 'Введіть ваше прізвище',
      requiredField: 'Обов\'язкові поля',
      continue: 'Продовжити',
      saving: 'Збереження...',
      bothNamesRequired: 'Ім\'я та прізвище обов\'язкові',
      failedToSaveProfile: 'Не вдалося зберегти профіль',
    },

    // Course Learn Page
    courseLearn: {
      loadingCourseContent: 'Завантаження вмісту курсу...',
      noContentAvailable: 'Для цього курсу вміст недоступний',
      backToDashboard: 'Повернутися до панелі управління',
      notEnrolledError: 'Ви не записані на цей курс',
      progress: 'Прогрес',
      courseContent: 'Зміст курсу',
      block: 'Блок',
      unknownContentType: 'Невідомий тип вмісту',
      testInformation: 'Інформація про тест',
      questions: 'Питання',
      passingScore: 'Прохідний бал',
      maxAttempts: 'Максимальна кількість спроб',
      unlimited: 'Необмежено',
      timeLimit: 'Часове обмеження',
      minutes: 'хвилин',
      noTimeLimit: 'Без обмежень',
      startTest: 'Почати тест',
      surveyInformation: 'Інформація про опитування',
      anonymous: 'Анонімне',
      required: 'Обов\'язкове',
      takeSurvey: 'Пройти опитування',
      yes: 'Так',
      no: 'Ні',
      markAsComplete: 'Позначити як завершене',
      nextBlock: 'Наступний блок',
      previousBlock: 'Попередній блок',
      completeCourseCongratulations: 'Вітаємо! Ви завершили курс!',
      youHaveCompleted: 'Ви успішно завершили всі блоки цього курсу.',
      generateCertificate: 'Згенерувати сертифікат',
      certificateGenerated: 'Сертифікат згенерований',
      viewCertificate: 'Сертифікат',
      returnToDashboard: 'Повернутися до панелі управління',
      getCertificate: 'Отримати сертифікат',
      completeCourse: 'Завершити курс',
      lessonContainsItems: 'Цей урок містить',
      contentItems: 'елементи',
      lessonNavigationHint: 'Використовуйте кнопки навігації нижче або панель зліва, щоб переглянути кожен елемент цього уроку.',
      completeRequiredTests: 'Виконайте всі обов\'язкові тести та опитування в цьому уроці, перш ніж позначити його як завершений',
      markLessonComplete: 'Позначити урок як завершений',
      // Content type labels
      noVideoUrl: 'URL відео не вказано',
      textContent: 'Текстовий вміст',
      document: 'Документ',
      openDocumentNewTab: 'Відкрити документ у новій вкладці',
      noDocumentAvailable: 'Документ недоступний',
      image: 'Зображення',
      courseImage: 'Зображення курсу',
      noImageAvailable: 'Зображення недоступне',
      audio: 'Аудіо',
      browserNotSupportAudio: 'Ваш браузер не підтримує аудіо елемент.',
      downloadAudio: 'Завантажити аудіо',
      noAudioAvailable: 'Аудіо недоступне',
      externalLink: 'Зовнішнє посилання',
      visitLink: 'Відвідати посилання',
      noLinkAvailable: 'Посилання недоступне',
      completeTestPrompt: 'Пройдіть тест, щоб позначити його як завершений',
      completeSurveyPrompt: 'Пройдіть опитування, щоб позначити його як завершене',
      testModal: {
        title: 'Тест',
        timeRemaining: 'Залишилось часу',
        question: 'Питання',
        of: 'з',
        selectAnswer: 'Виберіть відповідь',
        selectMultiple: 'Виберіть всі правильні відповіді',
        true: 'Правда',
        false: 'Неправда',
        typeYourAnswer: 'Введіть вашу відповідь тут...',
        previous: 'Попереднє',
        next: 'Наступне',
        submit: 'Відправити',
        testResults: 'Результати тесту',
        score: 'Ваш результат',
        passed: 'Ви пройшли тест!',
        failed: 'Ви не пройшли тест',
        tryAgain: 'Спробувати знову',
        close: 'Закрити',
      },
      surveyModal: {
        title: 'Опитування',
        question: 'Питання',
        of: 'з',
        selectAnswer: 'Виберіть відповідь',
        selectMultiple: 'Виберіть всі відповідні варіанти',
        typeYourAnswer: 'Введіть вашу відповідь тут...',
        previous: 'Попереднє',
        next: 'Наступне',
        submit: 'Відправити',
        thankYou: 'Дякуємо!',
        surveyCompleted: 'Ваші відповіді на опитування були збережені.',
        close: 'Закрити',
      },
    },

    // Certificate
    certificate: {
      certificateOfCompletion: 'Сертифікат про завершення',
      thisIsToCertify: 'Цим підтверджується, що',
      hasSuccessfullyCompleted: 'успішно завершив(ла) курс',
      issuedOn: 'Виданий',
      certificateNumber: 'Номер сертифіката',
      verificationCode: 'Код перевірки',
      validUntil: 'Дійсний до',
      cpdCredits: 'Бали БПР',
      instructor: 'Інструктор',
      verifyAt: 'Перевірити за адресою',
      generatingCertificate: 'Генерація сертифіката...',
      generateCertificate: 'Згенерувати сертифікат',
      getCertificate: 'Отримати сертифікат',
      downloadCertificate: 'Завантажити сертифікат',
      shareOnLinkedIn: 'Поділитись в LinkedIn',
      shareOnFacebook: 'Поділитись в Facebook',
      shareOnTwitter: 'Поділитись в Twitter',
      copyLink: 'Копіювати посилання',
      linkCopied: 'Посилання скопійовано!',
      certificateGenerated: 'Сертифікат згенеровано успішно!',
      errorGeneratingCertificate: 'Помилка при генерації сертифіката',
      ticketNoCertificateAccess: 'Ваш тип квитка не включає доступ до сертифіката. Будь ласка, зверніться до організатора або оновіть свій квиток.',
      knowledgeChecked: 'Тест пройдено – знання перевірено',
      knowledgeCheckedDescription: 'Ви пройшли тест і перевірили свої знання по матеріалу. Це чудовий результат!',
      certificateInPremium: 'Ваш поточний квиток не передбачає отримання сертифікату',
      notOfferedForThisEvent: 'Для цієї події сертифікати не передбачені',
      certificateInPremiumDescription: 'Щоб отримати сертифікат – оновіть квиток',
      upgradeTicketForCertificate: 'Оновити квиток та отримати сертифікат',
      upgradeAvailableUntil: 'Можливість оновити квиток доступна до {{deadline}}',
      certificateNotAvailable: 'Сертифікат недоступний',
      pleaseCompleteCourse: 'Будь ласка, завершіть курс, щоб отримати сертифікат',
      checkingRequirements: 'Перевірка вимог',
      verifyingStatus: 'Перевірка статусу завершення курсу...',
      congratulationsMessage: 'Вітаємо з завершенням курсу! Згенеруйте офіційний сертифікат, щоб відзначити ваше досягнення.',
      completeRequirementsMessage: 'Виконайте вимоги нижче, щоб згенерувати сертифікат.',
      certificateRequirements: 'Вимоги для сертифіката',
      enrolledInCourse: 'Записані на курс',
      completedAllMaterials: 'Завершені всі матеріали курсу',
      passedCourseTest: 'Складено тест курсу',
      completeProfileInfo: 'Заповнена інформація профілю',
      eventHasEnded: 'Подія завершена',
      allRequiredTestsPassed: 'Всі обов\'язкові тести пройдено',
      allRequiredSurveysCompleted: 'Всі обов\'язкові опитування завершено',
      clickToGenerate: 'Натисніть кнопку нижче, щоб згенерувати свій сертифікат',
      notConfiguredYet: 'Сертифікат готується',
      notConfiguredDescription: 'Сертифікат для цієї події ще готується організатором. Він буде доступний найближчим часом.',
      templateNotConfigured: 'Сертифікат для цієї події ще не налаштований організатором. Якщо ви виконали всі вимоги – не хвилюйтесь, сертифікат стане доступним, щойно організатор завершить налаштування. Спробуйте пізніше.',
      whatYouWillGet: 'Що ви отримаєте',
      officialCertificate: 'Офіційний сертифікат про завершення курсу',
      uniqueNumber: 'Унікальний номер сертифіката для перевірки',
      pdfDownload: 'PDF-завантаження для ваших записів',
      pdfPreparing: 'PDF готується...',
      viewOnline: 'Переглянути онлайн',
      shareableLink: 'Посилання для перевірки, яким можна поділитись',
      completeRequirementsFirst: 'Спочатку виконайте вимоги',
      pleaseWaitGenerating: 'Будь ласка, зачекайте, поки ми створюємо ваш сертифікат...',
      // Event-specific certificate messages
      availableAfterEvent: 'Сертифікат буде доступний після завершення події',
      certificateAvailableAfterEventEnds: 'Завершіть усі необхідні вимоги після закінчення події, щоб отримати ваш сертифікат.',
      certificateIssued: 'Сертифікат видано',
      congratsEarnedCertificate: 'Вітаємо! Ви успішно заробили сертифікат про завершення події.',
      autoGenerateNote: 'Сертифікат генерується автоматично після виконання всіх вимог. Використовуйте кнопку вище, щоб завантажити його.',
      generationTimeout: 'Час очікування генерації сертифіката вичерпано - будь ласка, спробуйте ще раз',
      generationFailed: 'Не вдалося згенерувати сертифікат',
      statusCheckFailed: 'Не вдалося перевірити статус генерації сертифіката',
      eventNotEnded: 'Подія ще не завершилася. Сертифікати будуть доступні після завершення події.',
      testsNotPassed: 'Ви повинні пройти всі обов\'язкові тести перед генерацією сертифіката.',
      surveysNotCompleted: 'Ви повинні завершити всі обов\'язкові опитування перед генерацією сертифіката.',
      certificateUnavailable: 'Сертифікат недоступний',
      testNotPassedMessage: 'Тестування не було пройдене, тому сертифікат не був виданий. Будь ласка, зв\'яжіться з організатором події, якщо ви вважаєте, що це помилка.',
      surveysNotCompletedMessage: 'Обов\'язкові опитування не були завершені, тому сертифікат не був виданий. Будь ласка, спочатку завершіть всі обов\'язкові опитування.',
      missingTests: 'Не пройдені тести',
      missingSurveys: 'Не завершені опитування',
      pdfNotReady: 'PDF сертифіката ще не готовий',
      missing: 'Відсутні',
      generatingPdf: 'Генерація PDF сертифіката',
      generatingPdfEllipsis: 'Генерація PDF...',
      certificateReady: 'Сертифікат готовий!',
      certificateEligible: 'Сертифікат здобуто!',
      pdfAvailableAfterEvent: 'PDF буде доступний після завершення події.',
      certificateProcessing: 'Сертифікат генерується...',
      notConfiguredNotified: 'Організатор ще не налаштував сертифікат для вашого квитка. Ми вже повідомили організатора – сертифікат з\'явиться тут, щойно налаштування буде завершено.',
      renderGenerating: 'Сертифікат генерується. Зазвичай це займає до хвилини – сторінку можна закрити.',
      renderDelayed: 'Генерація триває довше, ніж зазвичай. Ми автоматично повторимо спробу – нічого робити не потрібно.',
      renderFailed: 'Не вдалося згенерувати сертифікат. Ми вже знаємо про проблему. Спробуйте ще раз або напишіть на support@confy.cc.',
      retryGeneration: 'Спробувати ще раз',
      waitingInQueue: 'Очікування в черзі...',
      creatingCertificate: 'Створення сертифіката...',
    },

    // Payment
    payment: {
      processingPayment: 'Обробка платежу...',
      redirectingToPayment: 'Перенаправлення на сторінку оплати...',
      paymentFailed: 'Платіж не вдався',
      paymentCancelled: 'Платіж скасовано',
      tryAgain: 'Спробувати знову',
      contactSupport: 'Звернутися до підтримки',
      payNow: 'Оплатити зараз',
      securePayment: 'Безпечний платіж',
      orderSummary: 'Підсумок замовлення',
      course: 'Курс',
      price: 'Ціна',
      total: 'Всього',
    },

    // Content Blocks
    contentBlocks: {
      text: 'Текст',
      video: 'Відео',
      pdf: 'PDF',
      document: 'Документ',
      presentation: 'Презентація',
      image: 'Зображення',
      audio: 'Аудіо',
      link: 'Посилання',
      test: 'Тест',
      survey: 'Опитування',
      dragToReorder: 'Перетягніть для зміни порядку',
      addTitle: 'Додати заголовок',
      addDescription: 'Додати опис',
      addContent: 'Додати вміст',
      enterTitle: 'Введіть заголовок...',
      enterDescription: 'Введіть опис...',
      enterContent: 'Введіть вміст...',
      enterVideoUrl: 'Введіть URL відео (YouTube, Vimeo)...',
      enterAudioUrl: 'Введіть URL аудіо...',
      enterLink: 'Введіть посилання...',
      uploadFile: 'Завантажити файл',
      uploadImage: 'Завантажити зображення',
      removeBlock: 'Видалити блок',
      confirmRemove: 'Ви впевнені, що хочете видалити цей блок?',
      videoEmbed: 'Вбудоване відео',
      addYouTubeVimeo: 'Додати відео з YouTube або Vimeo',
      textBlock: 'Текстовий блок',
      addTextFormatting: 'Додати текст та форматування',
      pdfDocument: 'PDF документ',
      uploadDisplayPDF: 'Завантажити та відобразити PDF файли',
      uploadDisplayImages: 'Завантажити та відобразити зображення',
      enterBlockTitle: 'Введіть заголовок блока...',
      pasteVideoUrl: 'Вставте URL YouTube або Vimeo тут...',
      enterContentMarkdown: 'Введіть ваш вміст тут... Ви можете використовувати форматування Markdown.',
      preview: 'Попередній перегляд',
      describeImage: 'Опишіть, що зображує картинка...',
      removeImage: 'Видалити зображення',
      failedToLoadImage: 'Не вдалося завантажити зображення',
      openPDF: 'Відкрити PDF',
      removePDF: 'Видалити PDF',
      pdfPreview: 'Попередній перегляд PDF',
      collapse: 'Згорнути',
      expand: 'Розгорнути',
      heading1: 'Заголовок 1',
      heading2: 'Заголовок 2',
      heading3: 'Заголовок 3',
      bold: 'Жирний',
      italic: 'Курсив',
      bulletList: 'Маркований список',
      noVideoUrl: 'URL відео не вказано',
      noImageAvailable: 'Зображення недоступне',
      noLinkUrl: 'URL посилання недоступне',
    },

    // Test Editor
    testEditor: {
      testEditor: 'Редактор тестів',
      createTest: 'Створити тест',
      editTest: 'Редагувати тест',
      testTitle: 'Назва тесту',
      enterTestTitle: 'Введіть назву тесту...',
      testDescription: 'Опис тесту',
      enterTestDescription: 'Введіть опис тесту...',
      passingScore: 'Прохідний бал',
      maxAttempts: 'Максимальна кількість спроб',
      unlimitedAttempts: 'Необмежені спроби',
      timeLimit: 'Часове обмеження (хвилини)',
      noTimeLimit: 'Без часового обмеження',
      questions: 'Питання',
      addQuestion: 'Додати питання',
      questionType: 'Тип питання',
      singleChoice: 'Одиночний вибір',
      multipleChoice: 'Множинний вибір',
      trueFalse: 'Правда/Неправда',
      essay: 'Есе',
      questionText: 'Текст питання',
      enterQuestionText: 'Введіть текст питання...',
      points: 'Бали',
      explanation: 'Пояснення (необов\'язково)',
      enterExplanation: 'Введіть пояснення для цього питання...',
      options: 'Варіанти відповідей',
      addOption: 'Додати варіант',
      optionText: 'Текст варіанту',
      isCorrect: 'Правильна відповідь',
      removeOption: 'Видалити варіант',
      removeQuestion: 'Видалити питання',
      saveTest: 'Зберегти тест',
      cancel: 'Скасувати',
      saving: 'Збереження...',
      createNewTest: 'Створити новий тест',
      description: 'Опис',
      knowledgeCheck: 'Перевірка знань',
      finalExam: 'Підсумковий іспит',
      type: 'Тип',
      answerOptions: 'Варіанти відповідей',
      requiredForCompletion: 'Обов\'язковий для завершення курсу',
      showResultsImmediately: 'Показувати результати відразу',
      pleaseProvideTestTitle: 'Будь ласка, вкажіть назву тесту',
      pleaseAddQuestion: 'Будь ласка, додайте хоча б одне питання',
      noQuestionsAdded: 'Питання ще не додано. Натисніть "Додати питання", щоб почати.',
      enterQuestionPlaceholder: 'Введіть питання...',
      enterOptionPlaceholder: 'Введіть варіант...',
      optionalExplanationPlaceholder: 'Необов\'язкове пояснення...',
      moduleKnowledgeCheck: 'наприклад, Перевірка знань Модуль 1',
      briefTestDescription: 'Короткий опис тесту...',
      noLimit: 'Без обмежень',
      preAssessment: 'Попередня оцінка',
    },

    // Survey Editor
    surveyEditor: {
      surveyEditor: 'Редактор опитувань',
      createSurvey: 'Створити опитування',
      editSurvey: 'Редагувати опитування',
      surveyTitle: 'Назва опитування',
      enterSurveyTitle: 'Введіть назву опитування...',
      surveyDescription: 'Опис опитування',
      enterSurveyDescription: 'Введіть опис опитування...',
      isAnonymous: 'Анонімне опитування',
      isRequired: 'Обов\'язкове опитування',
      questions: 'Питання',
      addQuestion: 'Додати питання',
      questionType: 'Тип питання',
      singleChoice: 'Одиночний вибір',
      multipleChoice: 'Множинний вибір',
      trueFalse: 'Так/Ні',
      essay: 'Текстова відповідь',
      questionText: 'Текст питання',
      enterQuestionText: 'Введіть текст питання...',
      isRequiredQuestion: 'Обов\'язкове питання',
      options: 'Варіанти відповідей',
      addOption: 'Додати варіант',
      optionText: 'Текст варіанту',
      removeOption: 'Видалити варіант',
      removeQuestion: 'Видалити питання',
      saveSurvey: 'Зберегти опитування',
      cancel: 'Скасувати',
      saving: 'Збереження...',
      anonymousResponses: 'Анонімні відповіді',
      textAnswer: 'Текстова відповідь',
      pleaseProvidenSurveyTitle: 'Будь ласка, вкажіть назву опитування',
      courseFeedbackSurvey: 'наприклад, Опитування зворотного зв\'язку курсу',
      briefSurveyDescription: 'Короткий опис опитування...',
      createCourseSurvey: 'Створити опитування курсу',
      surveyTitlePlaceholder: 'наприклад, Опитування зворотного зв\'язку курсу',
      description: 'Опис',
      descriptionPlaceholder: 'Короткий опис опитування...',
      requiredForCompletion: 'Обов\'язкове для завершення курсу',
      availableAfterCompletion: 'Доступне лише після завершення курсу',
      quickTemplates: 'Швидкі шаблони',
      satisfactionRating: 'Оцінка задоволеності',
      npsScore: 'NPS балл',
      improvementFeedback: 'Відгук щодо покращень',
      type: 'Тип',
      required: 'Обов\'язкове',
      answerOptions: 'Варіанти відповідей',
      enterQuestion: 'Введіть питання...',
      enterOption: 'Введіть варіант...',
      noQuestionsAdded: 'Питання ще не додано. Використовуйте швидкі шаблони вище або натисніть "Додати питання" для початку.',
      pleaseProvideTitleAlert: 'Будь ласка, вкажіть назву опитування',
      pleaseAddQuestionAlert: 'Будь ласка, додайте принаймні одне питання',
      satisfactionQuestion: 'Наскільки ви задоволені цим курсом?',
      verySatisfied: 'Дуже задоволений',
      satisfied: 'Задоволений',
      neutral: 'Нейтрально',
      dissatisfied: 'Незадоволений',
      veryDissatisfied: 'Дуже незадоволений',
      recommendQuestion: 'Наскільки ймовірно, що ви порекомендуєте цей курс колезі?',
      improvementQuestion: 'Які аспекти курсу можна покращити?',
    },

    // Certificates
    certificates: {
      yourCertificate: 'Ваш сертифікат',
      failedToLoad: 'Не вдалося завантажити сертифікат',
      allowPopups: 'Будь ласка, дозвольте спливаючі вікна для створення PDF',
      failedToGeneratePDF: 'Не вдалося створити PDF',
      myCertificate: 'Мій сертифікат',
      earnedCertificate: 'Я отримав сертифікат',
      linkCopied: 'Посилання для перевірки сертифіката скопійовано в буфер обміну!',
      loadingCertificate: 'Завантаження сертифіката...',
      errorLoadingCertificate: 'Помилка завантаження сертифіката',
      certificateDetails: 'Деталі сертифіката',
      certificateNumber: 'Номер сертифіката',
      issuedDate: 'Дата видачі',
      status: 'Статус',
      statusIssued: 'Видано',
      hidePreview: 'Сховати попередній перегляд',
      showPreview: 'Показати попередній перегляд',
      downloadPDF: 'Завантажити PDF',
      downloadCertificate: 'Завантажити сертифікат',
      shareCertificate: 'Поділитись сертифікатом',
      certificatePreview: 'Попередній перегляд сертифіката',
      previewDescription: 'Так виглядатиме ваш сертифікат при друці або поширенні',
      failedToGenerate: 'Не вдалося згенерувати сертифікат',
      failedToGenerateTryAgain: 'Не вдалося згенерувати сертифікат. Будь ласка, спробуйте ще раз.',
      allowPopupsDownload: 'Будь ласка, дозвольте спливаючі вікна для завантаження сертифіката',
      failedToDownload: 'Не вдалося завантажити сертифікат',
      myCourseCertificate: 'Мій сертифікат курсу',
      completedCourse: 'Я завершив',
      certificateGenerated: 'Сертифікат згенеровано!',
      successfullyCreated: 'Ваш сертифікат було успішно створено.',
      existingRetrieved: 'Ваш існуючий сертифікат було отримано.',
      verificationCode: 'Код перевірки',
      useCodeToVerify: 'Використовуйте цей код для перевірки автентичності вашого сертифіката.',
      creationFailed: 'Не вдалося створити сертифікат. Будь ласка, спробуйте пізніше.',
      ticketNoCertificateAccess: 'Ваш тип квитка не включає доступ до сертифіката. Будь ласка, зверніться до організатора або оновіть свій квиток.',
      certificateCreated: 'Сертифікат створено!',
      certificateReady: 'Сертифікат готовий',
      pdfReady: 'PDF сертифіката готовий до завантаження!',
      pdfGenerationTimeout: 'Генерація PDF зайняла занадто багато часу. Спробуйте ще раз.',
      pdfGenerationFailed: 'Не вдалося згенерувати PDF. Спробуйте ще раз.',

      // Report wrong template
      reportWrongTemplate: 'Щось не так із сертифікатом?',
      reportSending: 'Надсилання...',
      reportSent: 'Організатора повідомлено. Дякуємо, що повідомили!',
      reportFailed: 'Не вдалося надіслати повідомлення. Спробуйте ще раз.',
      reportDialogTitle: 'Проблема з шаблоном сертифіката?',
      reportDialogRegenerateHint: 'Спробуйте спочатку оновити сертифікат – можливо, шаблон вже було виправлено організатором.',
      reportDialogRegenerateBtn: 'Оновити сертифікат',
      reportDialogAlreadyRegenerated: 'Вже оновлювали і проблема залишилась?',
      reportDialogBody: 'Якщо ваш сертифікат виглядає не зовсім коректно – наприклад, порушена розмітка, відсутній текст або дизайн не відповідає очікуванням – це, найімовірніше, пов\'язано з шаблоном сертифіката, який налаштував організатор заходу.',
      reportDialogCta: 'Бажаєте, щоб ми надіслали повідомлення організатору? Він отримає сповіщення про можливу проблему з шаблоном сертифіката і зможе її переглянути та виправити.',
      reportDialogConfirm: 'Так, повідомити організатора',
      reportDialogCancel: 'Скасувати',
      reportDialogContactAlt: 'Також ви можете звернутися до організатора напряму:',
      reportDialogLoadingOrganizer: 'Завантаження...',

      // Builder View
      builderNoEditPermissionEvent: 'Ви не маєте прав для редагування цього заходу',
      builderNoEditPermissionCourse: 'Ви не маєте прав для редагування цього курсу',
      builderLoadingError: 'Помилка при завантаженні даних',
      builderSaveError: 'Помилка при збереженні даних',
      builderSaveSuccess: 'Налаштування сертифіката збережено!',
    },

    // Test Taking
    testTaking: {
      testCompleted: 'Тест завершено',
      score: 'Бал',
      passed: 'Здано',
      failed: 'Не здано',
      errorSubmitting: 'Помилка при відправці тесту',
      question: 'Питання',
      of: 'з',
      answerPlaceholder: 'Введіть вашу відповідь тут...',
      submitting: 'Відправка...',
      submitTest: 'Відправити тест',
      pointOne: 'бал',
      pointFew: 'бали',
      pointMany: 'балів',
    },

    // Survey Taking
    surveyTaking: {
      submittedSuccessfully: 'Опитування успішно відправлено',
      errorSubmitting: 'Помилка при відправці опитування',
      answerPlaceholder: 'Введіть вашу відповідь тут...',
      submitting: 'Відправка...',
      submitSurvey: 'Відправити опитування',
      question: 'Питання',
      anonymousSurvey: 'Це опитування є анонімним.',
    },

    // Fix Profile Page
    fixProfile: {
      updateProfile: 'Оновити профіль',
      updateYourProfile: 'Оновіть інформацію вашого профілю',
      firstName: 'Ім\'я',
      lastName: 'Прізвище',
      phone: 'Телефон',
      updating: 'Оновлення...',
      updateButton: 'Оновити профіль',
      profileUpdated: 'Профіль успішно оновлено!',
      redirecting: 'Перенаправлення...',
      errorUpdating: 'Помилка оновлення профілю',
    },

    // Event Creation
    eventCreation: {
      createNewEvent: 'Створити нову подію',
      createEvent: 'Створити подію',
      editEvent: 'Редагувати подію',
      basicInformation: 'Основна інформація',
      basicInformationDescription: 'Основні деталі вашої події',
      locationFormat: 'Місце і формат',
      locationFormatDescription: 'Коли і де відбудеться подія',
      organizerInformationDescription: 'Контактна інформація організатора події',
      settingsAndPricing: 'Налаштування',
      settingsAndPricingDescription: 'Налаштуйте параметри події',
      speakersPartners: 'Спікери та партнери',
      speakersPartnersDescription: 'Додайте інформацію про спікерів та організації-партнери (необов\'язково)',
      speakers: 'Спікери',
      partners: 'Партнери',
      hasPartners: 'У події є партнери',
      partnerOrganization: 'Партнери події',
      enterPartnerOrganizations: 'Вкажіть організації-партнери події',
      partnerOrganizationsDescription: 'Вкажіть організації або установи, які є партнерами події',
      saveEventFirstForPartners: 'Спочатку збережіть подію',
      saveEventFirstForPartnersDescription: 'Щоб додати партнерів з логотипами та додатковою інформацією, спочатку збережіть основну інформацію про подію.',
      complete: 'Заповнено',
      selected: 'Вибрано',
      eventPreview: 'Попередній перегляд події',
      onlineFormat: 'Дистанційна участь у режимі реального часу',
      displayParticipantCount: 'Відображати кількість зареєстрованих учасників на сторінці події',
      cpdCreditsDescription: 'Бали безперервного професійного розвитку',
      privateEventLabel: 'Приватна подія',
      privateEventDescription: 'Приватні події не відображаються публічно та потребують посилання-запрошення',
      showParticipantCountLabel: 'Показувати кількість зареєстрованих учасників',
      showParticipantCountDescription: 'Відображати кількість зареєстрованих учасників на сторінці події',
      showTargetSpecialtiesLabel: 'Показувати цільову аудиторію на сторінці події',
      showTargetSpecialtiesDescription: 'Відображати обрані спеціальності на публічній сторінці події',
      certificateTemplateSection: 'Шаблон сертифіката',
      advancedFeatures: 'Додатково',
      advancedFeaturesDescription: 'Опціональні функції для покращення події',
      testsSection: 'Тести',
      testsDescription: 'Додайте тести для учасників (необов\'язково)',
      surveysSection: 'Опитування',
      surveysDescription: 'Зберіть відгуки від учасників (необов\'язково)',
      materialsSection: 'Матеріали',
      materialsDescription: 'Завантажте програму та додаткові матеріали (необов\'язково)',
      ticketsSection: 'Квитки',
      ticketsDescription: 'Налаштуйте квитки для реєстрації учасників (необов\'язково)',
      additionalQuestionsSection: 'Додаткові питання',
      additionalQuestionsDescription: 'Додайте особливі питання окрім базових полів профілю (необов\'язково)',
      mozSubmissionSection: 'БПР',
      navigation: 'Навігація',
      fillInRequired: 'Заповніть',
      requiredToFillIn: 'Необхідно заповнити',
      pleaseFirstSaveEvent: 'Будь ласка, спочатку збережіть основну інформацію події, щоб отримати доступ до додаткових опцій.',
      saveFirstMessage: 'Спочатку збережіть основну інформацію про подію',
      testsAvailableAfter: 'Тести доступні після збереження',
      surveysAvailableAfter: 'Опитування доступні після збереження',
      materialsAvailableAfter: 'Додаткові матеріали доступні після збереження',
      eventInformation: 'Інформація про подію',
      eventName: 'Назва події',
      titleRequired: 'Введіть назву події для збереження',
      enterEventName: 'Введіть назву події...',
      targetAudience: 'Цільові спеціалізації',
      selectTargetAudience: 'Виберіть цільову аудиторію...',
      eventType: 'Тип події (опціонально)',
      selectEventType: 'Виберіть тип події...',
      eventLocation: 'Місце проведення',
      eventFormat: 'Формат події',
      offline: 'Оффлайн',
      online: 'Онлайн',
      onlineEventUrl: 'Посилання на онлайн-подію',
      enterOnlineEventUrl: 'Введіть посилання на онлайн-подію...',
      onlineEventUrlHint: 'Надайте посилання на платформу, де відбудеться подія (наприклад, Zoom, Google Meet)',
      physicalLocation: 'Місце проведення',
      locationCountry: 'Країна',
      locationCountryPlaceholder: 'Оберіть країну',
      locationRegion: 'Область',
      locationRegionPlaceholder: 'Введіть область...',
      locationRegionSelectPlaceholder: 'Оберіть область',
      locationRegionSelectCountryFirst: 'Спочатку оберіть країну',
      locationDistrict: 'Район',
      locationDistrictPlaceholder: 'Введіть район...',
      locationCity: 'Місто',
      locationCityPlaceholder: 'Введіть місто...',
      locationStreet: 'Вулиця',
      locationStreetPlaceholder: 'Введіть назву вулиці...',
      locationBuilding: 'Будинок',
      locationBuildingPlaceholder: 'Введіть номер будинку...',
      locationAuditorium: 'Аудиторія/Зал',
      locationAuditoriumPlaceholder: 'Введіть номер аудиторії або назву залу...',
      dateAndTime: 'Дата та час події',
      timezone: 'Часовий пояс',
      timezoneHelper: 'Час події. Відвідувачі побачать час у своєму часовому поясі',
      timezoneOther: 'Інший',
      timezoneOtherPlaceholder: 'Наприклад: America/New_York',
      startDate: 'Дата початку',
      startsAt: 'Починається в',
      endDate: 'Дата закінчення',
      endsAt: 'Закінчується в',
      selectStartDateTime: 'Оберіть дату та час початку',
      selectEndDateTime: 'Оберіть дату та час завершення',
      startDateRequired: 'Дата початку обов\'язкова',
      endDateRequired: 'Дата закінчення обов\'язкова',
      invalidStartDate: 'Невірна дата початку. Будь ласка, введіть коректну дату.',
      invalidEndDate: 'Невірна дата закінчення. Будь ласка, введіть коректну дату.',
      endDateBeforeStartError: 'Дата закінчення не може бути раніше дати початку',
      organizerInformation: 'Інформація про організатора',
      organizerName: 'Організатор події',
      enterOrganizerName: 'Введіть ім\'я організатора...',
      organizerEmail: 'Email організатора',
      enterOrganizerEmail: 'Введіть email...',
      organizerPhone: 'Телефон організатора',
      enterOrganizerPhone: 'Введіть номер телефону...',
      organizerPhoneRequired: 'Телефон організатора обов\'язковий',
      organizerDescription: 'Опис організатора',
      enterOrganizerDescription: 'Розкажіть про організатора, його досвід та сферу діяльності...',
      organizerDescriptionHint: 'Коротка інформація про організатора (необов\'язково)',
      organizerWebsite: 'Веб-сайт організатора',
      enterOrganizerWebsite: 'https://example.com',
      organizerWebsiteHint: 'Веб-сайт організатора події',
      organizerFacebook: 'Facebook організатора',
      enterOrganizerFacebook: 'https://facebook.com/...',
      organizerFacebookHint: 'Сторінка організатора у Facebook',
      browseOrganizers: 'Організатори',
      noOrganizerYet: 'Організатора ще не додано',
      createNew: 'Створити нового',
      changeOrganizer: 'Змінити організатора',
      createNewOrganizer: 'Створити організатора',
      createNewOrganizerDescription: 'Заповніть форму, щоб додати нового організатора до вашого списку',
      website: 'Веб-сайт',
      organizerNameRequired: 'Обов\'язкове поле',
      organizerEmailRequired: 'Обов\'язкове поле',
      organizerSaved: 'Організатора збережено',
      invalidEmail: 'Невірний формат email',
      bprPointsError: 'Бали БПР мають бути від 0 до 1000',
      meetingUrlError: 'Будь ласка, введіть коректну URL-адресу (наприклад, https://example.com)',
      phoneError: 'Будь ласка, введіть коректний номер телефону (мінімум 10 цифр)',
      websiteUrlError: 'Будь ласка, введіть коректну URL-адресу (наприклад, https://example.com)',
      facebookUrlError: 'Будь ласка, введіть коректну URL-адресу (наприклад, https://facebook.com/...)',
      selectOrganizerToAutofill: 'Оберіть організатора для автозаповнення',
      searchOrganizers: 'Пошук за ім\'ям, email, телефоном...',
      noOrganizersFound: 'Організаторів не знайдено',
      noOrganizers: 'Немає збережених організаторів',
      quickFillOrganizer: 'Швидке заповнення',
      selectExistingOrganizer: 'Оберіть організатора зі списку для автоматичного заповнення даних',
      organizerImage: 'Зображення організатора',
      organizerImageDescription: 'Логотип або фото організатора/організації',
      uploadOrganizerImage: 'Завантажити зображення організатора',
      addOrganizer: 'Додати',
      editOrganizer: 'Редагувати організатора',
      addNewOrganizer: 'Новий організатор',
      errorFetchingOrganizers: 'Помилка завантаження організаторів',
      organizerNameEmailRequired: 'Ім\'я та email обов\'язкові',
      organizerUpdated: 'Організатора оновлено',
      organizerCreated: 'Організатора створено',
      organizerSelected: 'Організатора обрано',
      errorSavingOrganizer: 'Помилка збереження організатора',
      errorSavingPayment: 'Помилка збереження налаштувань оплати',
      confirmDeleteOrganizer: 'Ви впевнені, що хочете видалити цього організатора?',
      deleteOrganizer: 'Видалити організатора',
      organizerDeleted: 'Організатора видалено',
      errorDeletingOrganizer: 'Помилка видалення організатора',
      confirmReplaceOrganizer: 'Поточні дані організатора будуть видалені. Продовжити?',
      removeOrganizerConfirmTitle: 'Прибрати організатора з події?',
      removeOrganizerConfirmDescription: 'Організатора буде прибрано з цієї події. Дані організатора залишаться збереженими для використання в інших подіях.',
      removeOrganizerButton: 'Прибрати',
      // Program generator specific
      removeProgramOrganizerConfirmTitle: 'Прибрати організатора з програми?',
      removeProgramOrganizerConfirmDescription: 'Організатора буде прибрано з програми заходу. Дані організатора залишаться збереженими для використання в інших заходах.',
      organizerManagement: {
        title: 'Поділитись доступом',
        manageTitle: 'Керування організаторами',
        manageDescription: 'Запросіть інших людей допомогти організувати та керувати цією подією. Організатори мають такі ж права, як і ви.',
        description: 'Керуйте тими, хто може організовувати',
        event: 'цю подію',
        course: 'цей курс',
        inviteOrganizer: 'Запросити організатора',
        emailAddress: 'Адреса електронної пошти',
        emailPlaceholder: 'organizer@example.com',
        sendInvite: 'Надіслати запрошення',
        sending: 'Надсилання...',
        cancel: 'Скасувати',
        invitationNote: 'Людина отримає запрошення електронною поштою з посиланням для прийняття або відхилення.',
        currentOrganizers: 'Поточні організатори',
        noOrganizersYet: 'Організаторів ще немає.',
        owner: 'Власник',
        joined: 'Приєднався',
        pendingInvitations: 'Очікувані запрошення',
        sent: 'Надіслано',
        expires: 'Закінчується',
        expired: 'Закінчився',
        pending: 'Очікує',
        pleaseEnterEmail: 'Будь ласка, введіть адресу електронної пошти',
        pleaseEnterValidEmail: 'Будь ласка, введіть дійсну адресу електронної пошти',
        invitationSentSuccessfully: 'Запрошення успішно надіслано!',
        invitationCancelledSuccessfully: 'Запрошення успішно скасовано!',
        failedToLoadOrganizers: 'Не вдалося завантажити організаторів',
        failedToSendInvitation: 'Не вдалося надіслати запрошення',
        failedToCancelInvitation: 'Не вдалося скасувати запрошення',
        // Remove organizer
        removeOrganizer: 'Видалити організатора',
        removeOrganizerConfirmTitle: 'Прибрати організатора?',
        removeOrganizerConfirmDescription: '{{name}} буде прибрано зі списку організаторів. Вони більше не зможуть редагувати або керувати цим контентом.',
        removeButton: 'Прибрати',
        cancelButton: 'Скасувати',
        organizerRemovedSuccessfully: 'Організатора успішно прибрано',
        failedToRemoveOrganizer: 'Не вдалося прибрати організатора',
      },
      imageAndDescription: 'Зображення і опис події',
      mainEventImage: 'Головне зображення події',
      imageOptionalHint: 'Якщо ви не завантажите зображення, буде використано загальний шаблон',
      clickToUpload: 'Натисніть для завантаження зображення',
      shortDescription: 'Опис події',
      enterShortDescription: 'Введіть опис...',
      programHint: 'Детальна програма або порядок денний вашої події',
      enterEventProgram: 'Введіть програму події...',
      linksAndVisibility: 'Посилання та видимість події (опціонально)',
      eventWebsite: 'Веб-сайт події',
      enterEventWebsite: 'Введіть URL веб-сайту...',
      facebookPage: 'Facebook сторінка події',
      enterFacebookPage: 'Введіть URL Facebook сторінки...',
      privateEvent: 'Це приватна подія. Приватні події не видні в нашому каталозі, вони доступні тільки за посиланням',
      linkToEvent: 'Посилання на подію',
      showParticipantCount: 'Показувати кількість зареєстрованих учасників (Кількість буде відображатися на сторінці події)',
      bprPoints: 'Кількість балів БПР',
      enterBprPoints: 'Введіть кількість балів...',
      eventCost: 'Скільки коштує подія',
      enterEventCost: 'Введіть вартість...',
      free: 'Безкоштовно',
      saveEvent: 'Зберегти подію',
      saving: 'Збереження...',
      saveFailed: 'Не вдалося зберегти подію',
      eventSavedSuccessfully: 'Подію успішно збережено!',
      eventUpdatedSuccessfully: 'Подію успішно оновлено!',
      conflictDetected: 'Виявлено конфлікт',
      conflictMessage: 'Цю подію було змінено в іншій вкладці або браузері з моменту її відкриття. Якщо зберегти зараз, ваші зміни перезапишуть нову версію.',
      loadLatest: 'Завантажити останню',
      keepMine: 'Залишити мою',
      saveAnyway: 'Перезаписати',
      conflictCancel: 'Скасувати',
      eventPublishedSuccessfully: 'Подію успішно опубліковано!',
      eventUnpublishedSuccessfully: 'Публікацію події скасовано!',
      readyToPublish: 'Готово до публікації!',
      completeToPublish: 'Щоб опублікувати, заповніть:',
      sectionsIncomplete: 'розділів незавершено',
      publishRequirements: {
        title: 'Назву події',
        targetSpecialties: 'Цільову аудиторію',
        startDate: 'Дату початку',
        endDate: 'Дату завершення',
        location: 'Місце проведення',
        meetingUrl: 'Посилання на подію',
        locationAndMeetingUrl: 'Місце проведення та посилання на подію',
        organizer: 'Організатора',
        speakers: 'Хоча б одного спікера',
        paymentCredentials: 'Налаштування оплати для організатора',
      },
      paymentConfigured: 'Оплата налаштована',
      paymentNotConfigured: 'Оплата не налаштована',
      setupPayment: 'Налаштувати →',
      errorSavingEvent: 'Помилка збереження події',
      preview: 'Попередній перегляд',
      previewDescription: 'Так ваша подія виглядатиме для відвідувачів',
      previewNote: 'Перегляд для зареєстрованих користувачів',
      previewNoteDescription: 'Цей попередній перегляд показує весь вміст, до якого матимуть доступ зареєстровані користувачі протягом події.',
      untitledEvent: 'Подія без назви',
      noImageUploaded: 'Зображення не завантажено',
      requiredFieldsMissing: 'Необхідно заповнити обов\'язкові поля',
      pleaseEnterEventName: 'Будь ласка, введіть назву події',
      pleaseSelectTargetAudience: 'Будь ласка, виберіть цільову аудиторію',
      pleaseEnterLocation: 'Будь ласка, введіть місце проведення',
      pleaseEnterOrganizerName: 'Будь ласка, додайте організатора',
      pleaseEnterOrganizerEmail: 'Будь ласка, введіть email організатора',
      invalidEmailFormat: 'Невірний формат email',
      testAndSurvey: 'Тест і опитування',
      test: 'Тест',
      survey: 'Опитування',
      manageTest: 'Керувати тестом',
      manageSurvey: 'Керувати опитуванням',
      hideTest: 'Сховати тест',
      hideSurvey: 'Сховати опитування',
      unsavedChanges: 'Незбережені зміни',
      unsavedChangesWarning: 'У вас є незбережені зміни. Ви впевнені, що хочете закрити? Усі незбережені зміни будуть втрачені.',
      discardChanges: 'Відкинути зміни',
      saveFailedRetrying: 'Помилка збереження. Повторна спроба через {{seconds}}с... (Спроба {{attempt}}/{{max}})',
      saveFailedAllRetries: 'Помилка збереження після всіх спроб',
      paymentCredentialsRequired: 'Платіжні дані не налаштовані. Щоб створити платну подію/курс, будь ласка, налаштуйте платіжні дані в налаштуваннях організатора.',
      configurePaymentSettings: 'Налаштувати платіжні дані',
    },

    // Event Test & Survey Management
    eventTestSurvey: {
      deleteSurvey: 'Видалити опитування',
      deleteSurveyConfirmation: 'Ви впевнені, що хочете видалити це опитування? Усі питання, пов\'язані з ним, також будуть видалені. Цю дію не можна скасувати.',
      deleteSurveyConfirmationWithResponses: 'На це опитування вже відповіли {{count}} учасників. Видалення назавжди знищить опитування разом з усіма відповідями. Цю дію не можна скасувати. Продовжити?',
      deleteSurveyFailed: 'Не вдалося видалити опитування. Спробуйте ще раз.',
      deleteSurveyBlocked: 'Немає прав на видалення цього опитування.',
      deleteSurveySuccess: 'Опитування видалено',
      deleteQuestionFailed: 'Не вдалося видалити питання. Спробуйте ще раз.',
      deleteLastQuestionConfirmation: 'Це останнє питання опитування. Без питань опитування не показуватиметься учасникам, доки ви не додасте нове питання. Продовжити?',
      titleRequired: 'Вкажіть назву опитування',
      atLeastOneQuestionRequired: 'Додайте щонайменше одне питання - опитування без питань не показується учасникам',
      allQuestionsNeedText: 'Заповніть текст усіх питань',
      disableSurvey: 'Вимкнути опитування',
      enableSurvey: 'Увімкнути опитування',
      surveyDisabled: 'Опитування вимкнено - учасники його не бачать',
      surveyEnabled: 'Опитування увімкнено',
      toggleActiveFailed: 'Не вдалося змінити статус опитування. Спробуйте ще раз.',
      disabled: 'Вимкнено',
      noQuestionsBadge: 'Без питань',
      responsesBadge: 'Відповідей: {{count}}',
      testDescription: 'Ви можете додати один тест для цієї події. Тести будуть доступні учасникам тільки після закінчення події.',
      surveyDescription: 'Ви можете додати одне опитування для цієї події. Опитування можна налаштувати так, щоб воно було доступне до або після події.',
      addTest: 'Додати тест',
      addSurvey: 'Додати опитування',
      loadingTests: 'Завантаження тестів...',
      loadingSurveys: 'Завантаження опитувань...',
      noTestsYet: 'Поки немає тестів',
      noSurveysYet: 'Поки немає опитувань',
      selectTest: 'Виберіть тест для перегляду та редагування питань',
      selectSurvey: 'Виберіть опитування для перегляду та редагування питань',
      noMaterialsYet: 'Поки немає матеріалів',
      noQuestionsYet: 'Поки немає питань',
      testSettings: 'Налаштування тесту',
      surveySettings: 'Налаштування опитування',
      edit: 'Редагувати',
      save: 'Зберегти',
      cancel: 'Скасувати',
      type: 'Тип',
      passingScore: 'Прохідний бал',
      timeLimit: 'Обмеження часу',
      maxAttempts: 'Максимум спроб',
      available: 'Доступно',
      noLimit: 'Без обмежень',
      minutes: 'хвилин',
      afterEventEnds: 'Після закінчення події',
      anytime: 'Будь-коли',
      availableFrom: 'Доступно з',
      availableUntil: 'Доступно до',
      selectDateTime: 'Виберіть дату та час',
      noExpiration: 'Без обмеження терміну',
      questions: 'Питання',
      addQuestion: 'Додати питання',
      question: 'Питання',
      points: 'Бали',
      explanation: 'Пояснення',
      optional: 'необов\'язково',
      answerOptions: 'Варіанти відповідей',
      addOption: 'Додати варіант',
      title: 'Назва',
      description: 'Опис',
      anonymous: 'Анонімно',
      required: 'Обов\'язково',
      anonymousResponses: 'Анонімні відповіді',
      requiredSurvey: 'Обов\'язкове опитування',
      requiredTest: 'Обов\'язковий тест для сертифікату',
      onlyAvailableAfterEventEnds: 'Доступно тільки після закінчення події',
      yes: 'Так',
      no: 'Ні',
      options: 'Варіанти',
      afterEventOnly: 'Тільки після події',
      testTypes: {
        preAssessment: 'Попередня оцінка',
        knowledgeCheck: 'Перевірка знань',
        finalExam: 'Підсумковий екзамен',
      },
      questionTypes: {
        shortText: 'Короткий текст',
        singleChoice: 'Один варіант',
        multipleChoice: 'Декілька варіантів',
        trueFalse: 'Так/Ні',
        essay: 'Есе',
        textResponse: 'Текстова відповідь',
      },
      addVideoLinks: 'Додайте відеопосилання, завантажте PDF або додайте інші ресурси для цієї події',
      addVideoLink: 'Додати відеопосилання',
      addPDF: 'Додати PDF',
      materials: 'Матеріали',
      certificateTemplate: 'Шаблон сертифіката',
      certificateTemplateHTML: 'Шаблон сертифіката',
      certificateTemplatePlaceholder: 'Введіть HTML шаблон для сертифіката або залиште порожнім для шаблону за замовчуванням...',
      usePlaceholders: 'Використовуйте параметри',
      saveEventFirst: 'Спочатку збережіть деталі події',
      saveEventFirstDesc: 'Натисніть "Зберегти подію" нижче, щоб зберегти деталі події, після чого ви зможете додавати тести, опитування та матеріали.',
      deleteTest: 'Видалити тест',
      deleteTestConfirmation: 'Ви впевнені, що хочете видалити цей тест? Усі питання, пов\'язані з цим тестом, також будуть видалені. Цю дію не можна скасувати.',
      deleteTestConfirmationNoAttempts: 'Ніхто ще не проходив цей тест. Тест та всі його питання будуть видалені. Продовжити?',
      deleteTestConfirmationWithAttempts: 'Цей тест пройшли {{total}} учасників ({{passed}} успішно). Видалення назавжди видалить усі результати проходження. Видані сертифікати залишаться без змін. Ви впевнені?',
      deleteQuestion: 'Видалити питання',
      deleteQuestionConfirmation: 'Ви впевнені, що хочете видалити це питання? Цю дію не можна скасувати.',
      delete: 'Видалити',
      createTest: 'Створити тест',
      createSurvey: 'Створити опитування',
      saving: 'Збереження...',
      enterTestTitle: 'Введіть назву тесту',
      enterSurveyTitle: 'Введіть назву опитування',
      enterQuestion: 'Введіть текст питання',
      enterOption: 'Введіть варіант відповіді',
      noQuestionText: 'Немає тексту питання',
      emptyOption: 'Порожній варіант',
      true: 'Правда',
      false: 'Хибно',
      validationTitle: 'Увага',
      validationEnterQuestion: 'Будь ласка, введіть текст питання та щонайменше дві відповіді.',
      validationMinOptions: 'Будь ласка, введіть щонайменше два варіанти відповідей.',
      validationSelectCorrect: 'Будь ласка, виберіть правильну відповідь.',
      validationMinOneQuestion: 'Будь ласка, додайте щонайменше одне питання з текстом та варіантами відповідей.',
      saveFailed: 'Не вдалося зберегти питання тесту. Спробуйте ще раз.',
      deleteFailed: 'Не вдалося видалити тест. Спробуйте ще раз.',
      editTest: 'Редагувати тест',
      shuffleQuestions: 'Перемішувати питання',
      shuffleOptions: 'Перемішувати варіанти відповідей',
      // Post-event notification info
      notificationInfo: {
        title: 'Автоматичне сповіщення учасників',
        description: 'Після завершення події учасники автоматично отримають email-сповіщення про те, що тести та опитування стали доступними.',
        timing: 'Сповіщення надсилаються протягом 15 хвилин після часу завершення події.',
        endTimeWarning: 'Переконайтеся, що дата та час завершення події вказані правильно!',
        checkEndTime: 'Перевірте час завершення у розділі "Основна інформація".',
      },
    },

    // Materials Management (uk overrides; other keys fall back to en)
    materialsManagement: {
      copyParticipantsLink: 'Копіювати посилання для учасників',
      copyPublicLink: 'Копіювати публічне посилання',
      publicLink: 'Публічне посилання',
      publicLinkHint: 'Будь-хто з цим посиланням зможе дивитися запис без входу',
      publicLinkOn: 'Публічне посилання увімкнено',
      publicLinkOff: 'Публічне посилання вимкнено – старе посилання більше не працює',
      linkCopied: 'Посилання скопійовано',
      linkError: 'Не вдалося оновити посилання',
      defaultDocumentTitle: 'Слайди презентації',
      defaultLinkTitle: 'Відеозапис',
      pdfRequired: 'Завантажте PDF файл, щоб зберегти цей матеріал',
    },

    // Streaming functionality
    // In-platform video recording page
    recording: {
      watch: 'Дивитися відеозапис',
      notFound: 'Відеозапис не знайдено',
      loginRequired: 'Увійдіть, щоб переглянути відеозапис',
      notEnrolled: 'Відеозапис доступний лише зареєстрованим учасникам події',
      ticketRestricted: 'Ваш квиток не включає доступ до матеріалів',
      upcoming: 'Відеозапис ще недоступний. Доступно з:',
      closed: 'Термін доступу до відеозапису завершився:',
      signIn: 'Увійти',
      backToEvent: 'До сторінки події',
    },

    streaming: {
      // Event Builder Streaming Section
      sectionTitle: 'Онлайн-трансляція',
      sectionDescription: 'Налаштуйте пряму трансляцію для вашої події з чатом',
      embedUrlLabel: 'URL для вставки трансляції (iframe src)',
      embedUrlPlaceholder: 'https://youtube.com/embed/... або https://vimeo.com/...',
      embedUrlHint: 'Введіть URL для вставки вашої трансляції (YouTube, Vimeo або інше джерело iframe)',
      linkReadyTitle: 'Посилання на трансляцію готове!',
      linkReadyDescription: 'Поділіться цим посиланням з учасниками, щоб вони могли дивитися трансляцію та брати участь у чаті:',
      copyLinkButton: 'Копіювати посилання',
      linkCopiedToast: 'Посилання на трансляцію скопійовано!',

      // Stream Page
      loadingStream: 'Завантаження трансляції...',
      liveStreamSubtitle: 'Пряма трансляція',
      liveStreamTitle: 'Пряма трансляція',
      liveStreamFeature: 'прямої трансляції',
      noStreamAvailable: 'Трансляція недоступна',
      live: 'НАЖИВО',
      watching_one: 'дивиться',
      watching_other: 'дивляться',
      theaterMode: 'Режим театру',
      exitTheaterMode: 'Вийти з режиму театру',
      chat: 'Чат',

      // Live Chat
      chatHeader: 'Чат наживо',
      messageCount_one: '{{count}} повідомлення',
      messageCount_few: '{{count}} повідомлення',
      messageCount_many: '{{count}} повідомлень',
      message: 'повідомлення',
      messages: 'повідомлень',
      noMessagesYet: 'Поки що немає повідомлень',
      beFirstToChat: 'Будьте першим, хто залишить повідомлення!',
      deleteMessageButton: 'Видалити повідомлення',
      messageDeleted: 'Повідомлення видалено',

      // Message Input
      messagePlaceholder: 'Напишіть повідомлення...',
      sendMessage: 'Надіслати повідомлення...',
      characterCount: '{{count}}/500 символів',
      joinConversation: 'Приєднуйтесь до розмови',
      signInToParticipate: 'Увійдіть, щоб брати участь у чаті наживо',
      signInToChat: 'Увійти в чат',
      loginPrompt: 'Увійдіть, щоб брати участь у чаті',
      loginButton: 'Увійти',

      // Error Messages
      eventNotFound: 'Подію не знайдено',
      noStreamConfigured: 'Для цієї події не налаштовано пряму трансляцію',
      failedToLoadEvent: 'Не вдалося завантажити подію',
      pleaseLoginToChat: 'Будь ласка, увійдіть для відправки повідомлень',
      messageTooLong: 'Повідомлення занадто довге (максимум 500 символів)',
      failedToSendMessage: 'Не вдалося відправити повідомлення',
      failedToDeleteMessage: 'Не вдалося видалити повідомлення',
      invalidStreamUrl: 'Недійсна URL-адреса трансляції. Можна вставляти тільки відео з YouTube або Vimeo.',
      onlyYoutubeVimeo: 'З міркувань безпеки можна вставляти тільки відео з YouTube та Vimeo.',

      // Builder View
      builderTitle: 'Онлайн-трансляція',
      builderDescription: 'Налаштуйте онлайн-трансляцію для вашого заходу',
      urlLabel: 'URL для вбудовування (YouTube або Vimeo)',
      urlPlaceholder: 'https://www.youtube.com/watch?v=...',
      urlHint: 'Вставте посилання на YouTube або Vimeo відео для трансляції',
      participantLinkReady: 'Посилання для учасників готове',
      shareWithParticipants: 'Поділіться цим посиланням з учасниками для перегляду трансляції',
      copy: 'Копіювати',
      noEditPermission: 'Ви не маєте прав для редагування цього заходу',
      loadingError: 'Помилка при завантаженні даних',
      saveError: 'Помилка при збереженні даних',
      saveSuccess: 'Налаштування стрімінгу збережено!',
      invalidUrlFormat: 'Невірний формат URL',
      linkCopied: 'Посилання скопійовано!',
      loading: 'Завантаження...',
      saving: 'Збереження...',
      save: 'Зберегти',
    },

    // UI Components
    ui: {
      languageSwitcher: {
        english: 'Англійська',
        ukrainian: 'Українська',
        toggleMenu: 'Перемкнути меню',
      },
      search: {
        emergencyMedicine: 'Невідкладна медицина',
        surgery: 'Хірургія',
        internalMedicine: 'Внутрішні хвороби',
        cardiology: 'Кардіологія',
        pediatrics: 'Педіатрія',
        radiology: 'Радіологія',
        anesthesiology: 'Анестезіологія',
        neurology: 'Неврологія',
        anyFormat: 'Будь-який формат',
        inPerson: 'Очно',
        online: 'Онлайн',
        hybrid: 'Гібридний',
        selfPaced: 'Самостійний темп',
        popularSearches: 'Популярні пошуки:',
        acls: 'ACLS',
        bls: 'BLS',
        surgeryUpdates: 'Оновлення хірургії',
        mentalHealth: 'Психічне здоров\'я',
        pediatricEmergency: 'Педіатрична невідкладна допомога',
      },
      courseCard: {
        coursePreview: 'Попередній перегляд курсу',
        imageBlock: 'Блок зображення',
      },
      currency: {
        label: 'Валюта',
        switchTitle: 'Змінити валюту заходу?',
        switchDescription: 'Для заходу можна обрати лише одну валюту. Змінити валюту на {{currency}} для всіх квитків і промокодів?',
        lockedHint: 'Валюту не можна змінити: вже є оплати',
        merchantHint: 'Переконайтеся, що ваш мерчант WayForPay/LiqPay приймає цю валюту',
        locked: 'Валюту не можна змінити: вже є оплати',
        copyCurrencyTitle: 'Квитки в іншій валюті',
        copyLocked: 'Квитки скопійовано у валюті заходу ({{currency}}). Перевірте ціни.',
        copyMixed: 'Обрані квитки мають різні валюти. Ціни буде скопійовано числами у валюті заходу.',
      },
      tickets: {
        description: 'Квитки можуть бути безкоштовними або платними.',
        addTicket: 'Додати квиток',
        newTicket: 'Новий квиток',
        editTicket: 'Редагувати квиток',
        noTicketsYet: 'Поки немає квитків',
        addFirstTicket: 'Додайте перший квиток, щоб почати продаж.',
        ticketName: 'Назва квитка',
        ticketNamePlaceholder: 'Наприклад: Ранній квиток, VIP квиток, Стандартний квиток',
        ticketDescription: 'Опис квитка',
        descriptionPlaceholder: 'Опишіть що входить в цей квиток...',
        ticketType: 'Вид квитка',
        free: 'Безкоштовний',
        paid: 'Платний',
        price: 'Ціна',
        quantity: 'Кількість',
        unlimitedQuantity: 'Необмежено',
        quantityHint: 'Залиште порожнім для необмеженої кількості',
        status: 'Статус',
        statusAvailable: 'Доступний',
        statusSoldOut: 'Розпродано',
        statusDiscontinued: 'Знято з продажу',
        saleStartDate: 'Дата початку продажу',
        saleStartHint: 'Опціонально: Виберіть коли починається продаж',
        saleEndDate: 'Дата закінчення продажу',
        saleEndHint: 'Опціонально: Виберіть коли закінчується продаж',
        sold: 'Зареєстровано',
        remaining: 'Залишилось',
        unlimited: 'Необмежено',
        salePeriod: 'Період продажу',
        startsAt: 'Починається',
        endsAt: 'Закінчується',
        confirmDelete: 'Ви впевнені, що хочете видалити цей квиток?',
        confirmDeleteDescription: 'Після видалення квитка він стане недоступним для учасників. Цю дію не можна скасувати.',
        deleteSuccess: 'Квиток успішно видалено',
        deleteError: 'Не вдалося видалити квиток',
        saveEventFirst: 'Будь ласка, спочатку збережіть подію перед додаванням квитків.',
        createTicketError: 'Не вдалося створити квиток: ',
        requiresPromocode: 'Прихований. Реєстрація тільки за промокодом',
        requiresPromocodeHint: 'Користувачі зможуть побачити цей квиток і придбати його, якщо введуть промокод',
        requiresPromocodeLabel: 'Вимагає промокоду:',
        selectPromocode: 'Виберіть промокод',
        selectPromocodeOption: '-- Оберіть промокод --',
        noPromocodes: 'Немає доступних промокодів.',
        noPromocodesLink: 'Натисніть тут, щоб створити новий промокод зараз.',
        noPromocodesAfter: 'Ви зможете налаштувати його у розділі меню Промокоди пізніше.',
        promococeNotFound: 'Промокод не знайдено',
        noPromocodeSelected: 'Промокод не обраний',
        // Ticket Permissions
        ticketPermissions: 'Дозволи квитку',
        allowCertificate: 'Дозволити генерацію сертифіката',
        certificateTypes: 'Типи сертифікатів',
        certificateTypesHint: 'Оберіть які типи сертифікатів можуть отримати власники цього квитка',
        certificateTypeParticipant: 'Сертифікат учасника',
        certificateTypeSpeaker: 'Сертифікат спікера',
        allowMaterials: 'Дозволити доступ до матеріалів',
        allowStream: 'Дозволити доступ до трансляції',
        permissionsHint: 'Зніміть позначку, щоб обмежити доступ для користувачів з цим типом квитка',
        // Custom Fields
        customFields: 'Додаткові питання для квитку',
        addField: '+ Додати поле',
        noCustomFields: 'Додаткових полів немає',
        addCustomFieldsHint: 'Додайте поля для збору інформації під час реєстрації',
        fieldNumber: 'Поле',
        fieldType: 'Тип поля',
        fieldLabel: 'Назва поля',
        fieldLabelPlaceholder: 'наприклад, Назва компанії, Дієтичні вимоги тощо',
        placeholderText: 'Підказка',
        placeholderHint: 'Введіть підказку для користувача...',
        requiredField: 'Обов\'язкове поле',
        options: 'Варіанти',
        addOption: '+ Додати варіант',
        noOptionsYet: 'Варіантів ще немає. Натисніть "Додати варіант" для додавання',
        optionPlaceholder: 'Варіант',
        allowedFileTypes: 'Дозволені типи файлів',
        selectFileTypes: 'Виберіть, які типи файлів можуть завантажувати користувачі',
        maxFileSize: 'Макс. розмір файлу (МБ)',
        maxFileSizeHint: 'Максимум: 50 МБ',
        preview: 'Попередній перегляд:',
        previewLabel: 'Попередній перегляд',
        hint: 'Підказка',
        fieldTypes: {
          text: 'Короткий текст',
          essay: 'Есе',
          singleChoice: 'Один варіант',
          multipleChoice: 'Декілька варіантів',
          trueFalse: 'Так/Ні',
          file: 'Завантаження файлу',
        },
        previewPlaceholders: {
          text: 'Введіть текст...',
          essay: 'Введіть вашу відповідь...',
          option1: 'Варіант 1',
          option2: 'Варіант 2',
          yes: 'Так',
          no: 'Ні',
          fileUpload: 'Натисніть для завантаження або перетягніть файл',
          allowedFiles: 'Дозволено',
        },
        // Ticket Browser
        browseTickets: 'Переглянути квитки з інших подій',
        browseTicketsShort: 'Переглянути квитки',
        browseDescription: 'Оберіть квитки зі своїх інших подій, щоб використати їх тут',
        searchPlaceholder: 'Пошук подій або квитків...',
        noTicketsFound: 'Квитків не знайдено',
        noOtherEvents: 'Немає квитків з інших подій',
        tryDifferentSearch: 'Спробуйте інший пошуковий запит',
        createTicketsInOtherEvents: 'Створіть квитки в інших подіях, щоб використовувати їх тут',
        ticketsSelected: 'квиток(ів) обрано',
        noTicketsSelected: 'Квитків не обрано',
        copyTickets: 'Копіювати квитки',
        copying: 'Копіювання...',
        copiedSuccess: 'Квитки успішно скопійовано',
        copyError: 'Не вдалося скопіювати квитки',
        selectTicketsWarning: 'Будь ласка, оберіть хоча б один квиток',
        fetchError: 'Не вдалося завантажити квитки',
        certificate: 'Сертифікат',
        tests: 'Тести',
        surveys: 'Опитування',
        customFieldsShort: 'доп. полів',
        // Free ticket notification
        freeTicketNotice: 'Увага: безкоштовний квиток',
        freeTicketNoticeDescription: 'У вас є безкоштовний квиток. Якщо ви хочете зробити доступ тільки платним, видаліть всі безкоштовні квитки.',
        // Free ticket publish confirmation
        freeTicketConfirmTitle: 'Безкоштовний доступ',
        freeTicketConfirmDescription: 'У вас є безкоштовний квиток. Це означає, що користувачі зможуть реєструватися безкоштовно. Якщо ви хочете зробити доступ платним, спочатку видаліть безкоштовні квитки.',
        freeTicketConfirmPublish: 'Опублікувати з безкоштовним доступом',
        freeTicketConfirmCancel: 'Налаштувати квитки',
        // No tickets publish confirmation
        noTicketsConfirmTitle: 'Квитки не налаштовані',
        noTicketsConfirmDescription: 'У вас немає жодного квитка. Це означає, що користувачі зможуть реєструватися безкоштовно. Якщо ви хочете зробити доступ платним, спочатку створіть платні квитки.',
        noTicketsConfirmPublish: 'Опублікувати з безкоштовним доступом',
        noTicketsConfirmCancel: 'Налаштувати квитки',
      },
      promocodes: {
        description: 'Створіть промокоди для знижок на квитки',
        addPromocode: 'Додати промокод',
        newPromocode: 'Новий промокод',
        editPromocode: 'Редагувати промокод',
        noPromocodesYet: 'Промокодів ще немає',
        addFirstPromocode: 'Додайте перший промокод для знижок',
        promocodeName: 'Назва промокоду',
        promocodeNamePlaceholder: 'наприклад, freeenterall',
        promocodeType: 'Вид промокоду',
        percentage: '%',
        discountAmount: 'Сума знижки',
        usageLimit: 'Промокод може бути використаний:',
        unlimited: 'Необмежено',
        limitedTimes: 'Обмежену кількість разів',
        timesLabel: 'разів',
        validFrom: 'Промокод діє з:',
        now: 'Зараз',
        selectDateTime: 'Обрати дату і час',
        validUntil: 'Промокоду діє до:',
        untilEventEnd: 'Без обмеження',
        confirmDelete: 'Ви впевнені, що хочете видалити цей промокод?',
        confirmDeleteDescription: 'Після видалення промокоду його більше неможливо буде використати. Цю дію не можна скасувати.',
        code: 'Код',
        discount: 'Знижка',
        used: 'Використано',
        status: 'Статус',
        active: 'Активний',
        expired: 'Закінчився',
        depleted: 'Вичерпано',
        dateTimePlaceholder: 'дд.мм.рррр, гг:хх',
        deleteSuccess: 'Промокод успішно видалено',
        deleteError: 'Не вдалося видалити промокод',
        // Creation/Update errors
        createError: 'Не вдалося створити промокод: ',
        quickCreateSuccess: 'Промокод створено та прив\'язано до квитка.',
        duplicateCode: 'Промокод з таким кодом вже існує для цієї події. Виберіть інший код.',
        updateError: 'Не вдалося оновити промокод: ',
        // Validation API messages
        emptyCode: 'Будь ласка, введіть промокод',
        notFound: 'Такого промокоду не існує. Перевірте правильність написання.',
        notYetValid: 'Цей код стане активним {validFrom}',
        codeExpired: 'Термін дії коду закінчився {validUntil}',
        limitReached: 'Цей код вичерпав ліміт використань ({usageCount}/{usageLimit} використано)',
        validationError: 'Помилка перевірки промокоду. Спробуйте ще раз.',
        noEffects: 'Цей промокод дійсний, але не має активних знижок чи розблокувань.',
        applied: 'Промокод "{code}" застосовано!',
        unlockedTickets: 'Розблоковано квитків: {count}',
        unlockedSpecialTickets: 'Розблоковано спеціальних квитків: {count}',
        discountApplied: 'Застосовано знижку {discountText}',
        formatError: 'Промокод може містити лише літери, цифри та дефіси',
        formatHint: 'Використовуйте літери, цифри та дефіси (наприклад, Promo-2024). Регістр не має значення',
      },
    },

    // Certificate Components
    certificateComponents: {
      certificateDetails: 'Деталі сертифіката',
      certificatePreview: 'Попередній перегляд сертифіката',
      pleaseAllowPopups: 'Будь ласка, дозвольте спливаючі вікна для генерації PDF',
      failedToGeneratePDF: 'Не вдалося згенерувати PDF',
      verificationLinkCopied: 'Посилання для перевірки сертифіката скопійовано в буфер обміну!',
      failedToLoadCertificate: 'Не вдалося завантажити сертифікат',
      pleaseAllowPopupsDownload: 'Будь ласка, дозвольте спливаючі вікна для завантаження сертифіката',
      failedToDownloadCertificate: 'Не вдалося завантажити сертифікат',
      failedToGenerateCertificateRetry: 'Не вдалося згенерувати сертифікат. Спробуйте ще раз.',
      enterYourAnswer: 'Введіть вашу відповідь...',
      enterYourResponse: 'Введіть вашу відповідь...',
    },

    // Course Builder Extended
    courseBuilderExtended: {
      enterVenueAddress: 'Введіть адресу місця проведення...',
      priceExample: 'наприклад, 2500.00',
      cpdCreditsExample: 'наприклад, 5.5',
      leaveEmptyUnlimited: 'Залиште порожнім для необмеженої кількості',
      imageUrlExample: 'https://example.com/image.jpg',
      certificateTemplateHtml: 'Введіть користувацький HTML шаблон для сертифікатів (необов\'язково)...',
      pleaseEnterCourseTitle: 'Будь ласка, введіть назву курсу',
      pleaseEnterCourseTitleBeforeTest: 'Будь ласка, введіть назву курсу перед збереженням тесту.',
      pleaseEnterCourseTitleBeforeSurvey: 'Будь ласка, введіть назву курсу перед збереженням опитування.',
      testSavedSuccessfully: 'Тест успішно збережено!',
      surveySavedSuccessfully: 'Опитування успішно збережено!',
      courseUpdatedSuccessfully: 'Курс успішно оновлено!',
      courseSavedSuccessfully: 'Курс успішно збережено!',
      failedToCreateCourse: 'Не вдалося створити курс. Будь ласка, спочатку збережіть курс вручну.',
      failedToSaveSurveyRetry: 'Не вдалося зберегти опитування. Спробуйте ще раз.',
      accessDeniedOrganizers: 'Доступ заборонено. Тільки організатори можуть створювати курси.',
      failedToLoadCourseData: 'Не вдалося завантажити дані курсу',
    },

    // File Upload
    fileUpload: {
      selectFile: 'Вибрати файл',
      upload: 'Завантажити',
      externalUrl: 'Посилання',
      myFiles: 'Мої файли',
      clickToSelect: 'Натисніть для вибору файлу',
      orDragDrop: 'або перетягніть файл сюди',
      acceptedTypes: 'Дозволені типи',
      maxSize: 'Макс. розмір',
      uploading: 'Завантаження...',
      enterExternalUrl: 'Введіть URL файлу, який ви хочете використати',
      use: 'Використати',
      urlExamples: 'Приклади: посилання YouTube, Google Drive, Dropbox',
      search: 'Пошук файлів...',
      allFiles: 'Всі файли',
      images: 'Зображення',
      documents: 'Документи',
      videos: 'Відео',
      audio: 'Аудіо',
      loading: 'Завантаження...',
      noFiles: 'Ще немає завантажених файлів',
      delete: 'Видалити',
      confirmDelete: 'Ви впевнені, що хочете видалити цей файл?',
      deleteError: 'Не вдалося видалити файл',
      invalidFileType: 'Будь ласка, виберіть файл правильного типу',
      fileTooLarge: 'Розмір файлу перевищує допустимий',
      uploadError: 'Помилка завантаження файлу',
      enterValidUrl: 'Будь ласка, введіть дійсний URL',
      invalidUrl: 'Недійсний формат URL',
      useUrl: 'Використати URL',
      chooseFromFiles: 'Вибрати з моїх файлів',
      backToUpload: 'Повернутись до завантаження',
      uploadSuccess: 'Файл успішно завантажено',
      deleteSuccess: 'Файл успішно видалено',
      confirmDeleteTitle: 'Видалити файл',
      cancel: 'Скасувати',
    },

    // Full-size image viewer (lightbox)
    imageLightbox: {
      viewFullSize: 'Переглянути у повному розмірі',
      openOriginal: 'Відкрити оригінал',
      lowResolution: 'Низька роздільність',
      loadError: 'Не вдалося завантажити зображення',
    },

    // Ticket Custom Fields Form (for ticket purchase)
    ticketCustomFields: {
      title: 'Потрібна додаткова інформація',
      description: 'Будь ласка, заповніть наступну інформацію для вашого квитка',
      descriptionForTicket: 'Будь ласка, заповніть наступну інформацію для вашого квитка «{{ticketName}}».',
      trueOption: 'Так',
      falseOption: 'Ні',
      continue: 'Продовжити',
      finishRegistration: 'Завершити реєстрацію',
      uploading: 'Завантаження...',
      fixErrorsBeforeSubmitting: 'Будь ласка, виправте помилки перед відправкою',
      failedToSubmitForm: 'Не вдалося відправити форму. Спробуйте ще раз.',
      clickToUpload: 'Натисніть для завантаження або перетягніть файл',
      // Validation errors
      fieldRequired: '{{fieldLabel}} є обов\'язковим',
      onlyFileTypesAllowed: 'Дозволені лише файли: {{fileTypes}}',
      fileSizeMustBeLessThan: 'Розмір файлу має бути менше {{size}}МБ',
      failedToUploadFile: 'Не вдалося завантажити файл: {{error}}',
      noActiveSession: 'немає активної сесії',
      mustBeAtLeastChars: 'Має бути щонайменше {{count}} символів',
      mustBeNoMoreThanChars: 'Має бути не більше {{count}} символів',
      invalidFormat: 'Невірний формат',
    },

    // Errors
    errors: {
      general: 'Щось пішло не так. Спробуйте ще раз.',
      network: 'Помилка мережі. Перевірте ваше підключення.',
      auth: 'Помилка авторизації. Увійдіть знову.',
      notFound: 'Сторінку не знайдено',
      serverError: 'Помилка сервера. Спробуйте пізніше.',
      validation: 'Перевірте введені дані',
      courseNotFound: 'Курс не знайдено',
      returnToHomepage: 'Повернутися на головну',
      errorSavingData: 'Помилка збереження даних. Спробуйте ще раз.',
      pleaseSelectImageFile: 'Будь ласка, виберіть файл зображення.',
      imageSizeTooLarge: 'Розмір зображення повинен бути менше 5 МБ.',
      uploadImageError: 'Помилка завантаження зображення. Спробуйте ще раз.',
      pleaseDropImageFile: 'Будь ласка, перетягніть файл зображення.',
      pleaseSelectPDFFile: 'Будь ласка, виберіть PDF файл.',
      fileSizeTooLarge: 'Розмір файлу повинен бути менше 10 МБ.',
      uploadFileError: 'Помилка завантаження файлу. Спробуйте ще раз.',
      pleaseDropPDFFile: 'Будь ласка, перетягніть PDF файл.',
      // Error boundaries
      errorBoundary: {
        title: 'Щось пішло не так',
        description: 'На жаль, сталася несподівана помилка. Наша команда вже працює над її вирішенням.',
        tryAgain: 'Спробувати знову',
        goHome: 'На головну',
        goBack: 'Повернутися назад',
        errorId: 'Код помилки',
        dashboardError: 'Помилка панелі керування',
        dashboardDescription: 'Не вдалося завантажити панель керування. Спробуйте оновити сторінку.',
        eventsError: 'Помилка завантаження подій',
        eventsDescription: 'Не вдалося завантажити інформацію про події. Спробуйте пізніше.',
        coursesError: 'Помилка завантаження курсів',
        coursesDescription: 'Не вдалося завантажити інформацію про курси. Спробуйте пізніше.',
        profileError: 'Помилка профілю',
        profileDescription: 'Не вдалося завантажити ваш профіль. Спробуйте оновити сторінку.',
      },
      // Payment API errors
      payment: {
        UNAUTHORIZED: 'Для оплати потрібно увійти в обліковий запис.',
        INVALID_INPUT: 'Невірні дані. Перевірте введену інформацію.',
        CONTEXT_FETCH_FAILED: 'Не вдалося завантажити дані. Спробуйте ще раз.',
        CONTENT_NOT_FOUND: 'Подію або курс не знайдено.',
        USER_NOT_FOUND: 'Користувача не знайдено. Увійдіть знову.',
        ALREADY_ENROLLED: 'Ви вже зареєстровані на цю подію або курс.',
        PAYMENT_NOT_CONFIGURED: 'Оплата не налаштована. Зверніться до організатора.',
        NO_TICKETS_SELECTED: 'Оберіть хоча б один квиток.',
        ZERO_AMOUNT: 'Не можна оплатити безкоштовну подію.',
        PAYMENT_CREATE_FAILED: 'Не вдалося створити платіж. Спробуйте ще раз.',
      },
    },

    // Additional Profile Fields Form
    additionalFields: {
      title: 'Необхідна додаткова інформація',
      completeProfile: 'Заповніть свій профіль',
      course: 'Курс',
      description: 'Будь ласка, заповніть додаткові поля, необхідні для реєстрації.',
      saveAndContinue: 'Зберегти і продовжити реєстрацію',
      selectOption: '-- Оберіть опцію --',
      saving: 'Зберігається...',
      enterRegion: 'Введіть область',
      selectCountryFirst: 'Спочатку оберіть країну',
      validation: {
        required: "Це поле є обов'язковим",
        invalidEmail: 'Введіть коректну email адресу',
        invalidPhone: 'Введіть коректний номер телефону',
        minLength: 'Мінімум {count} символів',
        maxLength: 'Максимум {count} символів',
        invalidFormat: 'Невірний формат',
        fillAllRequired: "Будь ласка, заповніть усі обов'язкові поля",
      },
    },

    // Profile Page
    profile: {
      backToHomepage: 'Повернутися на головну',
      myProfile: 'Мій профіль',
      managePersonalInfo: 'Керуйте своєю особистою інформацією',
      editProfile: 'Редагувати профіль',
      edit: 'Редагувати',
      cancel: 'Скасувати',
      save: 'Зберегти',
      saveChanges: 'Зберегти зміни',
      saving: 'Збереження...',
      loadingProfile: 'Завантаження профілю...',
      basicInformation: 'Основна інформація',
      firstName: 'Ім\'я',
      lastName: 'Прізвище',
      patronymic: 'По батькові',
      email: 'Email',
      emailChangeButton: 'Змінити email',
      emailChangeNewLabel: 'Новий email',
      emailChangeNewPlaceholder: 'Введіть новий email',
      emailChangeSubmit: 'Надіслати підтвердження',
      emailChangeSending: 'Надсилання...',
      emailChangeConfirmationSent: 'Лист із підтвердженням надіслано на стару та нову email-адреси. Перевірте обидві скриньки.',
      emailChangePendingConfirmation: 'Очікується підтвердження зміни email',
      emailChangePendingFor: 'Зміна на:',
      emailChangeFirstConfirmed: 'Одну адресу підтверджено. Перевірте іншу поштову скриньку та натисніть посилання, щоб завершити зміну.',
      emailChangeSuccess: 'Email успішно змінено',
      emailChangeFailed: 'Не вдалося змінити email',
      emailChangeInvalidEmail: 'Введіть коректний email',
      emailChangeSameEmail: 'Новий email збігається з поточним',
      emailChangeAlreadyInUse: 'Цей email вже використовується',
      emailChangeRateLimit: 'Забагато спроб. Спробуйте пізніше.',
      emailChangeDoubleConfirmHint: 'Для безпеки потрібно підтвердити зміну на обох email-адресах.',
      emailChangeCancel: 'Скасувати зміну',
      emailChangeCancelling: 'Скасування...',
      emailChangeCancelled: 'Зміну email скасовано',
      emailChangeCancelFailed: 'Не вдалося скасувати зміну email',
      emailChangeEnterDifferent: 'Змінити адресу',
      phone: 'Телефон',
      country: 'Країна',
      selectCountry: 'Виберіть країну',
      region: 'Область',
      selectRegion: 'Виберіть область',
      enterRegion: 'Введіть область',
      selectCountryFirst: 'Спочатку оберіть країну',
      city: 'Місто',
      address: 'Адреса',
      postalCode: 'Поштовий індекс',
      dateOfBirth: 'Дата народження',
      professionalInformation: 'Професійна інформація',
      diplomaNumber: 'Номер диплому',
      specialty: 'Спеціальність',
      selectSpecialty: 'Виберіть спеціальність',
      searchSpecialty: 'Пошук: назва, група або «медсестра»…',
      noSpecialtyFound: 'Нічого не знайдено',
      primarySpecialty: 'Основна спеціальність',
      specialtyInTraining: 'Спеціальність, яку здобуваєте',
      secondarySpecialties: 'Додаткові спеціальності',
      addAnotherSpecialty: 'Додати ще одну спеціальність',
      makePrimary: 'Зробити основною',
      removeSpecialty: 'Прибрати',
      specifySpecialty: 'Вкажіть спеціальність',
      specifySpecialtyPlaceholder: 'Наприклад: Оптометрія',
      position: 'Посада',
      workplace: 'Місце роботи',
      healthcareRole: 'Ваша роль в охороні здоров\'я',
      unknownSpecialty: 'Оберіть спеціальність зі списку',
      roleOptions: {
        practitioner: 'Медичний працівник (лікар, медсестра, фармацевт та ін.)',
        student: 'Студент, інтерн, аспірант',
        adjacent: 'Суміжна сфера: фарма, медтех, освіта, адміністрування',
        none: 'Не працюю в охороні здоров\'я',
      },
      academicDegree: 'Вчений ступінь',
      academicDegreePlaceholder: 'Оберіть вчений ступінь',
      academicTitle: 'Вчене звання',
      academicTitlePlaceholder: 'Оберіть вчене звання',
      notWorking: 'Зараз не працюю',
      education: 'Освіта',
      educationOptions: {
        higherMedical: 'Вища медична',
        higherNonMedical: 'Вища немедична',
        middleMedical: 'Середня медична',
        professionalTechnical: 'Професійно-технічна',
        other: 'Інша',
      },
      specifyEducation: 'Уточніть освіту',
      specifyEducationPlaceholder: 'Наприклад: медичний коледж',
      organizationName: 'Назва організації',
      organizationNameHint: '(використовується як організатор для курсів і подій)',
      organizationNamePlaceholder: 'Наприклад: Медичний центр "Здоров\'я" або Ваше Ім\'я',
      courseSpecificInformation: 'Інша інформація',
      courseSpecificNote: 'Примітка:',
      courseSpecificNoteText: 'Інформація для конкретного курсу може бути відредагована під час реєстрації або зі сторінки курсу.',
      profilePhoto: 'Фото профілю',
      photoHint: 'Натисніть на іконку камери, щоб завантажити нове фото (макс. 5 МБ)',
      removePhoto: 'Видалити фото',
      changePhoto: 'Змінити фото',
      savedSuccessfully: 'Успішно збережено',
      removePhotoConfirmTitle: 'Видалити фото профілю?',
      removePhotoConfirmMessage: 'Ви впевнені, що хочете видалити своє фото профілю? Цю дію не можна скасувати.',
      selectImageFile: 'Будь ласка, виберіть файл зображення',
      imageSizeLimit: 'Розмір зображення має бути менше 5 МБ',
      photoRemovedSuccessfully: 'Фото профілю успішно видалено',

      // Linked Accounts
      linkedAccounts: 'Пов\'язані акаунти',
      linkedAccountsDescription: 'Облікові записи, через які ви можете входити',
      noLinkedAccounts: 'Немає пов\'язаних акаунтів',
      linkAccountInstructions: 'Щоб пов\'язати Google акаунт, вийдіть з системи та увійдіть через Google.',
      unlinkAccount: 'Від\'єднати',
      unlinkAccountConfirmTitle: 'Від\'єднати акаунт?',
      unlinkAccountConfirmMessage: 'Ви більше не зможете входити через цей акаунт. Щоб пов\'язати знову, вийдіть і увійдіть через Google.',
      unlinkAccountSuccess: 'Акаунт від\'єднано',
      unlinkAccountFailed: 'Не вдалося від\'єднати акаунт',

      // Account deletion
      deleteProfileTitle: 'Видалити профіль назавжди',
      deleteProfileButton: 'Видалити профіль',
      deleteProfileBlockedTitle: 'Видалення профілю недоступне',
      deleteProfileBlockedBody: 'Ваш акаунт адмініструє заходи, на які зареєстровані інші користувачі. Щоб видалити профіль, зверніться до support@confy.cc – ми передамо заходи іншому організатору та видалимо ваш профіль вручну.',
      deleteProfilePreviewErrorTitle: 'Не вдалося завантажити інформацію про видалення профілю',
      deleteProfilePreviewErrorBody: 'Спробуйте оновити сторінку. Якщо проблема повторюється, зверніться до support@confy.cc.',
      deleteProfileStep1: 'Крок 1. Завантажте копію ваших даних',
      deleteProfileDownload: 'Завантажити архів (.zip)',
      deleteProfileDownloadHint: 'дані, фото профілю та всі сертифікати PDF',
      deleteProfileWillDelete: 'Буде безповоротно видалено:',
      deleteProfileItemProfile: 'профіль і всі персональні дані',
      deleteProfileItemEnrollments: 'реєстрацій на заходи: {count}',
      deleteProfileItemCertificates: 'сертифікатів: {count} ({credits} балів БПР)',
      deleteProfileItemProgress: 'результати тестів, прогрес, відповіді на опитування',
      deleteProfileItemFiles: 'завантажені файли та фото',
      deleteProfileIrreversible: 'Відновити ці дані буде НЕМОЖЛИВО – ні вами, ні підтримкою. Сертифікати перестануть існувати.',
      deleteProfileStep2: 'Крок 2. Введіть код з листа',
      deleteProfileSendCode: 'Надіслати код',
      deleteProfileCodeSent: 'Код надіслано на вашу пошту',
      deleteProfileStep3: 'Крок 3. Для підтвердження введіть ВИДАЛИТИ',
      deleteProfileConfirm: 'Видалити назавжди',
      deleteProfileCancel: 'Скасувати',
      deleteProfileFailed: 'Не вдалося видалити профіль',
      deleteProfileInvalidCode: 'Невірний або застарілий код',
      deleteProfileRateLimited: 'Забагато спроб. Спробуйте за 10 хвилин',
      signOutAllTitle: 'Вихід з усіх пристроїв',
      signOutAllBody: 'Звичайний вихід завершує сеанс лише на цьому пристрої. Скористайтеся цією дією, якщо ви передали комусь код входу або втратили доступ до пристрою, на якому були авторизовані.',
      signOutAllButton: 'Вийти з усіх пристроїв',
      signOutAllConfirmPrompt: 'Усі сеанси буде завершено, зокрема на цьому пристрої. Щоб повернутися, вам знадобиться новий код входу.',
      signOutAllConfirmButton: 'Так, вийти звідусіль',
      signOutAllCancel: 'Скасувати',
      signOutAllError: 'Не вдалося завершити сеанси. Перевірте з’єднання та спробуйте ще раз.',
      exportDataTitle: 'Завантажити мої дані',
      exportDataBody: 'Архів містить ваші персональні дані, фото профілю, всі сертифікати у форматі PDF та відповіді на реєстраційні форми.',

      // Wayforpay Settings (Organizers only)
      paymentSettings: 'Налаштування оплати',
      paymentSettingsNote: 'Налаштування WayForPay для прийому оплати за квитки.',
      paymentSettingsGenericNote: 'Налаштування платіжного провайдера для прийому оплати за квитки.',
      paymentProviderLabel: 'Платіжний провайдер',
      liqpayPublicKey: 'Public Key',
      liqpayPublicKeyPlaceholder: 'sandbox_xxxxxxxx',
      liqpayPrivateKey: 'Private Key',
      liqpayPrivateKeyPlaceholder: '••••••••',
      wayforpayIntegration: 'Інтеграція Wayforpay',
      enablePaymentProcessing: 'Увімкнути обробку платежів',
      enablePaymentHint: 'Дозволити студентам оплачувати ваші події через Wayforpay',
      enabled: 'Увімкнено',
      disabled: 'Вимкнено',
      merchantAccount: 'Merchant login',
      merchantAccountRequired: 'Merchant login *',
      merchantAccountPlaceholder: 'your_merchant_login',
      merchantAccountHint: 'Значення "Merchant login" з особистого кабінету Wayforpay',
      merchantAccountRequiredError: 'Merchant login є обов\'язковим',
      merchantDomainNotice: 'У налаштуваннях WayForPay додайте confy.cc як домен продавця. Без цього WayForPay прийме оплату, але не надішле підтвердження, і квиток не буде видано.',
      merchantSecretKey: 'Секретний ключ продавця',
      merchantSecretKeyRequired: 'Секретний ключ продавця *',
      merchantSecretKeyPlaceholder: 'your_secret_key',
      merchantSecretKeyHint: 'Значення "Merchant secret key" з особистого кабінету Wayforpay',
      merchantSecretKeyRequiredError: 'Секретний ключ продавця є обов\'язковим',
      secretKeyWarning: '⚠️ Зберігайте цей ключ у безпеці. Ніколи не діліться ним публічно.',
      platformFee: 'Комісія платформи',
      platformFeeHint: 'Комісія платформи з кожної транзакції (0-100%)',
      wayforpaySetupTitle: 'Як отримати облікові дані Wayforpay',
      wayforpaySetupStep1: 'Зареєструйтеся для облікового запису продавця Wayforpay на wayforpay.com',
      wayforpaySetupStep2: 'Завершіть процес верифікації',
      wayforpaySetupStep3: 'Перейдіть до налаштувань продавця',
      wayforpaySetupStep4: 'Скопіюйте ваш акаунт продавця, домен та секретний ключ',
      wayforpaySetupStep5: 'Вставте їх у поля вище та увімкніть обробку платежів',
      wayforpaySetupNote: 'Після налаштування всі платежі за ваші події оброблятимуться через ваш власний акаунт Wayforpay.',

      // Offline payments (Organizers only)
      offlinePaymentsToggle: 'Прийом оплати офлайн (готівка / банківський переказ)',
      offlinePaymentsHint: 'Учасник резервує місце, а ви підтверджуєте оплату вручну.',
      offlineInstructionsLabel: 'Інструкції для оплати',
      offlineInstructionsPlaceholder: 'Напр.: IBAN UA00 0000..., отримувач ..., або «Оплата готівкою на реєстрації».',
      offlineInstructionsShownToBuyers: 'Ці інструкції побачить учасник після резервування місця.',

      // MOZ BPR Settings
      mozBprSettings: 'Налаштування МОЗ БПР',
      mozProviderToggle: 'Ви зареєстровані як провайдер БПР у МОЗ України?',
      mozLogin: 'Логін БПР',
      mozLoginHint: 'Email для входу в систему БПР МОЗ. Може відрізнятися від контактного email організатора.',
      mozLoginPlaceholder: 'your-moz-login@example.com',
      mozBprNumber: 'Номер провайдера БПР',
      mozBprNumberHint: 'Ваш 4-значний номер провайдера в системі БПР МОЗ',
      mozBprNumberPlaceholder: '0000',
      mozBprNumberError: 'Номер БПР має складатися з 4 цифр',
      mozLoginRequired: 'Логін БПР обов\'язковий',
      mozBprNumberRequired: 'Номер провайдера БПР обов\'язковий',
      mozSettingsNote: 'Ці дані використовуються для подання заявок на акредитацію подій у системі БПР МОЗ.',
      mozSecretsTitle: 'Дані для автоматизації БПР (опційно)',
      mozSecretsNote: 'Ці дані шифруються і після збереження недоступні для перегляду або завантаження нікому, включно з адміністраторами CONFY. Вони використовуються лише системою для подання заявок і звітів у БПР МОЗ.',
      mozPassword: 'Пароль до кабінету БПР',
      mozPasswordHint: 'Дозволить системі автоматично перевіряти статус заявок і подавати звіти.',
      mozSignatureKey: 'Файл ключа КЕП',
      mozSignatureKeyHint: 'Ключ електронного підпису юридичної особи (напр. Key-6.dat). Максимум 1 МБ.',
      mozSignatureKeyPassword: 'Пароль до ключа КЕП',
      mozSignatureKeyPasswordHint: 'Якщо пароль не збережено, його буде запитано при кожному поданні звіту – ключ без пароля використати неможливо.',
      mozSecretSaved: 'Збережено',
      mozSecretReplace: 'Замінити',
      mozSecretDelete: 'Видалити',
      mozSecretDeleteConfirm: 'Видалити збережене значення? Цю дію не можна скасувати.',
      mozKeyConsent: 'Я розумію, що ключ буде використовуватися системою CONFY для підписання документів від мого імені, і надаю на це згоду.',
      mozKeyConsentRequired: 'Потрібна згода на використання ключа',
      mozKeyTooLarge: 'Файл ключа перевищує 1 МБ',
      mozSecretsSaveError: 'Не вдалося зберегти дані БПР. Перевірте поля нижче.',

      // My Tests Page
      tests: {
        title: 'Мої тести',
        subtitle: 'Результати пройдених тестів',
        noTests: 'Ви ще не проходили жодного тесту',
        noTestsDescription: 'Тести стануть доступними після участі в курсах або подіях',
        browseContent: 'Переглянути події та курси',
        testName: 'Назва тесту',
        course: 'Курс/Подія',
        score: 'Результат',
        status: 'Статус',
        date: 'Дата',
        passed: 'Пройдено',
        failed: 'Не пройдено',
        inProgress: 'В процесі',
        attempts: 'Спроби',
        retake: 'Пройти знову',
        viewDetails: 'Деталі',
        passedCount: 'Пройдено тестів',
        failedCount: 'Не пройдено',
        totalAttempts: 'Всього спроб',
        availableTests: 'Доступні тести',
        goToTest: 'Перейти до тесту',
        startTestButton: 'Розпочати тест',
        open: 'Відкритий',
        closed: 'Закритий',
        upcoming: 'Очікується',
        passingScore: 'Прохідний бал',
        previousAttempts: 'Спроби',
        history: 'Історія',
        missedExpired: 'Пропущені тести',
        expired: 'Термін минув',
        attemptsExhausted: 'Спроби вичерпано',
        bestScore: 'Найкращий результат',
        notAttempted: 'Не розпочато',
        pendingTests: 'Очікують підготовки',
        errors: {
          ENROLLMENT_REFUNDED: 'Оплату за цю реєстрацію повернуто, доступ до тесту закрито.',
          TEST_NOT_AVAILABLE_FOR_TICKET: 'Ваш квиток не передбачає тестування та сертифіката. Зверніться до організатора.',
        },
      },

      // My Surveys Page
      surveys: {
        title: 'Мої опитування',
        subtitle: 'Пройдені опитування',
        noSurveys: 'Ви ще не проходили жодного опитування',
        noSurveysDescription: 'Опитування стануть доступними після участі в подіях або курсах',
        browseContent: 'Переглянути події та курси',
        surveyName: 'Назва опитування',
        course: 'Курс/Подія',
        status: 'Статус',
        date: 'Дата',
        completed: 'Завершено',
        pending: 'Очікує',
        viewResponses: 'Переглянути відповіді',
        completedCount: 'Завершено опитувань',
      },

      // My Certificates Page
      certificates: {
        title: 'Мої сертифікати',
        subtitle: 'Ваші отримані сертифікати',
        noCertificates: 'У вас ще немає сертифікатів',
        noCertificatesDescription: 'Сертифікати видаються після успішного завершення курсів або подій',
        browseContent: 'Переглянути події та курси',
        certificateName: 'Назва',
        course: 'Курс/Подія',
        issuedAt: 'Дата видачі',
        eventDate: 'Дата',
        status: 'Статус',
        issued: 'Видано',
        pending: 'Очікує',
        processing: 'Генерація',
        expired: 'Прострочено',
        revoked: 'Анульовано',
        download: 'Завантажити',
        view: 'Переглянути',
        verify: 'Перевірити',
        certificateNumber: 'Номер сертифіката',
        cpdCredits: 'Бали БПР',
        totalCertificates: 'Всього сертифікатів',
        totalCredits: 'Загальні бали БПР',
        generatePdf: 'Згенерувати PDF',
        regenerate: 'Перегенерувати',
        // TEMPORARY NOTICE: Remove this translation key after data migration is complete (added 2026-02-08)
        dataMigrationNotice: 'Наразі деякі сертифікати можуть не генеруватись, а деякі – взагалі не відображатись. Це пов\'язано з тим, що процес переносу даних на оновлену платформу ще триває. Перенос інформації повинен бути завершений протягом одного-двох тижнів. Просимо вибачення за тимчасові незручності і дякуємо за розуміння!',
        availableCertificates: 'Доступні сертифікати',
        allRequirementsComplete: 'Всі вимоги виконано',
        passTest: 'Складіть тест',
        testNotPassedCertificateUnavailable: 'Тест не складено. Сертифікат недоступний.',
        completeSurvey: 'Завершіть опитування',
        goToTest: 'Перейти до тесту',
        goToSurvey: 'Перейти до опитування',
        completeRequirements: 'Виконати вимоги',
      },

      // My Materials Page
      materials: {
        title: 'Мої матеріали',
        subtitle: 'Додаткові матеріали з ваших подій',
        noMaterials: 'У вас немає доступних матеріалів',
        noMaterialsDescription: 'Матеріали стануть доступними після участі в подіях',
        browseContent: 'Переглянути події',
        materialName: 'Назва',
        event: 'Подія',
        type: 'Тип',
        date: 'Дата',
        download: 'Завантажити',
        view: 'Переглянути',
        types: {
          video: 'Відео',
          document: 'Документ',
          presentation: 'Презентація',
          audio: 'Аудіо',
          link: 'Посилання',
          image: 'Зображення',
        },
        totalMaterials: 'Всього матеріалів',
        progress: 'Прогрес',
      },

      // My Tickets Page
      tickets: {
        title: 'Мої квитки',
        subtitle: 'Придбані курси та події',
        noTickets: 'У вас ще немає придбаних квитків',
        noTicketsDescription: 'Тут будуть відображатися ваші придбані курси та події',
        browseContent: 'Переглянути події та курси',
        ticketName: 'Квиток',
        course: 'Курс/Подія',
        type: 'Тип',
        purchaseDate: 'Дата покупки',
        date: 'Дата',
        price: 'Ціна',
        status: 'Статус',
        active: 'Активний',
        used: 'Використано',
        expired: 'Прострочено',
        refunded: 'Повернено',
        partiallyRefunded: 'Часткове повернення',
        viewEvent: 'Перейти до події',
        viewCourse: 'Перейти до курсу',
        downloadReceipt: 'Завантажити квитанцію',
        totalPurchases: 'Всього покупок',
        totalSpent: 'Загальна сума',
        event: 'Подія',
        courseType: 'Курс',
        free: 'Безкоштовно',
        // Ticket Management
        cancelRegistration: 'Скасувати реєстрацію',
        changeTicket: 'Змінити квиток',
        cancelConfirmTitle: 'Скасувати реєстрацію?',
        cancelConfirmMessage: 'Ви впевнені, що хочете скасувати реєстрацію на цю подію? Цю дію не можна скасувати.',
        cancelConfirmButton: 'Так, скасувати',
        cancelling: 'Скасування...',
        cancelSuccess: 'Реєстрацію успішно скасовано',
        cancelError: 'Не вдалося скасувати реєстрацію',
        eventStarted: 'Подія вже почалась',
        cannotModifyStarted: 'Неможливо змінити або скасувати реєстрацію після початку події',
        // Change Ticket Modal
        changeTicketTitle: 'Змінити квиток',
        currentTicket: 'Поточний квиток',
        selectNewTicket: 'Оберіть новий квиток',
        priceDifference: 'Різниця в ціні',
        upgrade: 'Доплата',
        noAdditionalPayment: 'Без додаткової оплати',
        changeTicketButton: 'Змінити квиток',
        payAndChange: 'Оплатити та змінити',
        changing: 'Зміна...',
        changeSuccess: 'Квиток успішно змінено',
        changeError: 'Не вдалося змінити квиток',
        soldOut: 'Розпродано',
        sameTicketError: 'Ви вже маєте цей квиток',
        noOtherTickets: 'Немає інших доступних квитків',
      },
    },

    // Phone input
    phone: {
      selectCountry: 'Оберіть країну',
      searchCountry: 'Пошук країни або коду',
      noCountryFound: 'Нічого не знайдено',
      invalid: 'Введіть коректний номер телефону',
    },

    // CPD (БПР) Submission
    mozSubmission: {
      // Page Header
      title: 'Подання події до БПР',
      subtitle: 'Заповніть форму для подання події до системи безперервного професійного розвитку (БПР)',

      // Loading States
      loading: 'Завантаження...',
      saving: 'Збереження...',
      submitting: 'Подання...',
      generatingPdf: 'Генерація PDF...',
      preparingPdf: 'Підготовка до генерації...',
      waitingInQueue: 'Очікування в черзі...',
      pdfReady: 'PDF готовий!',
      retryingPdf: 'Повторна спроба генерації...',
      unsaved: 'Не збережено',

      // Form Labels
      labels: {
        mozLogin: 'Логін БПР',
        mozLoginFromSettings: 'Логін з налаштувань організатора',
        mozLoginNotConfigured: 'Логін БПР не налаштовано для цього організатора.',
        mozLoginConfigureLink: 'Налаштувати в розділі Організатор',
        mozLoginWarning: 'Для подачі заявки до БПР необхідно вказати логін БПР в налаштуваннях організатора.',
        mozLoginGoToOrganizer: 'Перейти до налаштувань організатора',
        mozPassword: 'Пароль БПР',
        mozPasswordNote: 'Введіть пароль від вашого акаунта БПР МОЗ.',
        bprNumber: 'Номер зареєстрованого заходу БПР',
        eventType: 'Вид події',
        eventTheme: 'Тема події',
        eventDirection: 'Напрямок події',
        eventGoal: 'Мета події БПР',
        targetAudience: 'Цільова аудиторія',
        academicHours: 'Кількість навчальних годин',
        providerLink: 'Посилання на інформацію про подію на сайті провайдера',
        registrationLink: 'Посилання для реєстрації на подію',
        eventLanguages: 'Мова події',
        eventDates: 'Дата проведення',
        startDate: 'Початок',
        endDate: 'Кінець',
        eventFormat: 'Формат події',
        onlineUrl: 'Посилання на онлайн-подію',
        region: 'Область',
        district: 'Район',
        city: 'Місто',
        street: 'Вулиця',
        building: 'Будинок',
        auditorium: 'Аудиторія',
        address: 'Адреса',
        eventProgram: 'Програма події',
        educationalProgram: 'Навчальна програма події',
        technicalInstruments: 'Використання спеціалізованого матеріально-технічного забезпечення',
        intlAccreditation: 'Наявність акредитації за кордоном чи в Україні EACCME/ACCME/RCPSC або сертифікації ERC/ILCOR/AHA, або проведення заходу в країні OECD (у тому числі онлайн)',
        intlAccreditationFile: 'Документ, що підтверджує акредитацію / сертифікацію або проведення в країні OECD (PDF)',
        speakers: 'Спікери',
        participantCount: 'Запланована кількість учасників',
        partners: 'Партнери',
        organizationalCommittee: 'Організаційний комітет',
        mozContacts: 'Контактні особи (вимога МОЗ)',
        registrationContact: 'Особа, відповідальна за реєстрацію заходу та подання результатів проведення',
        onsiteContact: 'Особа, відповідальна за проведення заходу',
        dates: 'Дати проведення',
      },

      // Placeholders
      placeholders: {
        eventType: 'Оберіть вид події',
        eventTheme: 'Введіть тему події',
        eventDirection: 'Оберіть напрямок події',
        eventGoal: 'Введіть мету події',
        academicHours: 'Введіть кількість навчальних годин',
        providerLink: 'https://example.com',
        registrationLink: 'https://example.com/register',
        onlineUrl: 'https://example.com/online-event',
        region: 'Наприклад: Київська область',
        district: 'Опційно',
        city: 'Наприклад: Київ',
        street: 'Наприклад: Хрещатик',
        building: 'Наприклад: 1',
        auditorium: 'Наприклад: Зала 101',
        participantCount: 'Наприклад: 50',
        eventProgram: 'Опишіть програму події. Використовуйте заголовки для секцій, списки для розкладу...',
        educationalProgram: 'Опишіть навчальну програму події. Використовуйте заголовки для секцій, списки для розкладу...',
        partners: 'Вкажіть партнерів події (кожен з нового рядка або через кому)\nНаприклад:\nТОВ "Медична компанія"\nБлагодійний фонд "Здоров\'я"',
        organizationalCommittee: 'Вкажіть інформацію про організаційний комітет події\nНаприклад:\nНаціональна медична академія України\nАсоціація кардіологів України',
        contactName: 'Прізвище Імʼя По батькові',
        contactPhone: '+380XXXXXXXXX',
        datePicker: 'дд.мм.рррр',
        dateTimePicker: 'дд.мм.рррр гг:хх',
      },

      // Helper Text
      helperText: {
        required: 'обов\'язково',
        optional: 'необов\'язково',
        dateFormat: 'Можна вводити дату та час вручну або вибрати їх у календарі (формат: дд.мм.рррр гг:хх).',
        eventProgramInstructions: 'Введіть вміст програми події. Після заповнення натисніть "Згенерувати PDF" для створення файлу програми.',
        educationalProgramInstructions: 'Введіть вміст навчальної програми події. Після заповнення натисніть "Згенерувати PDF" для створення файлу навчальної програми.',
        noEducationalProgramForConference: 'Не потрібна для конференцій',
        educationalProgramLabel: 'Навчальна програма:',
        organizationalCommitteeNote: 'Для конференцій потрібно вказати організаційний комітет',
        mozContactsNote: 'МОЗ вимагає вказати ці дані у програмі заходу. Поля заповнюються автоматично з вашого попереднього подання – змініть їх за потреби.',
        autoFormat: 'автоматично',
        singleFormatSupported: 'Цей тип події підтримує тільки один формат проведення',
        noPartners: 'У події немає партнерів',
        partnersLabel: 'Партнери події',
        selected: 'Вибрано',
        clearAllSpecialties: 'Очистити все',
        clearSpecialtiesConfirmTitle: 'Очистити всі спеціальності?',
        clearSpecialtiesConfirmMessage: 'Ви впевнені, що хочете очистити всі вибрані спеціальності? Цю дію не можна скасувати.',
        bprLinkHint: 'Натисніть іконку посилання праворуч, щоб автоматично згенерувати коротке посилання на БПР сторінку вашої події',
      },

      // Hints
      hints: {
        eventTheme: 'Тема для подання до БПР. Може відрізнятися від назви події.',
        bprNumber: '7-значний номер, присвоєний після реєстрації заходу в системі БПР',
      },

      // Event Formats
      eventFormats: {
        online: 'Дистанційна участь у режимі реального часу',
        onlineDescription: 'Подія проводиться онлайн',
        inPerson: 'Особиста участь працівника сфери охорони здоров\'я в освітній події у місці її проведення',
        inPersonDescription: 'Подія потребує фізичної присутності',
        hybrid: 'Поєднання особистої та дистанційної участі',
        hybridDescription: 'Подія підтримує обидва формати',
        onlineAuto: 'Дистанційна участь (автоматично)',
        inPersonAuto: 'Очна участь (автоматично)',
      },

      // Button Labels
      buttons: {
        saveDraft: 'Зберегти чернетку',
        showJson: 'Показати JSON',
        submitToMoz: 'Подати до БПР',
        generatePdf: 'Згенерувати PDF',
        viewPdf: 'Переглянути PDF',
        viewPdfButton: 'Переглянути PDF',
        close: 'Закрити',
        save: 'Зберегти',
        edit: 'Редагувати',
        copy: 'Копіювати',
        yes: 'Так',
        removeFile: 'Видалити файл',
        openFile: 'Відкрити файл',
        no: 'Ні',
        generateAutoUrl: 'Згенерувати автоматичне посилання',
      },

      // Modal Titles
      modals: {
        programPreview: 'Попередній перегляд програми події',
        educationalProgramPreview: 'Попередній перегляд навчальної програми',
        jsonPayload: 'JSON Payload для BPR API',
        closeAriaLabel: 'Закрити',
      },

      // Success Messages
      success: {
        dataSaved: 'Дані успішно збережено!',
        programPdfGenerated: 'PDF програми успішно згенеровано!',
        educationalProgramPdfGenerated: 'PDF навчальної програми успішно згенеровано!',
        pdfGeneratedSuccessfully: 'PDF згенеровано успішно',
        pdfGenerated: 'PDF згенеровано',
        jsonCopied: 'JSON скопійовано до буферу обміну!',
        submittedToMoz: 'Подію успішно відправлено до БПР!',
      },

      // Status Messages
      statusMessages: {
        submittedSuccessfully: '✓ Подано успішно',
        submissionError: '✗ Помилка подання',
        processingSubmission: 'Обробка подання...',
        submittedSuccessMessage: 'Вашу подію було успішно подано до системи БПР.',
        failedToSubmit: 'Не вдалося подати подію до системи БПР.',
        resubmitEvent: 'Подайте подію знову, будь ласка.',
        details: 'Деталі:',
        processingMessage: 'Ваша подія наразі обробляється системою БПР. Це може зайняти кілька хвилин. Статус автоматично оновлюється.',
        timeoutError: 'Час очікування відповіді від системи БПР минув (15 хвилин). Будь ласка, спробуйте надіслати запит ще раз.',
        submittedAt: 'Подано:',
        applicationNumber: 'Номер заявки',
        viewApplication: 'Переглянути заявку на сайті БПР',
        needsChangesTitle: '! Повернуто на доопрацювання',
        needsChangesMessage: 'БПР МОЗ повернув заявку на доопрацювання. Відкрийте заявку на порталі БПР, перегляньте зауваження, внесіть правки та подайте її повторно там само.',
        takeAction: 'Виправити',
        rejectedTitle: '✗ Заявку відхилено',
        rejectedMessage: 'Цю заявку вже не можна редагувати. Внесіть потрібні зміни до заходу та подайте нову заявку.',
        viewReason: 'Переглянути причину',
        submitNewApplication: 'Подати нову заявку',
      },

      // Error Messages
      errors: {
        eventNotFound: 'Подію не знайдено',
        noPermissionToSubmit: 'Ви не маєте прав для подання цієї події',
        loadingDataFailed: 'Помилка при завантаженні даних',
        fillAtLeastOneField: 'Заповніть хоча б одне поле перед збереженням',
        saveInProgress: 'Зачекайте, зберігання вже виконується',
        saveTimeout: 'Час очікування збереження минув. Спробуйте ще раз.',
        savingDataFailed: 'Помилка при збереженні даних',
        enterProgramContent: 'Будь ласка, введіть вміст програми перед генерацією PDF',
        generatingProgramPdfFailed: 'Помилка при генерації PDF програми',
        enterEducationalProgramContent: 'Будь ласка, введіть вміст навчальної програми перед генерацією PDF',
        generatingEducationalProgramPdfFailed: 'Помилка при генерації PDF навчальної програми',
        fixFollowingErrors: 'Будь ласка, виправте наступні помилки:',
        providerLinkMustBeHttps: 'Посилання на інформацію має бути HTTPS URL',
        registrationLinkMustBeHttps: 'Посилання для реєстрації має бути HTTPS URL',
        onlineUrlMustBeHttps: 'Посилання на онлайн-подію має бути HTTPS URL',
        invalidStartDateFormat: 'Дата початку має бути у форматі дд.мм.рррр',
        invalidEndDateFormat: 'Дата закінчення має бути у форматі дд.мм.рррр',
        eventDateTooSoon: 'Дата початку події повинна бути щонайменше через 30 днів від сьогодні. Будь ласка, змініть дату перед поданням до БПР.',
        endDateBeforeStart: 'Дата закінчення не може бути раніше дати початку',
        selectTechnicalInstruments: 'Будь ласка, оберіть чи використовується спеціалізоване матеріально-технічне забезпечення',
        uploadIntlAccreditationFile: 'Завантажте PDF, що підтверджує акредитацію EACCME/ACCME/RCPSC, сертифікацію ERC/ILCOR/AHA або проведення заходу в країні OECD',
        specifyOrganizationalCommittee: 'Будь ласка, вкажіть організаційний комітет для конференції',
        specifyRegistrationContact: 'Вкажіть ПІБ та номер телефону контактної особи, яка відповідає за реєстрацію заходу та подання результатів проведення',
        specifyOnsiteContact: 'Вкажіть ПІБ та номер телефону контактної особи, яка відповідає за проведення',
        errorCheckingSpeakers: 'Помилка при перевірці спікерів',
        addAtLeastOneSpeaker: 'Додайте хоча б одного спікера',
        speakersMustHaveBio: 'Всі спікери повинні мати заповнене коротке резюме (обов\'язкове для БПР)',
        speakersMustHaveCv: 'Всі спікери повинні мати створений PDF файл резюме. Збережіть спікерів, щоб автоматично згенерувати PDF.',
        submissionError: 'Виникла помилка при поданні події',
        errorPrefix: 'Помилка:',
        details: 'Деталі:',
        failedToGeneratePdf: 'Помилка генерації PDF',
        missingLocationFields: 'Відсутні обов\'язкові поля адреси. Будь ласка, заповніть всі поля адреси для очних/гібридних подій.',
        passwordRequired: 'Збережений пароль недоступний. Введіть пароль до кабінету БПР вручну.',
        notOrganizerOwner: 'Лише власник профілю організатора може подавати заявку зі збереженим паролем. Введіть пароль вручну.',
        serverError: 'Помилка сервера',
        redisNotRunning: 'Перевірте, чи запущено Redis',
        failedToCheckJobStatus: 'Помилка перевірки статусу завдання',
        failedToCreatePdfJob: 'Помилка створення завдання PDF',
        failedToRetryJob: 'Помилка повторної спроби',
        jobNotFound: 'Завдання не знайдено',
      },
      warnings: {
        eventDateTooSoon: 'Увага: дата початку події раніше ніж за 30 днів від сьогодні. Прийняти заявку на сайті БПР МОЗ можна лише якщо подія щонайменше за 30 днів наперед. Перед поданням змініть дату на відповідну, подайте заявку, після чого можете повернути реальну дату та зберегти.',
        previewConfirmTitle: 'Дата події раніше ніж за 30 днів',
        previewConfirmQuestion: 'Продовжити генерацію документів попри це?',
        previewConfirmYes: 'Так, продовжити',
        previewConfirmNo: 'Ні, змінити дати',
      },
      review: {
        label: 'Поточний статус БПР',
        pending: 'На розгляді',
        confirmed: 'Підтверджено',
        rejected: 'Відхилено',
        eventNumber: '№ заходу',
        lastChecked: 'перевірено',
        checkNow: 'Перевірити статус заявки',
        checking: 'Перевіряємо… це може тривати до 2 хвилин',
        checkFailed: 'Не вдалося перевірити статус. Спробуйте пізніше.',
        saveFailed: 'Перевірку виконано, але пароль не вдалося зберегти. Спробуйте зберегти його в розділі «Провайдер БПР».',
        alreadyChecking: 'Перевірка вже виконується',
        promptTitle: 'Введіть пароль до порталу БПР',
        promptLogin: 'Логін на сайті БПР МОЗ',
        promptPassword: 'Пароль',
        promptSave: 'Зберегти пароль для автоматичної перевірки та email-сповіщень',
        promptSubmit: 'Перевірити',
        promptCancel: 'Скасувати',
        savePasswordHint: 'Збережіть пароль до порталу БПР у розділі «Провайдер БПР» нижче – і CONFY перевірятиме статус автоматично двічі на день та надішле email при зміні.',
        numberSaved: 'Номер заходу {number} збережено з порталу БПР',
        conflictTitle: 'Номер заходу відрізняється',
        conflictBody: 'БПР підтвердив захід під номером {portal}, а у CONFY збережено {ours}. Саме цей номер друкується у сертифікатах учасників.',
        conflictNote: 'Ми нічого не змінили. Оберіть, який номер залишити.',
        conflictUsePortal: 'Використати номер БПР',
        conflictKeepOurs: 'Залишити мій',
      },
      dateSync: {
        title: 'Дати на порталі МОЗ відрізняються від дат заходу',
        submitted: 'Подано до МОЗ',
        onPortal: 'На порталі БПР',
        actual: 'Фактичні дати',
        explain: 'Заявку подано з пізнішою датою, бо МОЗ приймає заявки щонайменше за 30 днів до заходу. Захід уже зареєстровано, тож дати можна повернути до фактичних – це не потребує повторного погодження МОЗ.',
        button: 'Синхронізувати дати',
        syncing: 'Змінюємо дати на порталі…',
        takesTime: 'Це може тривати до 2 хвилин – не закривайте сторінку.',
        confirmTitle: 'Змінити дати на порталі МОЗ?',
        confirmBody: 'Дати заходу на порталі МОЗ буде змінено на {dates}. Ця зміна не потребує погодження МОЗ і застосується одразу. Дати на вкладці БПР також буде оновлено.',
        confirmYes: 'Так, змінити дати',
        confirmNo: 'Скасувати',
        success: 'Дати на порталі МОЗ змінено на {dates}',
        noChange: 'На порталі МОЗ уже стоять правильні дати',
        diverged: 'Увага: на порталі було {dates} – схоже, дати змінювали вручну.',
        failed: 'Не вдалося змінити дати на порталі МОЗ. Спробуйте пізніше.',
        serviceUnavailable: 'Сервіс БПР тимчасово недоступний. Спробуйте за кілька хвилин – на порталі нічого не змінено.',
        pastBody: 'Портал МОЗ не приймає дати в минулому, тому автоматично синхронізувати ці дати неможливо. Змініть їх вручну на порталі БПР.',
        promptTitle: 'Введіть пароль до порталу БПР, щоб змінити дати',
      },
    },

    // BPR Public Application
    bprApply: {
      pageTitle: 'Заявка на акредитацію БПР',
      intro: 'Заповніть форму, щоб подати ваш захід на акредитацію для нарахування балів безперервного професійного розвитку (БПР). Після розгляду заявки ми зареєструємо захід від імені акредитованого провайдера.',
      sectionEvent: 'Основна інформація про захід',
      sectionBpr: 'Дані для БПР',
      sectionProgram: 'Програма заходу',
      sectionHours: 'Академічні години та бали БПР',
      sectionSpeakers: 'Спікери',
      sectionOrganizer: 'Організатор заходу',
      organizerHint: 'Вкажіть організацію, яка проводить захід. Наукового організатора БПР призначить акредитований провайдер під час розгляду.',
      eventName: 'Назва заходу',
      description: 'Опис заходу (для сторінки заходу)',
      coverImage: 'Обкладинка заходу',
      creditsTitle: 'Бали БПР для цього типу заходу',
      creditsPerHourInPerson: 'Учасник (очно): {{rate}} бала за академічну годину',
      creditsPerHourOnline: 'Учасник (онлайн): {{rate}} бала за академічну годину',
      creditsPerHourSpeaker: 'Спікер/тренер: {{rate}} бала за академічну годину',
      creditsPoster: 'Стендова доповідь: {{rate}} балів',
      creditsOral: 'Усна доповідь: {{rate}} балів',
      creditsCourseUa: 'Курс українською: {{rate}} бала за академічну годину',
      creditsCourseEn: 'Курс англійською: {{rate}} бала за академічну годину',
      limitTotal: 'Обмеження: не більше {{limit}} учасників на захід',
      limitPerTrainer: 'Обмеження: не більше {{limit}} учасників на одного викладача',
      limitCurrentMax: '{{speakers}} спікер(ів) → до {{max}} учасників',
      calcTitle: 'Розрахунок балів БПР',
      calcIntro: 'За {{hours}} академічних годин учасник отримає:',
      calcInPerson: '{{credits}} балів БПР (очна участь)',
      calcOnline: '{{credits}} балів БПР (онлайн участь)',
      calcCourseUa: '{{credits}} балів БПР (курс українською)',
      calcCourseEn: '{{credits}} балів БПР (курс англійською)',
      calcSpeaker: '{{credits}} балів БПР для спікера',
      formatNotAllowed: 'Цей тип заходу не може проводитися у вибраному форматі',
      participantLimitExceeded: 'Перевищено ліміт учасників для цього типу заходу (максимум {{max}})',
      addSpeaker: 'Додати спікера',
      removeSpeaker: 'Видалити спікера',
      speakersRequired: 'Додайте щонайменше одного спікера',
      selectExistingSpeaker: 'Обрати наявного спікера',
      optional: 'необов\'язково',
      organizerName: 'Назва організації',
      organizerEmail: 'Контактний email',
      organizerPhone: 'Контактний телефон',
      competencies: 'Перелік компетентностей, що будуть здобуті або вдосконалені',
      competenciesPlaceholder: 'Наприклад: діагностика та лікування гострого коронарного синдрому; інтерпретація ЕКГ; ведення пацієнтів після інфаркту міокарда',
      programRequired: 'Додайте щонайменше один пункт програми – час і опис обов\'язкові',
      previewButton: 'Попередній перегляд заявки',
      previewTitle: 'Перевірте дані заявки',
      previewIntro: 'Перегляньте введені дані. Якщо все правильно – подайте заявку, або поверніться до редагування.',
      backToEdit: 'Повернутися до редагування',
      submit: 'Подати заявку',
      resubmit: 'Подати заявку повторно',
      submitting: 'Надсилання…',
      fixErrors: 'Будь ласка, заповніть усі обов\'язкові поля',
      submitError: 'Не вдалося надіслати заявку. Ваші дані збережено – спробуйте ще раз.',
      successTitle: 'Заявку подано!',
      resubmitSuccessTitle: 'Заявку подано повторно!',
      saveChanges: 'Зберегти зміни',
      adminEditSuccessTitle: 'Зміни збережено',
      adminEditSuccessBody: 'Зміни в заявці збережено. Статус розгляду не змінився.',
      successBody: 'Вашу заявку збережено та передано на розгляд акредитованому провайдеру. Ми повідомимо вас електронною поштою про результат розгляду. Стежити за статусом можна на сторінці заявок.',
      successOpenApplications: 'Мої заявки',
      pageTitleEdit: 'Редагування заявки на акредитацію БПР',
      notEditable: 'Цю заявку вже не можна редагувати',
      loadError: 'Не вдалося завантажити заявку',
      draftRestored: 'Відновлено збережену чернетку заявки',
      requiredField: 'Обов\'язкове поле',
      backToApplications: 'До моїх заявок',
      saveDraft: 'Зберегти чернетку',
      draftSaving: 'Збереження…',
      draftSaved: 'Чернетку збережено',
      draftSaveError: 'Не вдалося зберегти чернетку. Спробуйте ще раз.',
      saveDraftHint: 'Заявку можна зберегти незаповненою та повернутися до неї пізніше.',
      draftSavedAt: 'Збережено о',
      pageTitleDraft: 'Чернетка заявки на акредитацію БПР',
      speakerCardTitle: 'Спікер',
      honorarium: {
        needed: 'Потрібно виплатити гонорар',
        hint: 'Для внутрішніх процесів: куди платити, скільки та чи вже виплачено. Ці дані не подаються до МОЗ.',
        iban: 'IBAN',
        ibanPlaceholder: 'UA00 0000 0000 0000 0000 0000 0000',
        taxId: 'ІПН (РНОКПП)',
        taxIdPlaceholder: '10 цифр',
        amount: 'Сума гонорару',
        currency: 'Валюта',
        fromPrevious: 'З попередньої заявки',
        needsEmail: 'Вкажіть email спікера, щоб зберегти дані гонорару',
        statusPending: 'Очікує',
        statusPaid: 'Виплачено',
        statusNotApplicable: 'Не потрібно',
        removeDataTitle: 'Видалити дані гонорару?',
        removeDataBody: 'Дані для виплати гонорару цьому спікеру буде видалено. Продовжити?',
        blockedTitle: 'Спочатку скасуйте виплату',
        statusSaveError: 'Не вдалося зберегти статус виплати',
        detailsLockedPaid: 'Щоб змінити реквізити, спочатку скасуйте позначку про виплату',
        blockedBody: 'Для цього спікера збережено виплату. Спочатку скасуйте позначку про виплату на сторінці заявок.',
        blockedDetail: 'Для цього спікера збережено виплату {{amount}} від {{date}}. Спочатку скасуйте позначку про виплату на сторінці заявок.',
      },
    },

    // Superadmin chrome shared by /admin and /admin/payments (Task 7, Phase 5)
    admin: {
      title: 'Адмін-панель',
      subtitle: 'Пошук користувачів і генерація магічних посилань',
      loadingProfile: 'Завантаження профілю...',
      open: 'Відкрити',
      accessDenied: {
        title: 'Доступ заборонено',
        superadminRequired: 'Потрібні права супер-адміністратора для доступу до цієї сторінки.',
        currentRole: 'Ваша поточна роль:',
        message: 'У вас немає доступу до цього розділу.',
      },
      bprDashboard: {
        title: 'БПР дашборд',
        subtitle: 'Статуси заявок та звітів МОЗ по всіх заходах',
      },
      paymentsCard: {
        subtitle: 'Повернення коштів та заблоковані зарахування',
      },
    },

    // Superadmin payment resolution UI (/admin/payments, Phase 4 spec Item 8)
    adminPayments: {
      title: 'Керування платежами',
      loadMore: 'Завантажити ще',
      noMore: 'Більше немає рядків',
      refunds: {
        title: 'Повернення коштів, що потребують уваги',
        empty: 'Немає повернень коштів, що потребують уваги.',
        columns: {
          requested: 'Запитано',
          event: 'Подія',
          participant: 'Учасник',
          amount: 'Сума',
          status: 'Статус',
          age: 'Днів очікування',
          lastAnswer: 'Остання відповідь шлюзу',
          approval: 'Підтвердження',
        },
        approval: {
          awaiting: 'Очікує підтвердження',
          approved: 'Підтверджено',
        },
        intentLevel: 'На рівні платежу',
        actions: {
          check: 'Перевірити в шлюзі',
          markSettled: 'Позначити повернутим',
          markFailed: 'Позначити невдалим',
          cancelQueued: 'Скасувати повернення',
          override: 'Підтвердити в обхід організатора',
        },
        override: {
          confirmTitle: 'Підтвердити це повернення коштів в обхід організатора?',
          confirmDescription:
            'Це повернення коштів очікує підтвердження, а організатор може бути недоступний (наприклад, подія скасована й покинута). Підтверджуючи зараз, ви, як суперадміністратор, робите це в обхід організатора. Цю дію буде записано в журнал аудиту разом з вашим ідентифікатором.',
          confirm: 'Підтвердити в обхід',
        },
        resolve: {
          title: 'Вирішити повернення коштів вручну',
          settledAmount: 'Повернена сума',
          note: 'Примітка',
          confirm: 'Підтвердити',
        },
      },
      blocked: {
        title: 'Заблоковані зарахування',
        empty: 'Немає заблокованих зарахувань.',
        includeResolved: 'Показати вирішені понад 30 днів тому',
        columns: {
          blockedAt: 'Заблоковано',
          reason: 'Причина',
          event: 'Подія',
          payer: 'Платник',
          amount: 'Сума',
          attempts: 'Спроб',
          resolution: 'Вирішення',
        },
        reason: {
          duplicate_enrollment: 'Учасник вже має оплачене зарахування',
          enrollment_error: 'Помилка під час зарахування',
          duplicate_upgrade: 'Повторне списання за підвищення тарифу',
        },
        resolution: {
          fulfilled: 'Зараховано',
          refunding: 'Кошти повертаються',
          refunded: 'Кошти повернуто',
          manual: 'Вирішено вручну',
          unresolved: 'Не вирішено',
        },
        actions: {
          retry: 'Повторити зарахування',
          refundNow: 'Повернути кошти зараз',
          markManual: 'Позначити вирішеним вручну',
          override: 'Підтвердити в обхід організатора',
        },
        override: {
          confirmTitle: 'Підтвердити повернення коштів в обхід організатора?',
          confirmDescription:
            'Це повернення коштів вже підготовлено, але його нікому підтвердити - в організатора немає доступу до цього платежу. Підтверджуючи зараз, ви, як суперадміністратор, робите це в обхід організатора. Цю дію буде записано в журнал аудиту разом з вашим ідентифікатором.',
          confirm: 'Підтвердити в обхід',
        },
      },
      toast: {
        checkedSettled: 'Шлюз підтвердив повернення коштів',
        checkedPending: 'Шлюз повідомляє, що повернення ще обробляється',
        checkedUnresolved: 'Шлюз не підтвердив повернення. Запис не змінено.',
        resolved: 'Повернення коштів вирішено',
        retried: 'Повторну спробу зарахування виконано',
        refunded: 'Кошти повернуто',
        refundPrepared: 'Повернення коштів підготовлено. Кошти будуть надіслані лише після підтвердження людиною.',
        refundProcessing: 'Повернення коштів надіслано, шлюз ще обробляє платіж',
        refundFailed: 'Шлюз не підтвердив повернення коштів. Перевірте запис вручну.',
        refundClaimedElsewhere: 'Цей платіж вже обробляється іншою дією. Нову спробу не розпочато.',
        refundWriteFailed: 'Шлюз підтвердив повернення коштів, але зберегти запис не вдалося. Перевірте платіж вручну.',
        refundInvalidAmount: 'У цього платежу немає коректної суми для повернення. Дію не виконано.',
        manual: 'Платіж позначено вирішеним вручну',
        overridden: 'Повернення коштів підтверджено в обхід організатора. Дію записано в журнал аудиту.',
        error: 'Не вдалося виконати дію. Спробуйте ще раз.',
      },
      errors: {
        RATE_LIMITED: 'Забагато запитів поспіль. Зачекайте хвилину і спробуйте ще раз.',
        NOT_AUTHORIZED: 'У вас немає прав для цієї дії.',
        REFUND_NOT_RESOLVABLE: 'Це повернення коштів не можна закрити вручну в поточному статусі.',
        REFUND_STATE_CHANGED: 'Стан повернення щойно змінився. Оновіть сторінку.',
        SETTLED_AMOUNT_EXCEEDS_ORIGINAL: 'Сума перевищує суму, яку ще можна повернути.',
        RETRY_NOT_APPLICABLE: 'Це блокування не можна усунути повторною спробою.',
        REFUND_NOT_APPLICABLE: 'Повернення коштів для цього платежу неможливе автоматично.',
        ALREADY_RESOLVED: 'Цей платіж вже вирішено.',
        REFUND_GATEWAY_UNAVAILABLE: 'Платіжний шлюз недоступний. Спробуйте пізніше.',
        REFUND_PREPARE_FAILED: 'Не вдалося підготувати повернення коштів. Спробуйте ще раз.',
      },
    },

    // BPR Applications manager
    bprApplications: {
      pageTitle: 'Мої заявки на БПР',
      intro: 'Тут ви можете відстежувати статус ваших заявок на акредитацію, редагувати їх та подавати повторно.',
      newApplication: 'Нова заявка',
      empty: 'У вас поки немає заявок на акредитацію БПР',
      signInRequired: 'Увійдіть, щоб переглянути свої заявки на акредитацію БПР',
      loadError: 'Не вдалося завантажити заявки. Спробуйте оновити сторінку.',
      actionError: 'Не вдалося виконати дію. Спробуйте ще раз.',
      submittedAt: 'подано',
      savedAt: 'збережено',
      untitledDraft: 'Чернетка без назви',
      continueDraft: 'Продовжити',
      applicant: 'Заявник',
      adminComment: 'Коментар акредитованого провайдера',
      deadline: 'Внести зміни до',
      duplicate: 'Дублювати',
      details: 'Деталі',
      withdraw: 'Відкликати',
      withdrawn: 'Заявку відкликано',
      deleted: 'Заявку видалено',
      history: 'Історія',
      openEvent: 'Відкрити захід',
      approve: 'Схвалити',
      approveSuccess: 'Заявку схвалено, захід створено',
      requestChanges: 'Запросити зміни',
      requestChangesSuccess: 'Коментар надіслано заявнику',
      commentPlaceholder: 'Опишіть, що потрібно змінити в заявці…',
      sendComment: 'Надіслати коментар',
      confirmWithdrawTitle: 'Відкликати заявку?',
      confirmWithdrawBody: 'Заявку буде знято з розгляду. Ви зможете продублювати її та подати знову.',
      confirmDeleteTitle: 'Видалити заявку?',
      confirmDeleteBody: 'Заявку та її історію буде видалено назавжди. Цю дію не можна скасувати.',
      confirmApproveTitle: 'Схвалити заявку?',
      confirmApproveBody: 'Буде створено захід із заповненим розділом БПР, а заявник отримає роль організатора та лист із підтвердженням.',
      status: {
        draft: 'Чернетка',
        submitted: 'На розгляді',
        needs_changes: 'Потребує змін',
        approved: 'Схвалено',
        withdrawn: 'Відкликано',
        expired: 'Прострочено',
      },
      historyActions: {
        draft_created: 'Чернетку створено',
        submitted: 'Заявку подано',
        updated: 'Заявку оновлено',
        resubmitted: 'Заявку подано повторно',
        changes_requested: 'Запрошено зміни',
        approved: 'Заявку схвалено',
        withdrawn: 'Заявку відкликано',
        expired: 'Термін внесення змін минув – заявку скасовано',
        honorarium_paid: 'Гонорар позначено виплаченим',
        honorarium_pending: 'Гонорар повернуто в очікування',
        honorarium_not_applicable: 'Гонорар позначено як не потрібний',
        honorarium_removed: 'Запис про гонорар видалено',
        honorarium_details_changed: 'Реквізити гонорару змінено',
      },
      honorariums: 'Гонорари спікерів',
      honorariumEditTitle: 'Виплата гонорару',
      honorariumStatus: 'Статус',
      honorariumPaidOn: 'Дата виплати',
      honorariumPaidTime: 'Час виплати',
      honorariumNote: 'Примітка',
      honorariumUnpayConfirm: 'Скасувати позначку про виплату гонорару?',
      honorariumDeleteWarning: 'Разом із заявкою буде видалено {{count}} запис(ів) про гонорар.',
    },

    // BPR Preview Modal
    bprPreview: {
      title: 'Попередній перегляд БПР',
      validating: 'Перевірка даних...',
      checkingChanges: 'Перевірка змін...',
      generatingCvs: 'Генерація резюме спікерів...',
      generatingProgram: 'Генерація програми події...',
      generatingEducational: 'Генерація навчальної програми...',
      generatingDocument: 'Генерація документа...',
      generationFailed: 'Помилка генерації',
      waitingForGeneration: 'Очікування генерації...',
      noDocument: 'Документ недоступний',
      ready: 'Готово',
      submitToMoz: 'Надіслати',
      submitting: 'Надсилання до МОЗ...',
      pleaseWait: 'Будь ласка, зачекайте, це може зайняти деякий час.',
      editForm: 'Редагувати форму',
      successTitle: 'Успішно надіслано!',
      successMessage: 'Вашу подію було надіслано до МОЗ на розгляд.',
      redirectingToStatus: 'За кілька секунд ви перейдете до статусу заявки…',
      goToStatus: 'Перейти до статусу',
      validationErrorTitle: 'Помилки валідації',
      errorTitle: 'Виникла помилка',
      generateAndPreview: 'Згенерувати та переглянути',
      sections: {
        eventInfo: 'Інформація про подію',
        location: 'Місце проведення',
        onlineAccess: 'Онлайн-доступ',
        speakers: 'Спікери',
        documents: 'Документи',
      },
      tabs: {
        summary: 'Огляд',
        documents: 'Документи',
      },
      tapToView: 'Натисніть кнопку нижче, щоб переглянути документ',
      openDocument: 'Відкрити документ',
      secureSubmission: 'Ваші дані зашифровані. Ми подаємо заявку від вашого імені.',
      savedPasswordTitle: 'Використовується збережений пароль',
      confirmSubmit: {
        title: 'Подати заявку до МОЗ?',
        description: 'Заявку буде надіслано до Центру тестування якості освіти МОЗ України.',
        confirm: 'Так, подати',
      },
      noDataTitle: 'Немає даних для перегляду',
      noDataMessage: 'Будь ласка, згенеруйте попередній перегляд з конструктора події.',
      backToBuilder: 'Повернутися до конструктора',
      redirecting: 'Перенаправлення до конструктора події...',
    },

    // API Messages (for client-facing errors)
    api: {
      unauthorized: 'Неавторизовано',
      forbidden: 'Заборонено',
      contentNotFound: 'Вміст не знайдено',
      eventNotFound: 'Подію не знайдено',
      failedToFetchTickets: 'Не вдалося завантажити квитки',
      failedToFetchEvents: 'Не вдалося завантажити події',
      noRecipientsSpecified: 'Отримувачів не вказано',
      subjectAndBodyRequired: 'Необхідна тема та текст повідомлення',
      messageBodyRequired: 'Необхідний текст повідомлення',
      eventIdRequired: 'Необхідний ID події',
      failedToCreateEventCopy: 'Не вдалося створити копію події',
      failedToCheckEnrollments: 'Не вдалося перевірити записи',
      cannotDeleteWithEnrollments: 'Неможливо видалити контент зі студентами',
      failedToDelete: 'Не вдалося видалити контент',
      alreadyEnrolled: 'Ви вже зареєстровані на цю подію',
      eventFull: 'Подію заповнено',
      failedToLoadEventData: 'Не вдалося завантажити дані події',
      failedToCheckProfile: 'Помилка перевірки профілю',
      registrationFailed: 'Помилка реєстрації',
      successfullyRegistered: 'Ви успішно зареєстровані!',
      pleaseLogIn: 'Будь ласка, увійдіть в систему',
      failedToUpdateStatus: 'Не вдалося оновити статус події',
      dataRefreshed: 'Дані оновлено з бази даних',
      keepingCurrentVersion: 'Збережено вашу поточну версію',
      failedToUploadImage: 'Не вдалося завантажити зображення',
      profilePhotoUploaded: 'Фото профілю успішно завантажено',
      failedToDeletePhoto: 'Не вдалося видалити фото',
      photoDeleted: 'Фото профілю видалено',
      failedToSavePaymentSettings: 'Не вдалося зберегти налаштування оплати',
      failedToSaveChanges: 'Не вдалося зберегти зміни. Будь ласка, спробуйте ще раз.',
      failedToLoadCourse: 'Не вдалося завантажити курс',
      failedToLoadCourseData: 'Не вдалося завантажити дані курсу',
      failedToCheckProfileCompletion: 'Не вдалося перевірити завершення профілю',
      eventProgramFileRequired: 'Файл програми події є обов\'язковим. Будь ласка, заповніть програму події у формі.',
    },

    // BPR Page
    bpr: {
      programTitle: 'Програма події',
      eventTopic: 'Тема події',
      eventType: 'Вид події',
      eventFormat: 'Формат події',
      accreditation: 'Акредитація події',
      eventDates: 'Дати проведення',
      language: 'Мова події',
      astronomicalHours: 'К-ть астрономічних годин',
      academicHours: 'К-ть академічних годин',
      bprPoints: 'Кількість балів БПР',
      organizer: 'Організатор події',
      program: 'Програма події',
      speakers: 'Викладачі події',
      participantCount: 'Кількість учасників',
      returnToHomepage: 'Повернутися на головну',
      youAreRegistered: 'Ви зареєстровані на цю подію',
      registering: 'Реєстрація...',
      register: 'Зареєструватися',
      programNotAvailable: 'Програма події ще не додана',
    },

    invitation: {
      accept: {
        title: 'Приймання запрошення організатора',
        processing: 'Обробка запрошення...',
        processingMessage: 'Будь ласка, зачекайте, поки ми обробляємо ваше запрошення...',
        success: 'Запрошення прийнято!',
        successMessage: 'Тепер ви організатор для',
        redirecting: 'Перенаправлення на сторінку управління...',
        goToBuilder: 'Перейти до конструктора',
        error: 'Помилка',
        goToDashboard: 'Панель управління',
        logIn: 'Увійти',
        invalidLink: 'Недійсне посилання',
        invalidLinkMessage: 'Це посилання на запрошення недійсне або термін дії закінчився.',
        goToHome: 'На головну',
        errors: {
          loginRequired: 'Вам потрібно увійти, щоб прийняти це запрошення',
          invalidOrExpired: 'Недійсне або термін дії запрошення закінчився',
          alreadyProcessed: 'Це запрошення вже оброблено',
          expired: 'Термін дії цього запрошення закінчився',
          unregisteredEmail: 'Це запрошення було надіслано на незареєстровану адресу електронної пошти. Запрошувати можна лише зареєстрованих користувачів.',
          profileNotFound: 'Профіль користувача не знайдено',
          emailMismatch: 'Це запрошення було надіслано на іншу адресу електронної пошти',
          accountMismatch: 'Це запрошення призначене не для вашого облікового запису',
          alreadyOrganizer: 'Ви вже є організатором цього контенту',
          failedToAdd: 'Не вдалося додати вас як організатора',
          internalError: 'Внутрішня помилка сервера',
        },
      },
      decline: {
        title: 'Відхилити запрошення організатора',
        confirmTitle: 'Відхилити запрошення',
        confirmMessage: 'Ви впевнені, що хочете відхилити це запрошення організатора?',
        confirmNote: 'Ви не будете додані як організатор цього контенту.',
        cancel: 'Скасувати',
        declineButton: 'Відхилити запрошення',
        processing: 'Обробка вашої відповіді...',
        success: 'Запрошення відхилено',
        successMessage: 'Запрошення було успішно відхилено.',
        redirecting: 'Перенаправлення на головну сторінку...',
        goToHome: 'На головну',
        error: 'Помилка',
        tryAgain: 'Спробувати ще раз',
        invalidLink: 'Недійсне посилання',
        invalidLinkMessage: 'Це посилання на запрошення недійсне або термін дії закінчився.',
        errors: {
          invalidOrExpired: 'Недійсне запрошення',
          alreadyProcessed: 'Це запрошення вже оброблено',
          emailMismatch: 'Це запрошення було надіслано на іншу адресу електронної пошти',
          failedToDecline: 'Не вдалося відхилити запрошення',
          internalError: 'Внутрішня помилка сервера',
        },
      },
    },

    // Speaker Invite Link
    speakerInvite: {
      honorariumExpected: 'Якщо передбачається гонорар, вкажіть банківські реквізити для оплати організатором',
      inviteButton: 'Запросити спікера',
      modalTitle: 'Посилання-запрошення для спікера',
      linkLabel: 'Посилання',
      copy: 'Копіювати',
      copied: 'Посилання скопійовано',
      regenerate: 'Оновити посилання',
      regenerateConfirmTitle: 'Оновити посилання?',
      regenerateConfirmBody: 'Попереднє посилання перестане працювати. Якщо ви вже надсилали його спікерам, їм доведеться отримати нове.',
      loadError: 'Не вдалося завантажити посилання-запрошення',
      copyError: 'Не вдалося скопіювати посилання',
      regenerateError: 'Не вдалося оновити посилання',
      hint: 'Спікер переходить за цим посиланням, входить у систему та самостійно заповнює свій профіль. Заповнений профіль з\'являється серед ваших збережених спікерів – його можна додати до будь-якої події чи заявки. Посилання лишається чинним, доки ви не згенеруєте нове.',
      pageTitle: 'Профіль спікера',
      pageIntro: '{organizer} запрошує вас заповнити профіль спікера на CONFY. Ці дані знадобляться для майбутніх заходів.',
      invalidTitle: 'Запрошення недійсне',
      invalidBody: 'Це посилання-запрошення більше не діє. Можливо, організатор згенерував нове – зверніться до нього, щоб отримати актуальне посилання.',
      submit: 'Надіслати',
      submitting: 'Надсилання...',
      successTitle: 'Дякуємо!',
      successBody: 'Ваш профіль спікера збережено. Організатор отримав сповіщення і зможе додати вас до заходу.',
      submitError: 'Не вдалося надіслати профіль. Спробуйте ще раз.',
      rateLimited: 'Забагато спроб надсилання. Спробуйте пізніше.',
    },

    // Speaker Management
    speakerManagement: {
      draftsDeletedDueToAge: 'Чернетки спікерів видалено через застарілість (старіше 7 днів)',
      errorDeletingSpeaker: 'Помилка при видаленні спікера',
      speakerDeletedSuccessfully: 'Спікера видалено успішно',
      confirmDeleteSpeaker: 'Ви впевнені, що хочете видалити цього спікера?',
      pleaseProvideFullName: 'Будь ласка, вкажіть прізвище та ім\'я спікера',
      titleQualificationMaxLength: 'Посада та кваліфікація не можуть перевищувати 150 символів',
      errorSavingSpeaker: 'Помилка при збереженні спікера',
      speakerSavedSuccessfully: 'Спікера збережено успішно',
      authenticationError: 'Помилка автентифікації',
      loadingError: 'Помилка завантаження спікерів',
      unexpectedError: 'Неочікувана помилка при завантаженні спікерів',
      speakerAddedFromExisting: 'Спікера додано з існуючих даних',
      possibleDuplicate: 'Можливий дублікат',
      possibleDuplicateHint: 'Інший запис у вашому списку спікерів має ту саму електронну пошту. Це можуть бути два записи про одну й ту саму людину – відредагуйте або видаліть один із них.',
      // Section Header
      title: 'Спікери',
      description: 'Додайте спікерів для події. Має бути хоча б один спікер.',
      noSpeakersYet: 'Спікерів ще не додано',
      // Photo
      uploadPhoto: 'Завантажити фото',
      changePhotoTitle: 'Змінити фото',
      removePhotoTitle: 'Видалити фото',
      removePhotoConfirmTitle: 'Видалити фото спікера?',
      removePhotoConfirmMessage: 'Ви впевнені, що хочете видалити фото цього спікера? Цю дію не можна скасувати.',
      removePhoto: 'Видалити',
      cancel: 'Скасувати',
      choosePhoto: 'Обрати',
      // Name Fields
      lastName: 'Прізвище',
      lastNamePlaceholder: 'Іваненко',
      firstName: 'Ім\'я',
      firstNamePlaceholder: 'Олена',
      middleName: 'По батькові',
      middleNamePlaceholder: 'Петрівна',
      // Bio
      shortBio: 'Коротке резюме',
      optional: 'необов\'язково',
      requiredForBpr: 'потрібно для БПР',
      bioPlaceholder: 'Введіть коротке резюме спікера, наприклад: Д.мед.н., професор кафедри терапії Національного медичного університету імені О.О. Богомольця (Київ)',
      // Additional Info Section
      additionalInfoTitle: 'Додаткова інформація про спікера',
      dateOfBirth: 'Дата народження',
      dateFormatPlaceholder: 'дд.мм.рррр',
      email: 'Email',
      emailPlaceholder: 'Введіть email спікера',
      phone: 'Телефон',
      phonePlaceholder: '+380XXXXXXXXX',
      education: 'Освіта',
      educationPlaceholder: 'Оберіть освіту спікера',
      educationOptions: {
        higherMedical: 'Вища медична',
        secondaryMedical: 'Середня медична',
        higherPharmaceutical: 'Вища фармацевтична',
        other: 'Інше',
      },
      workplace: 'Місце роботи',
      workplacePlaceholder: 'Введіть назву місця роботи спікера',
      position: 'Посада',
      positionPlaceholder: 'Введіть посаду спікера',
      academicDegree: 'Вчений ступінь',
      academicDegreePlaceholder: 'Оберіть вчений ступінь спікера',
      academicDegreeOptions: {
        candidateMedical: 'кандидат медичних наук',
        doctorMedical: 'доктор медичних наук',
        candidatePharmaceutical: 'кандидат фармацевтичних наук',
        doctorPharmaceutical: 'доктор фармацевтичних наук',
        candidatePsychological: 'кандидат психологічних наук',
        doctorPsychological: 'доктор психологічних наук',
        candidateBiological: 'кандидат біологічних наук',
        doctorBiological: 'доктор біологічних наук',
        noDegree: 'без ступеня',
        otherDegree: 'інше',
      },
      academicTitle: 'Вчене звання',
      academicTitlePlaceholder: 'Оберіть вчене звання спікера',
      academicTitleOptions: {
        docent: 'доцент',
        professor: 'професор',
        correspondingMember: 'член-кореспондент',
        academician: 'академік',
        seniorResearcher: 'старший науковий співробітник',
        leadResearcher: 'провідний науковий співробітник',
        noTitle: 'без вченого звання',
        otherTitle: 'інше',
      },
      // Additional Description
      additionalDescription: 'Інші відомості',
      additionalDescriptionPlaceholder: 'У 2000 році закінчила з відзнакою ХХХХХХ державний медичний інститут за спеціальністю «Лікувальна справа».\nКандидат медичних наук з 2000 року.\nНапрямки наукових досліджень та наукових інтересів: ХХХХХХ.\nЄ автором понад 100 навчально-методичних і наукових публікацій.',
      // Buttons
      saving: 'Зберігається...',
      saveSpeaker: 'Зберегти спікера',
      createNew: 'Створити нового',
      createNewSpeaker: 'Створити нового спікера',
      chooseExisting: 'Обрати існуючого',
      chooseExistingSpeaker: 'Обрати існуючого спікера',
      close: 'Закрити',
      // Remove from Event Confirmation
      removeConfirmTitle: 'Прибрати спікера з події?',
      removeConfirmDescription: 'Спікера буде прибрано з цієї події. Дані спікера залишаться у системі для використання в інших подіях.',
      removeButton: 'Прибрати',
      cancelButton: 'Скасувати',
      speakerRemovedSuccessfully: 'Спікера прибрано з події',
      errorRemovingSpeaker: 'Помилка при видаленні спікера з події',
    },

    // MOZ Speaker Management (CPD submission specific)
    mozSpeakers: {
      speakerAddedFromExisting: 'Спікера додано з існуючих даних',
      errorLoadingEventSpeakers: 'Помилка при завантаженні спікерів події',
      errorCopyingSpeakers: 'Помилка при копіюванні спікерів',
      speakersAddedFromEvent: 'Додано {count} спікер{suffix} з події',
      noEventSpeakersToCopy: 'У події немає спікерів для копіювання',
      allSpeakersAlreadyAdded: 'Усі спікери події вже додані до БПР',
      // Validation errors
      pleaseProvideName: 'Будь ласка, вкажіть прізвище та ім\'я спікера',
      pleaseProvideBio: 'Будь ласка, заповніть коротке резюме',
      pleaseProvideDateOfBirth: 'Будь ласка, вкажіть дату народження',
      pleasePprovideEmail: 'Будь ласка, вкажіть email спікера',
      pleaseProvidePhone: 'Будь ласка, вкажіть телефон спікера (мінімум 10 цифр)',
      invalidEmailFormat: 'Будь ласка, введіть коректну email адресу',
      pleaseSelectEducation: 'Будь ласка, оберіть освіту спікера',
      pleaseProvideWorkplace: 'Будь ласка, вкажіть місце роботи спікера',
      pleaseProvidePosition: 'Будь ласка, вкажіть посаду спікера',
      pleaseSelectAcademicDegree: 'Будь ласка, оберіть вчений ступінь спікера',
      pleaseSelectAcademicTitle: 'Будь ласка, оберіть вчене звання спікера',
      pleaseProvideAdditionalInfo: 'Будь ласка, заповніть інші відомості про спікера',
      authenticationError: 'Помилка автентифікації',
      errorSavingSpeaker: 'Помилка при збереженні спікера',
      speakerSavedSuccessfully: 'Спікера успішно збережено!',
      pleaseCompleteAllFields: 'Будь ласка, заповніть всі обов\'язкові поля для всіх спікерів',
      // UI text
      noSpeakersYet: 'Спікерів ще не додано',
      copyFromEvent: 'Скопіювати спікерів з події',
      copying: 'Копіювання...',
      copyFromEventDescription: 'Скопіюйте спікерів, доданих до події, щоб заповнити додаткові поля для БПР',
      createNew: 'Створити нового',
      chooseExisting: 'Обрати існуючого',
      photo: 'Фото',
      loading: 'Завантаження...',
      or: 'або',
      cvPdfNote: 'PDF резюме буде створено при генерації',
      speakerInfoForBpr: 'Інформація про спікера для БПР',
      addFromEvent: 'Додати спікерів з події',
      prefillConfirmTitle: 'Скопіювати спікерів з події?',
      prefillConfirmDescription: 'Спікери, додані до основної інформації про подію, будуть скопійовані до розділу БПР. Ви зможете заповнити додаткові поля, необхідні для подання в МОЗ. Спікери в БПР будуть незалежними від спікерів події.',
      copy: 'Скопіювати',
      save: 'Зберегти',
      registration: {
        register: 'Зареєструвати доповідача',
        registerAndIssue: 'Зареєструвати та видати сертифікат',
        switchTicket: 'Перевести на квиток доповідача',
        switchTicketAndReissue: 'Перевести на квиток доповідача та переоформити сертифікат',
        issue: 'Видати сертифікат',
        reissue: 'Переоформити як сертифікат доповідача',
        noSpeakerCredits: 'Спочатку вкажіть бали БПР для доповідачів у даних заходу',
        status: {
          no_email: 'Немає email – реєстрація неможлива',
          not_registered: 'Не зареєстровано на захід',
          registered_participant: 'Зареєстровано як учасник',
          participant_certificate: 'Зареєстровано як учасник, видано сертифікат учасника',
          registered_speaker: 'Зареєстровано (квиток доповідача)',
          speaker_ticket_participant_certificate: 'Квиток доповідача, але сертифікат видано як учаснику',
          certificate_issued: 'Сертифікат доповідача видано',
        },
        explain: {
          no_email: 'Без email на картці доповідача створити реєстрацію неможливо. Додайте email і збережіть картку.',
          not_registered: 'Доповідача буде зареєстровано на захід безкоштовним квитком «Доповідач» (він доступний лише за промокодом SPEAKER-… і створюється автоматично, якщо його ще немає). Якщо облікового запису з email картки не існує, його буде створено. Після завершення заходу сертифікат доповідача видається автоматично.',
          registered_participant: 'Доповідач зареєструвався на звичайний квиток учасника. Кнопка переведе його реєстрацію на квиток «Доповідач»; сертифікат доповідача буде видано після завершення заходу.',
          participant_certificate: 'Доповідач зареєстрований як учасник і вже отримав сертифікат учасника. Кнопка переведе реєстрацію на квиток «Доповідач» і переоформить цей самий сертифікат як сертифікат доповідача – під тим самим номером, з балами доповідача та даними з картки БПР. PDF оновиться, коли доповідач відкриє сертифікат.',
          registered_speaker: 'Доповідач зареєстрований квитком «Доповідач». Сертифікат доповідача буде видано автоматично після завершення заходу – або натисніть кнопку, щоб видати зараз.',
          speaker_ticket_participant_certificate: 'Доповідач на квитку «Доповідач», але його сертифікат було видано як сертифікат учасника. Кнопка переоформить його як сертифікат доповідача під тим самим номером, з балами доповідача.',
          certificate_issued: 'Сертифікат доповідача видано. У списку учасників для МОЗ цей доповідач буде з балами доповідача.',
        },
        notice: {
          no_email: 'На картці немає email – доповідача неможливо зареєструвати на захід і видати йому сертифікат доповідача.',
          not_registered: 'Цей доповідач не зареєстрований на захід. Без реєстрації він не отримає сертифікат доповідача і не потрапить до звіту для МОЗ як доповідач. Скористайтесь кнопкою «Зареєструвати доповідача» нижче.',
          registered_participant: 'Цей доповідач зареєстрований на захід як учасник, а не як доповідач. Переведіть його на квиток доповідача кнопкою нижче – сертифікат буде видано (або переоформлено) як сертифікат доповідача.',
          speaker_ticket_participant_certificate: 'Сертифікат цього доповідача видано як сертифікат учасника. Переоформіть його кнопкою нижче.',
        },
        done: {
          registered_speaker: 'Доповідача зареєстровано',
          registered_participant: 'Доповідач уже зареєстрований як учасник',
          certificate_issued: 'Сертифікат доповідача видано',
          reissued: 'Сертифікат переоформлено як сертифікат доповідача',
        },
        error: {
          request: 'Не вдалося виконати запит',
          no_email: 'На картці доповідача немає email',
          no_speaker_credits: 'Не вказано бали БПР для доповідачів',
          upgrade_in_flight: 'Для цієї реєстрації триває оплата зміни квитка, спробуйте пізніше',
          account_error: 'Не вдалося створити обліковий запис доповідача',
          write_failed: 'Не вдалося зберегти реєстрацію',
          speaker_not_found: 'Доповідача не знайдено у списку БПР',
        },
        dialog: {
          title: 'Реєстрація доповідача',
          chooseTicket: 'Оберіть квиток доповідача',
          chooseTemplate: 'Оберіть шаблон сертифіката доповідача',
          ticketWillBeCreated: 'Буде створено безкоштовний квиток «Доповідач», доступний лише за промокодом',
          noTemplate: 'У вас немає шаблону сертифіката доповідача. Створіть його у вкладці «Сертифікати» або пропустіть цього доповідача.',
          goToTemplates: 'Перейти до сертифікатів',
          confirm: 'Продовжити',
          ignore: 'Пропустити',
        },
        batch: {
          title: 'Доповідачі без сертифіката доповідача ({count})',
          hint: 'Щоб доповідач потрапив до списку учасників для МОЗ з балами доповідача, він має бути зареєстрований на захід квитком «Доповідач» і мати сертифікат доповідача. Кнопка робить для кожного доповідача зі списку те, що написано поруч з його ім’ям: реєструє незареєстрованих, переводить зареєстрованих як учасники на квиток «Доповідач» і видає сертифікат доповідача – або переоформлює вже виданий сертифікат учасника під тим самим номером. Якщо квитка «Доповідач» ще немає, його буде створено безкоштовним, за промокодом.',
          registerAll: 'Зареєструвати всіх',
          processAll: 'Оформити всіх',
          registering: 'Обробляємо…',
          done: 'Оброблено доповідачів: {count}',
          partial: 'Оброблено: {done}, з помилкою: {failed}',
          warning: 'У списку БПР є доповідачі без сертифіката доповідача ({count}). Вони не потраплять до списку учасників як доповідачі.',
          warningHint: 'Список учасників для МОЗ формується з виданих сертифікатів. Доповідач без сертифіката доповідача або не потрапить до списку взагалі, або потрапить як учасник із балами учасника. Щоб виправити, у блоці «Доповідачі без сертифіката доповідача» вище натисніть кнопку – або пройдіть по кожному доповідачу окремо у його картці в розділі «Доповідачі».',
          plan: {
            no_email: 'буде пропущено – немає email',
            not_registered: 'буде зареєстровано квитком «Доповідач»',
            not_registered_ended: 'буде зареєстровано квитком «Доповідач» і видано сертифікат доповідача',
            registered_participant: 'буде переведено на квиток «Доповідач»',
            registered_participant_ended: 'буде переведено на квиток «Доповідач» і видано сертифікат доповідача',
            participant_certificate: 'буде переведено на квиток «Доповідач», сертифікат учасника переоформлено як сертифікат доповідача (той самий номер)',
            registered_speaker: 'сертифікат доповідача буде видано після завершення заходу',
            registered_speaker_ended: 'буде видано сертифікат доповідача',
            speaker_ticket_participant_certificate: 'сертифікат учасника буде переоформлено як сертифікат доповідача (той самий номер)',
          },
        },
      },
    },

    // Partner Management
    partnerManagement: {
      // Section header
      title: 'Партнери заходу',
      description: 'Додайте партнерів з логотипами для відображення на сторінці заходу.',
      noPartnersYet: 'Партнерів ще не додано',
      createNew: 'Створити нового',
      chooseExisting: 'Обрати існуючого',
      createNewPartner: 'Створити нового партнера',
      chooseExistingPartner: 'Обрати існуючого партнера',
      // Logo
      partnerLogo: 'Логотип партнера',
      removeImage: 'Прибрати зображення',
      choose: 'Обрати',
      // Name field
      partnerName: 'Назва партнера',
      partnerNamePlaceholder: "Наприклад: ТОВ 'Медична компанія'",
      partnerNameRequired: 'Назва партнера обов\'язкова',
      enterPartnerName: 'Введіть назву партнера',
      // Additional info
      additionalInfo: 'Додаткова інформація',
      optional: '(необов\'язково)',
      additionalInfoPlaceholder: 'Наприклад: Генеральний партнер заходу, Інформаційна підтримка',
      additionalInfoDescription: 'Опис партнера, роль тощо',
      charactersCount: '{{count}}/200 символів',
      // Actions
      saving: 'Зберігається...',
      save: 'Зберегти',
      savePartner: 'Зберегти партнера',
      remove: 'Прибрати',
      close: 'Закрити',
      cancel: 'Скасувати',
      edit: 'Редагувати',
      delete: 'Видалити',
      select: 'Обрати',
      tryAgain: 'Спробувати знову',
      // Browser
      selectPartner: 'Виберіть партнера',
      selectFromYourEvents: 'Оберіть існуючого партнера зі своїх подій',
      searchByName: 'Пошук за назвою партнера...',
      editingPartner: 'Редагування партнера: {{name}}',
      partnerUpdated: 'Партнера оновлено',
      errorUpdatingPartner: 'Помилка при оновленні партнера',
      noPartnersFound: 'Партнерів не знайдено',
      noSavedPartners: 'У вас ще немає збережених партнерів',
      tryDifferentSearch: 'Спробуйте змінити пошуковий запит',
      createPartnerToSeeHere: 'Створіть партнера для події, і він з\'явиться тут',
      partnersFound: 'Знайдено партнерів:',
      cannotDeletePartner: 'Неможливо видалити партнера "{{name}}". Він використовується в події. Видаліть його з події спочатку.',
      deletePartnerTitle: 'Видалити партнера',
      deletePartnerConfirm: 'Ви впевнені, що хочете видалити партнера "{{name}}"? Цю дію неможливо скасувати.',
      // Remove from Event Confirmation
      removeConfirmTitle: 'Прибрати партнера з події?',
      removeConfirmDescription: 'Партнера буде прибрано з цієї події.',
      removeButton: 'Прибрати',
      cancelButton: 'Скасувати',
      partnerRemovedSuccessfully: 'Партнера прибрано з події',
      errorRemovingPartner: 'Помилка при видаленні партнера з події',
      errorDeletingPartner: 'Помилка при видаленні партнера',
      partnerDeletedSuccessfully: 'Партнера видалено успішно',
      pleaseProvidePartnerName: 'Будь ласка, вкажіть назву партнера',
      additionalInfoMaxLength: 'Додаткова інформація не може перевищувати 200 символів',
      errorSavingPartner: 'Помилка при збереженні партнера',
      partnerSavedSuccessfully: 'Партнера збережено успішно',
      partnerAddedFromExisting: 'Партнера додано з існуючих даних',
      errorLoadingPartners: 'Не вдалося завантажити список партнерів',
    },

    // Duplicate Detection Suggestions
    duplicateSuggestion: {
      speaker: 'спікер',
      organizer: 'організатор',
      partner: 'партнер',
      highConfidenceTitle: 'Знайдено схожий запис',
      possibleDuplicateTitle: 'Можливий дублікат',
      dismiss: 'Закрити',
      clickToUseExisting: 'Натисніть, щоб використати існуючий запис',
      viewAll: 'Переглянути всі',
      createNew: 'Створити новий',
      useExisting: 'Використати існуючий',
      continueCreating: 'Продовжити створення',
      similarRecordFound: 'Знайдено схожий запис у вашій базі даних',
      wouldYouLikeToUse: 'Бажаєте використати існуючий запис замість створення нового?',
    },

    // Course Builder Editor Toolbar
    courseBuilderEditor: {
      heading1: 'Заголовок 1',
      heading2: 'Заголовок 2',
      heading3: 'Заголовок 3',
      bold: 'Жирний',
      italic: 'Курсив',
      bulletList: 'Маркований список',
      link: 'Посилання',
    },
    organizerPage: {
      upcoming: 'Майбутні',
      past: 'Минулі',
      noUpcomingEvents: 'Немає майбутніх подій',
      noPastEvents: 'Немає минулих подій',
      organizerNotFound: 'Організатора не знайдено',
      organizerNotFoundDescription: 'Організатора за цією адресою не знайдено.',
      events: 'подій',
    },
    organizersPage: {
      title: 'Організатори',
      subtitle:
        'Медичні спільноти, асоціації та освітні провайдери, які проводять події на CONFY',
      events_one: 'подія',
      events_few: 'події',
      events_many: 'подій',
      empty: 'Поки що немає організаторів з опублікованими подіями.',
      becomeTitle: 'Організовуєте медичні події?',
      becomeText: 'Проводьте їх зручно на CONFY',
      becomeCta: 'Дізнатися більше',
    },
    embed: {
      // Auth
      enterEmail: 'Введіть ваш email',
      emailPlaceholder: 'email@example.com',
      sendCode: 'Надіслати код',
      verificationCode: 'Код підтвердження',
      enterCode: 'Введіть 6-значний код',
      verify: 'Підтвердити',
      continueWithGoogle: 'Продовжити з Google',
      or: 'або',
      didntReceiveCode: 'Не отримали код?',
      resendCode: 'Надіслати повторно',
      checkSpam: 'Перевірте папку спам',
      codeExpired: 'Код закінчився. Запросіть новий.',
      incorrectCode: 'Невірний код, спробуйте ще раз',
      tooManyAttempts: 'Забагато спроб. Спробуйте пізніше.',
      sessionExpired: 'Сесія закінчилася. Підтвердьте email, щоб продовжити.',
      popupBlocked: 'Ваш браузер заблокував вікно входу. Будь ласка, увійдіть за допомогою коду з email.',
      // Tickets
      selectTicket: 'Оберіть квиток',
      selectTicketFirst: 'Спершу оберіть квиток вище',
      free: 'Безкоштовно',
      continue: 'Продовжити',
      registering: 'Реєстрація...',
      promoCode: 'Промокод',
      apply: 'Застосувати',
      soldOut: 'Всі місця зайняті',
      salesNotStarted: 'Продаж починається',
      salesEnded: 'Продаж завершено',
      // Profile
      completeProfile: 'Заповніть профіль',
      profileRequired: 'Для реєстрації необхідно заповнити профіль',
      fillRequiredFields: 'Заповніть усі обов\'язкові поля, позначені *',
      save: 'Зберегти',
      // Payment
      proceedToPayment: 'Перейти до оплати',
      paymentBlocked: 'Ваш браузер заблокував вікно оплати. Ви можете завершити реєстрацію безпосередньо на CONFY.',
      paymentFailed: 'Оплату відхилено. Спробуйте ще раз або скористайтесь іншою карткою.',
      fulfilmentBlocked: 'Оплата пройшла успішно, але реєстрацію завершити не вдалося. Служба підтримки CONFY вже сповіщена та зв\'яжеться з вами – будь ласка, не оплачуйте повторно. З питаннями звертайтесь на support@confy.cc.',
      paymentPending: 'Оплату отримано, підтверджуємо реєстрацію. Це може зайняти кілька хвилин – ви отримаєте лист з підтвердженням.',
      paymentNotCompleted: 'Оплату не завершено. Бажаєте спробувати ще раз?',
      paymentWindowOpen: 'Завершіть оплату у вікні, що відкрилося.',
      reopenPaymentWindow: 'Відкрити вікно оплати ще раз',
      cancelPayment: 'Скасувати',
      paymentPopupBlocked: 'Браузер заблокував вікно оплати. Натисніть «Спробувати ще раз» або дозвольте спливаючі вікна для цього сайту.',
      // Payment popup window (opened over the organizer's site)
      popup: {
        loading: 'Завантаження оплати...',
        processing: 'Обробка оплати...',
        redirecting: 'Переходимо на сторінку оплати...',
        continueToPayment: 'Перейти до оплати',
        cancel: 'Скасувати',
        close: 'Закрити',
        sessionExpired: 'Час на оплату минув. Закрийте це вікно та спробуйте ще раз.',
        loadError: 'Не вдалося завантажити оплату. Закрийте це вікно та спробуйте ще раз.',
        declined: 'Оплату відхилено.',
        initFailed: 'Не вдалося запустити оплату.',
        missingSession: 'Сесію оплати не знайдено.',
        finishing: 'Завершуємо оплату...',
        notCompleted: 'Оплату не завершено. Можете закрити це вікно.',
        received: 'Оплату отримано. Можете закрити це вікно та повернутися на сайт.',
      },
      paymentUnavailable: 'Онлайн-оплата недоступна для цієї події. Зверніться до організатора.',
      tryAgain: 'Спробувати ще раз',
      completeOnConfy: 'Завершити реєстрацію на CONFY',
      // Document upload (needs a CONFY session, which the embedded form does not have)
      documentUploadTitle: 'Потрібно завантажити документ',
      documentUploadUnavailable: 'Для цього квитка організатор просить завантажити документ, а вбудована форма не може приймати файли. Завершіть реєстрацію на сторінці події на CONFY – усі ваші відповіді ви введете там.',
      documentUploadOptionalUnavailable: 'Це питання передбачає завантаження файлу, чого вбудована форма не підтримує. Ви можете продовжити тут без файлу або зареєструватися на сторінці події, щоб додати його.',
      // Confirmation
      registered: 'Ви зареєстровані!',
      registrationConfirmed: 'Вашу реєстрацію підтверджено',
      addToCalendar: 'Додати до календаря',
      viewOnConfy: 'Переглянути на CONFY',
      alreadyRegistered: 'Ви вже зареєстровані на цю подію!',
      answersNotStoredError: 'Вас зареєстровано, але не вдалося зберегти ваші відповіді на питання реєстрації. Будь ласка, зв\'яжіться з організатором.',
      // Event states
      eventNotAvailable: 'Ця подія недоступна',
      eventNotFound: 'Подію не знайдено',
      eventPassed: 'Ця подія вже відбулася',
      eventCancelled: 'Цю подію скасовано',
      // General
      loading: 'Завантаження...',
      error: 'Помилка',
      retry: 'Спробувати ще раз',
      poweredByConfy: 'Працює на CONFY',
      register: 'Зареєструватися',
      // PAY-10: shown instead of the widget when an embed.js load has no
      // nonce (an old, cached copy) past the legacy grace window.
      legacyExpired: 'Код вбудовування застарів. Попросіть організатора оновити код віджета CONFY на сайті.',
    },
    ticketQuestions: {
      errorRequired: 'Це поле обовʼязкове',
      errorTooShort: 'Занадто коротке значення',
      errorTooLong: 'Занадто довге значення',
      errorInvalidOption: 'Виберіть один із запропонованих варіантів',
      errorFileTooLarge: 'Файл завеликий. Максимальний розмір - {{size}} МБ',
      hintLabel: 'Підказка для учасника (необовʼязково)',
      hintPlaceholder: 'Коротке пояснення, яке побачить учасник під питанням',
      fileRules: 'Приймаються файли {{formats}}, розміром до {{size}} МБ',
      sectionTitle: 'Додаткові питання',
      addQuestion: 'Додати питання',
      noQuestions: 'Для цього квитка ще немає питань',
      askOn: 'Запитувати на:',
      thisTicketOnly: 'Тільки цей квиток',
      allTickets: 'Усі квитки',
      sharedWithTickets: 'Спільне питання',
      sharedEditWarning: 'Редагування або видалення змінить це питання на всіх квитках, де воно використовується',
      deleteQuestion: 'Видалити питання',
      deleteQuestionConfirmation: 'Питання буде видалено назавжди разом з усіма збереженими відповідями учасників на нього. Цю дію не можна скасувати.',
      // Plural variants (_one/_few/_many) are resolved by pluralKey() in
      // src/lib/i18n/plural.ts - Ukrainian agrees with the last digit, so a
      // single string renders "на 1 квитках". The answer count is deliberately
      // phrased as a trailing "відповідей: N" so it needs no agreement of its
      // own: one sentence cannot carry two independent plural forms.
      deleteQuestionSharedConfirmation_one: 'Це питання запитується на {{tickets}} квитку, і на нього збережено відповідей: {{answers}}. Видалення прибере питання з цього квитка і назавжди видалить усі ці відповіді. Цю дію не можна скасувати.',
      deleteQuestionSharedConfirmation_few: 'Це питання запитується на {{tickets}} квитках, і на нього збережено відповідей: {{answers}}. Видалення прибере питання з усіх цих квитків і назавжди видалить усі ці відповіді. Цю дію не можна скасувати.',
      deleteQuestionSharedConfirmation_many: 'Це питання запитується на {{tickets}} квитках, і на нього збережено відповідей: {{answers}}. Видалення прибере питання з усіх цих квитків і назавжди видалить усі ці відповіді. Цю дію не можна скасувати.',
      deleteEverywhere: 'Видалити з усіх квитків',
      detachFromTicket: 'Прибрати лише з цього квитка',
      newTicketPromptTitle_one: 'Ця подія вже запитує {{count}} питання на інших квитках:',
      newTicketPromptTitle_few: 'Ця подія вже запитує {{count}} питання на інших квитках:',
      newTicketPromptTitle_many: 'Ця подія вже запитує {{count}} питань на інших квитках:',
      newTicketPromptHint: 'Зніміть позначку з тих, які не потрібні для цього квитка.',
      askedOnCount_one: 'запитується на {{count}} квитку',
      askedOnCount_few: 'запитується на {{count}} квитках',
      askedOnCount_many: 'запитується на {{count}} квитках',
      newTicketLinkFailed: 'Квиток створено, але питання не вдалося прикріпити до нього. Скористайтеся кнопкою «Запитувати на», щоб додати їх вручну.',
    },
  },

  en: {
    // Header
    header: {
      logo: 'CONFY',
      nav: {
        courses: 'Courses',
        events: 'Events',
      },
      auth: {
        signIn: 'Sign In',
        signUp: 'Sign Up',
        signOut: 'Sign Out',
        profile: 'Profile',
        dashboard: 'Dashboard',
        myTests: 'My Tests',
        mySurveys: 'My Surveys',
        myCertificates: 'My Certificates',
        myMaterials: 'My Materials',
        createdByMe: 'Created by Me',
        myTickets: 'My Tickets',
        user: 'User',
        loadingName: 'Loading name...',
        profileUnavailable: 'Profile did not load',
        retryProfile: 'Retry',
      },
    },

    // Home Page
    home: {
      hero: {
        title: 'Advance Your',
        titleHighlight: 'Medical Career',
        subtitle: 'Discover medical courses and online events with CME credits and stay up to date with the latest advances',
        cta: 'Explore Events and Courses',
        ctaEvents: 'Explore Events',
        ctaSubtext: 'Faster. More convenient. More professional. We\'ve updated the platform for you',
      },
      browse: {
        title: 'Find Your Event or Course',
        subtitle: 'Search programs for your specialty and earn CME credits',
        mozAccredited: 'CME credits',
        availableContent: '{{count}}+ programs available',
        noResults: 'Nothing Found',
        noResultsDesc: 'Try adjusting your search parameters or browse all available events and courses.',
        loadFailed: 'Failed to load data',
        loadFailedDesc: 'Check your internet connection and try again.',
        retry: 'Try again',
        viewAll: 'View All',
        backToHome: 'Back to Home',
        resultsCount: 'Found: {{count}}',
        showingPastFallback: 'There are no upcoming events right now, so we\'re showing past events and courses.',
      },
      search: {
        placeholder: 'Search events and courses...',
        specialty: 'All Specialties',
        format: 'Any Format',
        type: 'Type',
        button: 'Search',
        popularSearches: 'Popular searches:',
        showFilters: 'Advanced filters',
        hideFilters: 'Hide filters',
        advancedFilters: 'Advanced search filters',
        filters: 'Filters',
        clearFilters: 'Clear',
        apply: 'Apply',
        showPastEvents: 'Show past events',
        types: {
          all: 'All',
          courses: 'Courses Only',
          events: 'Events Only',
        },
        specialties: {
          all: 'All Specialties',
          cardiology: 'Cardiology',
          neurology: 'Neurology',
          pediatrics: 'Pediatrics',
          surgery: 'Surgery',
          internal_medicine: 'Internal Medicine',
          emergency: 'Emergency Medicine',
          radiology: 'Radiology',
          anesthesiology: 'Anesthesiology',
        },
        formats: {
          any: 'Any Format',
          online: 'Online',
          inPerson: 'In-Person',
          hybrid: 'Hybrid',
          selfPaced: 'Self-Paced',
        },
      },
      courses: {
        latest: 'Latest Medical Courses',
        latestSubtitle: 'Recently added courses from leading medical educators',
        searchResults: 'Search Results',
        searchResultsSubtitle: 'Courses matching your search criteria',
        clearSearch: 'Clear Search & View All Courses',
        noCourses: 'Nothing found',
        noCoursesDesc: 'Try adjusting your search parameters or check back later.',
        loading: 'Loading...',
        loadMore: 'Load More',
        showing: 'Showing',
        of: 'of',
        noMore: 'No more items',
      },
      stats: {
        title: 'Join 78,000+ Medical Professionals',
        eventsHeld: 'Events Held',
        participants: 'Participants',
        doctorsInDatabase: 'Users',
        organizers: 'Organizers',
      },
      trust: {
        mozAccredited: 'CME Accreditation',
        doctorsTrust: 'registered HCPs',
        eventsHeld: 'events held',
      },
      featured: {
        title: 'Latest Events & Courses',
        subtitle: 'Browse events and register in one click',
        viewAll: 'View All',
      },
      browseSection: {
        title: 'Find Your Event or Course',
        subtitle: 'Search through all available events and courses',
      },
      whyChoose: {
        title: 'Why HCPs Choose CONFY',
        subtitle: 'A platform built for medical professionals',
        mozAccreditation: {
          title: 'Full history of education',
          description: 'All your certificates and recordings in one protected place',
        },
        expertInstructors: {
          title: 'Registration in one click',
          description: 'Your data is pulled from the profile. No more annoying registration forms',
        },
        flexibleLearning: {
          title: 'Flexible Schedule',
          description: 'Study at your own pace from practicing professionals',
        },
        cpdCredits: {
          title: 'CME Credits',
          description: 'Most courses and events are CME accredited',
        },
      },
      browseCourses: 'Browse Events & Courses',
      allContent: 'All Events & Courses',
    },

    // Course Card
    courseCard: {
      instructor: 'Instructor',
      duration: 'Duration',
      level: 'Level',
      price: 'Price',
      free: 'Free',
      register: 'Register',
      registerForEvent: 'Register for Event',
      registerForCourse: 'Register for Course',
      registrationOpensSoon: 'Registration will open soon',
      startLearning: 'Start Learning',
      continueLearning: 'Continue Learning',
      courseCompleted: 'Completed',
      eventCompleted: 'Event Completed!',
      startEvent: 'Start',
      continueEvent: 'Continue',
      goToCourse: 'Go to Course',
      goToEvent: 'Go to Event',
      viewEvent: 'View Event',
      past: 'Past',
      viewDetails: 'View Details',
      course: 'Course',
      event: 'Event',
      cpdCredits: 'CPD Credits',
      cpdCreditsAvailable: 'CPD Credits Available',
      scheduleTBA: 'Schedule TBA',
      locationTBA: 'Location TBA',
      levels: {
        beginner: 'Beginner',
        intermediate: 'Intermediate',
        advanced: 'Advanced',
      },
      formats: {
        online: 'Online',
        in_person: 'In-Person',
        hybrid: 'Hybrid',
        self_paced: 'Self-Paced',
      },
    },

    // Auth Modal
    auth: {
      signIn: {
        title: 'Sign In to Your Account',
        email: 'Email',
        password: 'Password',
        button: 'Sign In',
        forgotPassword: 'Forgot password?',
        noAccount: "Don't have an account?",
        signUp: 'Sign up',
        orContinueWith: 'or continue with',
        error: 'Sign in error',
      },
      signUp: {
        title: 'Create an Account',
        firstName: 'First Name',
        lastName: 'Last Name',
        email: 'Email',
        password: 'Password',
        confirmPassword: 'Confirm Password',
        phone: 'Phone',
        role: 'Role',
        selectRole: 'Select a role',
        roles: {
          student: 'Student',
          instructor: 'Instructor',
        },
        button: 'Sign Up',
        haveAccount: 'Already have an account?',
        signIn: 'Sign in',
        terms: 'By signing up, you agree to our',
        termsLink: 'User Agreement',
        and: 'and',
        privacyLink: 'Privacy Policy',
        error: 'Sign up error',
        success: 'Registration successful! Check your email for confirmation.',
        passwordMismatch: 'Passwords do not match',
      },
      // Sign-in confirmation interstitial (/auth/confirm)
      confirmTitle: 'Signing you in…',
      confirmBody: 'This takes a moment. If nothing happens, use the button below.',
      confirmAction: 'Sign in',
      confirmManualTitle: 'Confirm sign-in',
      confirmManualBody: 'Tap the button to sign in to CONFY.',
    },

    // Dashboard
    dashboard: {
      title: 'Dashboard',
      welcome: 'Welcome',
      myCourses: 'My Courses',
      enrolled: 'Enrolled',
      teaching: 'Teaching',
      createCourse: 'Create New Course',
      complete: 'Complete',
      lastAccessed: 'Last Accessed',
      noCourses: 'You have no courses yet',
      noCoursesDesc: 'Start by exploring available courses or create your own.',
      exploreCourses: 'Explore Courses',
      progress: 'Progress',
      certificate: 'Certificate',
      continue: 'Continue',
      completed: 'Completed',
      notStarted: 'Not Started',
      certificates: 'Certificates',
      inProgress: 'In Progress',
      myCreatedCourses: 'My Created Courses',
      courses: 'courses',
      course: 'course',
      noCoursesCreatedYet: 'No courses created yet',
      startCreatingFirstCourse: 'Start creating your first course to share your knowledge!',
      createYourFirstCourse: 'Create Your First Course',
      created: 'Created',
      starts: 'Starts',
      unpublish: 'Unpublish',
      publish: 'Publish',
      draft: 'Draft',
      published: 'Published',
      editCourse: 'Edit Course',
      viewAnalytics: 'View Analytics',
      enrolledCourses: 'Enrolled Courses',
      noCoursesYet: 'No courses yet',
      notEnrolledYet: 'You have not enrolled in any courses yet. Start exploring our course catalog!',
      enrolledStatus: 'Enrolled',
      materials: 'Materials',
      required: 'required',
      tests: 'Tests',
      surveys: 'Surveys',
      issued: 'issued',
      tickets: 'Tickets',
      purchased: 'Purchased',
      free: 'Free',
      startLearning: 'Start Learning',
      continueLearning: 'Continue Learning',
      courseCompleted: 'Completed',
      viewCertificate: 'Certificate',
      generateCertificate: 'Generate Certificate',
      createNewCourse: 'Create New Course',
      chooseHowToCreate: 'Choose how you want to create your course content. You can build it using our drag-and-drop editor with multiple content types.',
      startWithCourseBuilder: 'Start with Course Builder',
      useDragAndDrop: 'Use our drag-and-drop editor to create rich course content',
      useTemplate: 'Use Template',
      startWithTemplate: 'Start with a pre-built course template',
      importContent: 'Import Content',
      importExistingMaterials: 'Import existing course materials',
      creator: 'Creator',
      learner: 'Learner',
      more: 'More',
      archive: 'Archive',
      unarchive: 'Unarchive',
      archived: 'Archived',
      duplicate: 'Duplicate Event',
      delete: 'Delete',
      deleteSuccess: 'Content deleted successfully',
      deleteError: 'Failed to delete content',
      statusUpdateError: 'Failed to update status',
      enrolledEvents: 'Enrolled Events',
      filter: {
        all: 'All',
        active: 'Active',
        draft: 'Drafts',
        archived: 'Archived',
        past: 'Past',
      },
      deleteModal: {
        title: {
          event: 'Delete Event?',
          course: 'Delete Course?',
        },
        warning: 'This action is permanent and cannot be undone.',
        whatWillBeDeleted: 'What will be deleted:',
        items: {
          eventDetails: 'Event details and settings',
          courseDetails: 'Course details and settings',
          materials: 'All materials and content',
          tests: 'Tests and surveys',
          tickets: 'Tickets',
          promocodes: 'Promocodes',
          allData: 'All associated data',
        },
        confirmInstruction: 'Type "DELETE" to confirm:',
        cancel: 'Cancel',
        deletePermanently: 'Delete Permanently',
        deleting: 'Deleting...',
      },
      blockedDeleteModal: {
        title: {
          event: 'Cannot Delete Event',
          course: 'Cannot Delete Course',
        },
        message: 'This {contentType} cannot be deleted because there are active enrollments.',
        currentActivity: 'Current activity:',
        enrollments: '{count} enrolled participants',
        payments: '{count} completed payments',
        certificates: '{count} issued certificates',
        archiveRecommendation: 'Consider archiving this {contentType} instead to preserve participant records while hiding it from your active list.',
        cancel: 'Cancel',
        archiveInstead: 'Archive Instead',
      },
      duplicateModal: {
        title: 'Duplicate Event',
        description: 'Select which components you want to copy to the new event. The duplicated event will be created as a draft.',
        selectAll: 'Select All',
        button: 'Duplicate Event',
        duplicating: 'Duplicating...',
        success: 'Event duplicated successfully!',
        partialSuccess: 'Event duplicated, but some data could not be copied. Check the new event.',
        error: 'Failed to duplicate event',
        eventNotFoundOrAccessDenied: 'Event not found or access denied',
        options: {
          generalInfo: 'General Information (title, description, dates, location, specialty, etc.)',
          tickets: 'Tickets',
          promocodes: 'Promo Codes',
          speakers: 'Speakers',
          program: 'Program',
          materials: 'Additional Materials',
          partners: 'Partners',
          mozSubmission: 'CPD Data',
          tests: 'Tests',
          surveys: 'Surveys',
          customFields: 'Custom Enrollment Fields',
          organizerAccess: 'Organizer Access (no email notifications)',
        },
        availabilityHelpLine: 'Availability windows are copied – anchored ones carry over automatically; absolute dates shift to match the new event date.',
      },
      cancellation: {
        cancelEvent: 'Cancel Event',
        reactivateEvent: 'Reactivate Event',
        eventCancelled: 'Event Cancelled',
        cancelledOn: 'Cancelled on',
        cancelledBy: 'Cancelled by',
        reason: 'Cancellation Reason',
        reasonRequired: 'Cancellation reason is required',
        reasonPlaceholder: 'Enter reason for cancelling this event...',
        confirmCancel: 'Confirm Cancellation',
        confirmReactivate: 'Confirm Reactivation',
        cancelling: 'Cancelling...',
        reactivating: 'Reactivating...',
        cancelSuccess: 'Event cancelled successfully',
        reactivateSuccess: 'Event reactivated successfully',
        cancelError: 'Failed to cancel event',
        reactivateError: 'Failed to reactivate event',
        cannotCancelEnded: 'Cannot cancel an event that has already ended',
        alreadyCancelled: 'Event is already cancelled',
        notCancelled: 'Event is not cancelled',
        pendingRefunds: 'Pending refunds',
        cannotReactivateWhileRefunding: 'Cannot reactivate event while refunds are being processed',
        cannotPublishCancelled: 'Cannot publish a cancelled event. Please reactivate it first from the dashboard.',
        impactSummary: 'Cancellation Impact',
        enrolledUsers: 'Enrolled users',
        paidEnrollments: 'Paid enrollments',
        totalRefundAmount: 'Total refund amount',
        usersWillBeNotified: 'Users will be notified about the cancellation',
        refundsWillBeProcessed: 'Once approved by the organizer, refunds will be processed within 5-7 business days',
        refundsQueuedForApproval: 'Paid registrations ({{count}}) will be queued for the organizer\'s approval – you can approve refunds from this event\'s participant list.',
        refundsFailed: '{{count}} refunds could not be queued. CONFY support has been notified.',
        warningTitle: 'Warning!',
        warningMessage: 'This action will cancel the event and initiate refunds to all paid participants.',
        reactivateWarning: 'Users who received refunds will need to register again.',
        readyToReactivate: 'Ready to Reactivate',
        readyToReactivateDescription: 'This event can be reactivated and will become visible to users again.',
        currentStatus: 'Current Status',
        activeEnrollments: 'Active enrollments (not refunded)',
        notCancelledDescription: 'This event is not cancelled and does not need to be reactivated.',
        publicBannerMessage: 'This event has been cancelled. Registration is no longer available.',
        refundStatus: {
          pending: 'Pending',
          processing: 'Processing',
          completed: 'Refunded',
          failed: 'Failed',
          not_applicable: 'N/A',
          partial: 'Partially refunded',
          queued: 'Queued',
        },
      },
      // New 4-tab dashboard structure
      tabs: {
        pending: 'Pending',
        learning: 'My Learning',
        history: 'History',
        created: 'Created',
      },
      pending: {
        tests: 'Pending Tests',
        surveys: 'Pending Surveys',
        inProgress: 'Continue Learning',
        required: 'Required',
        passingScore: 'Passing',
        attempts: 'Attempts',
        overdue: 'Overdue',
        dueToday: 'Due today',
        daysLeft: 'days left',
        startTest: 'Start Test',
        completeSurvey: 'Complete Survey',
        testClosed: 'Test Closed',
        surveyClosed: 'Survey Closed',
        testOverdue: 'This test is no longer available – the deadline has passed',
        surveyOverdue: 'This survey is no longer available – the deadline has passed',
        continue: 'Continue',
        allCaughtUp: 'All caught up!',
        noPendingItems: 'You have no pending tests, surveys, or courses to complete.',
      },
      learning: {
        all: 'All',
        events: 'Events',
        courses: 'Courses',
        noEnrollments: 'No enrollments yet',
        startLearning: 'Start your learning journey by enrolling in events or courses.',
        browse: 'Browse Events & Courses',
      },
      history: {
        title: 'Completion History',
        certificateEarned: 'Certificate Earned',
        testCompleted: 'Test Completed',
        surveyCompleted: 'Survey Completed',
        certificateNumber: 'Certificate #',
        cpdCredits: 'CPD Credits',
        verificationCode: 'Verification',
        passed: 'Passed',
        failed: 'Failed',
        score: 'Score',
        required: 'required',
        download: 'Download',
        verify: 'Verify',
        getCertificate: 'Get Certificate',
        empty: 'No history yet',
        emptyDescription: 'Complete tests, surveys, or earn certificates to see your history here.',
        fromEvent: 'Event',
        fromCourse: 'Course',
      },
    },

    createdPage: {
      title: 'Created by Me',
      subtitle: "Events and courses you've created",
      tabEvents: 'Events',
      tabCourses: 'Courses',
      statsTotal: 'Total',
      typeEvent: 'Event',
      typeCourse: 'Course',
      enrolled: 'enrolled',
      statusActive: 'Active',
      statusDraft: 'Draft',
      statusArchived: 'Archived',
      statusCancelled: 'Cancelled',
      emptyEventsTitle: 'No events created yet',
      emptyEventsSubtitle: 'Start creating your first event to share it with others!',
      emptyCoursesTitle: 'No courses created yet',
      emptyCoursesSubtitle: 'Start creating your first course to share your knowledge!',
      emptyFilterTitle: 'Nothing found',
      emptyFilterSubtitle: 'Try selecting a different filter.',
      loadErrorTitle: 'Could not load the list',
      loadErrorSubtitle: 'Your events and courses are still there – we just could not fetch them. Please try again.',
      retry: 'Try again',
      profileUnavailableTitle: 'Profile did not load',
      profileUnavailableSubtitle: 'We could not verify your organizer role. Please try again.',
      createEvent: 'Create Event',
      createCourse: 'Create Course',
      actionEdit: 'Edit',
      actionDuplicate: 'Duplicate',
      actionArchive: 'Archive',
      actionUnarchive: 'Unarchive',
      actionCancel: 'Cancel',
      actionReactivate: 'Reactivate',
      actionViewStudents: 'View Students',
      actionDelete: 'Delete',
      backToDashboard: 'Back to Dashboard',
      noAccess: 'You do not have access to this page.',
    },

    // Course Details
    course: {
      about: 'About',
      curriculum: 'Curriculum',
      instructors: 'Instructors',
      reviews: 'Reviews',
      enroll: 'Enroll in Course',
      startLearning: 'Start Learning',
      price: 'Price',
      free: 'Free',
      duration: 'Duration',
      level: 'Level',
      language: 'Language',
      certificate: 'Certificate',
      yes: 'Yes',
      no: 'No',
      students: 'Participants',
      rating: 'Rating',
      whatYouWillLearn: 'What You Will Learn',
      requirements: 'Requirements',
      description: 'Description',
    },

    // Course Builder
    courseBuilder: {
      title: 'Course Builder',
      backToDashboard: 'Back to Dashboard',
      editingCourse: 'Editing Course',
      creatingNewCourse: 'Creating New Course',
      newCourse: 'New Course',
      saved: 'Saved',
      savedAt: 'Saved at',
      lastSavedAt: 'Last saved',
      courseLink: 'Course link',
      shareCourse: 'Share course',
      shareCourseLink: 'Share course link',
      copy: 'Copy',
      copied: 'Copied!',
      createCourse: 'Create New Course',
      editCourse: 'Edit Course',
      courseTitle: 'Course Title',
      courseDescription: 'Course Description',
      category: 'Category',
      selectCategory: 'Select a category',
      level: 'Level',
      selectLevel: 'Select level',
      duration: 'Duration (hours)',
      price: 'Price (UAH)',
      free: 'Free Course',
      addSection: 'Add Section',
      addLesson: 'Add Lesson',
      save: 'Save',
      publish: 'Publish',
      draft: 'Draft',
      published: 'Published',
      preview: 'Preview',
      studentViewPreview: 'Student View Preview',
      previewBadge: 'PREVIEW',
      closePreview: 'Close Preview',
      delete: 'Delete',
      checkingAccessPermissions: 'Checking access permissions...',
      createAndOrganizeCourseContent: 'Create and organize your course content',
      saveCourse: 'Save Course',
      saving: 'Saving...',
      coursePublishedSuccessfully: 'Course published successfully',
      courseUnpublishedSuccessfully: 'Course unpublished successfully',
      errorChangingCourseStatus: 'Error changing course status',
      pleaseSaveCourseFirst: 'Please save the course first',
      pleaseEnterCourseTitle: 'Please enter a course title',
      contentBlocksLabel: 'Course Blocks',
      courseInformation: 'Course Information',
      enterCourseTitle: 'Enter course title...',
      enterCourseDescription: 'Enter course description...',
      organizerName: 'Organization Name',
      enterOrganizerName: 'Enter organization name or your name...',
      medicalSpecialty: 'Medical Specialty',
      selectSpecialty: 'Select specialty...',
      courseFormat: 'Course Format',
      online: 'Online',
      inPerson: 'In-Person',
      hybrid: 'Hybrid',
      selfPaced: 'Self-Paced',
      locationAddress: 'Location/Address',
      enterVenueAddress: 'Enter venue address...',
      startDate: 'Start Date',
      endDate: 'End Date',
      coursePrice: 'Course Price (UAH)',
      cpdCredits: 'CPD Credits',
      maxParticipants: 'Max Participants',
      leaveEmptyForUnlimited: 'Leave empty for unlimited',
      courseImage: 'Course Image',
      uploadImage: 'Upload Image',
      certificateTemplate: 'Certificate Template',
      advanced: 'Advanced',
      previewCertificate: 'Preview Certificate',
      loadExampleTemplate: 'Load Example Template',
      clearTemplate: 'Clear Template',
      courseContent: 'Course Content',
      blocks: 'blocks',
      noContentBlocks: 'No content blocks yet',
      startBuildingCourse: 'Start building your course by adding blocks from the left panel.',
      contentBlocks: {
        text: 'Text',
        video: 'Video',
        pdf: 'PDF',
        image: 'Image',
        quiz: 'Quiz',
        assignment: 'Assignment',
        lesson: 'Lesson',
        test: 'Test',
        survey: 'Survey',
        videoEmbed: 'Video',
        textBlock: 'Text',
        pdfDocument: 'PDF',
        testBlock: 'Test',
        surveyBlock: 'Survey',
        lessonDesc: 'Create lesson to group blocks',
        videoEmbedDesc: 'Add YouTube or Vimeo videos',
        textBlockDesc: 'Add text content and formatting',
        pdfDocumentDesc: 'Upload and display PDF files',
        imageDesc: 'Upload and display images',
        testBlockDesc: 'Add a test to assess student knowledge',
        surveyBlockDesc: 'Add a survey to collect feedback',
        enterTitle: 'Enter lesson title',
        enterDescription: 'Enter lesson description',
        lessonTitle: 'Lesson Title',
        lessonDescription: 'Lesson Description',
      },
      addBlock: 'Add block',
      addToLesson: 'Add to lesson',
      dragContentBlocksIntoLesson: 'Drag other content blocks inside this lesson',
      dropBlockHere: 'Drop block here',
      noContentInLesson: 'No content in lesson',
      knowledgeTest: 'Knowledge Test',
      editTest: 'Edit Test',
      addTest: 'Add Test',
      courseSurvey: 'Course Survey',
      editSurvey: 'Edit Survey',
      addSurvey: 'Add Survey',
      noTestCreated: 'No test created yet',
      addKnowledgeTest: 'Add a knowledge test to assess student learning',
      noSurveyCreated: 'No survey created yet',
      addFeedbackSurvey: 'Add a feedback survey to gather student opinions',
      collapse: 'Collapse',
      expand: 'Expand',
      videoBlock: 'Video',
      videoEmbedBlock: 'Video Embed',
      textBlockLabel: 'Text Block',
      pdfDocumentBlock: 'PDF Document',
      documentBlock: 'Document',
      presentationBlock: 'Presentation',
      audioBlock: 'Audio',
      linkBlock: 'External Link',
      imageBlock: 'Image',
      lessonBlock: 'Lesson',
      blockTitle: 'Block Title',
      content: 'Content',
      enterBlockTitle: 'Enter block title...',
      enterTextHere: 'Enter your text here...',
      enterContentHere: 'Enter your content here... You can use Markdown formatting.',
      supportsMarkdown: 'Supports Markdown formatting. Use the toolbar buttons or type manually.',

      // Video Block Translations
      videoUrl: 'Video URL',
      pasteVideoUrl: 'Paste YouTube or Vimeo URL here...',
      supportsYoutubeVimeo: 'Supports YouTube and Vimeo URLs',
      validVideoUrl: '✓ Valid video URL',
      invalidVideoUrl: '✗ Invalid video URL',
      enterValidUrl: 'Please enter a valid YouTube or Vimeo URL',
      viewOriginalLink: 'View original link',
      videoPreviewHere: 'Video preview will appear here',

      // Navigation
      navigation: {
        mainSections: 'Main Sections',
        organizer: 'Organizer',
        courseDetails: 'Course Details',
        additionalOptions: 'Additional Options',
        statistics: 'Statistics',
        certificates: 'Certificates',
        tickets: 'Tickets',
        promocodes: 'Promocodes',
        toAccessAdditionalOptions: 'To access additional options',
        enterCourseTitle: 'Enter course title',
        enterOrganizerName: 'Enter organizer name',
        enterOrganizerEmail: 'Enter organizer email',
        fillInTitleAndOrganizer: 'Fill in the course title and organizer to access additional options.',
      },
      // Free registration
      freeRegistration: 'Free Registration',
      freeAccess: 'Free access',
      // Name of the ticket auto-created with a brand-new event
      defaultTicketName: 'Registration',

      // Image Block Translations
      imageLabel: 'Image',
      altText: 'Alt Text (for accessibility)',
      describeImage: 'Describe what the image shows...',
      altTextHelper: 'Alt text helps screen readers and appears when the image cannot load',
      clickToUpload: 'Click to upload an image',
      dragAndDrop: 'or drag and drop',
      pngJpgGif: 'PNG, JPG, GIF up to 5MB',
      uploadingImage: 'Uploading image...',
      removeImage: 'Remove image',
      failedToLoadImage: 'Failed to load image',

      // PDF Block Translations
      pdfDocument: 'PDF Document',
      clickToUploadPdf: 'Click to upload a PDF',
      pdfFilesUp10MB: 'PDF files up to 10MB',
      uploadingPdf: 'Uploading PDF...',
      pdfPreview: 'PDF Preview',
      clickDownloadToView: 'Click the download button to view the full document',
      viewPdf: 'View PDF',
      openPdf: 'Open PDF',
      removePdf: 'Remove PDF',
      pleaseSelectPdf: 'Please select a PDF file.',
      fileSizeLess10MB: 'File size should be less than 10MB.',
      pleaseDropPdf: 'Please drop a PDF file.',
      uploadError: 'Error uploading file. Please try again.',
      randomizeQuestionOrder: 'Randomize question order',
      availablePlaceholders: 'Available placeholders:',
      placeholderDescription: 'Leave empty to use the default certificate template. HTML, CSS, and inline styles are supported.',
      certificateTemplatePlaceholder: 'Enter custom HTML template for certificates (optional)...',
      certificateDescription: 'Configure the certificate template for course participants',
      pleaseAddCertificateTemplateFirst: 'Please add a certificate HTML template first',

      // Private course
      privateCourseLabel: 'Private Course',
      privateCourseDescription: 'Private courses are not listed publicly and require an invitation link',

      // Publishing validation
      pleaseSelectAtLeastOneSpecialty: 'Please select at least one target audience',
      pleaseAddAtLeastOneBlock: 'Please add at least one content block',
      pleaseEnterOrganizerPhone: 'Please enter organizer phone number',

      // Publishing requirements panel
      publishRequirements: 'Publishing Requirements',
      requirementCourseTitle: 'Enter course title',
      requirementOrganizer: 'Fill in organizer details',
      requirementSpecialties: 'Select target audience',
      requirementContent: 'Add course content',
    },

    // Footer
    footer: {
      about: 'CONFY',
      aboutText: 'CONFY – medical events and courses. Continuing professional development for healthcare professionals',
      quickLinks: 'Quick Links',
      courses: 'Courses',
      events: 'Events',
      contact: 'Contact',
      support: 'Support',
      reportBug: 'Report a bug',
      organizer: 'For organizers',
      legal: 'Legal Information',
      privacy: 'Privacy Policy',
      terms: 'Terms of Use',
      cookies: 'Cookie Policy',
      followUs: 'Follow Us',
      rights: 'All rights reserved',
      paymentsAccepted: 'We accept:',
    },

    // Terms page
    terms: {
      title: 'User Agreement',
    },

    // Privacy page
    privacy: {
      title: 'Privacy Policy',
    },

    // Session
    session: {
      expired: 'Your session has expired. Please refresh the page to continue.',
    },

    // Common
    common: {
      announcement: {
        text: 'We\'ve updated the platform! If you spot a bug, please let us know.',
        reportBug: 'Report a bug',
      },
      all: 'All',
      loading: 'Loading...',
      updating: 'Updating...',
      error: 'Error',
      success: 'Success',
      cancel: 'Cancel',
      save: 'Save',
      saving: 'Saving...',
      saved: 'Saved',
      processing: 'Processing…',
      autoSaving: 'Auto-saving...',
      publish: 'Publish',
      unsavedChanges: 'Unsaved changes',
      backToDashboard: 'Back to Dashboard',
      delete: 'Delete',
      remove: 'Remove',
      edit: 'Edit',
      view: 'View',
      upload: 'Upload',
      close: 'Close',
      next: 'Next',
      previous: 'Previous',
      submit: 'Submit',
      confirm: 'Confirm',
      required: 'Required field',
      optional: 'optional',
      yes: 'Yes',
      no: 'No',
      or: 'or',
      search: 'Search',
      filter: 'Filter',
      sort: 'Sort',
      select: 'Select',
      selectAll: 'Select All',
      note: 'Note',
      noResults: 'No results',
      tryAgain: 'Try again',
      retry: 'Retry',
      done: 'Done',
      share: 'Share',
      copied: 'Copied!',
      copyFailed: 'Failed to copy',
      linkCopied: 'Link copied!',
      comingSoon: 'Coming soon',
      learnMore: 'Learn more',
      start: 'Start',
      end: 'End',
      completed: 'Completed',
      progress: 'Progress',
      course: 'course',
      event: 'event',
      promocodes: 'Promo Codes',
      errorLoadingData: 'Error loading data',
      showing: 'Showing',
      of: 'of',
      events: 'events',
      showMore: 'Show more',
      loadMore: 'Load more',
      remaining: 'remaining',
      noMore: 'All loaded',
      backToHome: 'Back to Home',
      datePicker: {
        selectDate: 'Select date',
        clearDate: 'Clear date',
        openCalendar: 'Open calendar',
        time: 'Time',
        datePlaceholder: 'dd.mm.yyyy',
        dateTimePlaceholder: 'dd.mm.yyyy hh:mm',
        hourPlaceholder: 'HH',
        minutePlaceholder: 'MM',
        hourError: 'Hours must be between 0 and 23',
        minuteError: 'Minutes must be between 0 and 59',
        errorFormat: 'Check format. Examples:',
        exampleDate: '24.04.2025',
        exampleDateTime: '24.04.2025 14:30',
        errorMinDate: 'Date cannot be in the past',
        errorMaxDate: 'Date exceeds maximum allowed',
        warningTimeAfter: 'Time must be after',
      },
      availabilityWindow: {
        anchorAbsolute: 'Date/time',
        anchorEventStart: 'Event start',
        anchorEventEnd: 'Event end',
        resolvesTo: 'Resolves to:',
        eventDateNotSet: "Event date not set yet – this window won't take effect until you set it.",
      },
    },

    offlinePayment: {
      reserveTitle: 'Reserve your spot',
      reserveSubtitle: 'Payment is collected offline. Confirm your reservation and you will receive payment instructions.',
      amountDue: 'Amount due',
      confirmReservation: 'Confirm reservation',
      reserveSuccess: 'Seat reserved! Check your email for payment instructions.',
      awaitingBanner: 'Awaiting payment confirmation from the organizer. See the instructions in your email.',
      awaitingBadge: 'Awaiting payment',
      markAsPaid: 'Mark as paid',
      markAsPaidSuccess: 'Payment confirmed',
      markAsPaidFailed: 'Could not confirm payment',
      cancelReservation: 'Cancel reservation',
      cancelReservationSuccess: 'Reservation cancelled',
      cancelReservationFailed: 'Could not cancel reservation',
    },

    // Share functionality
    share: {
      title: 'Share',
      copyLink: 'Copy link',
      generatingLink: 'Generating link...',
      orShareVia: 'or share via',
      sendViaTelegram: 'Send via Telegram',
      sendViaViber: 'Send via Viber',
      sendViaEmail: 'Send via email',
      shareOnLinkedIn: 'Share on LinkedIn',
      shareOnFacebook: 'Share on Facebook',
      qrCode: 'QR code',
      downloadQR: 'QR code downloaded',
    },

    // In-app Notifications
    notifications: {
      title: 'Notifications',
      empty: 'No new notifications',
      markAllRead: 'Mark all read',
      markAsRead: 'Mark as read',
      viewDetails: 'View details',
      justNow: 'Just now',
      minutesAgo: '{count} min ago',
      hoursAgo: '{count} hr ago',
      daysAgo: '{count} days ago',
    },

    // Participants Statistics
    participants: {
      title: 'Participant Statistics',
      subtitle: 'Demographics and analytics',
      total: 'Total Participants',
      certificates: 'Certificates Issued',
      specialties: 'Specialties',
      regions: 'Regions',
      specialtyDistribution: 'Distribution by Specialty',
      regionDistribution: 'Distribution by Region',
      ageDistribution: 'Age Distribution',
      ticketDistribution: 'Distribution by Ticket',
      topCities: 'Top Cities',
      completionStatus: 'Completion Status',
      registrationTimeline: 'Registration Timeline',
      noData: 'No data to display',
      noParticipantsYet: 'No participants yet',
      noParticipantsMessage: 'Statistics will appear after the first participants register',
      status: {
        registered: 'Registered',
        started: 'Started',
        testsPassed: 'Tests Passed',
        testsFailed: 'Tests Failed',
        surveysCompleted: 'Surveys Completed',
        certificateIssued: 'Certificate Issued',
      },
    },

    // Analytics
    analytics: {
      title: 'Analytics',
      subtitle: 'Revenue, attendance and audience',
      tabs: { money: 'Revenue & Demand', operations: 'Attendance', demographics: 'Audience', livestream: 'Live Stream' },
      noData: 'No data to display',
      money: {
        free: 'Free event – no revenue',
        totalRevenue: 'Total revenue', paidOrders: 'Paid orders', avgOrder: 'Average order',
        salesTimeline: 'Sales over time', revenueByTicket: 'Revenue by ticket',
        refunded: 'Refunded', netRevenue: 'Net revenue', grossRevenue: 'Gross revenue',
      },
      ops: {
        registered: 'Registered', attended: 'Attended', noShow: 'No-show',
        attendanceRate: 'Attendance', certificates: 'Received certificate', passRate: 'Test pass rate',
        engaged: 'Took part', testsPassed: 'Passed test', pending: 'pending', completed: 'Completed',
        funnel: 'Completion funnel', timing: 'When tests are passed', avgProgress: 'Average progress',
        timingHourly: 'Tests passed by hour', hourAxis: 'h',
        timingHourlyHint: 'Hours after the event start (0-1 – first hour)',
        timingBuckets: { before: 'Before start', first_6h: 'First 6h', '6_24h': '6–24h', '1_7d': '1–7 days', later: 'Later', unknown: 'Unknown' },
        funnelStages: { registered: 'Registered', started: 'Took part', tests_passed: 'Passed test', certificate_issued: 'Received certificate' },
      },
      demo: {
        total: 'Total participants', specialty: 'Specialties', region: 'Regions',
        city: 'Top cities', age: 'Age', ticket: 'Tickets',
        specialtiesCount: 'Specialties', regionsCount: 'Regions', topCity: 'Top city',
        topRegions: 'Top regions', mapLess: 'fewer', mapMore: 'more', others: 'Others',
        registrationTimeline: 'Registrations over time',
      },
      share: {
        button: 'Share report',
        title: 'Share report',
        subtitle: 'Public partner report link (audience & attendance)',
        create: 'Create link', label: 'Label (optional)', labelPlaceholder: 'e.g. Sponsor X',
        expiry: 'Expires (optional)', copy: 'Copy', copied: 'Link copied', revoke: 'Revoke',
        active: 'Active', expired: 'Expired', revoked: 'Revoked', noLinks: 'No links yet',
        created: 'Created', downloadPdf: 'Download PDF', downloadReport: 'Download report', viewOnline: 'View online', reportFor: 'Event report',
        invalid: 'This link is invalid or revoked', poweredBy: 'Made on the CONFY platform',
        error: 'Error',
      },
      adjusted: {
        button: 'Adjusted report', title: 'Adjusted report',
        subtitle: 'Superadmins only: a public link with target numbers. Real data is not changed.',
        metric: 'Metric', real: 'Actual', target: 'Target', factor: 'Factor', apply: 'Apply',
        registered: 'Registered', engaged: 'Engaged', testsPassed: 'Passed the test', certificates: 'Received a certificate',
        belowReal: 'The actual value will be shown', preview: 'Preview', previewError: 'Could not build the preview',
        create: 'Create adjusted link', created: 'Adjusted link created and copied', badge: 'Adjusted',
        links: 'Adjusted links', noLinks: 'No adjusted links yet', targets: 'Targets',
        engagedAboveRegistered: 'Engaged cannot exceed registered',
      },
      livestream: {
        soon: 'Live stream stats – coming soon', soonDesc: 'Viewer counts from YouTube/Vimeo during the event will appear here.',
        title: 'Live Stream', badge: 'Stream',
        views: 'Total stream views', watch: 'Average watch time', concurrent: 'Average concurrent viewers',
        watchRecording: 'Watch recording',
        empty: 'No stream stats yet', emptyDesc: 'Add views, watch time and a recording link manually.',
        add: 'Add stream', edit: 'Edit', save: 'Save', cancel: 'Cancel', remove: 'Remove',
        saved: 'Stats saved', saveError: 'Failed to save stats', invalidWatch: 'Invalid time format (mm:ss)',
        invalidUrl: 'Invalid link – use http:// or https://',
        streamN: 'Stream', streamLabel: 'Label (optional)', labelPlaceholder: 'e.g. Day 1 – Main stage',
        recordingUrl: 'Recording link', watchHint: 'Format mm:ss, e.g. 6:12',
        recordingSelect: 'Choose an event recording', recordingOther: 'Other link',
        recordingMadePublic: 'The recording is now available via a public link', recordingsError: 'Could not load the event recordings',
      },
    },

    // Restricted Access Message
    restrictedAccess: {
      title: 'Access Restricted',
      message: 'Your ticket does not include access to {{featureName}}.',
      contactOrganizer: 'Please contact the event organizer if you believe this is an error.',
    },


    // Enhanced Dashboard
    enhancedDashboard: {
      organizerDashboard: 'Organizer Dashboard',
      myDashboard: 'My Dashboard',
      welcomeBack: 'Welcome back',
      backToHomepage: 'Back to Homepage',
      addCourse: 'Add Course',
      addEvent: 'Add Event',
      emailNewsletters: 'Email newsletters',
      course: 'Course',
      event: 'Event',
      myCourses: 'My Courses',
      myEvents: 'My Events',
      totalStudents: 'Total Participants',
      totalCourses: 'Total Courses',
      certificates: 'Certificates',
      inProgress: 'In Progress',
      students: 'Participants',
      myCreatedCourses: 'My Created Courses',
      myCreatedEvents: 'My Created Events',
      noEventsCreated: 'No events created yet',
      createFirstEvent: 'Start creating your first event to share it!',
      createYourFirstEvent: 'Create Your First Event',
      noPublishedEvents: 'No published events',
      noDraftEvents: 'No draft events',
      noArchivedEvents: 'No archived events',
      noPastEvents: 'No past events yet',
      noPastEventsHelp: 'Try selecting a different filter to see events.',
      noEventsInFilter: 'No events match this filter',
      tryDifferentFilterEvent: 'Try selecting a different filter to see events.',
      noEventsYet: 'No events yet',
      notEnrolledInEventsYet: 'You have not enrolled in any events yet. Start exploring our event catalog!',
      editEvent: 'Edit Event',
      viewEvent: 'View Event',
      noCoursesCreated: 'No courses created yet',
      createFirstCourse: 'Start creating your first course to share your knowledge!',
      createYourFirstCourse: 'Create Your First Course',
      noPublishedCourses: 'No published courses',
      noDraftCourses: 'No draft courses',
      noArchivedCourses: 'No archived courses',
      noPastCourses: 'No past courses yet',
      noPastCoursesHelp: 'Try selecting a different filter to see courses.',
      noCoursesInFilter: 'No courses match this filter',
      tryDifferentFilterCourse: 'Try selecting a different filter to see courses.',
      created: 'Created',
      starts: 'Starts',
      unpublish: 'Unpublish',
      publish: 'Publish',
      editCourse: 'Edit Course',
      viewCourse: 'View Course',
      viewAnalytics: 'View Analytics',
      analyticsComingSoon: 'Analytics coming soon!',
      deleteConfirm: 'Are you sure you want to delete',
      unknownError: 'Unknown error',
      unexpectedError: 'An unexpected error occurred. Please try again.',
      enrolledCourses: 'Enrolled Courses',
      noCoursesYet: 'No courses yet',
      notEnrolledYet: 'You have not enrolled in any courses yet. Start exploring our course catalog!',
      materials: 'Materials',
      required: 'required',
      tests: 'Tests',
      surveys: 'Surveys',
      tickets: 'Tickets',
      purchased: 'Purchased',
      free: 'Free',
      issued: 'issued',
      continueLearning: 'Continue Learning',
      viewCertificate: 'Certificate',
      generateCertificate: 'Generate Certificate',
      loadingDashboard: 'Loading your dashboard...',
      noEnrolledCourses: 'You are not enrolled in any courses yet',
      browseCoursesToEnroll: 'Browse our courses and start learning',
      browseCourses: 'Browse Courses',
      noEnrolledEvents: 'You are not enrolled in any events yet',
      browseEventsToEnroll: 'Browse our events and register',
      browseEvents: 'Browse Events',
      featured: {
        title: 'Latest Events & Courses',
        subtitle: 'Browse available events and register',
      },
      pleaseSignIn: 'Please sign in to view your dashboard.',
      createNewCourse: 'Create New Course',
      chooseCreateMethod: 'Choose how you want to create your course content. You can build it using our drag-and-drop editor with multiple content types.',
      startWithCourseBuilder: 'Start with Course Builder',
      useDragAndDrop: 'Use our drag-and-drop editor to create rich course content',
      useTemplate: 'Use Template',
      startWithPrebuilt: 'Start with a pre-built course template',
      importContent: 'Import Content',
      importExisting: 'Import existing course materials',
      templateComingSoon: 'Template option coming soon!',
      importComingSoon: 'Import option coming soon!',
      completed: 'Completed',
      progress: 'Progress',
      studentsEnrolled: 'Participants Enrolled',
      viewEnrolledStudents: 'View Enrolled Participants',
      enrolledStudentsList: 'Enrolled Participants List',
      enrolledOn: 'Enrolled on',
      noStudentsEnrolled: 'No Participants Enrolled',
      noStudentsEnrolledDesc: 'No participants have enrolled in this course yet.',
      studentName: 'Participant Name',
      studentEmail: 'Participant Email',
      enrollmentDate: 'Enrollment Date',
      paymentStatus: 'Payment Status',
      courseProgress: 'Course Progress',
      creator: 'Creator',
      learner: 'Learner',
      more: 'More',
      noPermission: 'You do not have permission to perform this action',
    },

    // Mini-CRM / Student Management
    miniCrm: {
      title: 'Student Management',
      studentDirectory: 'Student Directory',
      backToEvent: 'Back to Event',
      filters: 'Filters',
      showFilters: 'Show Filters',
      hideFilters: 'Hide Filters',
      clearAllFilters: 'Clear Filters',
      search: 'Search',
      searchPlaceholder: 'Search by name, email, or phone...',

      // Filters
      includeFilters: 'Include Filters',
      excludeFilters: 'Exclude Filters',
      ticketTypes: 'Ticket Types',
      selectTicketTypes: 'Select Ticket Types',
      noTicketTypes: 'No ticket types',
      promoCodes: 'Promo Codes',
      promoCode: 'Promo Code',
      noPromoCode: 'No promo code',
      paidAmount: 'Paid',
      paidAmountMin: 'Min',
      paidAmountMax: 'Max',
      paidAmountHelp: 'Amount actually paid by the participant, in the event currency (0 includes free / 100%-off rows).',
      specialties: 'Specialties',
      selectSpecialties: 'Select Specialties',
      noSpecialties: 'No specialties',
      clearAllSpecialties: 'Clear all',
      clearSpecialtiesConfirmTitle: 'Clear all specialties?',
      clearSpecialtiesConfirmMessage: 'Are you sure you want to clear all selected specialties? This action cannot be undone.',
      specialtyScopePrimary: 'Primary',
      specialtyScopeAny: 'Any',
      secondarySpecialties: 'Additional specialties',
      attendanceStatus: 'Attendance Status',
      attended: 'Attended',
      notAttended: 'Did Not Attend',
      assessmentStatus: 'Assessment Status',
      completedRequiredAssessments: 'Completed Required Tests and Surveys',
      notCompletedRequiredAssessments: 'Not Completed Required Tests and Surveys',
      testStatus: 'Test Status',
      testPassed: 'Test Passed',
      testNotPassed: 'Test Not Passed',
      completionStatus: 'Completion Status',
      completionStatuses: {
        registered: 'Registered',
        started: 'Started',
        tests_passed: 'Tests Passed',
        tests_failed: 'Tests Failed',
        surveys_completed: 'Surveys Completed',
        certificate_issued: 'Certificate Issued',
      },
      filterMode: 'Mode',
      matchAny: 'Any',
      matchAll: 'All',
      milestoneYes: 'Yes',
      milestoneNo: 'No',

      // Actions
      selectAll: 'Select All',
      deselectAll: 'Deselect All',
      sendEmail: 'Send Email',
      selectRecipientsFirst: 'Please select recipients before sending an email',
      sendSMS: 'Send SMS',
      exportList: 'Export List',

      // Table
      name: 'Full Name',
      email: 'Email',
      emailAndPhone: 'Email & Phone Number',
      phone: 'Phone',
      ticketType: 'Ticket Type',
      specialty: 'Specialty',
      registered: 'Registered',
      status: 'Status',
      noData: 'No data',

      // Stats
      showingStudents: 'Showing',
      ofStudents: 'of',
      students: 'participants',
      selected: 'selected',
      participantsOnPageSelected: 'participants on this page selected.',
      selectAllParticipants: 'Select all ${count} participants',
      allParticipantsSelected: 'All ${count} participants selected.',
      clearSelection: 'Clear selection',
      includeFutureRegistrants: 'Include future registrants',
      noStudentsEnrolled: 'No participants enrolled yet',
      noStudentsMatch: 'No participants match your search',

      // Email Modal
      emailCompose: 'Compose Email',
      emailTo: 'To',
      emailSubject: 'Subject',
      emailSubjectPlaceholder: 'Enter email subject...',
      emailBody: 'Message',
      emailBodyPlaceholder: 'Enter email message...',
      insertVariable: 'Insert Variable',
      insertVariables: 'Insert Variables',
      preview: 'Preview',
      noSubject: '(No subject)',
      noMessage: '(No message)',
      send: 'Send',
      sending: 'Sending...',
      cancel: 'Cancel',
      emailSentSuccess: 'Email sent successfully',
      emailSentTo: 'Email sent to',
      recipients: 'recipients',

      // SMS Modal
      smsCompose: 'Compose SMS',
      smsTo: 'To',
      smsMessage: 'Message',
      smsMessagePlaceholder: 'Enter SMS message (max 160 characters)...',
      charLimit: 'Character limit',
      charsRemaining: '{count} characters remaining',
      charsOver: 'Message exceeds {count} characters',
      smsSentSuccess: 'SMS sent successfully',
      smsSentTo: 'SMS sent to',
      fillAllFields: 'Please fill all fields',

      // Variables
      variables: 'Variables',
      variablesHelp: 'Use {{variable_name}} for personalization',
      availableVariables: 'Available variables',
      firstName: 'first_name',
      lastName: 'last_name',
      emailVar: 'email',
      phoneVar: 'phone',
      eventTitle: 'event_title',

      // Variable Labels
      varLabels: {
        first_name: 'First Name',
        last_name: 'Last Name',
        email: 'Email',
        phone: 'Phone',
        event_title: 'Event Title',
      },

      // Formatting
      bold: 'Bold',
      italic: 'Italic',
      underline: 'Underline',
      heading1: 'Heading 1',
      heading2: 'Heading 2',
      bulletList: 'Bullet List',
      numberedList: 'Numbered List',

      // Errors
      noRecipients: 'No recipients',
      selectRecipients: 'Please select recipients',
      sendFailed: 'Failed to send',
      loadFailed: 'Failed to load data',
      failedToSendEmails: 'Failed to send ${failCount} emails',
      failedToSendSms: 'Failed to send ${failCount} SMS messages',
      failedToScheduleEmails: 'Failed to schedule ${failCount} emails',

      // Unified CRM
      unifiedCRM: 'Unified CRM',
      studentManagement: 'Participant Management',
      allStudents: 'All participants across your events and courses',
      contentType: 'Content Type',
      eventsOnly: 'Events Only',
      coursesOnly: 'Courses Only',
      filterByContent: 'Filter by Event/Course',
      searchContent: 'Search courses/events...',
      noMatchingContent: 'No matching courses/events found',
      eventCourse: 'Event/Course',
      event: 'Event',
      course: 'Course',
      clickToSeeResponses: 'Click to see additional field responses',
      tip: '💡 Tip',
      expandRowHint: 'Click on any participant row to see their responses to additional registration questions.',
      additionalQuestionOne: 'additional question',
      additionalQuestionFew: 'additional questions',
      additionalQuestionMany: 'additional questions',
      ticketQuestionsInfo: 'Registration question answers',
      ticketQuestionsFilterTitle: 'Registration questions',
      selectContentFirstForQuestions: 'Select an event or course to filter by registration questions',
      noTicketQuestionResponses: 'No participants have answered ticket registration questions yet',
      ticketQuestionDownload: 'Download',
      ticketQuestionDownloadFailed: 'Failed to get document link',
      ticketQuestionAnswered: 'Answered',
      ticketQuestionNotAnswered: 'Not answered',
      ticketQuestionFileUploaded: 'Document uploaded',
      exportBlockedByQuestionFilter: 'Export is unavailable while a registration-question filter is active. Clear that filter to export participants.',
      selectAllBlockedByQuestionFilter: 'Selecting all participants is unavailable while a registration-question filter is active',

      // Export
      export: 'Export',
      exporting: 'Exporting...',
      exportToExcel: 'Export to Excel',
      exportSuccess: 'Export completed successfully',
      exportFailed: 'Failed to export participants',
      noStudentsToExport: 'No participants to export',

      // Student Management Actions
      noTicket: 'No Ticket',
      ticketUpdated: 'Ticket updated successfully',
      ticketUpdateFailed: 'Failed to update ticket',
      deleteStudent: 'Delete Student',
      studentDeleted: 'Student deleted successfully',
      deleteFailed: 'Failed to delete student',
      confirmDelete: 'Confirm Delete',
      confirmDeleteMessage: 'Are you sure you want to delete',
      fromEvent: 'from',
      deleteWarning: 'This action cannot be undone.',
      deleting: 'Deleting...',

      // Organizer Actions
      actions: 'Actions',
      changeTicket: 'Change Ticket',
      updatingTicket: 'Updating...',
      selectTicket: '– Select ticket –',
      grantTestAndCertificate: 'Grant Test & Certificate',
      deleteCertificate: 'Delete Certificate',
      clearTestAttempts: 'Clear Test Attempts',
      confirmGrantTestCert: 'Grant test (100%) and create certificate for',
      confirmDeleteCert: 'Delete certificate for',
      confirmClearAttempts: 'Clear all test attempts for',
      grantingTestCert: 'Granting...',
      deletingCertificate: 'Deleting...',
      clearingAttempts: 'Clearing...',
      testCertGranted: 'Test granted, certificate created',
      certificateDeleted: 'Certificate deleted',
      testAttemptsCleared: 'Test attempts cleared',
      noTestConfigured: 'No test configured for this event',
      testAlreadyPassed: 'Successful test attempt already exists – certificate can be created from the UI',
      certificateAlreadyExists: 'Certificate already exists',
      noCertificateFound: 'No certificate found',
      noTestAttempts: 'No test attempts found',
      enrollmentRefunded: 'This registration was refunded, so this action is not available.',
      bulkActions: 'Bulk Actions',
      bulkConfirm: 'for ${count} participants',
      bulkResult: 'Completed: ${succeeded} of ${total}',
      bulkPartialFail: 'Errors: ${failed}',
      registerParticipant: 'Register Participant',
      enterParticipantEmail: 'Enter participant email...',
      userNotFound: 'No user found with this email',
      alreadyEnrolled: 'This participant is already enrolled',
      invalidTicket: 'Invalid ticket for this event',
      ticketRequired: 'A ticket must be selected for this event',
      participantRegistered: 'Participant registered',
      registering: 'Registering...',
      register: 'Register',

      // Field Settings
      fieldSettings: 'CRM Field Settings',
      fieldSettingsDescription: 'Choose which fields to display in CRM and export',
      fieldsSelected: 'fields selected',
      resetToDefaults: 'Reset to Defaults',
      requiredField: 'Required field (always visible)',
      additionalFieldsNote: 'All additional registration fields are always visible and filterable.',
      settings: 'Settings',

      // Templates
      templates: 'Templates',
      emailTemplates: 'Email Templates',
      smsTemplates: 'SMS Templates',
      saveTemplate: 'Save as Template',
      loadTemplate: 'Load Template',
      newTemplate: 'New Template',
      templateName: 'Template Name',
      templateNamePlaceholder: 'Enter template name...',
      saveAsDefault: 'Save as Default',
      deleteTemplate: 'Delete Template',
    },

    // Email Templates & Scheduling
    email: {
      subject: 'Subject',

      templates: {
        browse: 'Templates',
        browser: 'Email Templates',
        browserDescription: 'Browse and use saved email templates',
        saveAs: 'Save as Template',
        saving: 'Saving...',
        saved: 'Template saved successfully',
        saveFailed: 'Failed to save template',
        fillFields: 'Please fill in subject and body before saving',
        noEvent: 'Cannot save template without an event',
        templateTitle: 'Template Title',
        enterTitle: 'Enter a title for this template',
        loadFailed: 'Failed to load templates',
        updateFailed: 'Failed to update template',
        confirmDelete: 'Delete Template?',
        confirmDeleteMessage: 'Are you sure you want to delete',
        cannotBeUndone: 'This action cannot be undone.',
        update: 'Update Template',
        updated: 'Template updated successfully',
        edit: 'Edit template',
        delete: 'Delete template',
        deleted: 'Template deleted successfully',
        deleteFailed: 'Failed to delete template',
        search: 'Search templates...',
        favoritesOnly: 'Favorites Only',
        noTemplates: 'No templates saved yet',
        noMatches: 'No templates match your search',
        addToFavorites: 'Add to favorites',
        removeFromFavorites: 'Remove from favorites',
        addedToFavorites: 'Added to favorites',
        removedFromFavorites: 'Removed from favorites',
        global: 'Global',
      },

      scheduling: {
        schedule: 'Schedule',
        title: 'Schedule Email',
        date: 'Date',
        time: 'Time',
        info: 'The email will be sent automatically at the scheduled time.',
        selectDateTime: 'Please select both date and time for scheduling',
        mustBeFuture: 'Scheduled time must be in the future',
        scheduleButton: 'Schedule Email',
        scheduled: 'Email scheduled.',
        viewScheduled: 'View Scheduled',
        scheduledCampaigns: 'Scheduled Campaigns',
        scheduledCampaignsDescription: 'View and manage your scheduled email campaigns',
        noCampaigns: 'No scheduled campaigns',
        noScheduledEmails: 'You don\'t have any scheduled email campaigns yet',
        scheduledFor: 'Scheduled for',
        recipients: 'recipients',
        cancelCampaign: 'Cancel Campaign',
        confirmCancel: 'Cancel Campaign?',
        confirmCancelMessage: 'Are you sure you want to cancel this scheduled campaign?',
        campaignCanceled: 'Campaign canceled successfully',
        cancelFailed: 'Failed to cancel campaign',
        loadingCampaigns: 'Loading campaigns...',
        statusScheduled: 'Scheduled',
        statusSending: 'Sending',
        statusCompleted: 'Sent',
        statusFailed: 'Failed',
        sent: 'sent',
        failed: 'failed',
        yourTimezone: 'Your timezone',
        edit: 'Edit',
        duplicate: 'Duplicate',
        saveChanges: 'Save Changes',
      },

      confirm: {
        title: 'Confirmation',
        sendMessage: 'Send email to {{count}} recipients now?',
        scheduleMessage: 'Schedule email for {{count}} recipients on {{date}}?',
        dynamicNote: 'All participants registered at the time of sending will receive the email, including new registrations.',
        confirm: 'Confirm',
        cancel: 'Cancel',
      },

      test: {
        button: 'Send Test to Me',
        sending: 'Sending...',
        sent: 'Test email sent to your address',
        failed: 'Failed to send test email',
        fillFields: 'Please fill in subject and body before sending test',
      },

      sender: {
        name: 'Sender Name',
        email: 'Sender Email',
        namePlaceholder: 'Enter sender name',
      },

      history: {
        title: 'Email History',
        description: 'View all sent email campaigns and their statistics',
        backToHistory: 'Back to History',
        noCampaigns: 'No campaigns sent yet',
        noCampaignsDescription: 'Your sent email campaigns will appear here',
        campaign: 'Campaign',
        campaigns: 'Campaigns',
        allEvents: 'All Events',
        filterByEvent: 'Filter by Event',
        filterByStatus: 'Filter by Status',
        allStatuses: 'All Statuses',
        loading: 'Loading...',
        loadMore: 'Load More',
        viewDetails: 'View Details',
        sentTo: 'Sent to',
        recipients: 'recipients',
        sentAt: 'Sent at',
        scheduledFor: 'Scheduled for',
        statistics: 'Statistics',
        deliveryRate: 'Delivery Rate',
        openRate: 'Open Rate',
        clickRate: 'Click Rate',
        bounceRate: 'Bounce Rate',
        clickThroughRate: 'CTR',
        sent: 'Sent',
        delivered: 'Delivered',
        opened: 'Opened',
        clicked: 'Clicked',
        bounced: 'Bounced',
        failed: 'Failed',
        unsubscribed: 'Unsubscribed',
        status: {
          draft: 'Draft',
          scheduled: 'Scheduled',
          sending: 'Sending',
          completed: 'Sent',
          failed: 'Failed',
        },
        recipientDetails: 'Recipient Details',
        emailAddress: 'Email Address',
        recipientName: 'Name',
        recipientStatus: 'Status',
        openedAt: 'Opened at',
        clickedAt: 'Clicked at',
        deliveredAt: 'Delivered at',
        bouncedAt: 'Bounced at',
        errorMessage: 'Error',
        noOpens: 'Not opened',
        noClicks: 'No clicks',
        opens: 'opens',
        clicks: 'clicks',
        view: 'View',
        edit: 'Edit',
        duplicate: 'Duplicate',
        cancel: 'Cancel',
        confirmCancel: 'Cancel Campaign?',
        confirmCancelMessage: 'Are you sure you want to cancel this campaign?',
        campaignCanceled: 'Campaign canceled successfully',
        cancelFailed: 'Failed to cancel campaign',
        emailBody: 'Email Body',
        createdAt: 'Created',
      },
    },

    // CRM Refund System
    crm: {
      refund: {
        title: 'Issue Refund',
        amount: 'Refund Amount',
        reason: 'Reason',
        reasonPlaceholder: 'Enter refund reason (optional)',
        originalPayment: 'Original Payment',
        previousRefunds: 'Previous Refunds',
        maxRefund: 'Available to Refund',
        maxNote: 'Maximum',
        status: 'Refund Status',
        warning: 'This action cannot be undone. The refund is processed through the organizer\'s payment gateway and the funds are returned to the participant\'s payment method. Processing can take several business days.',
        issueRefund: 'Issue Refund',
        processing: 'Processing...',
        success: 'Refund processed successfully',
        error: 'Refund failed',
        invalidAmount: 'Invalid refund amount',
        exceedsMax: 'Refund amount cannot exceed maximum',
        errors: {
          INVALID_REFUND_PRECISION: 'The amount has too many decimal places for this currency.',
          ENROLLMENT_NOT_FOUND: 'Enrollment not found',
          NOT_AUTHORIZED: 'You do not have permission to issue refunds for this event',
          ENROLLMENT_NOT_PAID: 'This enrollment has no online payment',
          REFUND_NOT_SUPPORTED_OFFLINE: 'This payment was taken outside the platform (cash or bank transfer). Refund it directly and record it in your own books.',
          REFUND_ALREADY_IN_PROGRESS: 'A refund for this order is already being processed',
          INVALID_REFUND_AMOUNT: 'Invalid refund amount',
          CREDENTIALS_NOT_CONFIGURED: 'The payment gateway is not configured',
          REFUND_GATEWAY_UNAVAILABLE: 'The payment gateway is unavailable right now. Please try again later.',
          REFUND_DECLINED: 'The payment gateway declined the refund',
          REFUND_STATUS_UNKNOWN: 'The payment gateway gave an answer we could not interpret. Check the status in your payment provider dashboard before retrying.',
          REFUND_SETTLED_LEDGER_NOT_UPDATED: 'The refund was issued but the refund record was not updated. Please contact support@confy.cc',
          REFUND_SETTLED_ENROLLMENT_NOT_UPDATED: 'The refund was issued but the enrollment was not updated. Please contact support@confy.cc',
          RATE_LIMITED: 'Too many requests. Wait a minute and try again.',
          ORDER_NOT_ON_ENROLLMENT: 'The selected order does not belong to this enrollment',
        },
        processingNotice: 'The refund has been accepted by the payment gateway and is still settling. Check your payment provider dashboard for the final status.',
        partial: 'Partial refund',
        order: 'Order',
      },
      ticketChange: {
        errors: {
          UPGRADE_IN_FLIGHT: 'The participant is currently paying for a ticket upgrade. Try again later.',
          TICKET_CHANGED: 'The ticket just changed. Refresh and try again.',
          DOWNGRADE_NOT_SELF_SERVICE: 'Only the organizer can change your ticket to a cheaper one. Please contact the event organizer.',
        },
      },
      pendingRefunds: {
        title: 'Refunds awaiting approval',
        subtitle: 'Nothing is sent to the payment gateway until you approve each refund.',
        columns: {
          participant: 'Participant',
          ticket: 'Ticket',
          amount: 'Amount',
          reason: 'Reason',
          queuedAt: 'Queued since',
        },
        total: 'Total',
        approve: 'Approve',
        approveAll: 'Approve all',
        approveAllConfirm: 'Approve all refunds totaling {{total}}? Once approved, the funds will be sent to the payment gateway.',
        confirm: {
          title: 'Approve all refunds',
          cancel: 'Cancel',
          confirm: 'Yes, approve all',
        },
        loadError: 'Could not load the refunds awaiting approval. There may be refunds here that need your approval.',
        retry: 'Retry',
        toast: {
          approved: 'Approved {{count}} refund(s)',
          someRefused: 'Some refunds could not be approved',
          error: 'Could not send the refund approval request. Please try again.',
        },
        errors: {
          REFUND_EXCEEDS_PAID: 'The refund amount exceeds what can still be refunded on this order. Refresh the page and check the amount.',
          ALREADY_APPROVED: 'This refund has already been approved.',
          NOT_ON_THIS_EVENT: 'This refund belongs to a different event.',
          generic: 'Could not approve this refund. Please try again.',
        },
      },
      paymentTimeline: {
        title: 'Payment history',
        empty: 'This enrollment is free - there is no payment history.',
        loadError: 'Could not load the payment history.',
        retry: 'Retry',
        kinds: {
          payment_created: 'Payment created',
          payment_approved: 'Payment approved',
          upgrade_approved: 'Ticket upgrade approved',
          refund_queued: 'Refund queued',
          refund_approved: 'Refund approved',
          refund_sent: 'Refund request sent to the payment gateway',
          refund_settled: 'Refund settled',
          refund_failed: 'Refund failed',
          audit: 'Administrative action',
        },
        auditActions: {
          refund_admin_override: 'Refund released by an administrator, bypassing the organizer',
          payment_amount_mismatch: 'The payment gateway reported a different amount than expected',
          payment_fulfilment_blocked: 'Payment received, but the enrollment was blocked for review',
          generic: 'Unknown administrative action',
        },
      },
      student: 'Student',
      unknown: 'Unknown',
    },

    // Course Builder
    courseBuilderPage: {
      courseBuilder: 'Course Builder',
      editCourse: 'Edit Course',
      createOrganizeContent: 'Create and organize your course content',
      preview: 'Preview',
      saveCourse: 'Save Course',
      saving: 'Saving...',
      contentBlocksLabel: 'Course Blocks',
      courseInformation: 'Course Information',
      courseTitle: 'Course Title',
      enterCourseTitle: 'Enter course title...',
      courseDescription: 'Course Description',
      enterCourseDescription: 'Enter course description...',
      medicalSpecialty: 'Medical Specialty',
      selectSpecialty: 'Select specialty...',
      courseFormat: 'Course Format',
      online: 'Online',
      inPerson: 'In-Person',
      hybrid: 'Hybrid',
      selfPaced: 'Self-Paced',
      locationAddress: 'Location/Address',
      enterVenueAddress: 'Enter venue address...',
      startDate: 'Start Date',
      endDate: 'End Date',
      coursePriceUAH: 'Course Price (UAH)',
      cpdCredits: 'CPD Credits',
      maxParticipants: 'Max Participants',
      leaveEmptyUnlimited: 'Leave empty for unlimited',
      courseImage: 'Course Image',
      uploadImage: 'Upload Image',
      courseContent: 'Course Content',
      blocks: 'blocks',
      noContentBlocks: 'No content blocks yet',
      startBuildingCourse: 'Start building your course by adding content blocks from the left panel.',
      knowledgeTest: 'Knowledge Test',
      editTest: 'Edit Test',
      addTest: 'Add Test',
      optional: 'Optional',
      questions: 'Questions',
      passing: 'Passing',
      maxAttempts: 'Max Attempts',
      timeLimit: 'Time Limit',
      none: 'None',
      noTestCreated: 'No test created yet',
      addKnowledgeTest: 'Add a knowledge test to assess student learning',
      courseSurvey: 'Course Survey',
      editSurvey: 'Edit Survey',
      addSurvey: 'Add Survey',
      anonymous: 'Anonymous',
      availableAfterCompletion: 'Available after completion',
      availableAnytime: 'Available anytime',
      noSurveyCreated: 'No survey created yet',
      addFeedbackSurvey: 'Add a feedback survey to gather student opinions',
      failedToUploadImage: 'Failed to upload image',
      checkingAccessPermissions: 'Checking access permissions...',
      accessDenied: 'Access denied. Only organizers can create courses.',
      failedToLoadCourse: 'Failed to load course data',
      pleaseEnterCourseTitle: 'Please enter a course title',
      courseUpdatedSuccessfully: 'Course updated successfully!',
      courseSavedSuccessfully: 'Course saved successfully!',
      errorSavingCourse: 'Error saving course',
      testSavedSuccessfully: 'Test saved successfully!',
      failedToSaveTest: 'Failed to save test',
      surveysSavedSuccessfully: 'Survey saved successfully!',
      failedToSaveSurvey: 'Failed to save survey. Please try again.',
      noCourseId: 'No course ID available. Please save the course first.',
      loadExampleTemplate: 'Load Example Template',
      clearTemplate: 'Clear Template',
      availablePlaceholders: 'Available placeholders:',
      placeholderDescription: 'Leave empty to use the default certificate template. HTML, CSS, and inline styles are supported.',
      certificateTemplatePlaceholder: 'Enter custom HTML template for certificates (optional)...',

      randomizeQuestionOrder: 'Randomize question order',
      pleaseAddCertificateTemplateFirst: 'Please add a certificate template first',
      materialBlocksSaveWarning: 'Warning: Some material blocks may not have been saved',
    },

    // Course Details
    courseDetails: {
      inYourTime: 'Your time',
      backToCourses: 'Back to Courses',
      backToEvents: 'Back to Events',
      startAnytime: 'Start Anytime',
      limitedParticipants: 'Limited to',
      participants: 'participants',
      enrollNow: 'Enroll Now',
      processing: 'Processing...',
      goToCourse: 'Go to Course',
      goToEvent: 'Go to Event',
      courseContent: 'Course Content',
      eventContent: 'Event Content',
      eventDetails: 'Event Details',
      eventDescription: 'Event Description',
      available: 'Available',
      contentAvailableAfterEnrollment: 'Course content will be available after enrollment.',
      eventContentAvailableAfterEnrollment: 'Event content will be available after enrollment.',
      courseDetails: 'Course Details',
      courseDescription: 'Course Description',
      format: 'Format',
      duration: 'Duration',
      dates: 'Dates',
      venue: 'Venue',
      price: 'Price',
      start: 'Start',
      end: 'End',
      readyToStart: 'Ready to start?',
      youAreEnrolled: "You're enrolled! Access your course content from the dashboard.",
      youAreRegisteredEvent: "You're registered for this event!",
      joinCourseToday: 'Join this course and start learning today.',
      registerForEventToday: 'Register for this event and get access to all materials.',
      enrollFor: 'Enroll',
      goToDashboard: 'Go to Dashboard',
      courseNotFound: 'Course not found',
      returnToHomepage: 'Return to homepage',
      pleaseLogIn: 'Please log in to enroll in this course',
      paymentSuccessful: 'Payment successful! You are registered.',
      paymentFailed: 'Payment failed. Please try again.',
      successfullyEnrolled: 'Registration successful!',
      failedToEnroll: 'Registration failed',
      fulfilmentBlocked: 'Your payment went through, but the registration could not be completed. CONFY support has already been notified and will follow up – please do not pay again. Questions? Email support@confy.cc.',
      answersNotStoredError: 'You are registered, but your registration answers could not be saved. Please contact the organizer.',
      failedToCheckProfileRequirements: 'Failed to check profile requirements. Please try again.',
      sessionExpiredPleaseRefresh: 'Session expired. Please refresh the page and try again.',
      serverErrorTryAgain: 'Server error. Please try again in a minute.',
      networkErrorCheckConnection: 'Cannot connect to server. Check your internet and try again.',
      refreshPage: 'Refresh page',
      failedToProcessPayment: 'Failed to process payment',
      failedToInitiatePayment: 'Failed to initiate payment',
      paymentConfirmingTitle: 'Payment is being confirmed',
      paymentConfirming: 'We are confirming your payment – this usually takes a few minutes. You will receive a confirmation email once your registration is confirmed. No need to pay again.',
      paymentConfirmingDelayedTitle: 'Confirmation is taking longer than usual',
      paymentConfirmingDelayed: 'Your payment is still being processed – it is just taking longer than usual. You will receive a confirmation email once your registration is confirmed. No need to pay again.',
      paymentRedirecting: 'Redirecting to the payment page…',
      paymentContinue: 'Continue to payment',
      paymentCancel: 'Cancel',
      paymentSuccessPage: {
        title: 'Payment processing',
        message: 'Your payment has been received. Registration will be confirmed within a few minutes.',
        successTitle: 'Payment confirmed!',
        successMessage: 'You are successfully registered. Your ticket is available in your profile.',
        declinedTitle: 'Payment not completed',
        declinedMessage: 'The payment was not completed. If the money was charged anyway, your registration will be confirmed automatically within an hour.',
        blockedTitle: 'Payment received, registration not completed',
        blockedMessage: 'The payment went through but the registration could not be completed. Do not pay again – write to support@confy.cc.',
        goToEvent: 'Go to event',
        goToTickets: 'My tickets',
        goToHome: 'Go to home',
        verifying: 'Verifying payment status...',
        tryAgain: 'Try again',
        redirecting: 'Taking you back to the event page.',
      },
      module: 'Module',
      cpdCredits: 'CPD Credits',
      targetSpecialties: 'Target Audience',
      passingScore: 'Passing Score',
      required: 'Required',
      optional: 'Optional',
      free: 'FREE',
      inPerson: 'In-Person',
      online: 'Online',
      hybrid: 'Hybrid',
      selfPaced: 'Self-Paced',
      website: 'Website',
      visitPage: 'Visit Page',
      visitWebsite: 'Visit Website',
      noDescription: 'No description available',
      noProgram: 'No program available',
      eventTimezone: 'event time',
      yourLocalTime: 'your local time',
    },

    // Event-specific translations
    event: {
      eventNotFound: 'Event not found',
      loadFailed: 'Could not load the event. Check your connection and try again.',
      retry: 'Try again',
      register: 'Register for Event',
      registered: 'registered',
      registerSuccess: 'You have successfully registered for the event!',
      joinNow: 'Join Event',
      viewMaterials: 'View Materials',
      viewEvent: 'View Event',
      happeningNow: 'Event is happening now',
      upcoming: 'Upcoming event',
      ended: 'Event ended',
      startsIn: 'Starts in',
      completionRequirements: 'Requirements for certificate',
      agenda: 'Agenda',
      eventDetails: 'Event Details',
      youreRegistered: "You're Registered!",
      eventStartsIn: 'Event starts in',
      joinEventNow: 'Join Event Now',
      viewEventMaterials: 'View Event Materials',
      eventHappeningNow: 'Event Happening Now',
      upcomingEvent: 'Upcoming Event',
      eventEnded: 'Event Ended',
      prepareForEvent: 'Prepare for the Event',
      completeBeforeEvent: 'Complete these materials before the event starts.',
      completeToEarnCertificate: 'Complete these to earn your certificate:',
      attendedEvent: 'Attended event',
      completeFinalTest: 'Complete final test',
      completeSurvey: 'Complete survey',
      days: 'days',
      daysUntilEvent: 'days until event',
      eventInProgress: 'Event in Progress',
      clickToJoin: 'Click to join',
      viewMaterialsAndCertificate: 'View materials and certificate',
      certificateReady: 'Certificate Ready!',
      clickToGenerate: 'Click the button below to generate your certificate',
      notConfiguredYet: 'Certificate in Preparation',
      notConfiguredDescription: 'The certificate for this event is still being prepared by the organizer. It will be available soon.',
      templateNotConfigured: 'The certificate template for this event is not yet configured. The certificate will be available soon.',
      allRequirementsComplete: 'You have completed all requirements for the certificate.',
      generateCertificateInTab: 'Go to the Certificates tab to generate your certificate.',
      streamingAvailable: 'Online streaming available',
      sessionSchedule: 'Session Schedule',
      session: 'Session',
      agendaComingSoon: 'Event agenda will be updated soon',

      // Social Proof & Scarcity
      spotsRemaining: 'spots remaining',
      registerSoon: 'Register soon - limited availability',
      soldOut: 'Sold Out',

      // Test Types
      finalExam: 'Final Exam',
      preAssessment: 'Pre-Assessment',
      knowledgeCheck: 'Knowledge Check',
      attempts: 'attempts',

      // Event Organization
      speakers: 'Speakers',
      organizedBy: 'Organized by',
      organizerInformation: 'Organizer',

      // Online Event Access
      onlineAccess: {
        title: 'Join Online Event',
        availableBeforeStart: 'The meeting link will become active shortly before the event starts.',
        clickToJoin: 'Click the button below to join the online event.',
        notYetAvailable: 'Not Yet Available',
        joinNow: 'Join Online Event',
        availableSoon: 'Available when event starts',
      },

      // Exit Confirmation Modal
      confirmExit: 'Exit Test?',
      progressWillBeLost: 'Your answers will not be saved',
      exitAnyway: 'Exit Anyway',

      // Event Tests and Surveys (Student-facing)
      test: {
        maxAttemptsReached: 'You have reached the maximum number of attempts',
        loading: 'Loading tests...',
        noTestsAvailable: 'No tests available at this time.',
        checkBackLater: 'Check back later when tests become available.',
        availableAfterEvent: 'Tests will be available after the event ends.',
        passedTitle: 'Congratulations! You Passed!',
        scoredAbove: 'You scored above the passing grade of',
        certificateGenerating: 'Your certificate is being generated and will be available shortly!',
        notPassedTitle: 'Test Not Passed',
        retryEncouragement: 'You need {percentage}% to pass. You can try again.',
        backToTests: 'Back to Tests',
        tryAgain: 'Try Again',
        availableTestsTitle: 'Available Tests',
        closedTestsTitle: 'Closed Tests',
        upcomingTestsTitle: 'Upcoming Tests',
        startTest: 'Start Test',
        submitTest: 'See Results',
        closed: 'Closed',
        upcoming: 'Coming soon',
        missedTest: 'You did not complete this test in time',
        viewResults: 'View Results',
        yourAnswer: 'Your answer',
        correctAnswer: 'Correct answer',
        testAlreadyPassed: 'You have already passed this test',
        answerAllQuestions: 'Please answer all questions before submitting',
        questionsAnswered: 'questions answered',
        questionsCount: 'Questions',
        attemptsRemaining: 'Attempts remaining',
        attemptsUnlimited: 'Attempts: unlimited',
        startDate: 'Start',
        deadline: 'Deadline',
        beginTest: 'Begin Test',
        questionOf: 'Question',
        reviewTitle: 'Review Answers',
        answeredCount: 'answered',
        notAnswered: 'Not answered',
        congratulations: 'Congratulations!',
        youPassedTest: 'You passed the test!',
        yourScore: 'Your score',
        passingPercentage: 'Passing threshold',
        next: 'Next',
        previous: 'Back',
        close: 'Close',
        timeUp: 'Time is up',
        cancel: 'Cancel',
        noAttemptsRemaining: 'No attempts remaining',
        notPreparedByOrganizer: 'There is currently no information about testing. Either it is not planned, or it has not yet been prepared by the organizer.',
        notIncluded: {
          title: 'The test is not included in your ticket',
          body: 'A test is open for this event, but your ticket «{{ticket}}» does not include the test or a certificate.',
          bodyNoTicketName: 'A test is open for this event, but your ticket does not include the test or a certificate.',
          upgradeHint: 'Upgrade your ticket to take the test and get a certificate.',
          contactHint: 'If you think this is a mistake, please contact the organizer.',
          upgradeButton: 'Upgrade ticket',
          contactButton: 'Email the organizer',
          openUntil: 'The test is open until {{date}}',
        },
        contactOrganizerAboutTest: 'If you have questions about the test, please contact the organizer:',
      },
      testHistory: {
        title: 'Test History',
        passed: 'Passed',
        failed: 'Failed',
        attempt: 'Attempt',
        loadMore: 'Load More',
        remaining: 'remaining',
        noHistory: 'No test history',
      },
      survey: {
        alreadyCompleted: 'You have already completed this survey.',
        answerRequired: 'Please answer all required questions before submitting.',
        loading: 'Loading surveys...',
        noSurveysAvailable: 'No surveys available at this time.',
        checkBackLater: 'Check back later when surveys become available.',
        availableAfterEvent: 'Surveys will be available after the event ends.',
        thankYouTitle: 'Thank You!',
        submittedSuccess: 'Your survey response has been submitted successfully.',
        backToSurveys: 'Back to Surveys',
        availableSurveysTitle: 'Available Surveys',
        closedSurveysTitle: 'Closed Surveys',
        upcomingSurveysTitle: 'Upcoming Surveys',
        missedSurvey: 'You did not complete this survey in time',
        closed: 'Closed',
        upcoming: 'Coming soon',
        notYetAvailable: 'Survey is not yet available',
        startSurvey: 'Start Survey',
        submitSurvey: 'Submit Survey',
        anonymous: 'Anonymous',
        errorSubmitting: 'Failed to submit survey. Please try again.',
      },
      preEvent: {
        testsTitle: 'Pre-Event Tests',
        surveysTitle: 'Pre-Event Surveys',
        preAssessmentBadge: 'Pre-Assessment',
      },
      tabs: {
        program: 'Program',
        speakers: 'Speakers',
        materials: 'Materials',
        partners: 'Partners',
        tests: 'Tests',
        surveys: 'Surveys',
        certificates: 'Certificates',
      },
      streamingError: 'Unable to join the stream. Please try again or contact support.',

      // Promocode Registration
      registration: {
        promocode: {
          haveCode: 'Have a promocode?',
          placeholder: 'Enter promocode',
          apply: 'Apply',
          remove: 'Remove',
          validating: 'Validating...',
          invalid: 'Invalid promocode',
          validationError: 'Error validating promocode. Please try again.',
          enterCode: 'Please enter a promocode',
          locked: 'Locked',
          needsCode: 'Enter a promocode to unlock this ticket',
          promocodeRequired: 'Promocode Required',
          unlocked: 'Unlocked',
        },
        ticketsAvailable: 'available',
        soldOut: 'Sold Out',
        noTicketsAvailable: 'No tickets available',
        loadFailed: 'Could not load tickets',
        loadFailedHint: 'Check your connection and try again. Registration is still open.',
        retryLoad: 'Try again',
        salesEnded: 'Registration closed',
        salesEndedHint: 'The registration period for this event has ended',
        enterPromoToAccess: 'Enter a promo code to access registration',
        availableTickets: 'Available Tickets',
        selectTickets: 'Select Tickets',
        selectYourTickets: 'Select Your Tickets',
        total: 'Total:',
        proceedToCheckout: 'Proceed',
        finishRegistration: 'Finish Registration',
        specialAccessTickets: 'Special Access (Promocode Required)',
        includesParticipantCert: 'Participant certificate',
        includesSpeakerCert: 'Speaker certificate',
      },
    },

    // Certificate Verification
    certificateVerification: {
      title: 'Certificate Verification',
      description: 'Verify the authenticity of CONFY certificates',
      certificateVerification: 'Certificate Verification',
      verifyAuthenticity: 'Verify the authenticity of CONFY certificates',
      backToHomepage: 'Back to Homepage',
      verifyCertificate: 'Verify Certificate',
      verifyButton: 'Verify Certificate',
      instructions: 'Enter a verification code or certificate number to check the authenticity of a certificate',
      enterVerificationCode: 'Enter a verification code or certificate number to check the authenticity of a certificate',
      verificationCode: 'Verification Code',
      verificationCodeLabel: 'Verification Code',
      certificateNumber: 'Certificate Number',
      certificateNumberLabel: 'Certificate Number',
      verificationCodePlaceholder: 'Enter verification code',
      enterVerificationCodePlaceholder: 'Enter the verification code (e.g., AB1CD2EF3GH4IJ5K)',
      certificateNumberPlaceholder: 'Enter certificate number',
      verificationCodeHelp: 'The verification code can be found on the certificate or shared link',
      certificateNumberHelp: 'The certificate number is displayed on the certificate',
      verificationCodeLocation: 'The verification code can be found on the certificate or shared link',
      enterCertificateNumber: 'Enter the certificate number (e.g., CERT-2025-ABC1234567)',
      certificateNumberLocation: 'The certificate number is displayed on the certificate',
      verifying: 'Verifying...',
      verified: 'Certificate Verified',
      certificateVerified: 'Certificate Verified',
      verificationFailed: 'Verification Failed',
      validAndAuthentic: 'This certificate is valid and authentic.',
      certificateNotFound: 'Certificate not found. The verification code or certificate number may be incorrect.',
      certificateHasExpired: 'This certificate has expired.',
      certificateStatus: 'This certificate status is:',
      certificateDetails: 'Certificate Details',
      recipient: 'Recipient',
      course: 'Course',
      cpdCredits: 'CPD Credits',
      completionDate: 'Completion Date',
      issueDate: 'Issue Date',
      expiredWarning: 'This certificate has expired',
      certificateExpired: '⚠️ This certificate has expired.',
      expiryDate: 'Expiry date',
      howToUse: 'How to Use This Tool',
      howToUseThisTool: 'How to Use This Tool',
      howToUseStep1: 'Verification Code: Found on certificates and shared links - a unique code for verification',
      howToUseStep2: 'Certificate Number: The official certificate number displayed on the certificate document',
      howToUseStep3: 'Authenticity: Valid certificates show detailed information including recipient name, course, and completion dates',
      howToUseStep4: 'Security: All certificates are digitally signed and stored securely in our system',
      verificationCodeInfo: '• Verification Code: Found on certificates and shared links - a unique code for verification',
      certificateNumberInfo: '• Certificate Number: The official certificate number displayed on the certificate document',
      authenticityInfo: '• Authenticity: Valid certificates show detailed information including recipient name, course, and completion dates',
      securityInfo: '• Security: All certificates are digitally signed and stored securely in our system',
      pleaseEnterValid: 'Please enter a valid',
      errorOccurred: 'An error occurred while verifying the certificate. Please try again.',
      loadingVerification: 'Loading...',
      loadingCertificateVerification: 'Loading certificate verification...',
    },

    // Auth Modal Enhancements
    authModal: {
      welcomeBack: 'Welcome',
      joinCONFY: 'Join CONFY',
      signInAccess: 'Sign in or sign up to use the platform',
      createAccount: 'Create account',
      signInWithEmail: 'Sign in with Email',
      enterYourEmail: 'Enter your email',
      createYourAccount: 'Create your account',
      checking: 'Checking...',
      continue: 'Continue',
      signInSubtitle: 'Enter your credentials to access your account',
      signUpSubtitle: 'We only need your name and email to get started',
      firstName: 'First Name',
      lastName: 'Last Name',
      firstNamePlaceholder: 'Enter your first name',
      lastNamePlaceholder: 'Enter your last name',
      emailAddress: 'Email address',
      sending: 'Sending...',
      sendSignInLink: 'Send sign in link',
      sendAccountSetupLink: 'Send account setup link',
      sendSecureLinkSignIn: 'We will send you a secure link to sign in instantly.',
      sendSecureLinkSetup: 'We will send you a secure link to complete your account setup.',
      pleaseEnterEmail: 'Please enter your email address',
      pleaseEnterName: 'Please enter your first and last name',
      pleaseProvideNames: 'Please provide your first and last name',
      userNotFoundError: 'No account found with this email. Would you like to create one?',
      userAlreadyExistsError: 'An account with this email already exists. Please sign in instead.',
      switchToSignUp: 'Create new account',
      switchToSignIn: 'Sign in to existing account',
      accountCreated: 'Account created! Check your email to complete registration.',
      magicLinkSent: 'Sign in link sent! Check your email to sign in.',
      failedToSendMagicLink: 'Failed to send magic link',
      failedToSignInWithGoogle: 'Failed to sign in with Google',
      johnPlaceholder: 'John',
      doePlaceholder: 'Doe',
      emailPlaceholder: 'john@example.com',
      continueWithGoogle: 'Sign in with Google',
      pleaseWait: 'Please wait...',
      or: 'or',
      continueWithEmail: 'Sign in with Email',
      continueWithPhoneComingSoon: 'Continue with Phone (Coming Soon)',
      dontHaveAccount: "Don't have an account?",
      alreadyHaveAccount: 'Already have an account?',
      signUp: 'Sign up',
      signIn: 'Sign in',
      bySigningUp: 'By signing up, you agree to our',
      userAgreement: 'User Agreement',
      and: 'and',
      privacyPolicy: 'Privacy Policy',
      // Check Email / OTP Verification
      checkYourEmail: 'Check your email',
      magicLinkInstructions: 'We sent a sign-in email to',
      clickButtonInEmail: 'Click the button in the email to sign in',
      resendEmail: 'Resend email',
      enterCodeManually: 'Or enter the 6-digit code manually',
      enterCodeManuallyHint: 'Enter the code from the email:',
      enterCode: 'Enter code',
      enterCodeSubtitle: 'Enter the 6-digit code sent to',
      verificationCode: 'Verification code',
      codePlaceholder: '000000',
      verifying: 'Verifying...',
      verify: 'Verify',
      invalidCode: 'Invalid code',
      codeExpired: 'Code expired',
      resendCode: 'Resend code',
      checkEmailForCode: 'Check your email for the code or click the link in the email',
      rateLimitError: 'Please wait {seconds} sec. before requesting again',
      pleaseWaitBeforeResending: 'Please wait before resending the code',
      resendInvalidatesCode: 'Sending a new code will invalidate the previous one',
      typoQuestion: 'Did you mean {email}?',
      typoUseFix: 'Yes, fix it',
      typoKeep: 'No, send to {email}',
      resendIn: 'Resend in {seconds}s',
      newCodeSent: 'New code sent. The code from the previous email no longer works – use the one from the latest email.',
      googleNudgeTitle: 'Having trouble signing in?',
      googleNudgeBody: 'Your email runs on Google – sign in with one tap, no emails or codes.',
      googleNudgeAccount: 'Choose the {email} account.',
      // Auth error/recovery messages
      authErrorPkce: 'You opened the link in a different browser. For security reasons, sign-in must be completed in the same browser where it was initiated. Please sign in with Google or request a new email and enter the 6-digit code from it.',
      authErrorGeneric: 'Sign-in failed. Please try again.',
      authErrorLinkAlreadyUsed: 'This sign-in link has already been used. Every link and code works only once \u2013 request a new email.',
      authRequestNewLink: 'Send a new email',
      authErrorSessionExpired: 'Your session has expired. Please sign in again.',
      authSuccessSignedIn: 'Successfully signed in!',
      authTryAgain: 'Try again',
      authSessionRestoreFailed: 'Something went wrong. Clear the session and try again.',
      authClearSessionAndRetry: 'Clear session',
      // Device clock differs from server time (see ClockSkewNotice)
      clockSkewNotice: 'Your device clock is off by {{amount}}. Turn on automatic date, time and time zone in your device settings, then reload the page.',
      clockSkewMinutes: '{{minutes}} min',
      clockSkewHours: '{{hours}} h {{minutes}} min',
      clockSkewHoursOnly: '{{hours}} h',
      clockSkewReload: 'Reload page',
      clockSkewDismiss: 'Close',
    },

    loginPage: {
      title: 'Sign In',
      loginRequired: 'Please sign in to access this page',
      sessionExpired: 'Your session has expired. Please sign in again.',
      alreadyAuthenticated: 'You are already signed in. Redirecting...',
    },

    // Profile Completion Modal
    profileCompletion: {
      title: 'Complete Your Profile',
      subtitle: 'Just one more step to get started',
      emailAddress: 'Email Address',
      firstName: 'First Name',
      lastName: 'Last Name',
      firstNamePlaceholder: 'Enter your first name',
      lastNamePlaceholder: 'Enter your last name',
      requiredField: 'Required fields',
      continue: 'Continue',
      saving: 'Saving...',
      bothNamesRequired: 'Both first name and last name are required',
      failedToSaveProfile: 'Failed to save profile',
    },

    // Course Learn Page
    courseLearn: {
      loadingCourseContent: 'Loading course content...',
      noContentAvailable: 'No content available for this course',
      backToDashboard: 'Back to Dashboard',
      notEnrolledError: 'You are not enrolled in this course',
      progress: 'Progress',
      courseContent: 'Course Content',
      block: 'Block',
      unknownContentType: 'Unknown content type',
      testInformation: 'Test Information',
      questions: 'Questions',
      passingScore: 'Passing Score',
      maxAttempts: 'Max Attempts',
      unlimited: 'Unlimited',
      timeLimit: 'Time Limit',
      minutes: 'minutes',
      noTimeLimit: 'No time limit',
      startTest: 'Start Test',
      surveyInformation: 'Survey Information',
      anonymous: 'Anonymous',
      required: 'Required',
      takeSurvey: 'Take Survey',
      yes: 'Yes',
      no: 'No',
      markAsComplete: 'Mark as Complete',
      nextBlock: 'Next Block',
      previousBlock: 'Previous Block',
      completeCourseCongratulations: 'Congratulations! You have completed the course!',
      youHaveCompleted: 'You have successfully completed all blocks in this course.',
      generateCertificate: 'Generate Certificate',
      certificateGenerated: 'Certificate Generated',
      viewCertificate: 'Certificate',
      returnToDashboard: 'Return to Dashboard',
      getCertificate: 'Get Certificate',
      completeCourse: 'Complete Course',
      lessonContainsItems: 'This lesson contains',
      contentItems: 'content items',
      lessonNavigationHint: 'Use the navigation buttons below or the sidebar to go through each content item in this lesson.',
      completeRequiredTests: 'Complete all required tests and surveys in this lesson before marking it as complete',
      markLessonComplete: 'Mark Lesson as Complete',
      // Content type labels
      noVideoUrl: 'Video URL not provided',
      textContent: 'Text Content',
      document: 'Document',
      openDocumentNewTab: 'Open document in new tab',
      noDocumentAvailable: 'Document not available',
      image: 'Image',
      courseImage: 'Course Image',
      noImageAvailable: 'Image not available',
      audio: 'Audio',
      browserNotSupportAudio: 'Your browser does not support the audio element.',
      downloadAudio: 'Download Audio',
      noAudioAvailable: 'Audio not available',
      externalLink: 'External Link',
      visitLink: 'Visit Link',
      noLinkAvailable: 'Link not available',
      completeTestPrompt: 'Complete the test to mark it as finished',
      completeSurveyPrompt: 'Complete the survey to mark it as finished',
      testModal: {
        title: 'Test',
        timeRemaining: 'Time Remaining',
        question: 'Question',
        of: 'of',
        selectAnswer: 'Select an answer',
        selectMultiple: 'Select all correct answers',
        true: 'True',
        false: 'False',
        typeYourAnswer: 'Type your answer here...',
        previous: 'Previous',
        next: 'Next',
        submit: 'Submit',
        testResults: 'Test Results',
        score: 'Your Score',
        passed: 'You passed the test!',
        failed: 'You did not pass the test',
        tryAgain: 'Try Again',
        close: 'Close',
      },
      surveyModal: {
        title: 'Survey',
        question: 'Question',
        of: 'of',
        selectAnswer: 'Select an answer',
        selectMultiple: 'Select all that apply',
        typeYourAnswer: 'Type your answer here...',
        previous: 'Previous',
        next: 'Next',
        submit: 'Submit',
        thankYou: 'Thank You!',
        surveyCompleted: 'Your survey responses have been saved.',
        close: 'Close',
      },
    },

    // Certificate
    certificate: {
      certificateOfCompletion: 'Certificate of Completion',
      thisIsToCertify: 'This is to certify that',
      hasSuccessfullyCompleted: 'has successfully completed the course',
      issuedOn: 'Issued on',
      certificateNumber: 'Certificate Number',
      verificationCode: 'Verification Code',
      validUntil: 'Valid until',
      cpdCredits: 'CPD Credits',
      instructor: 'Instructor',
      verifyAt: 'Verify at',
      generatingCertificate: 'Generating certificate...',
      generateCertificate: 'Generate Certificate',
      getCertificate: 'Get Certificate',
      downloadCertificate: 'Download Certificate',
      shareOnLinkedIn: 'Share on LinkedIn',
      shareOnFacebook: 'Share on Facebook',
      shareOnTwitter: 'Share on Twitter',
      copyLink: 'Copy Link',
      linkCopied: 'Link copied!',
      certificateGenerated: 'Certificate generated successfully!',
      errorGeneratingCertificate: 'Error generating certificate',
      ticketNoCertificateAccess: 'Your ticket type does not include certificate access. Please contact the organizer or upgrade your ticket.',
      knowledgeChecked: 'Test passed – knowledge verified',
      knowledgeCheckedDescription: 'You passed the test and verified your knowledge of the material. Great result!',
      certificateInPremium: 'Your current ticket does not include a certificate',
      notOfferedForThisEvent: 'Certificates are not offered for this event',
      certificateInPremiumDescription: 'To get the certificate, upgrade your ticket',
      upgradeTicketForCertificate: 'Upgrade ticket and get certificate',
      upgradeAvailableUntil: 'Ticket upgrade is available until {{deadline}}',
      certificateNotAvailable: 'Certificate not available',
      certificateTemporarilyUnavailable: 'Certificate issuance is temporarily unavailable due to a platform update. If you have passed the test – don\'t worry, your certificate will appear around February 20-25. We apologize for the temporary inconvenience and thank you for your understanding!',
      pleaseCompleteCourse: 'Please complete the course to get a certificate',
      checkingRequirements: 'Checking Requirements',
      verifyingStatus: 'Verifying your course completion status...',
      congratulationsMessage: 'Congratulations on completing this course! Generate your official certificate to commemorate your achievement.',
      completeRequirementsMessage: 'Complete the requirements below to generate your certificate.',
      certificateRequirements: 'Certificate Requirements',
      enrolledInCourse: 'Enrolled in course',
      completedAllMaterials: 'Completed all course materials',
      passedCourseTest: 'Passed course test',
      completeProfileInfo: 'Complete profile information',
      eventHasEnded: 'Event has ended',
      allRequiredTestsPassed: 'All required tests passed',
      allRequiredSurveysCompleted: 'All required surveys completed',
      clickToGenerate: 'Click the button below to generate your certificate',
      notConfiguredYet: 'Certificate in Preparation',
      notConfiguredDescription: 'The certificate for this event is still being prepared by the organizer. It will be available soon.',
      templateNotConfigured: 'The certificate template for this event is not yet configured. The certificate will be available soon.',
      whatYouWillGet: 'What you\'ll get',
      officialCertificate: 'Official course completion certificate',
      uniqueNumber: 'Unique certificate number for verification',
      pdfDownload: 'PDF download for your records',
      pdfPreparing: 'PDF preparing...',
      viewOnline: 'View Online',
      shareableLink: 'Shareable verification link',
      completeRequirementsFirst: 'Complete Requirements First',
      pleaseWaitGenerating: 'Please wait while we create your certificate...',
      // Event-specific certificate messages
      availableAfterEvent: 'Certificate Available After Event',
      certificateAvailableAfterEventEnds: 'Complete all requirements after the event ends to receive your certificate.',
      certificateIssued: 'Certificate Issued',
      congratsEarnedCertificate: 'Congratulations! You have successfully earned your event completion certificate.',
      autoGenerateNote: 'Your certificate will be generated automatically once you complete all requirements. Use the button above to download it.',
      generationTimeout: 'Certificate generation timeout - please try again',
      generationFailed: 'Certificate generation failed',
      statusCheckFailed: 'Failed to check certificate generation status',
      eventNotEnded: 'The event has not ended yet. Certificates will be available after the event concludes.',
      testsNotPassed: 'You must pass all required tests before generating a certificate.',
      surveysNotCompleted: 'You must complete all required surveys before generating a certificate.',
      certificateUnavailable: 'Certificate Unavailable',
      testNotPassedMessage: 'The test was not passed, so the certificate was not issued. Please contact the event organizer if you believe this is an error.',
      surveysNotCompletedMessage: 'Required surveys were not completed, so the certificate was not issued. Please complete all required surveys first.',
      missingTests: 'Tests not passed',
      missingSurveys: 'Surveys not completed',
      pdfNotReady: 'Certificate PDF not ready yet',
      missing: 'Missing',
      generatingPdf: 'Generating Certificate PDF',
      generatingPdfEllipsis: 'Generating PDF...',
      certificateReady: 'Certificate ready!',
      certificateEligible: 'Certificate earned!',
      pdfAvailableAfterEvent: 'PDF will be available after the event ends.',
      certificateProcessing: 'Certificate is being generated...',
      notConfiguredNotified: 'The organizer has not set up the certificate for your ticket yet. We have notified them – it will appear here as soon as it is ready.',
      renderGenerating: 'Your certificate is being generated. This usually takes under a minute – you can close this page.',
      renderDelayed: 'Generation is taking longer than usual. We will retry automatically – no action needed.',
      renderFailed: 'We could not generate your certificate. We already know about the problem. Try again or write to support@confy.cc.',
      retryGeneration: 'Try again',
      waitingInQueue: 'Waiting in queue...',
      creatingCertificate: 'Creating certificate...',
    },

    // Payment
    payment: {
      processingPayment: 'Processing payment...',
      redirectingToPayment: 'Redirecting to payment page...',
      paymentFailed: 'Payment failed',
      paymentCancelled: 'Payment cancelled',
      tryAgain: 'Try Again',
      contactSupport: 'Contact Support',
      payNow: 'Pay Now',
      securePayment: 'Secure Payment',
      orderSummary: 'Order Summary',
      course: 'Course',
      price: 'Price',
      total: 'Total',
    },

    // Content Blocks
    contentBlocks: {
      text: 'Text',
      video: 'Video',
      pdf: 'PDF',
      videoEmbed: 'Video Embed',
      document: 'Document',
      presentation: 'Presentation',
      image: 'Image',
      audio: 'Audio',
      link: 'Link',
      test: 'Test',
      survey: 'Survey',
      dragToReorder: 'Drag to reorder',
      addTitle: 'Add title',
      addDescription: 'Add description',
      addContent: 'Add content',
      enterTitle: 'Enter title...',
      enterDescription: 'Enter description...',
      enterContent: 'Enter content...',
      enterVideoUrl: 'Enter video URL (YouTube, Vimeo)...',
      enterAudioUrl: 'Enter audio URL...',
      enterLink: 'Enter link...',
      uploadFile: 'Upload File',
      uploadImage: 'Upload Image',
      removeBlock: 'Remove Block',
      confirmRemove: 'Are you sure you want to remove this block?',
      addYouTubeVimeo: 'Add a YouTube or Vimeo video',
      textBlock: 'Text Block',
      addTextFormatting: 'Add text content and formatting',
      pdfDocument: 'PDF Document',
      uploadDisplayPDF: 'Upload and display PDF files',
      uploadDisplayImages: 'Upload and display images',
      enterBlockTitle: 'Enter block title...',
      pasteVideoUrl: 'Paste a YouTube or Vimeo URL here...',
      enterContentMarkdown: 'Enter your content here... You can use Markdown formatting.',
      preview: 'Preview',
      describeImage: 'Describe what the image shows...',
      removeImage: 'Remove Image',
      failedToLoadImage: 'Failed to load image',
      openPDF: 'Open PDF',
      removePDF: 'Remove PDF',
      pdfPreview: 'PDF Preview',
      collapse: 'Collapse',
      expand: 'Expand',
      heading1: 'Heading 1',
      heading2: 'Heading 2',
      heading3: 'Heading 3',
      bold: 'Bold',
      italic: 'Italic',
      bulletList: 'Bullet list',
      noVideoUrl: 'Video URL not provided',
      noImageAvailable: 'Image not available',
      noLinkUrl: 'Link URL not provided',
    },

    // Test Editor
    testEditor: {
      testEditor: 'Test Editor',
      createTest: 'Create Test',
      editTest: 'Edit Test',
      testTitle: 'Test Title',
      enterTestTitle: 'Enter test title...',
      testDescription: 'Test Description',
      enterTestDescription: 'Enter test description...',
      passingScore: 'Passing Score',
      maxAttempts: 'Max Attempts',
      unlimitedAttempts: 'Unlimited attempts',
      timeLimit: 'Time Limit (minutes)',
      noTimeLimit: 'No time limit',
      questions: 'Questions',
      addQuestion: 'Add Question',
      questionType: 'Question Type',
      singleChoice: 'Single Choice',
      multipleChoice: 'Multiple Choice',
      trueFalse: 'True/False',
      essay: 'Essay',
      questionText: 'Question Text',
      enterQuestionText: 'Enter question text...',
      points: 'Points',
      explanation: 'Explanation (optional)',
      enterExplanation: 'Enter an explanation for this question...',
      options: 'Answer Options',
      addOption: 'Add Option',
      optionText: 'Option Text',
      isCorrect: 'Correct Answer',
      removeOption: 'Remove Option',
      removeQuestion: 'Remove Question',
      createNewTest: 'Create New Test',
      description: 'Description',
      knowledgeCheck: 'Knowledge Check',
      finalExam: 'Final Exam',
      type: 'Type',
      answerOptions: 'Answer Options',
      requiredForCompletion: 'Required for course completion',
      showResultsImmediately: 'Show results immediately',
      pleaseProvideTestTitle: 'Please provide a test title',
      pleaseAddQuestion: 'Please add at least one question',
      noQuestionsAdded: 'No questions added yet. Click "Add Question" to get started.',
      enterQuestionPlaceholder: 'Enter a question...',
      enterOptionPlaceholder: 'Enter an option...',
      optionalExplanationPlaceholder: 'Optional explanation...',
      moduleKnowledgeCheck: 'e.g., Module 1 Knowledge Check',
      briefTestDescription: 'Brief description of the test...',
      noLimit: 'No limit',
      preAssessment: 'Pre-Assessment',
      saveTest: 'Save Test',
      cancel: 'Cancel',
      saving: 'Saving...',
    },

    // Survey Editor
    surveyEditor: {
      surveyEditor: 'Survey Editor',
      createSurvey: 'Create Survey',
      editSurvey: 'Edit Survey',
      surveyTitle: 'Survey Title',
      enterSurveyTitle: 'Enter survey title...',
      surveyDescription: 'Survey Description',
      enterSurveyDescription: 'Enter survey description...',
      isAnonymous: 'Anonymous Survey',
      isRequired: 'Required Survey',
      questions: 'Questions',
      addQuestion: 'Add Question',
      questionType: 'Question Type',
      singleChoice: 'Single Choice',
      multipleChoice: 'Multiple Choice',
      trueFalse: 'Yes/No',
      essay: 'Text Response',
      questionText: 'Question Text',
      enterQuestionText: 'Enter question text...',
      isRequiredQuestion: 'Required Question',
      options: 'Answer Options',
      addOption: 'Add Option',
      optionText: 'Option Text',
      removeOption: 'Remove Option',
      removeQuestion: 'Remove Question',
      saveSurvey: 'Save Survey',
      cancel: 'Cancel',
      saving: 'Saving...',
      createCourseSurvey: 'Create Course Survey',
      surveyTitlePlaceholder: 'e.g., Course Feedback Survey',
      description: 'Description',
      descriptionPlaceholder: 'Brief description of the survey...',
      anonymousResponses: 'Anonymous responses',
      requiredForCompletion: 'Required for course completion',
      availableAfterCompletion: 'Available only after course completion',
      quickTemplates: 'Quick Templates',
      satisfactionRating: 'Satisfaction Rating',
      npsScore: 'NPS Score',
      improvementFeedback: 'Improvement Feedback',
      type: 'Type',
      required: 'Required',
      answerOptions: 'Answer Options',
      enterQuestion: 'Enter question...',
      enterOption: 'Enter option...',
      textAnswer: 'Text Answer',
      pleaseProvidenSurveyTitle: 'Please provide a survey title',
      courseFeedbackSurvey: 'e.g., Course Feedback Survey',
      briefSurveyDescription: 'Brief description of the survey...',
      noQuestionsAdded: 'No questions added yet. Use the quick templates above or click "Add Question" to get started.',
      pleaseProvideTitleAlert: 'Please provide a survey title',
      pleaseAddQuestionAlert: 'Please add at least one question',
      satisfactionQuestion: 'How satisfied are you with this course?',
      verySatisfied: 'Very Satisfied',
      satisfied: 'Satisfied',
      neutral: 'Neutral',
      dissatisfied: 'Dissatisfied',
      veryDissatisfied: 'Very Dissatisfied',
      recommendQuestion: 'How likely are you to recommend this course to a colleague?',
      improvementQuestion: 'What aspects of the course could be improved?',
    },

    // Certificates
    certificates: {
      yourCertificate: 'Your Certificate',
      failedToLoad: 'Failed to load certificate',
      allowPopups: 'Please allow pop-ups to generate PDF',
      failedToGeneratePDF: 'Failed to generate PDF',
      myCertificate: 'My Certificate',
      earnedCertificate: 'I\'ve earned a certificate',
      linkCopied: 'Certificate verification link copied to clipboard!',
      loadingCertificate: 'Loading certificate...',
      errorLoadingCertificate: 'Error Loading Certificate',
      certificateDetails: 'Certificate Details',
      certificateNumber: 'Certificate Number',
      issuedDate: 'Issued Date',
      status: 'Status',
      statusIssued: 'Issued',
      hidePreview: 'Hide Preview',
      showPreview: 'Show Preview',
      downloadPDF: 'Download PDF',
      downloadCertificate: 'Download Certificate',
      shareCertificate: 'Share Certificate',
      certificatePreview: 'Certificate Preview',
      previewDescription: 'This is how your certificate will appear when printed or shared',
      failedToGenerate: 'Failed to generate certificate',
      failedToGenerateTryAgain: 'Failed to generate certificate. Please try again.',
      allowPopupsDownload: 'Please allow pop-ups to download the certificate',
      failedToDownload: 'Failed to download certificate',
      myCourseCertificate: 'My Course Certificate',
      completedCourse: 'I\'ve completed',
      certificateGenerated: 'Certificate Generated!',
      successfullyCreated: 'Your certificate has been successfully created.',
      existingRetrieved: 'Your existing certificate has been retrieved.',
      verificationCode: 'Verification Code',
      useCodeToVerify: 'Use this code to verify your certificate\'s authenticity.',
      creationFailed: 'Failed to create certificate. Please try again later.',
      ticketNoCertificateAccess: 'Your ticket type does not include certificate access. Please contact the organizer or upgrade your ticket.',
      certificateCreated: 'Certificate created!',
      certificateReady: 'Certificate ready',
      pdfReady: 'PDF certificate is ready for download!',
      pdfGenerationTimeout: 'PDF generation took too long. Please try again.',
      pdfGenerationFailed: 'Failed to generate PDF. Please try again.',

      // Report wrong template
      reportWrongTemplate: 'Something wrong with the certificate?',
      reportSending: 'Sending...',
      reportSent: 'The organizer has been notified. Thank you for letting them know!',
      reportFailed: 'Failed to send report. Please try again.',
      reportDialogTitle: 'Certificate template issue?',
      reportDialogRegenerateHint: 'Try regenerating your certificate first – the template may have already been updated by the organizer.',
      reportDialogRegenerateBtn: 'Regenerate certificate',
      reportDialogAlreadyRegenerated: 'Already regenerated and still looks wrong?',
      reportDialogBody: "If your certificate doesn't look quite right – for example, the layout seems off, text is missing, or the design doesn't match what you expected – this is most likely related to the certificate template set up by the event organizer.",
      reportDialogCta: 'Would you like us to send a notification to the organizer? They will receive a message that there may be an issue with the certificate template and will be able to review and fix it.',
      reportDialogConfirm: 'Yes, notify organizer',
      reportDialogCancel: 'Cancel',
      reportDialogContactAlt: 'Alternatively, you can contact the organizer directly:',
      reportDialogLoadingOrganizer: 'Loading...',

      // Builder View
      builderNoEditPermissionEvent: 'You do not have permission to edit this event',
      builderNoEditPermissionCourse: 'You do not have permission to edit this course',
      builderLoadingError: 'Error loading data',
      builderSaveError: 'Error saving data',
      builderSaveSuccess: 'Certificate settings saved!',
    },

    // Test Taking
    testTaking: {
      testCompleted: 'Test Completed',
      score: 'Score',
      passed: 'Passed',
      failed: 'Failed',
      errorSubmitting: 'Error submitting test',
      question: 'Question',
      of: 'of',
      answerPlaceholder: 'Type your answer here...',
      submitting: 'Submitting...',
      submitTest: 'Submit Test',
      pointOne: 'point',
      pointFew: 'points',
      pointMany: 'points',
    },

    // Survey Taking
    surveyTaking: {
      submittedSuccessfully: 'Survey submitted successfully',
      errorSubmitting: 'Error submitting survey',
      answerPlaceholder: 'Type your answer here...',
      submitting: 'Submitting...',
      submitSurvey: 'Submit Survey',
      question: 'Question',
      anonymousSurvey: 'This survey is anonymous.',
    },

    // Certificate Components
    certificateComponents: {
      certificateDetails: 'Certificate Details',
      certificatePreview: 'Certificate Preview',
      pleaseAllowPopups: 'Please allow pop-ups to generate PDF',
      failedToGeneratePDF: 'Failed to generate PDF',
      verificationLinkCopied: 'Certificate verification link copied to clipboard!',
      failedToLoadCertificate: 'Failed to load certificate',
      pleaseAllowPopupsDownload: 'Please allow pop-ups to download the certificate',
      failedToDownloadCertificate: 'Failed to download the certificate',
      failedToGenerateCertificateRetry: 'Failed to generate certificate. Please try again.',
      enterYourAnswer: 'Enter your answer...',
      enterYourResponse: 'Enter your response...',
    },

    // Fix Profile Page
    fixProfile: {
      updateProfile: 'Update Profile',
      updateYourProfile: 'Update your profile information',
      firstName: 'First Name',
      lastName: 'Last Name',
      phone: 'Phone',
      updating: 'Updating...',
      updateButton: 'Update Profile',
      profileUpdated: 'Profile updated successfully!',
      redirecting: 'Redirecting...',
      errorUpdating: 'Error updating profile',
    },

    // Event Creation
    eventCreation: {
      createNewEvent: 'Create New Event',
      createEvent: 'Create Event',
      editEvent: 'Edit Event',
      basicInformation: 'Basic Information',
      basicInformationDescription: 'Core details about your event',
      locationFormat: 'Location & Format',
      locationFormatDescription: 'When and where the event takes place',
      organizerInformationDescription: 'Contact information for the event organizer',
      settingsAndPricing: 'Settings & Pricing',
      settingsAndPricingDescription: 'Configure event settings',
      speakersPartners: 'Speakers & Partners',
      speakersPartnersDescription: 'Add speaker information and partner organizations (optional)',
      speakers: 'Speakers',
      partners: 'Partners',
      hasPartners: 'Event has partners',
      partnerOrganization: 'Partner organization',
      enterPartnerOrganizations: 'Enter partner organizations',
      partnerOrganizationsDescription: 'Specify organizations or institutions that are event partners',
      saveEventFirstForPartners: 'Save the event first',
      saveEventFirstForPartnersDescription: 'To add partners with logos and additional information, first save the basic event information.',
      complete: 'Complete',
      selected: 'Selected',
      eventPreview: 'Event preview',
      onlineFormat: 'Remote participation in real-time',
      displayParticipantCount: 'Display the number of registered participants on the event page',
      cpdCreditsDescription: 'Continuing professional development credits',
      privateEventLabel: 'Private Event',
      privateEventDescription: 'Private events are not listed publicly and require an invitation link',
      showParticipantCountLabel: 'Show participant count',
      showParticipantCountDescription: 'Display the number of registered participants on the event page',
      showTargetSpecialtiesLabel: 'Show target audience on event page',
      showTargetSpecialtiesDescription: 'Display selected specialties on the public event page',
      certificateTemplateSection: 'Certificate Template',
      advancedFeatures: 'Advanced Features',
      advancedFeaturesDescription: 'Optional features to enhance your event',
      testsSection: 'Tests & Assessments',
      testsDescription: 'Add tests for participants (optional)',
      surveysSection: 'Surveys',
      surveysDescription: 'Collect feedback from participants (optional)',
      materialsSection: 'Materials',
      materialsDescription: 'Upload program and additional materials (optional)',
      ticketsSection: 'Tickets',
      ticketsDescription: 'Configure tickets for participant registration (optional)',
      additionalQuestionsSection: 'Additional Questions',
      additionalQuestionsDescription: 'Add extra questions beyond basic profile fields (optional)',
      mozSubmissionSection: 'CPD',
      navigation: 'Navigation',
      fillInRequired: 'Fill in',
      requiredToFillIn: 'Required to fill in',
      pleaseFirstSaveEvent: 'Please save the basic event information first to access additional options.',
      saveFirstMessage: 'Save basic event information first',
      testsAvailableAfter: 'Tests available after saving',
      surveysAvailableAfter: 'Surveys available after saving',
      materialsAvailableAfter: 'Additional materials available after saving',
      eventInformation: 'Event Information',
      eventName: 'Event Theme',
      titleRequired: 'Enter event theme to save',
      enterEventName: 'Enter event theme...',
      targetAudience: 'Target Specializations',
      selectTargetAudience: 'Select target audience...',
      eventType: 'Event Type (optional)',
      selectEventType: 'Select event type...',
      eventLocation: 'Event Location',
      eventFormat: 'Event Format',
      offline: 'Offline',
      online: 'Online',
      onlineEventUrl: 'Online Event URL',
      enterOnlineEventUrl: 'Enter online event URL...',
      onlineEventUrlHint: 'Provide the link to the platform where the event will take place (e.g., Zoom, Google Meet)',
      physicalLocation: 'Event Venue',
      locationCountry: 'Country',
      locationCountryPlaceholder: 'Select country',
      locationRegion: 'Region',
      locationRegionPlaceholder: 'Enter region...',
      locationRegionSelectPlaceholder: 'Select region',
      locationRegionSelectCountryFirst: 'Select a country first',
      locationDistrict: 'District',
      locationDistrictPlaceholder: 'Enter district...',
      locationCity: 'City',
      locationCityPlaceholder: 'Enter city...',
      locationStreet: 'Street',
      locationStreetPlaceholder: 'Enter street name...',
      locationBuilding: 'Building',
      locationBuildingPlaceholder: 'Enter building number...',
      locationAuditorium: 'Auditorium/Hall',
      locationAuditoriumPlaceholder: 'Enter auditorium number or hall name...',
      dateAndTime: 'Event Date and Time',
      timezone: 'Timezone',
      timezoneHelper: 'Event time. Viewers will see times in their local timezone',
      timezoneOther: 'Other',
      timezoneOtherPlaceholder: 'e.g. America/New_York',
      startDate: 'Start Date',
      startsAt: 'Starts At',
      endDate: 'End Date',
      endsAt: 'Ends At',
      selectStartDateTime: 'Select start date and time',
      selectEndDateTime: 'Select end date and time',
      startDateRequired: 'Start date is required',
      endDateRequired: 'End date is required',
      invalidStartDate: 'Invalid start date. Please enter a valid date.',
      invalidEndDate: 'Invalid end date. Please enter a valid date.',
      endDateBeforeStartError: 'End date cannot be earlier than start date',
      organizerInformation: 'Organizer',
      organizerName: 'Event Organizer',
      enterOrganizerName: 'Enter organizer name...',
      organizerEmail: 'Organizer Email',
      enterOrganizerEmail: 'Enter email...',
      organizerPhone: 'Organizer Phone',
      enterOrganizerPhone: 'Enter phone number...',
      organizerPhoneRequired: 'Organizer phone is required',
      organizerDescription: 'Organizer Description',
      enterOrganizerDescription: 'Tell us about the organizer, their experience and field of activity...',
      organizerDescriptionHint: 'Brief information about the organizer (optional)',
      organizerWebsite: 'Organizer Website',
      enterOrganizerWebsite: 'https://example.com',
      organizerWebsiteHint: 'Organizer\'s website URL',
      organizerFacebook: 'Organizer Facebook',
      enterOrganizerFacebook: 'https://facebook.com/...',
      organizerFacebookHint: 'Organizer\'s Facebook page',
      browseOrganizers: 'Organizers',
      noOrganizerYet: 'No organizer added yet',
      createNew: 'Create New',
      changeOrganizer: 'Change Organizer',
      createNewOrganizer: 'Create Organizer',
      createNewOrganizerDescription: 'Fill out the form to add a new organizer to your list',
      website: 'Website',
      organizerNameRequired: 'Required field',
      organizerEmailRequired: 'Required field',
      organizerSaved: 'Organizer saved',
      invalidEmail: 'Invalid email format',
      bprPointsError: 'BPR points must be between 0 and 1000',
      meetingUrlError: 'Please enter a valid URL (e.g., https://example.com)',
      phoneError: 'Please enter a valid phone number (min 10 digits)',
      websiteUrlError: 'Please enter a valid URL (e.g., https://example.com)',
      facebookUrlError: 'Please enter a valid URL (e.g., https://facebook.com/...)',
      selectOrganizerToAutofill: 'Select an organizer to autofill information',
      searchOrganizers: 'Search by name, email, phone...',
      noOrganizersFound: 'No organizers found',
      noOrganizers: 'No saved organizers',
      quickFillOrganizer: 'Quick Fill',
      selectExistingOrganizer: 'Select an organizer from the list to automatically fill in the details',
      organizerImage: 'Organizer Image',
      organizerImageDescription: 'Logo or photo of the organizer/organization',
      uploadOrganizerImage: 'Upload Organizer Image',
      addOrganizer: 'Add',
      editOrganizer: 'Edit Organizer',
      addNewOrganizer: 'New Organizer',
      errorFetchingOrganizers: 'Error loading organizers',
      organizerNameEmailRequired: 'Name and email are required',
      organizerUpdated: 'Organizer updated',
      organizerCreated: 'Organizer created',
      organizerSelected: 'Organizer selected',
      errorSavingOrganizer: 'Error saving organizer',
      errorSavingPayment: 'Error saving payment settings',
      confirmDeleteOrganizer: 'Are you sure you want to delete this organizer?',
      deleteOrganizer: 'Delete Organizer',
      organizerDeleted: 'Organizer deleted',
      errorDeletingOrganizer: 'Error deleting organizer',
      confirmReplaceOrganizer: 'Current organizer data will be deleted. Continue?',
      removeOrganizerConfirmTitle: 'Remove organizer from event?',
      removeOrganizerConfirmDescription: 'The organizer will be removed from this event. Organizer data will remain saved for use in other events.',
      removeOrganizerButton: 'Remove',
      // Program generator specific
      removeProgramOrganizerConfirmTitle: 'Remove organizer from program?',
      removeProgramOrganizerConfirmDescription: 'The organizer will be removed from the event program. Organizer data will remain saved for use in other events.',
      organizerManagement: {
        title: 'Organizers',
        manageTitle: 'Manage Organizers',
        manageDescription: 'Invite other people to help organize and manage this event. Organizers have the same permissions as you.',
        description: 'Manage who can organize and edit this',
        event: 'this event',
        course: 'this course',
        inviteOrganizer: 'Invite Organizer',
        emailAddress: 'Email Address',
        emailPlaceholder: 'organizer@example.com',
        sendInvite: 'Send Invite',
        sending: 'Sending...',
        cancel: 'Cancel',
        invitationNote: 'The person will receive an email invitation with a link to accept or decline.',
        currentOrganizers: 'Current Organizers',
        noOrganizersYet: 'No organizers yet.',
        owner: 'Owner',
        joined: 'Joined',
        pendingInvitations: 'Pending Invitations',
        sent: 'Sent',
        expires: 'Expires',
        expired: 'Expired',
        pending: 'Pending',
        pleaseEnterEmail: 'Please enter an email address',
        pleaseEnterValidEmail: 'Please enter a valid email address',
        invitationSentSuccessfully: 'Invitation sent successfully!',
        invitationCancelledSuccessfully: 'Invitation cancelled successfully!',
        failedToLoadOrganizers: 'Failed to load organizers',
        failedToSendInvitation: 'Failed to send invitation',
        failedToCancelInvitation: 'Failed to cancel invitation',
        // Remove organizer
        removeOrganizer: 'Remove organizer',
        removeOrganizerConfirmTitle: 'Remove organizer?',
        removeOrganizerConfirmDescription: '{{name}} will be removed from the organizers list. They will no longer be able to edit or manage this content.',
        removeButton: 'Remove',
        cancelButton: 'Cancel',
        organizerRemovedSuccessfully: 'Organizer removed successfully',
        failedToRemoveOrganizer: 'Failed to remove organizer',
      },
      imageAndDescription: 'Event Image & Description',
      mainEventImage: 'Main Event Image (optional)',
      imageOptionalHint: 'If you don\'t upload an image, a generic placeholder will be used',
      clickToUpload: 'Click to upload image',
      shortDescription: 'Event Description',
      enterShortDescription: 'Enter description...',
      programHint: 'Detailed program or agenda of your event',
      enterEventProgram: 'Enter event program...',
      linksAndVisibility: 'Event Links & Visibility (optional)',
      eventWebsite: 'Event Website',
      enterEventWebsite: 'Enter website URL...',
      facebookPage: 'Event Facebook Page',
      enterFacebookPage: 'Enter Facebook page URL...',
      privateEvent: 'This is a private event. Private events are not visible in our catalog, they are accessible only via link',
      linkToEvent: 'Link to Event',
      showParticipantCount: 'Show registered participant count (Count will be displayed on the event page)',
      bprPoints: 'Amount of BPR Points',
      enterBprPoints: 'Enter points amount...',
      eventCost: 'How much does the event cost',
      enterEventCost: 'Enter cost...',
      free: 'Free',
      saveEvent: 'Save Event',
      saving: 'Saving...',
      saveFailed: 'Failed to save event',
      eventSavedSuccessfully: 'Event saved successfully!',
      eventUpdatedSuccessfully: 'Event updated successfully!',
      conflictDetected: 'Conflict Detected',
      conflictMessage: 'This event was modified in another tab or browser since you opened it. Saving now will overwrite the newer version.',
      loadLatest: 'Load Latest',
      keepMine: 'Keep Mine',
      saveAnyway: 'Overwrite',
      conflictCancel: 'Cancel',
      eventPublishedSuccessfully: 'Event published successfully!',
      eventUnpublishedSuccessfully: 'Event unpublished successfully!',
      readyToPublish: 'Ready to publish!',
      completeToPublish: 'To publish, complete:',
      sectionsIncomplete: 'sections incomplete',
      publishRequirements: {
        title: 'Event title',
        targetSpecialties: 'Target audience',
        startDate: 'Start date',
        endDate: 'End date',
        location: 'Location',
        meetingUrl: 'Meeting URL',
        locationAndMeetingUrl: 'Location and meeting URL',
        organizer: 'Organizer',
        speakers: 'At least one speaker',
        paymentCredentials: 'Payment credentials for organizer',
      },
      paymentConfigured: 'Payment configured',
      paymentNotConfigured: 'Payment not configured',
      setupPayment: 'Set up →',
      errorSavingEvent: 'Error saving event',
      preview: 'Preview',
      previewDescription: 'This is how your event will appear to visitors',
      previewNote: 'Enrolled User View',
      previewNoteDescription: 'This preview shows all content that enrolled users will have access to throughout the event.',
      untitledEvent: 'Untitled Event',
      noImageUploaded: 'No image uploaded',
      requiredFieldsMissing: 'Required fields are missing',
      pleaseEnterEventName: 'Please enter event name',
      pleaseSelectTargetAudience: 'Please select target audience',
      pleaseEnterLocation: 'Please enter location',
      pleaseEnterOrganizerName: 'Please add an organizer',
      pleaseEnterOrganizerEmail: 'Please enter organizer email',
      invalidEmailFormat: 'Invalid email format',
      testAndSurvey: 'Test & Survey',
      test: 'Test',
      survey: 'Survey',
      manageTest: 'Manage Test',
      manageSurvey: 'Manage Survey',
      hideTest: 'Hide Test',
      hideSurvey: 'Hide Survey',
      unsavedChanges: 'Unsaved Changes',
      unsavedChangesWarning: 'You have unsaved changes. Are you sure you want to close? All unsaved changes will be lost.',
      discardChanges: 'Discard Changes',
      saveFailedRetrying: 'Save failed. Retrying in {{seconds}}s... (Attempt {{attempt}}/{{max}})',
      saveFailedAllRetries: 'Save failed after all retry attempts',
      paymentCredentialsRequired: 'Payment credentials not configured. To create a paid event/course, please configure your payment credentials in organizer settings.',
      configurePaymentSettings: 'Configure payment settings',
    },

    // Event Test & Survey Management
    eventTestSurvey: {
      deleteSurvey: 'Delete Survey',
      deleteSurveyConfirmation: 'Are you sure you want to delete this survey? All questions associated with it will also be deleted. This action cannot be undone.',
      deleteSurveyConfirmationWithResponses: 'This survey has already been answered by {{count}} participants. Deleting it will permanently destroy the survey together with all responses. This action cannot be undone. Continue?',
      deleteSurveyFailed: 'Failed to delete survey. Please try again.',
      deleteSurveyBlocked: 'You do not have permission to delete this survey.',
      deleteSurveySuccess: 'Survey deleted',
      deleteQuestionFailed: 'Failed to delete question. Please try again.',
      deleteLastQuestionConfirmation: 'This is the last question in the survey. With no questions the survey will not be shown to participants until you add one. Continue?',
      titleRequired: 'Enter a survey title',
      atLeastOneQuestionRequired: 'Add at least one question - a survey with no questions is not shown to participants',
      allQuestionsNeedText: 'Fill in the text of every question',
      disableSurvey: 'Disable survey',
      enableSurvey: 'Enable survey',
      surveyDisabled: 'Survey disabled - participants no longer see it',
      surveyEnabled: 'Survey enabled',
      toggleActiveFailed: 'Failed to change the survey status. Please try again.',
      disabled: 'Disabled',
      noQuestionsBadge: 'No questions',
      responsesBadge: 'Responses: {{count}}',
      testDescription: 'You can add one test for this event. Tests will only be available to participants after the event ends.',
      surveyDescription: 'You can add one survey for this event. Surveys can be configured to be available before or after the event.',
      addTest: 'Add Test',
      addSurvey: 'Add Survey',
      loadingTests: 'Loading tests...',
      loadingSurveys: 'Loading surveys...',
      noTestsYet: 'No tests yet',
      noSurveysYet: 'No surveys yet',
      selectTest: 'Select a test to view and edit questions',
      selectSurvey: 'Select a survey to view and edit questions',
      noMaterialsYet: 'No materials yet',
      noQuestionsYet: 'No questions yet',
      testSettings: 'Test Settings',
      surveySettings: 'Survey Settings',
      edit: 'Edit',
      save: 'Save',
      cancel: 'Cancel',
      type: 'Type',
      passingScore: 'Passing Score',
      timeLimit: 'Time Limit',
      maxAttempts: 'Max Attempts',
      available: 'Available',
      noLimit: 'No limit',
      minutes: 'minutes',
      afterEventEnds: 'After event ends',
      anytime: 'Anytime',
      availableFrom: 'Available from',
      availableUntil: 'Available until',
      selectDateTime: 'Select date and time',
      noExpiration: 'No expiration',
      questions: 'Questions',
      addQuestion: 'Add Question',
      question: 'Question',
      points: 'Points',
      explanation: 'Explanation',
      optional: 'optional',
      answerOptions: 'Answer Options',
      addOption: 'Add Option',
      title: 'Title',
      description: 'Description',
      anonymous: 'Anonymous',
      required: 'Required',
      anonymousResponses: 'Anonymous responses',
      requiredSurvey: 'Required survey',
      requiredTest: 'Required test for certificate',
      onlyAvailableAfterEventEnds: 'Only available after event ends',
      yes: 'Yes',
      no: 'No',
      options: 'Options',
      afterEventOnly: 'After Event Only',
      testTypes: {
        preAssessment: 'Pre-Assessment',
        knowledgeCheck: 'Knowledge Check',
        finalExam: 'Final Exam',
      },
      questionTypes: {
        shortText: 'Short Text',
        singleChoice: 'Single Choice',
        multipleChoice: 'Multiple Choice',
        trueFalse: 'True/False',
        essay: 'Essay',
        textResponse: 'Text Response',
      },
      addVideoLinks: 'Add video links, upload PDFs, or add other resources for this event',
      addVideoLink: 'Add Video Link',
      addPDF: 'Add PDF',
      materials: 'Materials',
      certificateTemplate: 'Certificate Template',
      certificateTemplateHTML: 'Certificate Template',
      certificateTemplatePlaceholder: 'Enter HTML template for certificate or leave empty for default template...',
      usePlaceholders: 'Use placeholders',
      saveEventFirst: 'Save event details first',
      saveEventFirstDesc: 'Click "Save Event" below to save your event details, then you\'ll be able to add tests, surveys, and materials.',
      deleteTest: 'Delete Test',
      deleteTestConfirmation: 'Are you sure you want to delete this test? All questions associated with this test will also be deleted. This action cannot be undone.',
      deleteTestConfirmationNoAttempts: 'No one has taken this test yet. The test and all its questions will be deleted. Continue?',
      deleteTestConfirmationWithAttempts: 'This test has been taken by {{total}} participants ({{passed}} passed). Deleting will permanently remove all attempt records. Issued certificates will not be affected. Are you sure?',
      deleteQuestion: 'Delete Question',
      deleteQuestionConfirmation: 'Are you sure you want to delete this question? This action cannot be undone.',
      delete: 'Delete',
      createTest: 'Create Test',
      createSurvey: 'Create Survey',
      saving: 'Saving...',
      enterTestTitle: 'Enter test title',
      enterSurveyTitle: 'Enter survey title',
      enterQuestion: 'Enter question text',
      enterOption: 'Enter answer option',
      noQuestionText: 'No question text',
      emptyOption: 'Empty option',
      true: 'True',
      false: 'False',
      validationTitle: 'Attention',
      validationEnterQuestion: 'Please enter the question text and at least two answer options.',
      validationMinOptions: 'Please enter at least two answer options.',
      validationSelectCorrect: 'Please select the correct answer.',
      validationMinOneQuestion: 'Please add at least one question with text and answer options.',
      saveFailed: 'Failed to save test questions. Please try again.',
      deleteFailed: 'Failed to delete test. Please try again.',
      editTest: 'Edit Test',
      shuffleQuestions: 'Shuffle questions',
      shuffleOptions: 'Shuffle answer options',
      // Post-event notification info
      notificationInfo: {
        title: 'Automatic participant notification',
        description: 'After the event ends, participants will automatically receive an email notification that tests and surveys are now available.',
        timing: 'Notifications are sent within 15 minutes after the event end time.',
        endTimeWarning: 'Make sure the event end date and time are set correctly!',
        checkEndTime: 'Check the end time in the "Basic Information" section.',
      },
    },

    // Streaming functionality
    // In-platform video recording page
    recording: {
      watch: 'Watch recording',
      notFound: 'Recording not found',
      loginRequired: 'Sign in to watch this recording',
      notEnrolled: 'This recording is available to registered participants only',
      ticketRestricted: 'Your ticket does not include access to materials',
      upcoming: 'This recording is not available yet. Available from:',
      closed: 'Access to this recording has ended:',
      signIn: 'Sign in',
      backToEvent: 'Back to event',
    },

    streaming: {
      // Event Builder Streaming Section
      sectionTitle: 'Live Streaming',
      sectionDescription: 'Configure live stream for your event with chat',
      embedUrlLabel: 'Stream Embed URL (iframe src)',
      embedUrlPlaceholder: 'https://youtube.com/embed/... or https://vimeo.com/...',
      embedUrlHint: 'Enter the embed URL for your stream (YouTube, Vimeo, or custom iframe source)',
      linkReadyTitle: 'Stream Link Ready!',
      linkReadyDescription: 'Share this link with your attendees to watch the stream and participate in live chat:',
      copyLinkButton: 'Copy Stream Link',
      linkCopiedToast: 'Stream link copied to clipboard!',

      // Stream Page
      loadingStream: 'Loading stream...',
      liveStreamSubtitle: 'Live Stream',
      liveStreamTitle: 'Live Stream',
      liveStreamFeature: 'the live stream',
      noStreamAvailable: 'No stream available',
      live: 'LIVE',
      watching_one: 'watching',
      watching_other: 'watching',
      theaterMode: 'Theater mode',
      exitTheaterMode: 'Exit theater mode',
      chat: 'Chat',

      // Live Chat
      chatHeader: 'Live Chat',
      messageCount_one: '{{count}} message',
      messageCount_other: '{{count}} messages',
      message: 'message',
      messages: 'messages',
      noMessagesYet: 'No messages yet',
      beFirstToChat: 'Be the first to say something!',
      deleteMessageButton: 'Delete message',
      messageDeleted: 'Message deleted',

      // Message Input
      messagePlaceholder: 'Type a message...',
      sendMessage: 'Send a message...',
      characterCount: '{{count}}/500 characters',
      joinConversation: 'Join the conversation',
      signInToParticipate: 'Sign in to participate in live chat',
      signInToChat: 'Sign In to Chat',
      loginPrompt: 'Please log in to participate in the chat',
      loginButton: 'Log In',

      // Error Messages
      eventNotFound: 'Event not found',
      noStreamConfigured: 'This event does not have a live stream configured',
      failedToLoadEvent: 'Failed to load event',
      pleaseLoginToChat: 'Please log in to chat',
      messageTooLong: 'Message is too long (max 500 characters)',
      failedToSendMessage: 'Failed to send message',
      failedToDeleteMessage: 'Failed to delete message',
      invalidStreamUrl: 'Invalid stream URL. Only YouTube and Vimeo videos can be embedded.',
      onlyYoutubeVimeo: 'For security reasons, only YouTube and Vimeo videos can be embedded.',

      // Builder View
      builderTitle: 'Live Streaming',
      builderDescription: 'Configure live streaming for your event',
      urlLabel: 'Embed URL (YouTube or Vimeo)',
      urlPlaceholder: 'https://www.youtube.com/watch?v=...',
      urlHint: 'Paste a YouTube or Vimeo video link for streaming',
      participantLinkReady: 'Participant link ready',
      shareWithParticipants: 'Share this link with participants to watch the stream',
      copy: 'Copy',
      noEditPermission: 'You do not have permission to edit this event',
      loadingError: 'Error loading data',
      saveError: 'Error saving data',
      saveSuccess: 'Streaming settings saved!',
      invalidUrlFormat: 'Invalid URL format',
      linkCopied: 'Link copied!',
      loading: 'Loading...',
      saving: 'Saving...',
      save: 'Save',
    },

    // UI Components
    ui: {
      languageSwitcher: {
        english: 'English',
        ukrainian: 'Ukrainian',
        toggleMenu: 'Toggle menu',
      },
      search: {
        emergencyMedicine: 'Emergency Medicine',
        surgery: 'Surgery',
        internalMedicine: 'Internal Medicine',
        cardiology: 'Cardiology',
        pediatrics: 'Pediatrics',
        radiology: 'Radiology',
        anesthesiology: 'Anesthesiology',
        neurology: 'Neurology',
        anyFormat: 'Any Format',
        inPerson: 'In-Person',
        online: 'Online',
        hybrid: 'Hybrid',
        selfPaced: 'Self-Paced',
        popularSearches: 'Popular searches:',
        acls: 'ACLS',
        bls: 'BLS',
        surgeryUpdates: 'Surgery Updates',
        mentalHealth: 'Mental Health',
        pediatricEmergency: 'Pediatric Emergency',
      },
      courseCard: {
        coursePreview: 'Course Preview',
        imageBlock: 'Image Block',
      },
      currency: {
        label: 'Currency',
        switchTitle: 'Change the event currency?',
        switchDescription: 'An event can have only one currency. Change it to {{currency}} for all tickets and promocodes?',
        lockedHint: 'The currency can’t be changed: there are already payments',
        merchantHint: 'Make sure your WayForPay/LiqPay merchant accepts this currency',
        locked: 'The currency can’t be changed: there are already payments',
        copyCurrencyTitle: 'Tickets in another currency',
        copyLocked: 'Tickets were copied in the event currency ({{currency}}). Check the prices.',
        copyMixed: 'The selected tickets use different currencies. Prices will be copied as numbers in the event currency.',
      },
      tickets: {
        description: 'Tickets can be free or paid.',
        addTicket: 'Add Ticket',
        newTicket: 'New Ticket',
        editTicket: 'Edit Ticket',
        noTicketsYet: 'No tickets yet',
        addFirstTicket: 'Add your first ticket to start selling.',
        ticketName: 'Ticket Name',
        ticketNamePlaceholder: 'E.g., Early Bird, VIP Ticket, Standard Ticket',
        ticketDescription: 'Ticket Description',
        descriptionPlaceholder: 'Describe what is included in this ticket...',
        ticketType: 'Ticket Type',
        free: 'Free',
        paid: 'Paid',
        price: 'Price',
        quantity: 'Quantity',
        unlimitedQuantity: 'Unlimited',
        quantityHint: 'Leave empty for unlimited quantity',
        status: 'Status',
        statusAvailable: 'Available',
        statusSoldOut: 'Sold Out',
        statusDiscontinued: 'Discontinued',
        saleStartDate: 'Sale Start Date',
        saleStartHint: 'Optional: Choose when sales start',
        saleEndDate: 'Sale End Date',
        saleEndHint: 'Optional: Choose when sales end',
        sold: 'Registered',
        remaining: 'Remaining',
        unlimited: 'Unlimited',
        salePeriod: 'Sale Period',
        startsAt: 'Starts',
        endsAt: 'Ends',
        confirmDelete: 'Are you sure you want to delete this ticket?',
        confirmDeleteDescription: 'Deleting this ticket will remove it from attendee view and cannot be undone.',
        deleteSuccess: 'Ticket deleted successfully',
        deleteError: 'Failed to delete ticket',
        saveEventFirst: 'Please save the event first before adding tickets.',
        createTicketError: 'Failed to create ticket: ',
        requiresPromocode: 'Hidden. Registration only by promocode',
        requiresPromocodeHint: 'Users will be able to see and purchase this ticket only after entering a promocode',
        requiresPromocodeLabel: 'Requires promocode:',
        selectPromocode: 'Select Promocode',
        selectPromocodeOption: '-- Select a promocode --',
        noPromocodes: 'No promo codes available.',
        noPromocodesLink: 'Click here to create a new promo code now.',
        noPromocodesAfter: 'You can configure it later in the Promo Codes menu section.',
        promococeNotFound: 'Promocode not found',
        noPromocodeSelected: 'No promocode selected',
        // Ticket Permissions
        ticketPermissions: 'Ticket Permissions',
        allowCertificate: 'Allow certificate generation',
        certificateTypes: 'Certificate Types',
        certificateTypesHint: 'Select which certificate types holders of this ticket can receive',
        certificateTypeParticipant: 'Participant Certificate',
        certificateTypeSpeaker: 'Speaker Certificate',
        allowMaterials: 'Allow materials access',
        allowStream: 'Allow stream access',
        permissionsHint: 'Uncheck permissions to restrict access for users with this ticket type',
        // Custom Fields
        customFields: 'Additional Ticket Questions',
        addField: '+ Add Field',
        noCustomFields: 'No custom fields yet',
        addCustomFieldsHint: 'Add fields to collect information during registration',
        fieldNumber: 'Field',
        fieldType: 'Field Type',
        fieldLabel: 'Field Label',
        fieldLabelPlaceholder: 'e.g., Company Name, Dietary Requirements, etc.',
        placeholderText: 'Placeholder Text',
        placeholderHint: 'Enter hint text for the user...',
        requiredField: 'Required field',
        options: 'Options',
        addOption: '+ Add Option',
        noOptionsYet: 'No options yet. Click "Add Option" to add choices',
        optionPlaceholder: 'Option',
        allowedFileTypes: 'Allowed File Types',
        selectFileTypes: 'Select which file types users can upload',
        maxFileSize: 'Max File Size (MB)',
        maxFileSizeHint: 'Maximum: 50 MB',
        preview: 'Preview:',
        previewLabel: 'Preview',
        hint: 'Hint',
        fieldTypes: {
          text: 'Short Text',
          essay: 'Essay',
          singleChoice: 'Single Choice',
          multipleChoice: 'Multiple Choice',
          trueFalse: 'True/False',
          file: 'File Upload',
        },
        previewPlaceholders: {
          text: 'Enter text...',
          essay: 'Enter your response...',
          option1: 'Option 1',
          option2: 'Option 2',
          yes: 'Yes',
          no: 'No',
          fileUpload: 'Click to upload or drag and drop',
          allowedFiles: 'Allowed',
        },
        // Ticket Browser
        browseTickets: 'Browse Tickets from Other Events',
        browseTicketsShort: 'Browse Tickets',
        browseDescription: 'Select tickets from your other events to reuse them here',
        searchPlaceholder: 'Search events or tickets...',
        noTicketsFound: 'No tickets found',
        noOtherEvents: 'No tickets available from other events',
        tryDifferentSearch: 'Try a different search term',
        createTicketsInOtherEvents: 'Create tickets in your other events to reuse them here',
        ticketsSelected: 'ticket(s) selected',
        noTicketsSelected: 'No tickets selected',
        copyTickets: 'Copy Tickets',
        copying: 'Copying...',
        copiedSuccess: 'Tickets copied successfully',
        copyError: 'Failed to copy tickets',
        selectTicketsWarning: 'Please select at least one ticket',
        fetchError: 'Failed to load tickets',
        certificate: 'Certificate',
        tests: 'Tests',
        surveys: 'Surveys',
        customFieldsShort: 'custom fields',
        // Free ticket notification
        freeTicketNotice: 'Note: Free ticket',
        freeTicketNoticeDescription: 'You have a free ticket. If you want to make access paid-only, delete all free tickets.',
        // Free ticket publish confirmation
        freeTicketConfirmTitle: 'Free Access',
        freeTicketConfirmDescription: 'You have a free ticket. This means users will be able to register for free. If you want to make access paid-only, delete the free tickets first.',
        freeTicketConfirmPublish: 'Publish with free access',
        freeTicketConfirmCancel: 'Configure tickets',
        // No tickets publish confirmation
        noTicketsConfirmTitle: 'No Tickets Configured',
        noTicketsConfirmDescription: 'You have no tickets configured. This means users will be able to register for free. If you want to make access paid-only, create paid tickets first.',
        noTicketsConfirmPublish: 'Publish with free access',
        noTicketsConfirmCancel: 'Configure tickets',
      },
      promocodes: {
        description: 'Create promocodes for ticket discounts',
        addPromocode: 'Add Promocode',
        newPromocode: 'New Promocode',
        editPromocode: 'Edit Promocode',
        noPromocodesYet: 'No promocodes yet',
        addFirstPromocode: 'Add your first promocode for discounts',
        promocodeName: 'Promocode name',
        promocodeNamePlaceholder: 'e.g., freeenterall',
        promocodeType: 'Promocode type',
        percentage: '%',
        discountAmount: 'Discount amount',
        usageLimit: 'Promocode can be used:',
        unlimited: 'Unlimited',
        limitedTimes: 'Limited number of times',
        timesLabel: 'times',
        validFrom: 'Promocode valid from:',
        now: 'Now',
        selectDateTime: 'Select date and time',
        validUntil: 'Promocode valid until:',
        untilEventEnd: 'No expiry',
        confirmDelete: 'Are you sure you want to delete this promocode?',
        confirmDeleteDescription: 'Deleting this promocode will make it unavailable for attendees. This action cannot be undone.',
        code: 'Code',
        discount: 'Discount',
        used: 'Used',
        status: 'Status',
        active: 'Active',
        expired: 'Expired',
        depleted: 'Depleted',
        dateTimePlaceholder: 'dd.mm.yyyy, hh:mm',
        deleteSuccess: 'Promocode deleted successfully',
        deleteError: 'Failed to delete promocode',
        // Creation/Update errors
        createError: 'Failed to create promocode: ',
        quickCreateSuccess: 'Promo code created and linked to this ticket.',
        duplicateCode: 'A promocode with this code already exists for this event. Please choose a different code.',
        updateError: 'Failed to update promocode: ',
        // Validation API messages
        emptyCode: 'Please enter a promocode',
        notFound: 'This promocode doesn\'t exist. Check for typos.',
        notYetValid: 'This code will be valid starting {validFrom}',
        codeExpired: 'This code expired on {validUntil}',
        limitReached: 'This code has reached its usage limit ({usageCount}/{usageLimit} used)',
        validationError: 'Error validating promocode. Please try again.',
        noEffects: 'This promocode is valid but has no active discounts or unlocks configured.',
        applied: 'Promocode "{code}" applied!',
        unlockedTickets: 'Unlocked tickets: {count}',
        unlockedSpecialTickets: 'Unlocked special tickets: {count}',
        discountApplied: '{discountText} applied',
        formatError: 'Promocode can only contain letters, numbers, and hyphens',
        formatHint: 'Use letters, numbers, and hyphens (e.g., Promo-2024). Case-insensitive when redeeming',
      },
    },

    // Profile Page
    profile: {
      backToHomepage: 'Back to Homepage',
      myProfile: 'My Profile',
      managePersonalInfo: 'Manage your personal information',
      editProfile: 'Edit Profile',
      edit: 'Edit',
      cancel: 'Cancel',
      save: 'Save',
      saveChanges: 'Save Changes',
      saving: 'Saving...',
      loadingProfile: 'Loading profile...',
      basicInformation: 'Basic Information',
      firstName: 'First Name',
      lastName: 'Last Name',
      patronymic: 'Patronymic',
      email: 'Email',
      emailChangeButton: 'Change email',
      emailChangeNewLabel: 'New email',
      emailChangeNewPlaceholder: 'Enter new email',
      emailChangeSubmit: 'Send confirmation',
      emailChangeSending: 'Sending...',
      emailChangeConfirmationSent: 'Confirmation email sent to both old and new addresses. Check both inboxes.',
      emailChangePendingConfirmation: 'Pending email change confirmation',
      emailChangePendingFor: 'Changing to:',
      emailChangeFirstConfirmed: 'One address confirmed. Check your other inbox and click the link to complete the change.',
      emailChangeSuccess: 'Email changed successfully',
      emailChangeFailed: 'Failed to change email',
      emailChangeInvalidEmail: 'Please enter a valid email',
      emailChangeSameEmail: 'New email is the same as current',
      emailChangeAlreadyInUse: 'This email is already in use',
      emailChangeRateLimit: 'Too many attempts. Try again later.',
      emailChangeDoubleConfirmHint: 'For security, the change must be confirmed on both email addresses.',
      emailChangeCancel: 'Cancel change',
      emailChangeCancelling: 'Cancelling...',
      emailChangeCancelled: 'Email change cancelled',
      emailChangeCancelFailed: 'Failed to cancel email change',
      emailChangeEnterDifferent: 'Change address',
      phone: 'Phone',
      country: 'Country',
      selectCountry: 'Select country',
      region: 'Region',
      selectRegion: 'Select region',
      enterRegion: 'Enter region',
      selectCountryFirst: 'Select country first',
      city: 'City',
      address: 'Address',
      postalCode: 'Postal Code',
      dateOfBirth: 'Date of Birth',
      professionalInformation: 'Professional Information',
      diplomaNumber: 'Diploma Number',
      specialty: 'Specialty',
      selectSpecialty: 'Select specialty',
      searchSpecialty: 'Search: name, group or "nurse"…',
      noSpecialtyFound: 'Nothing found',
      primarySpecialty: 'Primary specialty',
      specialtyInTraining: 'Specialty in training',
      secondarySpecialties: 'Additional specialties',
      addAnotherSpecialty: 'Add another specialty',
      makePrimary: 'Make primary',
      removeSpecialty: 'Remove',
      specifySpecialty: 'Specify your specialty',
      specifySpecialtyPlaceholder: 'For example: Optometry',
      position: 'Position',
      workplace: 'Workplace',
      healthcareRole: 'Your role in healthcare',
      unknownSpecialty: 'Choose a specialty from the list',
      roleOptions: {
        practitioner: 'Healthcare practitioner (physician, nurse, pharmacist, etc.)',
        student: 'Student, intern or resident',
        adjacent: 'Adjacent field: pharma, medtech, education, administration',
        none: "I don't work in healthcare",
      },
      academicDegree: 'Academic degree',
      academicDegreePlaceholder: 'Select academic degree',
      academicTitle: 'Academic title',
      academicTitlePlaceholder: 'Select academic title',
      notWorking: 'Not currently working',
      education: 'Education',
      educationOptions: {
        higherMedical: 'Higher medical',
        higherNonMedical: 'Higher non-medical',
        middleMedical: 'Middle medical',
        professionalTechnical: 'Professional-technical',
        other: 'Other',
      },
      specifyEducation: 'Specify your education',
      specifyEducationPlaceholder: 'For example: medical college',
      organizationName: 'Organization Name',
      organizationNameHint: '(used as organizer for courses and events)',
      organizationNamePlaceholder: 'E.g.: Medical Center "Health" or Your Name',
      courseSpecificInformation: 'Other Information',
      courseSpecificNote: 'Note:',
      profilePhoto: 'Profile Photo',
      photoHint: 'Click the camera icon to upload a new photo (max 5MB)',
      removePhoto: 'Remove photo',
      changePhoto: 'Change photo',
      courseSpecificNoteText: 'Course-specific information can be edited during enrollment or from the course page.',
      savedSuccessfully: 'Saved successfully',
      removePhotoConfirmTitle: 'Remove profile photo?',
      removePhotoConfirmMessage: 'Are you sure you want to remove your profile photo? This action cannot be undone.',
      selectImageFile: 'Please select an image file',
      imageSizeLimit: 'Image size should be less than 5MB',
      photoRemovedSuccessfully: 'Profile photo removed successfully',

      // Linked Accounts
      linkedAccounts: 'Linked Accounts',
      linkedAccountsDescription: 'Accounts you can use to sign in',
      noLinkedAccounts: 'No linked accounts',
      linkAccountInstructions: 'To link a Google account, sign out and sign back in with Google.',
      unlinkAccount: 'Unlink',
      unlinkAccountConfirmTitle: 'Unlink account?',
      unlinkAccountConfirmMessage: 'You will no longer be able to sign in with this account. To re-link, sign out and sign in with Google.',
      unlinkAccountSuccess: 'Account unlinked',
      unlinkAccountFailed: 'Failed to unlink account',

      // Account deletion
      deleteProfileTitle: 'Delete profile permanently',
      deleteProfileButton: 'Delete profile',
      deleteProfileBlockedTitle: 'Profile deletion unavailable',
      deleteProfileBlockedBody: 'Your account administers events that other users are registered for. To delete your profile, contact support@confy.cc – we will transfer the events to another organizer and delete your profile manually.',
      deleteProfilePreviewErrorTitle: 'Could not load account deletion information',
      deleteProfilePreviewErrorBody: 'Try refreshing the page. If the problem continues, contact support@confy.cc.',
      deleteProfileStep1: 'Step 1. Download a copy of your data',
      deleteProfileDownload: 'Download archive (.zip)',
      deleteProfileDownloadHint: 'data, profile photo and all certificate PDFs',
      deleteProfileWillDelete: 'The following will be permanently deleted:',
      deleteProfileItemProfile: 'your profile and all personal data',
      deleteProfileItemEnrollments: 'event enrollments: {count}',
      deleteProfileItemCertificates: 'certificates: {count} ({credits} CME credits)',
      deleteProfileItemProgress: 'test results, progress, survey responses',
      deleteProfileItemFiles: 'uploaded files and photos',
      deleteProfileIrreversible: 'Recovering this data will be IMPOSSIBLE – not by you, not by support. Certificates will cease to exist.',
      deleteProfileStep2: 'Step 2. Enter the code from the email',
      deleteProfileSendCode: 'Send code',
      deleteProfileCodeSent: 'Code sent to your email',
      deleteProfileStep3: 'Step 3. To confirm, type DELETE',
      deleteProfileConfirm: 'Delete permanently',
      deleteProfileCancel: 'Cancel',
      deleteProfileFailed: 'Failed to delete profile',
      deleteProfileInvalidCode: 'Invalid or expired code',
      deleteProfileRateLimited: 'Too many attempts. Try again in 10 minutes',
      signOutAllTitle: 'Sign out from all devices',
      signOutAllBody: 'A normal sign-out only ends the session on this device. Use this if you shared a login code with someone or lost access to a device you were signed in on.',
      signOutAllButton: 'Sign out from all devices',
      signOutAllConfirmPrompt: 'Every session will be ended, including on this device. You will need a new login code to get back in.',
      signOutAllConfirmButton: 'Yes, sign out everywhere',
      signOutAllCancel: 'Cancel',
      signOutAllError: 'Could not end the sessions. Check your connection and try again.',
      exportDataTitle: 'Download my data',
      exportDataBody: 'The archive contains your personal data, profile photo, all certificates in PDF format and registration form responses.',

      // Wayforpay Settings (Organizers only)
      paymentSettings: 'Payment Settings',
      paymentSettingsNote: 'WayForPay settings for accepting ticket payments.',
      paymentSettingsGenericNote: 'Payment provider settings for accepting ticket payments.',
      paymentProviderLabel: 'Payment Provider',
      liqpayPublicKey: 'Public Key',
      liqpayPublicKeyPlaceholder: 'sandbox_xxxxxxxx',
      liqpayPrivateKey: 'Private Key',
      liqpayPrivateKeyPlaceholder: '••••••••',
      wayforpayIntegration: 'Wayforpay Integration',
      enablePaymentProcessing: 'Enable Payment Processing',
      enablePaymentHint: 'Allow participants to pay for your events using Wayforpay',
      enabled: 'Enabled',
      disabled: 'Disabled',
      merchantAccount: 'Merchant Login',
      merchantAccountRequired: 'Merchant Login *',
      merchantAccountPlaceholder: 'your_merchant_login',
      merchantAccountHint: 'The "Merchant login" value from your Wayforpay portal',
      merchantAccountRequiredError: 'Merchant Login is required',
      merchantDomainNotice: 'Add confy.cc as the merchant domain in your WayForPay account. Without it WayForPay accepts the payment but never sends the confirmation, and the ticket is not issued.',
      merchantSecretKey: 'Merchant Secret Key',
      merchantSecretKeyRequired: 'Merchant Secret Key *',
      merchantSecretKeyPlaceholder: 'your_secret_key',
      merchantSecretKeyHint: 'The "Merchant secret key" value from your Wayforpay portal',
      merchantSecretKeyRequiredError: 'Merchant Secret Key is required',
      secretKeyWarning: '⚠️ Keep this key secure. Never share it publicly.',
      platformFee: 'Platform Fee Percentage',
      platformFeeHint: 'Platform commission on each transaction (0-100%)',
      wayforpaySetupTitle: 'How to get your Wayforpay credentials',
      wayforpaySetupStep1: 'Register for a Wayforpay merchant account at wayforpay.com',
      wayforpaySetupStep2: 'Complete the verification process',
      wayforpaySetupStep3: 'Navigate to your merchant settings',
      wayforpaySetupStep4: 'Copy your Merchant Account, Domain, and Secret Key',
      wayforpaySetupStep5: 'Paste them into the fields above and enable payment processing',
      wayforpaySetupNote: 'Once configured, all payments for your events will be processed through your own Wayforpay account.',

      // Offline payments (Organizers only)
      offlinePaymentsToggle: 'Accept offline payments (cash / bank transfer)',
      offlinePaymentsHint: 'Participants reserve a seat and you confirm payment manually.',
      offlineInstructionsLabel: 'Payment instructions',
      offlineInstructionsPlaceholder: 'E.g.: IBAN UA00 0000..., recipient ..., or "Pay in cash at registration."',
      offlineInstructionsShownToBuyers: 'Participants will see these instructions after reserving a seat.',

      // MOZ BPR Settings
      mozBprSettings: 'MOZ BPR Settings',
      mozProviderToggle: 'Are you registered as a BPR provider with the Ministry of Health of Ukraine?',
      mozLogin: 'BPR Login',
      mozLoginHint: 'Email for logging into MOZ BPR system. May differ from the organizer contact email.',
      mozLoginPlaceholder: 'your-moz-login@example.com',
      mozBprNumber: 'BPR Provider Number',
      mozBprNumberHint: 'Your 4-digit provider number in the MOZ BPR system',
      mozBprNumberPlaceholder: '0000',
      mozBprNumberError: 'BPR number must be exactly 4 digits',
      mozLoginRequired: 'BPR login is required',
      mozBprNumberRequired: 'BPR provider number is required',
      mozSettingsNote: 'These credentials are used for submitting event accreditation requests to the MOZ BPR system.',
      mozSecretsTitle: 'BPR automation data (optional)',
      mozSecretsNote: 'This data is encrypted and, once saved, cannot be viewed or downloaded by anyone, including CONFY administrators. It is used only by the system to submit applications and reports to MOZ BPR.',
      mozPassword: 'BPR dashboard password',
      mozPasswordHint: 'Lets the system automatically check application status and submit reports.',
      mozSignatureKey: 'Digital signature (КЕП) key file',
      mozSignatureKeyHint: 'The legal entity digital signature key (e.g. Key-6.dat). Maximum 1 MB.',
      mozSignatureKeyPassword: 'Key file password',
      mozSignatureKeyPasswordHint: 'If the password is not saved, it will be requested at every report submission – the key is unusable without it.',
      mozSecretSaved: 'Saved',
      mozSecretReplace: 'Replace',
      mozSecretDelete: 'Delete',
      mozSecretDeleteConfirm: 'Delete the saved value? This cannot be undone.',
      mozKeyConsent: 'I understand that the key will be used by the CONFY system to sign documents on my behalf, and I give my consent.',
      mozKeyConsentRequired: 'Consent to use the key is required',
      mozKeyTooLarge: 'The key file exceeds 1 MB',
      mozSecretsSaveError: 'Failed to save BPR data. Check the fields below.',

      // My Tests Page
      tests: {
        title: 'My Tests',
        subtitle: 'Results of completed tests',
        noTests: 'You haven\'t taken any tests yet',
        noTestsDescription: 'Tests will become available after participating in courses or events',
        browseContent: 'Browse events and courses',
        testName: 'Test Name',
        course: 'Course/Event',
        score: 'Score',
        status: 'Status',
        date: 'Date',
        passed: 'Passed',
        failed: 'Failed',
        inProgress: 'In Progress',
        attempts: 'Attempts',
        retake: 'Retake',
        viewDetails: 'Details',
        passedCount: 'Tests Passed',
        failedCount: 'Tests Failed',
        totalAttempts: 'Total Attempts',
        availableTests: 'Available Tests',
        goToTest: 'Go to Test',
        startTestButton: 'Start Test',
        open: 'Open',
        closed: 'Closed',
        upcoming: 'Upcoming',
        passingScore: 'Passing score',
        previousAttempts: 'Attempts',
        history: 'History',
        missedExpired: 'Missed Tests',
        expired: 'Expired',
        attemptsExhausted: 'Attempts exhausted',
        bestScore: 'Best score',
        notAttempted: 'Not attempted',
        pendingTests: 'Pending preparation',
        errors: {
          ENROLLMENT_REFUNDED: 'This registration was refunded, so the test is no longer available.',
          TEST_NOT_AVAILABLE_FOR_TICKET: 'Your ticket does not include a test or certificate. Please contact the organizer.',
        },
      },

      // My Surveys Page
      surveys: {
        title: 'My Surveys',
        subtitle: 'Completed surveys',
        noSurveys: 'You haven\'t completed any surveys yet',
        noSurveysDescription: 'Surveys will become available after participating in events or courses',
        browseContent: 'Browse events and courses',
        surveyName: 'Survey Name',
        course: 'Course/Event',
        status: 'Status',
        date: 'Date',
        completed: 'Completed',
        pending: 'Pending',
        viewResponses: 'View Responses',
        completedCount: 'Surveys Completed',
      },

      // My Certificates Page
      certificates: {
        title: 'My Certificates',
        subtitle: 'Your earned certificates',
        noCertificates: 'You don\'t have any certificates yet',
        noCertificatesDescription: 'Certificates are issued after successfully completing courses or events',
        browseContent: 'Browse events and courses',
        certificateName: 'Name',
        course: 'Course/Event',
        issuedAt: 'Issue Date',
        eventDate: 'Date',
        status: 'Status',
        issued: 'Issued',
        pending: 'Pending',
        processing: 'Processing',
        expired: 'Expired',
        revoked: 'Revoked',
        download: 'Download',
        view: 'View',
        verify: 'Verify',
        certificateNumber: 'Certificate Number',
        cpdCredits: 'CPD Credits',
        totalCertificates: 'Total Certificates',
        totalCredits: 'Total CPD Credits',
        generatePdf: 'Generate PDF',
        regenerate: 'Regenerate',
        // TEMPORARY NOTICE: Remove this translation key after data migration is complete (added 2026-02-08)
        dataMigrationNotice: 'Some certificates may not generate correctly, and some may not appear at all. This is because the data migration to the updated platform is still in progress. The transfer should be completed within one to two weeks. We apologize for the temporary inconvenience and thank you for your understanding!',
        availableCertificates: 'Available Certificates',
        allRequirementsComplete: 'All requirements complete',
        passTest: 'Pass test',
        testNotPassedCertificateUnavailable: 'Test not passed. Certificate unavailable.',
        completeSurvey: 'Complete survey',
        goToTest: 'Go to test',
        goToSurvey: 'Go to survey',
        completeRequirements: 'Complete requirements',
      },

      // My Materials Page
      materials: {
        title: 'My Materials',
        subtitle: 'Additional materials from your events',
        noMaterials: 'You don\'t have any available materials',
        noMaterialsDescription: 'Materials will become available after participating in events',
        browseContent: 'Browse events',
        materialName: 'Name',
        event: 'Event',
        type: 'Type',
        date: 'Date',
        download: 'Download',
        view: 'View',
        types: {
          video: 'Video',
          document: 'Document',
          presentation: 'Presentation',
          audio: 'Audio',
          link: 'Link',
          image: 'Image',
        },
        totalMaterials: 'Total Materials',
        progress: 'Progress',
      },

      // My Tickets Page
      tickets: {
        title: 'My Tickets',
        subtitle: 'Purchased courses and events',
        noTickets: 'You don\'t have any purchased tickets yet',
        noTicketsDescription: 'Your purchased courses and events will appear here',
        browseContent: 'Browse events and courses',
        ticketName: 'Ticket',
        course: 'Course/Event',
        type: 'Type',
        purchaseDate: 'Purchase Date',
        date: 'Date',
        price: 'Price',
        status: 'Status',
        active: 'Active',
        used: 'Used',
        expired: 'Expired',
        refunded: 'Refunded',
        partiallyRefunded: 'Partially refunded',
        viewEvent: 'Go to Event',
        viewCourse: 'Go to Course',
        downloadReceipt: 'Download Receipt',
        totalPurchases: 'Total Purchases',
        totalSpent: 'Total Spent',
        event: 'Event',
        courseType: 'Course',
        free: 'Free',
        // Ticket Management
        cancelRegistration: 'Cancel Registration',
        changeTicket: 'Change Ticket',
        cancelConfirmTitle: 'Cancel Registration?',
        cancelConfirmMessage: 'Are you sure you want to cancel your registration for this event? This action cannot be undone.',
        cancelConfirmButton: 'Yes, Cancel',
        cancelling: 'Cancelling...',
        cancelSuccess: 'Registration cancelled successfully',
        cancelError: 'Failed to cancel registration',
        eventStarted: 'Event has already started',
        cannotModifyStarted: 'Cannot modify or cancel registration after the event has started',
        // Change Ticket Modal
        changeTicketTitle: 'Change Ticket',
        currentTicket: 'Current Ticket',
        selectNewTicket: 'Select New Ticket',
        priceDifference: 'Price Difference',
        upgrade: 'Additional Payment',
        noAdditionalPayment: 'No additional payment',
        changeTicketButton: 'Change Ticket',
        payAndChange: 'Pay & Change',
        changing: 'Changing...',
        changeSuccess: 'Ticket changed successfully',
        changeError: 'Failed to change ticket',
        soldOut: 'Sold Out',
        sameTicketError: 'You already have this ticket',
        noOtherTickets: 'No other tickets available',
      },
    },

    // Phone input
    phone: {
      selectCountry: 'Select country',
      searchCountry: 'Search country or code',
      noCountryFound: 'No countries found',
      invalid: 'Please enter a valid phone number',
    },

    // Ticket Custom Fields Form (for ticket purchase)
    ticketCustomFields: {
      title: 'Additional Information Required',
      description: 'Please provide the following information for your ticket',
      descriptionForTicket: 'Please provide the following information for your «{{ticketName}}» ticket.',
      trueOption: 'Yes',
      falseOption: 'No',
      continue: 'Continue',
      finishRegistration: 'Finish registration',
      uploading: 'Uploading...',
      fixErrorsBeforeSubmitting: 'Please fix errors before submitting',
      failedToSubmitForm: 'Failed to submit form. Please try again.',
      clickToUpload: 'Click to upload or drag and drop',
      // Validation errors
      fieldRequired: '{{fieldLabel}} is required',
      onlyFileTypesAllowed: 'Only {{fileTypes}} files are allowed',
      fileSizeMustBeLessThan: 'File size must be less than {{size}}MB',
      failedToUploadFile: 'Failed to upload file: {{error}}',
      noActiveSession: 'no active session',
      mustBeAtLeastChars: 'Must be at least {{count}} characters',
      mustBeNoMoreThanChars: 'Must be no more than {{count}} characters',
      invalidFormat: 'Invalid format',
    },

    // Additional Profile Fields Form
    additionalFields: {
      title: 'Additional information needed',
      completeProfile: 'Complete Profile',
      course: 'Course',
      description: 'Please fill in the additional fields required for registration.',
      saveAndContinue: 'Save and Continue',
      selectOption: '-- Select an option --',
      saving: 'Saving...',
      enterRegion: 'Enter region',
      selectCountryFirst: 'Select country first',
      validation: {
        required: 'This field is required',
        invalidEmail: 'Please enter a valid email address',
        invalidPhone: 'Please enter a valid phone number',
        minLength: 'Minimum {count} characters',
        maxLength: 'Maximum {count} characters',
        invalidFormat: 'Invalid format',
        fillAllRequired: 'Please fill in all required fields',
      },
    },

    // Course Builder Extended
    courseBuilderExtended: {
      enterVenueAddress: 'Enter venue address...',
      priceExample: 'e.g., 2500.00',
      cpdCreditsExample: 'e.g., 5.5',
      leaveEmptyUnlimited: 'Leave empty for unlimited',
      imageUrlExample: 'https://example.com/image.jpg',
      certificateTemplateHtml: 'Enter a custom HTML template for certificates (optional)...',
      pleaseEnterCourseTitle: 'Please enter a course title',
      pleaseEnterCourseTitleBeforeTest: 'Please enter a course title before saving the test.',
      pleaseEnterCourseTitleBeforeSurvey: 'Please enter a course title before saving the survey.',
      testSavedSuccessfully: 'Test saved successfully!',
      surveySavedSuccessfully: 'Survey saved successfully!',
      courseUpdatedSuccessfully: 'Course updated successfully!',
      courseSavedSuccessfully: 'Course saved successfully!',
      failedToCreateCourse: 'Failed to create course. Please save the course manually first.',
      failedToSaveSurveyRetry: 'Failed to save survey. Please try again.',
      accessDeniedOrganizers: 'Access denied. Only organizers can create courses.',
      failedToLoadCourseData: 'Failed to load course data',
    },

    // File Upload
    fileUpload: {
      selectFile: 'Select File',
      upload: 'Upload',
      externalUrl: 'URL',
      myFiles: 'My Files',
      clickToSelect: 'Click to select file',
      orDragDrop: 'or drag and drop here',
      acceptedTypes: 'Accepted types',
      maxSize: 'Max size',
      uploading: 'Uploading...',
      enterExternalUrl: 'Enter the URL of the file you want to use',
      use: 'Use',
      urlExamples: 'Examples: YouTube, Google Drive, Dropbox links',
      search: 'Search files...',
      allFiles: 'All Files',
      images: 'Images',
      documents: 'Documents',
      videos: 'Videos',
      audio: 'Audio',
      loading: 'Loading...',
      noFiles: 'No files uploaded yet',
      delete: 'Delete',
      confirmDelete: 'Are you sure you want to delete this file?',
      deleteError: 'Failed to delete file',
      invalidFileType: 'Please select a file of the correct type',
      fileTooLarge: 'File size exceeds the maximum allowed',
      uploadError: 'File upload error',
      enterValidUrl: 'Please enter a valid URL',
      invalidUrl: 'Invalid URL format',
      useUrl: 'Use URL',
      chooseFromFiles: 'Choose from my files',
      backToUpload: 'Back to upload',
      uploadSuccess: 'File uploaded successfully',
      deleteSuccess: 'File deleted successfully',
      confirmDeleteTitle: 'Delete File',
      cancel: 'Cancel',
    },

    // Full-size image viewer (lightbox)
    imageLightbox: {
      viewFullSize: 'View full size',
      openOriginal: 'Open original',
      lowResolution: 'Low resolution',
      loadError: 'Could not load the image',
    },

    // Errors
    errors: {
      general: 'Something went wrong. Please try again.',
      network: 'Network error. Please check your connection.',
      auth: 'Authentication error. Please sign in again.',
      notFound: 'Page not found',
      serverError: 'Server error. Please try later.',
      validation: 'Please check your input',
      courseNotFound: 'Course not found',
      returnToHomepage: 'Return to homepage',
      errorSavingData: 'Error saving data. Please try again.',
      pleaseSelectImageFile: 'Please select an image file.',
      imageSizeTooLarge: 'Image size should be less than 5MB.',
      uploadImageError: 'Error uploading image. Please try again.',
      pleaseDropImageFile: 'Please drop an image file.',
      pleaseSelectPDFFile: 'Please select a PDF file.',
      fileSizeTooLarge: 'File size should be less than 10MB.',
      uploadFileError: 'Error uploading file. Please try again.',
      pleaseDropPDFFile: 'Please drop a PDF file.',
      // Error boundaries
      errorBoundary: {
        title: 'Something went wrong',
        description: 'Sorry, an unexpected error occurred. Our team has been notified and is working on a fix.',
        tryAgain: 'Try again',
        goHome: 'Go to homepage',
        goBack: 'Go back',
        errorId: 'Error ID',
        dashboardError: 'Dashboard Error',
        dashboardDescription: 'Failed to load the dashboard. Please try refreshing the page.',
        eventsError: 'Events Error',
        eventsDescription: 'Failed to load event information. Please try again later.',
        coursesError: 'Courses Error',
        coursesDescription: 'Failed to load course information. Please try again later.',
        profileError: 'Profile Error',
        profileDescription: 'Failed to load your profile. Please try refreshing the page.',
      },
      // Payment API errors
      payment: {
        UNAUTHORIZED: 'Please sign in to proceed with payment.',
        INVALID_INPUT: 'Invalid data. Please check your input.',
        CONTEXT_FETCH_FAILED: 'Failed to load data. Please try again.',
        CONTENT_NOT_FOUND: 'Event or course not found.',
        USER_NOT_FOUND: 'User not found. Please sign in again.',
        ALREADY_ENROLLED: 'You are already enrolled in this event or course.',
        PAYMENT_NOT_CONFIGURED: 'Payment is not configured. Please contact the organizer.',
        NO_TICKETS_SELECTED: 'Please select at least one ticket.',
        ZERO_AMOUNT: 'Cannot process payment for free events.',
        PAYMENT_CREATE_FAILED: 'Failed to create payment. Please try again.',
      },
    },

    // UnifiedEditor
    unifiedEditor: {
      preview: 'Попередній перегляд',
      addLink: 'Додати посилання',
      url: 'URL',
      urlPlaceholder: 'https://example.com',
      removeLink: 'Прибрати посилання',
      insertButton: 'Вставити кнопку',
      buttonText: 'Текст кнопки',
      buttonTextPlaceholder: 'напр., Приєднатися, Дізнатися більше, Підписатися',
      buttonUrl: 'URL кнопки',
      buttonUrlPlaceholder: 'https://example.com',
      saving: 'Збереження...',
      saved: 'Збережено',
      closeModal: 'Закрити модальне вікно',
      buttonColor: 'Колір кнопки',
      previewLabel: 'Попередній перегляд:',
      heading: 'Заголовок',
      htmlMode: 'HTML код',
      visualMode: 'Візуальний редактор',
    },

    // Materials Management
    materialsManagement: {
      title: 'Назва',
      titlePlaceholder: 'Назва матеріалу',
      descriptionPlaceholder: 'Короткий опис',
      pdfFile: 'PDF файл',
      pdfUploaded: 'PDF завантажено',
      videoUrlPlaceholder: 'https://www.youtube.com/watch?v=...',
      required: 'Обов\'язковий',
      downloadable: 'Можна завантажити',
      deleteMaterial: 'Видалити матеріал',
      deleteMaterialConfirm: 'Ви впевнені, що хочете видалити цей матеріал? Цю дію не можна скасувати.',
      availableFrom: 'Доступно з',
      availableUntil: 'Доступно до',
      availableFromHint: 'Доступно з',
      expiredHint: 'Недоступно з',
      defaultDocumentTitle: 'Presentation slides',
      defaultLinkTitle: 'Video recording',
      copyParticipantsLink: 'Copy participants link',
      copyPublicLink: 'Copy public link',
      publicLink: 'Public link',
      publicLinkHint: 'Anyone with this link can watch without signing in',
      publicLinkOn: 'Public link enabled',
      publicLinkOff: 'Public link disabled – the old link no longer works',
      linkCopied: 'Link copied',
      linkError: 'Could not update the link',
      pdfRequired: 'Upload a PDF file to save this material',
    },

    // Email Templates Manager
    emailTemplatesManager: {
      emailTemplates: 'Шаблони Email',
      newTemplate: 'Новий шаблон',
      templateName: 'Назва шаблону',
      templateNamePlaceholder: 'напр., Вітальний лист',
      subject: 'Тема',
      subjectPlaceholder: 'Тема email з підтримкою {{змінних}}',
      messageBody: 'Текст повідомлення',
      messageBodyPlaceholder: 'Текст email з підтримкою {{first_name}}, {{last_name}}, {{email}}...',
      variablesHelp: 'Використовуйте {{змінна}} для персоналізації. Доступні: first_name, last_name, email, phone, event_title',
      failedToLoadTemplates: 'Не вдалося завантажити шаблони',
      fillAllFields: 'Будь ласка, заповніть всі поля',
      templateUpdated: 'Шаблон оновлено',
      templateCreated: 'Шаблон створено',
      failedToSaveTemplate: 'Не вдалося зберегти шаблон',
      templateDeleted: 'Шаблон видалено',
      failedToDeleteTemplate: 'Не вдалося видалити шаблон',
    },

    // SMS Templates Manager
    smsTemplatesManager: {
      smsTemplates: 'Шаблони SMS',
      newTemplate: 'Новий шаблон',
      templateName: 'Назва шаблону',
      templateNamePlaceholder: 'напр., Нагадування про подію',
      message: 'Повідомлення (SMS)',
      messagePlaceholder: 'SMS повідомлення з підтримкою {{first_name}}, {{last_name}}, {{email}} (макс. 160 символів)...',
      variablesHelp: 'Використовуйте {{змінна}} для персоналізації. Доступні: first_name, last_name, email, phone, event_title',
      failedToLoadTemplates: 'Не вдалося завантажити шаблони',
      fillAllFields: 'Будь ласка, заповніть всі поля',
      messageExceedsLimit: 'Повідомлення перевищує {limit} символів',
      templateUpdated: 'Шаблон оновлено',
      templateCreated: 'Шаблон створено',
      failedToSaveTemplate: 'Не вдалося зберегти шаблон',
      templateDeleted: 'Шаблон видалено',
      failedToDeleteTemplate: 'Не вдалося видалити шаблон',
      messageExceedsBy: '⚠️ Повідомлення перевищує на {count} символ(ів)',
    },

    // Speaker Invite Link
    speakerInvite: {
      honorariumExpected: 'If an honorarium is expected, provide the bank details for the organizer to pay you',
      inviteButton: 'Invite speaker',
      modalTitle: 'Speaker invite link',
      linkLabel: 'Link',
      copy: 'Copy',
      copied: 'Link copied',
      regenerate: 'Regenerate link',
      regenerateConfirmTitle: 'Regenerate the link?',
      regenerateConfirmBody: 'The previous link will stop working. If you already sent it to speakers, they will need the new one.',
      loadError: 'Failed to load the invite link',
      copyError: 'Failed to copy the link',
      regenerateError: 'Failed to regenerate the link',
      hint: 'The speaker opens this link, signs in, and fills in their own profile. The finished profile then appears among your saved speakers – ready to add to any event or application. The link keeps working until you regenerate it.',
      pageTitle: 'Speaker profile',
      pageIntro: '{organizer} has invited you to fill in a speaker profile on CONFY. This information will be used for upcoming events.',
      invalidTitle: 'Invitation is no longer valid',
      invalidBody: 'This invite link no longer works. The organizer may have generated a new one – ask them for the current link.',
      submit: 'Submit',
      submitting: 'Submitting...',
      successTitle: 'Thank you!',
      successBody: 'Your speaker profile has been saved. The organizer has been notified and can now add you to an event.',
      submitError: 'Failed to submit your profile. Please try again.',
      rateLimited: 'Too many submission attempts. Please try again later.',
    },

    // Speaker Management
    speakerManagement: {
      draftsDeletedDueToAge: 'Speaker drafts deleted due to age (older than 7 days)',
      errorDeletingSpeaker: 'Error deleting speaker',
      speakerDeletedSuccessfully: 'Speaker deleted successfully',
      confirmDeleteSpeaker: 'Are you sure you want to delete this speaker?',
      pleaseProvideFullName: 'Please provide speaker\'s first and last name',
      titleQualificationMaxLength: 'Position and qualification cannot exceed 150 characters',
      errorSavingSpeaker: 'Error saving speaker',
      speakerSavedSuccessfully: 'Speaker saved successfully',
      authenticationError: 'Authentication error',
      loadingError: 'Error loading speakers',
      unexpectedError: 'Unexpected error loading speakers',
      speakerAddedFromExisting: 'Speaker added from existing data',
      possibleDuplicate: 'Possible duplicate',
      possibleDuplicateHint: 'Another record in your speaker list has the same email address. These may be two records for the same person – edit or delete one of them.',
      // Section Header
      title: 'Speakers',
      description: 'Add speakers for the event. At least one speaker is required.',
      noSpeakersYet: 'No speakers added yet',
      // Photo
      uploadPhoto: 'Upload photo',
      changePhotoTitle: 'Change photo',
      removePhotoTitle: 'Delete photo',
      removePhotoConfirmTitle: 'Delete speaker photo?',
      removePhotoConfirmMessage: 'Are you sure you want to delete this speaker\'s photo? This action cannot be undone.',
      removePhoto: 'Delete',
      cancel: 'Cancel',
      choosePhoto: 'Choose',
      // Name Fields
      lastName: 'Last Name',
      lastNamePlaceholder: 'Smith',
      firstName: 'First Name',
      firstNamePlaceholder: 'John',
      middleName: 'Middle Name',
      middleNamePlaceholder: 'William',
      // Bio
      shortBio: 'Short Bio',
      optional: 'optional',
      requiredForBpr: 'required for CPD',
      bioPlaceholder: 'Enter a short bio for the speaker, e.g.: MD, PhD, Professor of Internal Medicine at the National Medical University (Kyiv)',
      // Additional Info Section
      additionalInfoTitle: 'Additional speaker information',
      dateOfBirth: 'Date of Birth',
      dateFormatPlaceholder: 'dd.mm.yyyy',
      email: 'Email',
      emailPlaceholder: 'Enter speaker email',
      phone: 'Phone',
      phonePlaceholder: '+380XXXXXXXXX',
      education: 'Education',
      educationPlaceholder: 'Select speaker education',
      educationOptions: {
        higherMedical: 'Higher Medical',
        secondaryMedical: 'Secondary Medical',
        higherPharmaceutical: 'Higher Pharmaceutical',
        other: 'Other',
      },
      workplace: 'Workplace',
      workplacePlaceholder: 'Enter speaker workplace',
      position: 'Position',
      positionPlaceholder: 'Enter speaker position',
      academicDegree: 'Academic Degree',
      academicDegreePlaceholder: 'Select academic degree',
      academicDegreeOptions: {
        candidateMedical: 'Candidate of Medical Sciences',
        doctorMedical: 'Doctor of Medical Sciences',
        candidatePharmaceutical: 'Candidate of Pharmaceutical Sciences',
        doctorPharmaceutical: 'Doctor of Pharmaceutical Sciences',
        candidatePsychological: 'Candidate of Psychological Sciences',
        doctorPsychological: 'Doctor of Psychological Sciences',
        candidateBiological: 'Candidate of Biological Sciences',
        doctorBiological: 'Doctor of Biological Sciences',
        noDegree: 'No Degree',
        otherDegree: 'Other',
      },
      academicTitle: 'Academic Title',
      academicTitlePlaceholder: 'Select academic title',
      academicTitleOptions: {
        docent: 'Associate Professor',
        professor: 'Professor',
        correspondingMember: 'Corresponding Member',
        academician: 'Academician',
        seniorResearcher: 'Senior Researcher',
        leadResearcher: 'Leading Researcher',
        noTitle: 'No Academic Title',
        otherTitle: 'Other',
      },
      // Additional Description
      additionalDescription: 'Other Information',
      additionalDescriptionPlaceholder: 'In 2000 graduated with honors from XXXXX State Medical Institute with a degree in Medicine.\nCandidate of Medical Sciences since 2000.\nResearch interests: XXXXX.\nAuthor of over 100 educational and scientific publications.',
      // Buttons
      saving: 'Saving...',
      saveSpeaker: 'Save Speaker',
      createNew: 'Create New',
      createNewSpeaker: 'Create New Speaker',
      chooseExisting: 'Choose Existing',
      chooseExistingSpeaker: 'Choose Existing Speaker',
      close: 'Close',
      // Remove from Event Confirmation
      removeConfirmTitle: 'Remove speaker from event?',
      removeConfirmDescription: 'The speaker will be removed from this event. Speaker data will remain in the system for use in other events.',
      removeButton: 'Remove',
      cancelButton: 'Cancel',
      speakerRemovedSuccessfully: 'Speaker removed from event',
      errorRemovingSpeaker: 'Error removing speaker from event',
    },

    // MOZ Speaker Management (CPD submission specific)
    mozSpeakers: {
      speakerAddedFromExisting: 'Speaker added from existing data',
      errorLoadingEventSpeakers: 'Error loading event speakers',
      errorCopyingSpeakers: 'Error copying speakers',
      speakersAddedFromEvent: 'Added {count} speaker(s) from event',
      noEventSpeakersToCopy: 'No speakers in event to copy',
      allSpeakersAlreadyAdded: 'All event speakers are already added to CPD',
      // Validation errors
      pleaseProvideName: 'Please provide speaker\'s first and last name',
      pleaseProvideBio: 'Please fill in the short biography',
      pleaseProvideDateOfBirth: 'Please provide date of birth',
      pleasePprovideEmail: 'Please provide speaker email',
      pleaseProvidePhone: 'Please provide a speaker phone number (at least 10 digits)',
      invalidEmailFormat: 'Please enter a valid email address',
      pleaseSelectEducation: 'Please select speaker education',
      pleaseProvideWorkplace: 'Please provide speaker workplace',
      pleaseProvidePosition: 'Please provide speaker position',
      pleaseSelectAcademicDegree: 'Please select academic degree',
      pleaseSelectAcademicTitle: 'Please select academic title',
      pleaseProvideAdditionalInfo: 'Please fill in additional information',
      authenticationError: 'Authentication error',
      errorSavingSpeaker: 'Error saving speaker',
      speakerSavedSuccessfully: 'Speaker saved successfully!',
      pleaseCompleteAllFields: 'Please complete all required fields for all speakers',
      // UI text
      noSpeakersYet: 'No speakers added yet',
      copyFromEvent: 'Copy speakers from event',
      copying: 'Copying...',
      copyFromEventDescription: 'Copy speakers added to the event to fill in additional fields for CPD',
      createNew: 'Create new',
      chooseExisting: 'Choose existing',
      photo: 'Photo',
      loading: 'Loading...',
      or: 'or',
      cvPdfNote: 'CV PDF will be generated automatically',
      speakerInfoForBpr: 'Speaker information for CPD',
      addFromEvent: 'Add speakers from event',
      prefillConfirmTitle: 'Copy speakers from event?',
      prefillConfirmDescription: 'Speakers added to the main event information will be copied to the CPD section. You can fill in additional fields required for MOZ submission. CPD speakers will be independent from event speakers.',
      copy: 'Copy',
      save: 'Save',
      registration: {
        register: 'Register speaker',
        registerAndIssue: 'Register and issue certificate',
        switchTicket: 'Switch to speaker ticket',
        switchTicketAndReissue: 'Switch to speaker ticket and re-issue the certificate',
        issue: 'Issue certificate',
        reissue: 'Re-issue as a speaker certificate',
        noSpeakerCredits: 'Set the CPD speaker credits in the event data first',
        status: {
          no_email: 'No email – registration is not possible',
          not_registered: 'Not registered for the event',
          registered_participant: 'Registered as a participant',
          participant_certificate: 'Registered as a participant, participant certificate issued',
          registered_speaker: 'Registered (speaker ticket)',
          speaker_ticket_participant_certificate: 'Speaker ticket, but the certificate was issued as a participant one',
          certificate_issued: 'Speaker certificate issued',
        },
        explain: {
          no_email: 'Without an email on the speaker card no registration can be created. Add the email and save the card.',
          not_registered: 'The speaker will be registered for the event with a free "Speaker" ticket (promo-code only, SPEAKER-…, created automatically if missing). If no account exists for the card email, one is created. The speaker certificate is issued automatically after the event ends.',
          registered_participant: 'The speaker registered themselves on a regular participant ticket. The button moves their registration to the "Speaker" ticket; the speaker certificate is issued after the event ends.',
          participant_certificate: 'The speaker is registered as a participant and already has a participant certificate. The button moves the registration to the "Speaker" ticket and re-issues that same certificate as a speaker certificate – same number, speaker credits, data from the CPD card. The PDF is refreshed when the speaker opens the certificate.',
          registered_speaker: 'The speaker holds the "Speaker" ticket. The speaker certificate is issued automatically after the event ends – or press the button to issue it now.',
          speaker_ticket_participant_certificate: 'The speaker holds the "Speaker" ticket, but the certificate was issued as a participant one. The button re-issues it as a speaker certificate under the same number, with speaker credits.',
          certificate_issued: 'Speaker certificate issued. This speaker appears in the participant list for the Ministry with speaker credits.',
        },
        notice: {
          no_email: 'The card has no email – this speaker cannot be registered for the event or receive a speaker certificate.',
          not_registered: 'This speaker is not registered for the event. Without a registration they get no speaker certificate and are not reported to the Ministry as a speaker. Use the "Register speaker" button below.',
          registered_participant: 'This speaker is registered for the event as a participant, not as a speaker. Move them to the speaker ticket with the button below – the certificate will be issued (or re-issued) as a speaker certificate.',
          speaker_ticket_participant_certificate: 'This speaker\'s certificate was issued as a participant certificate. Re-issue it with the button below.',
        },
        done: {
          registered_speaker: 'Speaker registered',
          registered_participant: 'Speaker is already registered as a participant',
          certificate_issued: 'Speaker certificate issued',
          reissued: 'Certificate re-issued as a speaker certificate',
        },
        error: {
          request: 'Could not complete the request',
          no_email: 'The speaker card has no email',
          no_speaker_credits: 'Speaker CPD credits are not set',
          upgrade_in_flight: 'A ticket switch payment is in progress for this registration, try again later',
          account_error: 'Could not create the speaker account',
          write_failed: 'Could not save the registration',
          speaker_not_found: 'Speaker not found in the CPD list',
        },
        dialog: {
          title: 'Speaker registration',
          chooseTicket: 'Choose the speaker ticket',
          chooseTemplate: 'Choose the speaker certificate template',
          ticketWillBeCreated: 'A free "Speaker" ticket, available by promo code only, will be created',
          noTemplate: 'You have no speaker certificate template. Create one in the "Certificates" tab, or skip this speaker.',
          goToTemplates: 'Go to certificates',
          confirm: 'Continue',
          ignore: 'Skip',
        },
        batch: {
          title: 'Speakers without a speaker certificate ({count})',
          hint: 'To appear in the participant list for the Ministry with speaker credits, a speaker must be registered for the event on the "Speaker" ticket and hold a speaker certificate. The button does, for every speaker listed, what is written next to their name: registers the unregistered, moves those registered as participants to the "Speaker" ticket, and issues the speaker certificate – or re-issues an already issued participant certificate under the same number. If there is no "Speaker" ticket yet, a free promo-code ticket is created.',
          registerAll: 'Register all',
          processAll: 'Process all',
          registering: 'Processing…',
          done: 'Processed speakers: {count}',
          partial: 'Processed: {done}, failed: {failed}',
          warning: 'The CPD list has speakers without a speaker certificate ({count}). They will not appear in the participant list as speakers.',
          warningHint: 'The participant list for the Ministry is built from issued certificates. A speaker without a speaker certificate is either missing from the list or listed as a participant with participant credits. To fix it, press the button in the "Speakers without a speaker certificate" block above – or handle each speaker in their card in the "Speakers" section.',
          plan: {
            no_email: 'will be skipped – no email',
            not_registered: 'will be registered on the "Speaker" ticket',
            not_registered_ended: 'will be registered on the "Speaker" ticket and issued a speaker certificate',
            registered_participant: 'will be moved to the "Speaker" ticket',
            registered_participant_ended: 'will be moved to the "Speaker" ticket and issued a speaker certificate',
            participant_certificate: 'will be moved to the "Speaker" ticket; the participant certificate is re-issued as a speaker certificate (same number)',
            registered_speaker: 'the speaker certificate is issued after the event ends',
            registered_speaker_ended: 'will be issued a speaker certificate',
            speaker_ticket_participant_certificate: 'the participant certificate will be re-issued as a speaker certificate (same number)',
          },
        },
      },
    },

    // Partner Management
    partnerManagement: {
      // Section header
      title: 'Event Partners',
      description: 'Add partners with logos to display on the event page.',
      noPartnersYet: 'No partners added yet',
      createNew: 'Create new',
      chooseExisting: 'Choose existing',
      createNewPartner: 'Create new partner',
      chooseExistingPartner: 'Choose existing partner',
      // Logo
      partnerLogo: 'Partner logo',
      removeImage: 'Remove image',
      choose: 'Choose',
      // Name field
      partnerName: 'Partner name',
      partnerNamePlaceholder: "e.g.: Medical Company LLC",
      partnerNameRequired: 'Partner name is required',
      enterPartnerName: 'Enter partner name',
      // Additional info
      additionalInfo: 'Additional information',
      optional: '(optional)',
      additionalInfoPlaceholder: 'e.g.: General event partner, Information support',
      additionalInfoDescription: 'Partner description, role, etc.',
      charactersCount: '{{count}}/200 characters',
      // Actions
      saving: 'Saving...',
      save: 'Save',
      savePartner: 'Save partner',
      remove: 'Remove',
      close: 'Close',
      cancel: 'Cancel',
      edit: 'Edit',
      delete: 'Delete',
      select: 'Select',
      tryAgain: 'Try again',
      // Browser
      selectPartner: 'Select partner',
      selectFromYourEvents: 'Choose an existing partner from your events',
      searchByName: 'Search by partner name...',
      editingPartner: 'Editing partner: {{name}}',
      partnerUpdated: 'Partner updated',
      errorUpdatingPartner: 'Error updating partner',
      noPartnersFound: 'No partners found',
      noSavedPartners: 'You don\'t have any saved partners yet',
      tryDifferentSearch: 'Try changing your search query',
      createPartnerToSeeHere: 'Create a partner for an event and it will appear here',
      partnersFound: 'Partners found:',
      cannotDeletePartner: 'Cannot delete partner "{{name}}". It is used in an event. Remove it from the event first.',
      deletePartnerTitle: 'Delete partner',
      deletePartnerConfirm: 'Are you sure you want to delete partner "{{name}}"? This action cannot be undone.',
      // Remove from Event Confirmation
      removeConfirmTitle: 'Remove partner from event?',
      removeConfirmDescription: 'The partner will be removed from this event.',
      removeButton: 'Remove',
      cancelButton: 'Cancel',
      partnerRemovedSuccessfully: 'Partner removed from event',
      errorRemovingPartner: 'Error removing partner from event',
      errorDeletingPartner: 'Error deleting partner',
      partnerDeletedSuccessfully: 'Partner deleted successfully',
      pleaseProvidePartnerName: 'Please provide partner name',
      additionalInfoMaxLength: 'Additional information cannot exceed 200 characters',
      errorSavingPartner: 'Error saving partner',
      partnerSavedSuccessfully: 'Partner saved successfully',
      partnerAddedFromExisting: 'Partner added from existing data',
      errorLoadingPartners: 'Failed to load partners list',
    },

    // Duplicate Detection Suggestions
    duplicateSuggestion: {
      speaker: 'speaker',
      organizer: 'organizer',
      partner: 'partner',
      highConfidenceTitle: 'Similar record found',
      possibleDuplicateTitle: 'Possible duplicate',
      dismiss: 'Dismiss',
      clickToUseExisting: 'Click to use existing record',
      viewAll: 'View all',
      createNew: 'Create new',
      useExisting: 'Use existing',
      continueCreating: 'Continue creating',
      similarRecordFound: 'A similar record was found in your database',
      wouldYouLikeToUse: 'Would you like to use the existing record instead of creating a new one?',
    },

    // Course Builder Editor Toolbar
    courseBuilderEditor: {
      heading1: 'Heading 1',
      heading2: 'Heading 2',
      heading3: 'Heading 3',
      bold: 'Bold',
      italic: 'Italic',
      bulletList: 'Bullet List',
      link: 'Link',
    },

    // Dashboard Messages
    dashboardMessages: {
      templateComingSoon: 'Опція шаблону незабаром!',
      importComingSoon: 'Опція імпорту незабаром!',
    },

    // Course Builder Messages
    courseBuilderMessages: {
      certificateOfCompletion: 'Сертифікат про завершення',
      thisCertifies: 'Цим підтверджується, що',
      certificateNumber: 'Номер сертифіката',
      issueDate: 'Дата видачі',
      verification: 'Верифікація',
    },

    // Event Stream
    eventStream: {
      delete: 'Видалити',
    },

    // Event Manage
    eventManage: {
      manageStudents: 'Керуйте вашими учасниками та відправляйте повідомлення',
      students: 'Учасники',
    },

    // Event Builder Tests
    eventBuilderTests: {
      testsAvailableAfterSaving: 'Тести доступні після збереження',
    },

    // Event Builder Surveys
    eventBuilderSurveys: {
      surveysAvailableAfterSaving: 'Опитування доступні після збереження',
    },

    // Course Builder Test Editor
    courseBuilderTest: {
      type: 'Тип',
    },

    // CRM Dashboard
    crmDashboard: {
      email: 'Email',
      sms: 'SMS',
    },

    // CPD (БПР) Submission
    mozSubmission: {
      // Page Header
      title: 'CPD Event Submission',
      subtitle: 'Complete the form to submit an event to the Continuing Professional Development (CPD) system',

      // Loading States
      loading: 'Loading...',
      saving: 'Saving...',
      submitting: 'Submitting...',
      generatingPdf: 'Generating PDF...',
      preparingPdf: 'Preparing to generate...',
      waitingInQueue: 'Waiting in queue...',
      pdfReady: 'PDF ready!',
      retryingPdf: 'Retrying generation...',
      unsaved: 'Unsaved',

      // Form Labels
      labels: {
        mozLogin: 'CPD Login',
        mozLoginFromSettings: 'Login from organizer settings',
        mozLoginNotConfigured: 'CPD login not configured for this organizer.',
        mozLoginConfigureLink: 'Configure in Organizer Details',
        mozLoginWarning: 'To submit to CPD, you need to configure the CPD login in the organizer settings.',
        mozLoginGoToOrganizer: 'Go to Organizer Settings',
        mozPassword: 'CPD Password',
        mozPasswordNote: 'Enter the password for your MOZ CPD account.',
        bprNumber: 'Registered BPR event number',
        eventType: 'Event Type',
        eventTheme: 'Event Theme',
        eventDirection: 'Event Direction',
        eventGoal: 'CPD Event Goal',
        targetAudience: 'Target Audience',
        academicHours: 'Academic Hours',
        providerLink: 'Link to Event Information on Provider Website',
        registrationLink: 'Event Registration Link',
        eventLanguages: 'Event Language',
        eventDates: 'Event Date',
        startDate: 'Start',
        endDate: 'End',
        eventFormat: 'Event Format',
        onlineUrl: 'Online Event Link',
        region: 'Region',
        district: 'District',
        city: 'City',
        street: 'Street',
        building: 'Building',
        auditorium: 'Room',
        address: 'Address',
        eventProgram: 'Event Program',
        educationalProgram: 'Educational Program',
        technicalInstruments: 'Use of Specialized Equipment and Materials',
        intlAccreditation: 'Accreditation abroad or in Ukraine by EACCME/ACCME/RCPSC or certification by ERC/ILCOR/AHA, or the event is held in an OECD country (online included)',
        intlAccreditationFile: 'Document confirming the accreditation / certification or that the event is held in an OECD country (PDF)',
        speakers: 'Lecturers/Trainers/Speakers',
        participantCount: 'Planned Number of Participants',
        partners: 'Partners',
        organizationalCommittee: 'Organizational Committee',
        mozContacts: 'Contact persons (МОЗ requirement)',
        registrationContact: 'Person responsible for registering the event and submitting its results',
        onsiteContact: 'Person responsible for running the event',
        dates: 'Event Dates',
      },

      // Placeholders
      placeholders: {
        eventType: 'Select event type',
        eventTheme: 'Enter event theme',
        eventDirection: 'Select event direction',
        eventGoal: 'Enter event goal',
        academicHours: 'Enter academic hours',
        providerLink: 'https://example.com',
        registrationLink: 'https://example.com/register',
        onlineUrl: 'https://example.com/online-event',
        region: 'E.g.: Kyiv Region',
        district: 'Optional',
        city: 'E.g.: Kyiv',
        street: 'E.g.: Khreshchatyk',
        building: 'E.g.: 1',
        auditorium: 'E.g.: Hall 101',
        participantCount: 'E.g.: 50',
        eventProgram: 'Describe the event program. Use headings for sections, lists for schedule...',
        educationalProgram: 'Describe the educational program. Use headings for sections, lists for schedule...',
        partners: 'List event partners (each on a new line or comma-separated)\nFor example:\nMedical Company LLC\nHealth Charity Foundation',
        organizationalCommittee: 'Provide information about the event\'s organizational committee\nFor example:\nNational Medical Academy of Ukraine\nAssociation of Cardiologists of Ukraine',
        contactName: 'Last name First name Patronymic',
        contactPhone: '+380XXXXXXXXX',
        datePicker: 'dd.mm.yyyy',
        dateTimePicker: 'dd.mm.yyyy hh:mm',
      },

      // Helper Text
      helperText: {
        required: 'required',
        optional: 'optional',
        dateFormat: 'You can enter date and time manually or select them in the calendar (format: dd.mm.yyyy hh:mm).',
        eventProgramInstructions: 'Enter the event program content. After filling it out, click "Generate PDF" to create the program file.',
        educationalProgramInstructions: 'Enter the educational program content. After filling it out, click "Generate PDF" to create the educational program file.',
        noEducationalProgramForConference: 'Not required for conferences',
        educationalProgramLabel: 'Educational Program:',
        organizationalCommitteeNote: 'Conferences require an organizational committee',
        mozContactsNote: 'МОЗ requires these details on the event program. Prefilled from your previous submission – change them if needed.',
        autoFormat: 'automatic',
        singleFormatSupported: 'This event type supports only one format',
        noPartners: 'This event has no partners',
        partnersLabel: 'Event Partners',
        selected: 'Selected',
        clearAllSpecialties: 'Clear all',
        clearSpecialtiesConfirmTitle: 'Clear all specialties?',
        clearSpecialtiesConfirmMessage: 'Are you sure you want to clear all selected specialties? This action cannot be undone.',
        bprLinkHint: 'Click the link icon on the right to auto-generate a short link to your event\'s CPD page',
      },

      // Hints
      hints: {
        eventTheme: 'Theme for CPD submission. May differ from the event title.',
        bprNumber: '7-digit number assigned after event registration in the BPR system',
      },

      // Event Formats
      eventFormats: {
        online: 'Remote participation in real time',
        onlineDescription: 'Event will be conducted online',
        inPerson: 'In-person attendance by healthcare professionals at the educational event venue',
        inPersonDescription: 'Event requires physical presence',
        hybrid: 'Combination of in-person and remote participation',
        hybridDescription: 'Event supports both formats',
        onlineAuto: 'Remote participation (automatic)',
        inPersonAuto: 'In-person attendance (automatic)',
      },

      // Button Labels
      buttons: {
        saveDraft: 'Save Draft',
        showJson: 'Show JSON',
        submitToMoz: 'Submit to CPD',
        generatePdf: 'Generate PDF',
        viewPdf: 'View PDF',
        viewPdfButton: 'View PDF',
        close: 'Close',
        save: 'Save',
        edit: 'Edit',
        copy: 'Copy',
        yes: 'Yes',
        removeFile: 'Remove file',
        openFile: 'Open file',
        no: 'No',
        generateAutoUrl: 'Generate auto link',
      },

      // Modal Titles
      modals: {
        programPreview: 'Event Program Preview',
        educationalProgramPreview: 'Educational Program Preview',
        jsonPayload: 'JSON Payload for CPD API',
        closeAriaLabel: 'Close',
      },

      // Success Messages
      success: {
        dataSaved: 'Data saved successfully!',
        programPdfGenerated: 'Program PDF generated successfully!',
        educationalProgramPdfGenerated: 'Educational program PDF generated successfully!',
        pdfGeneratedSuccessfully: 'PDF generated successfully',
        pdfGenerated: 'PDF generated',
        jsonCopied: 'JSON copied to clipboard!',
        submittedToMoz: 'Event successfully submitted to CPD!',
      },

      // Status Messages
      statusMessages: {
        submittedSuccessfully: '✓ Submitted Successfully',
        submissionError: '✗ Submission Error',
        processingSubmission: 'Processing Submission...',
        submittedSuccessMessage: 'Your event has been successfully submitted to the CPD system.',
        failedToSubmit: 'Failed to submit the event to the CPD system.',
        resubmitEvent: 'Please resubmit the event.',
        details: 'Details:',
        processingMessage: 'Your event is currently being processed by the CPD system. This may take a few minutes. The status updates automatically.',
        timeoutError: 'The response timeout from the CPD system has expired (15 minutes). Please try submitting the request again.',
        submittedAt: 'Submitted:',
        applicationNumber: 'Application number',
        viewApplication: 'View application on BPR website',
        needsChangesTitle: '! Returned for changes',
        needsChangesMessage: 'МОЗ BPR returned the application for changes. Open it on the BPR portal, read their remarks, make the edits and resubmit it there.',
        takeAction: 'Take action',
        rejectedTitle: '✗ Application rejected',
        rejectedMessage: 'This application can no longer be edited. Make the required changes to the event and submit a new application.',
        viewReason: 'View the reason',
        submitNewApplication: 'Submit a new application',
      },

      // Error Messages
      errors: {
        eventNotFound: 'Event not found',
        noPermissionToSubmit: 'You do not have permission to submit this event',
        loadingDataFailed: 'Error loading data',
        fillAtLeastOneField: 'Fill in at least one field before saving',
        savingDataFailed: 'Error saving data',
        enterProgramContent: 'Please enter program content before generating PDF',
        generatingProgramPdfFailed: 'Error generating program PDF',
        enterEducationalProgramContent: 'Please enter educational program content before generating PDF',
        generatingEducationalProgramPdfFailed: 'Error generating educational program PDF',
        fixFollowingErrors: 'Please fix the following errors:',
        providerLinkMustBeHttps: 'Provider information link must be an HTTPS URL',
        registrationLinkMustBeHttps: 'Registration link must be an HTTPS URL',
        onlineUrlMustBeHttps: 'Online event link must be an HTTPS URL',
        invalidStartDateFormat: 'Start date must be in dd.mm.yyyy format',
        invalidEndDateFormat: 'End date must be in dd.mm.yyyy format',
        eventDateTooSoon: 'The event start date must be at least 30 days from today. Please change the date before submitting to CPD.',
        endDateBeforeStart: 'End date cannot be earlier than start date',
        selectTechnicalInstruments: 'Please select whether specialized equipment and materials are used',
        uploadIntlAccreditationFile: 'Upload a PDF confirming the EACCME/ACCME/RCPSC accreditation, ERC/ILCOR/AHA certification or that the event is held in an OECD country',
        specifyOrganizationalCommittee: 'Please specify the organizational committee for the conference',
        specifyRegistrationContact: 'Specify the full name and phone number of the person responsible for registering the event and submitting its results',
        specifyOnsiteContact: 'Specify the full name and phone number of the person responsible for running the event',
        errorCheckingSpeakers: 'Error checking speakers',
        addAtLeastOneSpeaker: 'Add at least one speaker',
        speakersMustHaveBio: 'All speakers must have a completed short biography (required for CPD)',
        speakersMustHaveCv: 'All speakers must have a generated CV PDF file. Save speakers to automatically generate PDF.',
        submissionError: 'An error occurred while submitting the event',
        errorPrefix: 'Error:',
        details: 'Details:',
        failedToGeneratePdf: 'Failed to generate PDF',
        missingLocationFields: 'Missing required address fields. Please fill in all address fields for in-person/hybrid events.',
        passwordRequired: 'The saved password is unavailable. Please enter your БПР portal password manually.',
        notOrganizerOwner: 'Only the owner of the organizer profile can submit with the saved password. Please enter it manually.',
        serverError: 'Server error',
        redisNotRunning: 'Please check if Redis is running',
        failedToCheckJobStatus: 'Failed to check job status',
        failedToCreatePdfJob: 'Failed to create PDF job',
        failedToRetryJob: 'Failed to retry job',
        jobNotFound: 'Job not found',
      },
      warnings: {
        eventDateTooSoon: 'Warning: the event start date is sooner than 30 days from today. The CPD/МОЗ portal only accepts an application when the event is at least 30 days ahead. Before submitting, change the date to a compliant one, submit the application, then you may restore the real date and save.',
        previewConfirmTitle: 'Event date is sooner than 30 days',
        previewConfirmQuestion: 'Generate the documents anyway?',
        previewConfirmYes: 'Yes, continue',
        previewConfirmNo: 'No, change the dates',
      },
      review: {
        label: 'Current BPR status',
        pending: 'Under review',
        confirmed: 'Confirmed',
        rejected: 'Rejected',
        eventNumber: 'Event number',
        lastChecked: 'checked',
        checkNow: 'Check application status',
        checking: 'Checking… this can take up to 2 minutes',
        checkFailed: 'Could not check the status. Try again later.',
        saveFailed: 'The check succeeded, but the password could not be saved. Try saving it in the BPR provider section.',
        alreadyChecking: 'A check is already running',
        promptTitle: 'Enter your BPR portal password',
        promptLogin: 'BPR portal login',
        promptPassword: 'Password',
        promptSave: 'Save the password for automatic checks and email notifications',
        promptSubmit: 'Check',
        promptCancel: 'Cancel',
        savePasswordHint: 'Save your BPR portal password in the BPR provider section below – CONFY will check the status automatically twice a day and email you on changes.',
        numberSaved: 'Event number {number} saved from the BPR portal',
        conflictTitle: 'Event number differs',
        conflictBody: 'BPR confirmed the event under number {portal}, while CONFY has {ours} saved. This is the number printed on participant certificates.',
        conflictNote: 'We changed nothing. Choose which number to keep.',
        conflictUsePortal: 'Use the BPR number',
        conflictKeepOurs: 'Keep mine',
      },
      dateSync: {
        title: 'The dates on the МОЗ portal differ from the event dates',
        submitted: 'Submitted to МОЗ',
        onPortal: 'On the BPR portal',
        actual: 'Actual dates',
        explain: 'The application was submitted with a later date because МОЗ only accepts applications at least 30 days before the event. The event is now registered, so the dates can be set back to the real ones – this needs no further МОЗ approval.',
        button: 'Synchronise dates',
        syncing: 'Changing the dates on the portal…',
        takesTime: 'This can take up to 2 minutes – keep this page open.',
        confirmTitle: 'Change the dates on the МОЗ portal?',
        confirmBody: 'The event dates on the МОЗ portal will be changed to {dates}. This change needs no МОЗ approval and takes effect immediately. The dates on the BPR tab will be updated too.',
        confirmYes: 'Yes, change the dates',
        confirmNo: 'Cancel',
        success: 'The dates on the МОЗ portal were changed to {dates}',
        noChange: 'The МОЗ portal already has the correct dates',
        diverged: 'Note: the portal had {dates} – the dates appear to have been changed manually.',
        failed: 'Could not change the dates on the МОЗ portal. Try again later.',
        serviceUnavailable: 'The BPR service is temporarily unavailable. Try again in a few minutes – nothing was changed on the portal.',
        pastBody: 'The МОЗ portal does not accept dates in the past, so these dates cannot be synchronised automatically. Change them manually on the BPR portal.',
        promptTitle: 'Enter your BPR portal password to change the dates',
      },
    },

    // BPR Public Application
    bprApply: {
      pageTitle: 'BPR Accreditation Application',
      intro: 'Fill in this form to submit your event for accreditation and continuous professional development (BPR) credits. After review we will register the event on behalf of the accredited provider.',
      sectionEvent: 'Event basics',
      sectionBpr: 'BPR details',
      sectionProgram: 'Event program',
      sectionHours: 'Academic hours & BPR credits',
      sectionSpeakers: 'Speakers',
      sectionOrganizer: 'Event organizer',
      organizerHint: 'Specify the organization running the event. The scientific BPR organizer will be assigned by the accredited provider during review.',
      eventName: 'Event name',
      description: 'Event description (for the event page)',
      coverImage: 'Cover image',
      creditsTitle: 'BPR credits for this event type',
      creditsPerHourInPerson: 'Participant (in-person): {{rate}} credits per academic hour',
      creditsPerHourOnline: 'Participant (online): {{rate}} credits per academic hour',
      creditsPerHourSpeaker: 'Speaker/trainer: {{rate}} credits per academic hour',
      creditsPoster: 'Poster presentation: {{rate}} credits',
      creditsOral: 'Oral presentation: {{rate}} credits',
      creditsCourseUa: 'Course in Ukrainian: {{rate}} credits per academic hour',
      creditsCourseEn: 'Course in English: {{rate}} credits per academic hour',
      limitTotal: 'Limit: no more than {{limit}} participants per event',
      limitPerTrainer: 'Limit: no more than {{limit}} participants per trainer',
      limitCurrentMax: '{{speakers}} speaker(s) → up to {{max}} participants',
      calcTitle: 'BPR credits calculation',
      calcIntro: 'For {{hours}} academic hours a participant receives:',
      calcInPerson: '{{credits}} BPR credits (in-person attendance)',
      calcOnline: '{{credits}} BPR credits (online attendance)',
      calcCourseUa: '{{credits}} BPR credits (course in Ukrainian)',
      calcCourseEn: '{{credits}} BPR credits (course in English)',
      calcSpeaker: '{{credits}} BPR credits for a speaker',
      formatNotAllowed: 'This event type cannot be held in the selected format',
      participantLimitExceeded: 'Participant limit exceeded for this event type (maximum {{max}})',
      addSpeaker: 'Add speaker',
      removeSpeaker: 'Remove speaker',
      speakersRequired: 'Add at least one speaker',
      selectExistingSpeaker: 'Select existing speaker',
      optional: 'optional',
      organizerName: 'Organization name',
      organizerEmail: 'Contact email',
      organizerPhone: 'Contact phone',
      competencies: 'Competencies to be acquired or improved',
      competenciesPlaceholder: 'For example: diagnosis and management of acute coronary syndrome; ECG interpretation; post-infarction patient care',
      programRequired: 'Add at least one program item – time and description are required',
      previewButton: 'Preview application',
      previewTitle: 'Review your application',
      previewIntro: 'Check the entered data. If everything is correct, submit the application, or go back to editing.',
      backToEdit: 'Back to editing',
      submit: 'Submit application',
      resubmit: 'Resubmit application',
      submitting: 'Submitting…',
      fixErrors: 'Please fill in all required fields',
      submitError: 'Failed to submit the application. Your data is saved – please try again.',
      successTitle: 'Application submitted!',
      resubmitSuccessTitle: 'Application resubmitted!',
      saveChanges: 'Save changes',
      adminEditSuccessTitle: 'Changes saved',
      adminEditSuccessBody: 'The application changes were saved. The review status is unchanged.',
      successBody: 'Your application has been saved and sent to the accredited provider for review. We will notify you by email about the outcome. You can track its status on the applications page.',
      successOpenApplications: 'My applications',
      pageTitleEdit: 'Edit BPR Accreditation Application',
      notEditable: 'This application can no longer be edited',
      loadError: 'Failed to load the application',
      draftRestored: 'Restored your saved application draft',
      requiredField: 'Required field',
      backToApplications: 'My applications',
      saveDraft: 'Save draft',
      draftSaving: 'Saving…',
      draftSaved: 'Draft saved',
      draftSaveError: 'Could not save the draft. Please try again.',
      saveDraftHint: 'You can save an unfinished application and come back to it later.',
      draftSavedAt: 'Saved at',
      pageTitleDraft: 'BPR accreditation application draft',
      speakerCardTitle: 'Speaker',
      honorarium: {
        needed: 'Honorarium to be paid',
        hint: 'For internal processes: where to pay, how much, and whether it is already paid. This is not submitted to the MoH.',
        iban: 'IBAN',
        ibanPlaceholder: 'UA00 0000 0000 0000 0000 0000 0000',
        taxId: 'Tax number',
        taxIdPlaceholder: '10 digits',
        amount: 'Amount',
        currency: 'Currency',
        fromPrevious: 'From a previous application',
        needsEmail: "Add the speaker's email to save the honorarium details",
        statusPending: 'Pending',
        statusPaid: 'Paid',
        statusNotApplicable: 'Not needed',
        removeDataTitle: 'Delete honorarium data?',
        removeDataBody: 'The honorarium data for this speaker will be deleted. Continue?',
        blockedTitle: 'Cancel the payment first',
        statusSaveError: 'Could not save the payment status',
        detailsLockedPaid: 'To change the details, cancel the payment mark first',
        blockedBody: 'A payment is recorded for this speaker. Cancel the payment mark on the applications page first.',
        blockedDetail: 'A payment of {{amount}} from {{date}} is recorded for this speaker. Cancel the payment mark on the applications page first.',
      },
    },

    // Superadmin chrome shared by /admin and /admin/payments (Task 7, Phase 5)
    admin: {
      title: 'Admin Panel',
      subtitle: 'Search for users and generate magic links',
      loadingProfile: 'Loading profile...',
      open: 'Open',
      accessDenied: {
        title: 'Access Denied',
        superadminRequired: 'You need superadmin privileges to access this page.',
        currentRole: 'Your current role:',
        message: 'You do not have access to this section.',
      },
      bprDashboard: {
        title: 'BPR dashboard',
        subtitle: 'BPR application and report statuses across all events',
      },
      paymentsCard: {
        subtitle: 'Refunds and blocked enrollments',
      },
    },

    // Superadmin payment resolution UI (/admin/payments, Phase 4 spec Item 8)
    adminPayments: {
      title: 'Payment resolution',
      loadMore: 'Load more',
      noMore: 'No more rows',
      refunds: {
        title: 'Refunds needing attention',
        empty: 'No refunds need attention right now.',
        columns: {
          requested: 'Requested',
          event: 'Event',
          participant: 'Participant',
          amount: 'Amount',
          status: 'Status',
          age: 'Days waiting',
          lastAnswer: 'Last gateway answer',
          approval: 'Approval',
        },
        approval: {
          awaiting: 'Awaiting approval',
          approved: 'Approved',
        },
        intentLevel: 'Intent-level',
        actions: {
          check: 'Check with gateway',
          markSettled: 'Mark settled',
          markFailed: 'Mark failed',
          cancelQueued: 'Cancel refund',
          override: 'Approve override (bypass organizer)',
        },
        override: {
          confirmTitle: 'Approve this refund by overriding the organizer?',
          confirmDescription:
            'This refund is awaiting approval, and the organizer may be unreachable (for example, an abandoned cancelled event). Approving it now, as a superadmin, bypasses the organizer. This override will be recorded in the audit log with your identity.',
          confirm: 'Confirm override',
        },
        resolve: {
          title: 'Resolve refund by hand',
          settledAmount: 'Settled amount',
          note: 'Note',
          confirm: 'Confirm',
        },
      },
      blocked: {
        title: 'Blocked fulfilments',
        empty: 'No blocked fulfilments right now.',
        includeResolved: 'Show resolved older than 30 days',
        columns: {
          blockedAt: 'Blocked at',
          reason: 'Reason',
          event: 'Event',
          payer: 'Payer',
          amount: 'Amount',
          attempts: 'Attempts',
          resolution: 'Resolution',
        },
        reason: {
          duplicate_enrollment: 'Participant already holds a paid enrollment',
          enrollment_error: 'Enrollment error',
          duplicate_upgrade: 'Second charge on an upgrade order',
        },
        resolution: {
          fulfilled: 'Fulfilled',
          refunding: 'Refunding',
          refunded: 'Refunded',
          manual: 'Resolved manually',
          unresolved: 'Unresolved',
        },
        actions: {
          retry: 'Retry now',
          refundNow: 'Refund now',
          markManual: 'Mark manual',
          override: 'Approve override (bypass organizer)',
        },
        override: {
          confirmTitle: 'Approve this refund by overriding the organizer?',
          confirmDescription:
            'This refund is already prepared, but there is no organizer who can approve it - the organizer has no access to this payment. Approving it now, as a superadmin, bypasses the organizer. This override will be recorded in the audit log with your identity.',
          confirm: 'Confirm override',
        },
      },
      toast: {
        checkedSettled: 'The gateway confirmed the refund settled',
        checkedPending: 'The gateway says the refund is still in progress',
        checkedUnresolved: 'The gateway did not confirm the refund. Nothing was changed.',
        resolved: 'Refund resolved',
        retried: 'Fulfilment retried',
        refunded: 'Funds refunded',
        refundPrepared: 'The refund was prepared. It will not be sent until a person approves it.',
        refundProcessing: 'The refund was submitted; the gateway is still processing it',
        refundFailed: 'The gateway did not confirm the refund. Check the row by hand.',
        refundClaimedElsewhere: 'This payment is already being handled by another action. No new refund was started.',
        refundWriteFailed: 'The gateway confirmed the refund, but saving the record failed. Check the payment by hand.',
        refundInvalidAmount: 'This payment has no valid amount to refund. Nothing was done.',
        manual: 'Payment marked resolved manually',
        overridden: 'Refund approved by overriding the organizer. Recorded in the audit log.',
        error: 'Could not complete the action. Please try again.',
      },
      errors: {
        RATE_LIMITED: 'Too many requests in a row. Wait a minute and try again.',
        NOT_AUTHORIZED: 'You do not have access to this action.',
        REFUND_NOT_RESOLVABLE: 'This refund cannot be resolved by hand in its current status.',
        REFUND_STATE_CHANGED: 'The refund state just changed. Refresh the page.',
        SETTLED_AMOUNT_EXCEEDS_ORIGINAL: 'The amount exceeds what can still be refunded.',
        RETRY_NOT_APPLICABLE: 'This block cannot be resolved by retrying.',
        REFUND_NOT_APPLICABLE: 'This payment cannot be refunded automatically.',
        ALREADY_RESOLVED: 'This payment has already been resolved.',
        REFUND_GATEWAY_UNAVAILABLE: 'The payment gateway is unavailable. Try again later.',
        REFUND_PREPARE_FAILED: 'Could not prepare the refund. Please try again.',
      },
    },

    // BPR Applications manager
    bprApplications: {
      pageTitle: 'My BPR Applications',
      intro: 'Track the status of your accreditation applications, edit them, and resubmit.',
      newApplication: 'New application',
      empty: 'You have no BPR accreditation applications yet',
      signInRequired: 'Sign in to view your BPR accreditation applications',
      loadError: 'Failed to load applications. Try refreshing the page.',
      actionError: 'Action failed. Please try again.',
      submittedAt: 'submitted',
      savedAt: 'saved',
      untitledDraft: 'Untitled draft',
      continueDraft: 'Continue',
      applicant: 'Applicant',
      adminComment: 'Comment from the accredited provider',
      deadline: 'Apply changes by',
      duplicate: 'Duplicate',
      details: 'Details',
      withdraw: 'Withdraw',
      withdrawn: 'Application withdrawn',
      deleted: 'Application deleted',
      history: 'History',
      openEvent: 'Open event',
      approve: 'Approve',
      approveSuccess: 'Application approved, event created',
      requestChanges: 'Request changes',
      requestChangesSuccess: 'Comment sent to the applicant',
      commentPlaceholder: 'Describe what needs to be changed in the application…',
      sendComment: 'Send comment',
      confirmWithdrawTitle: 'Withdraw application?',
      confirmWithdrawBody: 'The application will be taken out of review. You can duplicate it and submit again later.',
      confirmDeleteTitle: 'Delete application?',
      confirmDeleteBody: 'The application and its history will be permanently deleted. This cannot be undone.',
      confirmApproveTitle: 'Approve application?',
      confirmApproveBody: 'An event with a completed BPR section will be created, and the applicant will receive the organizer role and a confirmation email.',
      status: {
        draft: 'Draft',
        submitted: 'Under review',
        needs_changes: 'Changes required',
        approved: 'Approved',
        withdrawn: 'Withdrawn',
        expired: 'Expired',
      },
      historyActions: {
        draft_created: 'Draft created',
        submitted: 'Application submitted',
        updated: 'Application updated',
        resubmitted: 'Application resubmitted',
        changes_requested: 'Changes requested',
        approved: 'Application approved',
        withdrawn: 'Application withdrawn',
        expired: 'Change deadline passed – application cancelled',
        honorarium_paid: 'Honorarium marked as paid',
        honorarium_pending: 'Honorarium returned to pending',
        honorarium_not_applicable: 'Honorarium marked as not needed',
        honorarium_removed: 'Honorarium record removed',
        honorarium_details_changed: 'Honorarium details changed',
      },
      honorariums: 'Speaker honorariums',
      honorariumEditTitle: 'Honorarium payment',
      honorariumStatus: 'Status',
      honorariumPaidOn: 'Payment date',
      honorariumPaidTime: 'Payment time',
      honorariumNote: 'Note',
      honorariumUnpayConfirm: 'Cancel the payment mark for this honorarium?',
      honorariumDeleteWarning: 'This will also delete {{count}} honorarium record(s).',
    },

    // BPR Preview Modal
    bprPreview: {
      title: 'BPR Preview',
      validating: 'Validating form data...',
      checkingChanges: 'Checking for changes...',
      generatingCvs: 'Generating speaker CVs...',
      generatingProgram: 'Generating event program...',
      generatingEducational: 'Generating educational program...',
      generatingDocument: 'Generating document...',
      generationFailed: 'Generation failed',
      waitingForGeneration: 'Waiting for generation...',
      noDocument: 'No document available',
      ready: 'Ready',
      submitToMoz: 'Submit to MOZ',
      submitting: 'Submitting to MOZ...',
      pleaseWait: 'Please wait, this may take a moment.',
      editForm: 'Edit Form',
      successTitle: 'Submitted Successfully!',
      successMessage: 'Your event has been submitted to MOZ for review. You will receive a notification once the review is complete.',
      redirectingToStatus: 'Taking you to the application status in a few seconds…',
      goToStatus: 'Go to status',
      validationErrorTitle: 'Validation Errors',
      errorTitle: 'An Error Occurred',
      generateAndPreview: 'Generate and Preview',
      sections: {
        eventInfo: 'Event Information',
        location: 'Location',
        onlineAccess: 'Online Access',
        speakers: 'Speakers',
        documents: 'Documents',
      },
      tabs: {
        summary: 'Summary',
        documents: 'Documents',
      },
      tapToView: 'Tap the button below to view this document',
      openDocument: 'Open Document',
      secureSubmission: 'Your credentials are encrypted. We submit on your behalf.',
      savedPasswordTitle: 'Using your saved password',
      confirmSubmit: {
        title: 'Submit the application to МОЗ?',
        description: 'The application will be sent to the Testing Centre for Quality of Education of the Ministry of Health of Ukraine.',
        confirm: 'Yes, submit',
      },
      noDataTitle: 'No Preview Data',
      noDataMessage: 'Please generate the preview from the event builder.',
      backToBuilder: 'Back to Builder',
      redirecting: 'Redirecting to event builder...',
    },

    // API Messages (for client-facing errors)
    api: {
      unauthorized: 'Unauthorized',
      forbidden: 'Forbidden',
      contentNotFound: 'Content not found',
      eventNotFound: 'Event not found',
      failedToFetchTickets: 'Failed to fetch tickets',
      failedToFetchEvents: 'Failed to fetch events',
      noRecipientsSpecified: 'No recipients specified',
      subjectAndBodyRequired: 'Subject and body required',
      messageBodyRequired: 'Message body required',
      eventIdRequired: 'Event ID required',
      failedToCreateEventCopy: 'Failed to create event copy',
      failedToCheckEnrollments: 'Failed to check enrollments',
      cannotDeleteWithEnrollments: 'Cannot delete content with students',
      failedToDelete: 'Failed to delete content',
      alreadyEnrolled: 'Already enrolled in this event',
      eventFull: 'Event is full',
      failedToLoadEventData: 'Failed to load event data',
      failedToCheckProfile: 'Failed to check profile requirements',
      registrationFailed: 'Registration failed',
      successfullyRegistered: 'Successfully registered!',
      pleaseLogIn: 'Please log in',
      failedToUpdateStatus: 'Failed to update event status',
      dataRefreshed: 'Event data refreshed from database',
      keepingCurrentVersion: 'Keeping your current version',
      failedToUploadImage: 'Failed to upload image',
      profilePhotoUploaded: 'Profile photo uploaded successfully',
      failedToDeletePhoto: 'Failed to delete photo',
      photoDeleted: 'Profile photo removed',
      failedToSavePaymentSettings: 'Failed to save payment settings',
      failedToSaveChanges: 'Failed to save changes. Please try again.',
      failedToLoadCourse: 'Failed to load course',
      failedToLoadCourseData: 'Failed to load course data',
      failedToCheckProfileCompletion: 'Failed to check profile completion',
      eventProgramFileRequired: 'Event program file is required. Please upload the event program in the form.',
    },

    // BPR Page
    bpr: {
      programTitle: 'Event Program',
      eventTopic: 'Event Topic',
      eventType: 'Event Type',
      eventFormat: 'Format',
      accreditation: 'Accreditation',
      eventDates: 'Event Dates',
      language: 'Language',
      astronomicalHours: 'Astronomical Hours',
      academicHours: 'Academic Hours',
      bprPoints: 'BPR Points',
      organizer: 'Organizer',
      program: 'Program',
      speakers: 'Speakers',
      participantCount: 'Participants',
      returnToHomepage: 'Return to homepage',
      youAreRegistered: 'You are registered for this event',
      registering: 'Registering...',
      register: 'Register',
      programNotAvailable: 'Event program not yet available',
    },

    invitation: {
      accept: {
        title: 'Accepting Organizer Invitation',
        processing: 'Processing invitation...',
        processingMessage: 'Please wait while we process your invitation...',
        success: 'Invitation Accepted!',
        successMessage: 'You are now an organizer for',
        redirecting: 'Redirecting to the management page...',
        goToBuilder: 'Go to Builder',
        error: 'Error',
        goToDashboard: 'Go to Dashboard',
        logIn: 'Log In',
        invalidLink: 'Invalid Link',
        invalidLinkMessage: 'This invitation link is invalid or has expired.',
        goToHome: 'Go to Home',
        errors: {
          loginRequired: 'You must be logged in to accept this invitation',
          invalidOrExpired: 'Invalid or expired invitation',
          alreadyProcessed: 'This invitation has already been processed',
          expired: 'This invitation has expired',
          unregisteredEmail: 'This invitation was sent to an unregistered email address. Only registered users can be invited as organizers.',
          profileNotFound: 'User profile not found',
          emailMismatch: 'This invitation was sent to a different email address',
          accountMismatch: 'This invitation is not for your account',
          alreadyOrganizer: 'You are already an organizer for this content',
          failedToAdd: 'Failed to add you as an organizer',
          internalError: 'Internal server error',
        },
      },
      decline: {
        title: 'Decline Organizer Invitation',
        confirmTitle: 'Decline Invitation',
        confirmMessage: 'Are you sure you want to decline this organizer invitation?',
        confirmNote: 'You will not be added as an organizer for this content.',
        cancel: 'Cancel',
        declineButton: 'Decline Invitation',
        processing: 'Processing your response...',
        success: 'Invitation Declined',
        successMessage: 'The invitation has been declined successfully.',
        redirecting: 'Redirecting to home page...',
        goToHome: 'Go to Home',
        error: 'Error',
        tryAgain: 'Try Again',
        invalidLink: 'Invalid Link',
        invalidLinkMessage: 'This invitation link is invalid or has expired.',
        errors: {
          invalidOrExpired: 'Invalid invitation',
          alreadyProcessed: 'This invitation has already been processed',
          emailMismatch: 'This invitation was sent to a different email address',
          failedToDecline: 'Failed to decline invitation',
          internalError: 'Internal server error',
        },
      },
    },
    organizerPage: {
      upcoming: 'Upcoming',
      past: 'Past',
      noUpcomingEvents: 'No upcoming events',
      noPastEvents: 'No past events',
      organizerNotFound: 'Organizer not found',
      organizerNotFoundDescription: 'No organizer was found at this address.',
      events: 'events',
    },
    organizersPage: {
      title: 'Organizers',
      subtitle:
        'Medical communities, associations and education providers hosting events on CONFY',
      events_one: 'event',
      events_few: 'events',
      events_many: 'events',
      empty: 'No organizers with published events yet.',
      becomeTitle: 'Organizing medical events?',
      becomeText: 'Host them conveniently on CONFY',
      becomeCta: 'Learn more',
    },
    embed: {
      // Auth
      enterEmail: 'Enter your email',
      emailPlaceholder: 'email@example.com',
      sendCode: 'Send code',
      verificationCode: 'Verification code',
      enterCode: 'Enter 6-digit code',
      verify: 'Verify',
      continueWithGoogle: 'Continue with Google',
      or: 'or',
      didntReceiveCode: "Didn't receive the code?",
      resendCode: 'Resend code',
      checkSpam: 'Check your spam folder',
      codeExpired: 'Code expired. Request a new one.',
      incorrectCode: 'Incorrect code, try again',
      tooManyAttempts: 'Too many attempts. Try again later.',
      sessionExpired: 'Session expired. Please verify your email again to continue.',
      popupBlocked: 'Your browser blocked the sign-in window. Please sign in with email code.',
      // Tickets
      selectTicket: 'Select a ticket',
      selectTicketFirst: 'Select a ticket above first',
      free: 'Free',
      continue: 'Continue',
      registering: 'Registering...',
      promoCode: 'Promo code',
      apply: 'Apply',
      soldOut: 'Sold out',
      salesNotStarted: 'Sales start on',
      salesEnded: 'Sales have ended',
      // Profile
      completeProfile: 'Complete your profile',
      profileRequired: 'Please complete your profile to register',
      fillRequiredFields: 'Fill in all required fields marked *',
      save: 'Save',
      // Payment
      proceedToPayment: 'Proceed to payment',
      paymentBlocked: 'Your browser blocked the payment window. You can complete registration on CONFY directly.',
      paymentFailed: 'Payment was declined. Please try again or use a different card.',
      fulfilmentBlocked: 'Your payment went through, but the registration could not be completed. CONFY support has already been notified and will follow up – please do not pay again. Questions? Email support@confy.cc.',
      paymentPending: 'Payment received, confirming your registration. This can take a few minutes – you will get a confirmation email.',
      paymentNotCompleted: 'Payment was not completed. Would you like to try again?',
      paymentWindowOpen: 'Complete the payment in the window that opened.',
      reopenPaymentWindow: 'Open the payment window again',
      cancelPayment: 'Cancel',
      paymentPopupBlocked: 'Your browser blocked the payment window. Press "Try again" or allow pop-ups for this site.',
      // Payment popup window (opened over the organizer's site)
      popup: {
        loading: 'Loading payment...',
        processing: 'Processing payment...',
        redirecting: 'Redirecting to the payment page...',
        continueToPayment: 'Continue to payment',
        cancel: 'Cancel',
        close: 'Close',
        sessionExpired: 'The payment session has expired. Close this window and try again.',
        loadError: 'Could not load the payment. Close this window and try again.',
        declined: 'Payment was declined.',
        initFailed: 'Could not start the payment.',
        missingSession: 'Payment session not found.',
        finishing: 'Finishing payment...',
        notCompleted: 'Payment not completed. You can close this window.',
        received: 'Payment received. You can close this window and return to the site.',
      },
      paymentUnavailable: 'Online payment is not available for this event. Please contact the organizer.',
      tryAgain: 'Try again',
      completeOnConfy: 'Complete registration on CONFY',
      // Document upload (needs a CONFY session, which the embedded form does not have)
      documentUploadTitle: 'A document upload is required',
      documentUploadUnavailable: 'For this ticket the organizer asks you to upload a document, and the embedded form cannot accept files. Complete your registration on the event page on CONFY - you will enter all of your answers there.',
      documentUploadOptionalUnavailable: 'This question expects a file upload, which the embedded form does not support. You can continue here without the file, or register on the event page to attach it.',
      // Confirmation
      registered: "You're registered!",
      registrationConfirmed: 'Your registration is confirmed',
      addToCalendar: 'Add to calendar',
      viewOnConfy: 'View on CONFY',
      alreadyRegistered: "You're already registered for this event!",
      answersNotStoredError: 'You are registered, but your registration answers could not be saved. Please contact the organizer.',
      // Event states
      eventNotAvailable: 'This event is not available',
      eventNotFound: 'Event not found',
      eventPassed: 'This event has already taken place',
      eventCancelled: 'This event has been cancelled',
      // General
      loading: 'Loading...',
      error: 'Error',
      retry: 'Try again',
      poweredByConfy: 'Powered by CONFY',
      register: 'Register',
      // PAY-10: shown instead of the widget when an embed.js load has no
      // nonce (an old, cached copy) past the legacy grace window.
      legacyExpired: 'This embed code is out of date. Ask the organizer to update the CONFY widget code on their site.',
    },
    ticketQuestions: {
      errorRequired: 'This field is required',
      errorTooShort: 'Value is too short',
      errorTooLong: 'Value is too long',
      errorInvalidOption: 'Choose one of the offered options',
      errorFileTooLarge: 'File is too large. Maximum size is {{size}} MB',
      hintLabel: 'Hint for the participant (optional)',
      hintPlaceholder: 'A short explanation shown under the question',
      fileRules: 'Accepted files: {{formats}}, up to {{size}} MB',
      sectionTitle: 'Additional questions',
      addQuestion: 'Add question',
      noQuestions: 'This ticket has no questions yet',
      askOn: 'Ask on:',
      thisTicketOnly: 'This ticket only',
      allTickets: 'All tickets',
      sharedWithTickets: 'Shared question',
      sharedEditWarning: 'Editing or deleting changes this question on every ticket that uses it',
      deleteQuestion: 'Delete question',
      deleteQuestionConfirmation: 'The question will be deleted permanently, together with every answer participants have stored for it. This cannot be undone.',
      // English needs only _one and _many - pluralForm() never resolves to
      // `few` outside Ukrainian. The answer count sits in its own clause for
      // the same reason as the Ukrainian copy: it agrees with nothing.
      deleteQuestionSharedConfirmation_one: 'This question is asked on {{tickets}} ticket. Stored answers: {{answers}}. Deleting it removes the question from that ticket and permanently destroys all of those answers. This cannot be undone.',
      deleteQuestionSharedConfirmation_many: 'This question is asked on {{tickets}} tickets. Stored answers: {{answers}}. Deleting it removes the question from all of those tickets and permanently destroys all of those answers. This cannot be undone.',
      deleteEverywhere: 'Delete from all tickets',
      detachFromTicket: 'Remove from this ticket only',
      newTicketPromptTitle_one: 'This event already asks {{count}} question on its other tickets:',
      newTicketPromptTitle_many: 'This event already asks {{count}} questions on its other tickets:',
      newTicketPromptHint: "Uncheck any you don't want on this ticket.",
      askedOnCount_one: 'asked on {{count}} ticket',
      askedOnCount_many: 'asked on {{count}} tickets',
      newTicketLinkFailed: "The ticket was created, but the questions could not be attached. Use the Ask on control to attach them.",
    },
  },
};

export type Language = keyof typeof translations;
export type TranslationKeys = typeof translations.uk;
